/**
 * #subreddits_msg.ts
 *
 * Code generated by ts-proto. DO NOT EDIT.
 * @packageDocumentation
 */
/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal.js";
import { Any } from "../../../../google/protobuf/any.js";
import { BoolValue, Int32Value, Int64Value, StringValue } from "../../../../google/protobuf/wrappers.js";
import { messageTypeRegistry } from "../../../../typeRegistry.js";
import { CommentContributionSettings, MediaEmbed, UserFlairRichtext } from "../../../reddit/common.js";
import { highlightedPostLabelFromJSON, highlightedPostLabelToJSON, } from "../common/common_msg.js";
function createBaseAboutWhereRequest() {
    return {
        after: undefined,
        before: undefined,
        count: undefined,
        limit: undefined,
        show: undefined,
        user: undefined,
        subreddit: undefined,
        where: "",
    };
}
export const AboutWhereRequest = {
    $type: "devvit.plugin.redditapi.subreddits.AboutWhereRequest",
    encode(message, writer = _m0.Writer.create()) {
        if (message.after !== undefined) {
            StringValue.encode({ value: message.after }, writer.uint32(10).fork()).ldelim();
        }
        if (message.before !== undefined) {
            StringValue.encode({ value: message.before }, writer.uint32(18).fork()).ldelim();
        }
        if (message.count !== undefined) {
            Int64Value.encode({ value: message.count }, writer.uint32(26).fork()).ldelim();
        }
        if (message.limit !== undefined) {
            Int64Value.encode({ value: message.limit }, writer.uint32(34).fork()).ldelim();
        }
        if (message.show !== undefined) {
            StringValue.encode({ value: message.show }, writer.uint32(42).fork()).ldelim();
        }
        if (message.user !== undefined) {
            StringValue.encode({ value: message.user }, writer.uint32(58).fork()).ldelim();
        }
        if (message.subreddit !== undefined) {
            StringValue.encode({ value: message.subreddit }, writer.uint32(66).fork()).ldelim();
        }
        if (message.where !== "") {
            writer.uint32(74).string(message.where);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAboutWhereRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.after = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.before = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.count = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.limit = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.show = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.user = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.subreddit = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 9:
                    if (tag !== 74) {
                        break;
                    }
                    message.where = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            after: isSet(object.after) ? String(object.after) : undefined,
            before: isSet(object.before) ? String(object.before) : undefined,
            count: isSet(object.count) ? Number(object.count) : undefined,
            limit: isSet(object.limit) ? Number(object.limit) : undefined,
            show: isSet(object.show) ? String(object.show) : undefined,
            user: isSet(object.user) ? String(object.user) : undefined,
            subreddit: isSet(object.subreddit) ? String(object.subreddit) : undefined,
            where: isSet(object.where) ? globalThis.String(object.where) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.after !== undefined) {
            obj.after = message.after;
        }
        if (message.before !== undefined) {
            obj.before = message.before;
        }
        if (message.count !== undefined) {
            obj.count = message.count;
        }
        if (message.limit !== undefined) {
            obj.limit = message.limit;
        }
        if (message.show !== undefined) {
            obj.show = message.show;
        }
        if (message.user !== undefined) {
            obj.user = message.user;
        }
        if (message.subreddit !== undefined) {
            obj.subreddit = message.subreddit;
        }
        if (message.where !== "") {
            obj.where = message.where;
        }
        return obj;
    },
    create(base) {
        return AboutWhereRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAboutWhereRequest();
        message.after = object.after ?? undefined;
        message.before = object.before ?? undefined;
        message.count = object.count ?? undefined;
        message.limit = object.limit ?? undefined;
        message.show = object.show ?? undefined;
        message.user = object.user ?? undefined;
        message.subreddit = object.subreddit ?? undefined;
        message.where = object.where ?? "";
        return message;
    },
};
messageTypeRegistry.set(AboutWhereRequest.$type, AboutWhereRequest);
function createBaseBasicSubredditRequest() {
    return { subreddit: "" };
}
export const BasicSubredditRequest = {
    $type: "devvit.plugin.redditapi.subreddits.BasicSubredditRequest",
    encode(message, writer = _m0.Writer.create()) {
        if (message.subreddit !== "") {
            writer.uint32(10).string(message.subreddit);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBasicSubredditRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.subreddit = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { subreddit: isSet(object.subreddit) ? globalThis.String(object.subreddit) : "" };
    },
    toJSON(message) {
        const obj = {};
        if (message.subreddit !== "") {
            obj.subreddit = message.subreddit;
        }
        return obj;
    },
    create(base) {
        return BasicSubredditRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBasicSubredditRequest();
        message.subreddit = object.subreddit ?? "";
        return message;
    },
};
messageTypeRegistry.set(BasicSubredditRequest.$type, BasicSubredditRequest);
function createBaseDeleteSrImgRequest() {
    return { subreddit: "", imgName: "" };
}
export const DeleteSrImgRequest = {
    $type: "devvit.plugin.redditapi.subreddits.DeleteSrImgRequest",
    encode(message, writer = _m0.Writer.create()) {
        if (message.subreddit !== "") {
            writer.uint32(10).string(message.subreddit);
        }
        if (message.imgName !== "") {
            writer.uint32(18).string(message.imgName);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDeleteSrImgRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.subreddit = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.imgName = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            subreddit: isSet(object.subreddit) ? globalThis.String(object.subreddit) : "",
            imgName: isSet(object.imgName) ? globalThis.String(object.imgName) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.subreddit !== "") {
            obj.subreddit = message.subreddit;
        }
        if (message.imgName !== "") {
            obj.imgName = message.imgName;
        }
        return obj;
    },
    create(base) {
        return DeleteSrImgRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDeleteSrImgRequest();
        message.subreddit = object.subreddit ?? "";
        message.imgName = object.imgName ?? "";
        return message;
    },
};
messageTypeRegistry.set(DeleteSrImgRequest.$type, DeleteSrImgRequest);
function createBaseBasicSearchRequest() {
    return {
        exact: undefined,
        includeOver18: undefined,
        includeUnadvertisable: undefined,
        query: "",
        searchQueryId: undefined,
        typeaheadActive: undefined,
    };
}
export const BasicSearchRequest = {
    $type: "devvit.plugin.redditapi.subreddits.BasicSearchRequest",
    encode(message, writer = _m0.Writer.create()) {
        if (message.exact !== undefined) {
            BoolValue.encode({ value: message.exact }, writer.uint32(10).fork()).ldelim();
        }
        if (message.includeOver18 !== undefined) {
            BoolValue.encode({ value: message.includeOver18 }, writer.uint32(18).fork()).ldelim();
        }
        if (message.includeUnadvertisable !== undefined) {
            BoolValue.encode({ value: message.includeUnadvertisable }, writer.uint32(26).fork()).ldelim();
        }
        if (message.query !== "") {
            writer.uint32(34).string(message.query);
        }
        if (message.searchQueryId !== undefined) {
            StringValue.encode({ value: message.searchQueryId }, writer.uint32(42).fork()).ldelim();
        }
        if (message.typeaheadActive !== undefined) {
            BoolValue.encode({ value: message.typeaheadActive }, writer.uint32(50).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBasicSearchRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.exact = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.includeOver18 = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.includeUnadvertisable = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.query = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.searchQueryId = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.typeaheadActive = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            exact: isSet(object.exact) ? Boolean(object.exact) : undefined,
            includeOver18: isSet(object.includeOver18) ? Boolean(object.includeOver18) : undefined,
            includeUnadvertisable: isSet(object.includeUnadvertisable) ? Boolean(object.includeUnadvertisable) : undefined,
            query: isSet(object.query) ? globalThis.String(object.query) : "",
            searchQueryId: isSet(object.searchQueryId) ? String(object.searchQueryId) : undefined,
            typeaheadActive: isSet(object.typeaheadActive) ? Boolean(object.typeaheadActive) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.exact !== undefined) {
            obj.exact = message.exact;
        }
        if (message.includeOver18 !== undefined) {
            obj.includeOver18 = message.includeOver18;
        }
        if (message.includeUnadvertisable !== undefined) {
            obj.includeUnadvertisable = message.includeUnadvertisable;
        }
        if (message.query !== "") {
            obj.query = message.query;
        }
        if (message.searchQueryId !== undefined) {
            obj.searchQueryId = message.searchQueryId;
        }
        if (message.typeaheadActive !== undefined) {
            obj.typeaheadActive = message.typeaheadActive;
        }
        return obj;
    },
    create(base) {
        return BasicSearchRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBasicSearchRequest();
        message.exact = object.exact ?? undefined;
        message.includeOver18 = object.includeOver18 ?? undefined;
        message.includeUnadvertisable = object.includeUnadvertisable ?? undefined;
        message.query = object.query ?? "";
        message.searchQueryId = object.searchQueryId ?? undefined;
        message.typeaheadActive = object.typeaheadActive ?? undefined;
        return message;
    },
};
messageTypeRegistry.set(BasicSearchRequest.$type, BasicSearchRequest);
function createBaseSiteAdminRequest() {
    return {
        acceptFollowers: false,
        adminOverrideSpamComments: false,
        adminOverrideSpamLinks: false,
        adminOverrideSpamSelfposts: false,
        allOriginalContent: false,
        allowChatPostCreation: false,
        allowDiscovery: false,
        allowGalleries: false,
        allowImages: false,
        allowPolls: false,
        allowPostCrossposts: false,
        allowPredictionContributors: false,
        allowPredictions: false,
        allowPredictionsTournament: false,
        allowTalks: false,
        allowTop: false,
        allowVideos: false,
        banEvasionThreshold: 0,
        collapseDeletedComments: false,
        commentScoreHideMins: 0,
        crowdControlFilter: false,
        crowdControlLevel: 0,
        crowdControlMode: false,
        crowdControlPostLevel: 0,
        description: "",
        disableContributorRequests: false,
        excludeBannedModqueue: false,
        freeFormReports: false,
        gRecaptchaResponse: "",
        hatefulContentThresholdAbuse: 0,
        hatefulContentThresholdIdentity: 0,
        headerTitle: "",
        keyColor: "",
        linkType: "",
        name: "",
        newPinnedPostPnsEnabled: false,
        originalContentTagEnabled: false,
        over18: false,
        predictionLeaderboardEntryType: 0,
        publicDescription: "",
        restrictCommenting: false,
        restrictPosting: false,
        shouldArchivePosts: false,
        showMedia: false,
        showMediaPreview: false,
        spamComments: "",
        spamLinks: "",
        spamSelfposts: "",
        spoilersEnabled: false,
        sr: "",
        submitLinkLabel: "",
        submitText: "",
        submitTextLabel: "",
        suggestedCommentSort: "",
        title: "",
        toxicityThresholdChatLevel: 0,
        type: "",
        userFlairPnsEnabled: false,
        welcomeMessageEnabled: false,
        welcomeMessageText: "",
        wikiEditAge: 0,
        wikiEditKarma: 0,
        wikimode: "",
        crowdControlChatLevel: 0,
        hideAds: false,
        modmailHarassmentFilterEnabled: false,
    };
}
export const SiteAdminRequest = {
    $type: "devvit.plugin.redditapi.subreddits.SiteAdminRequest",
    encode(message, writer = _m0.Writer.create()) {
        if (message.acceptFollowers !== false) {
            writer.uint32(8).bool(message.acceptFollowers);
        }
        if (message.adminOverrideSpamComments !== false) {
            writer.uint32(16).bool(message.adminOverrideSpamComments);
        }
        if (message.adminOverrideSpamLinks !== false) {
            writer.uint32(24).bool(message.adminOverrideSpamLinks);
        }
        if (message.adminOverrideSpamSelfposts !== false) {
            writer.uint32(32).bool(message.adminOverrideSpamSelfposts);
        }
        if (message.allOriginalContent !== false) {
            writer.uint32(40).bool(message.allOriginalContent);
        }
        if (message.allowChatPostCreation !== false) {
            writer.uint32(48).bool(message.allowChatPostCreation);
        }
        if (message.allowDiscovery !== false) {
            writer.uint32(56).bool(message.allowDiscovery);
        }
        if (message.allowGalleries !== false) {
            writer.uint32(64).bool(message.allowGalleries);
        }
        if (message.allowImages !== false) {
            writer.uint32(72).bool(message.allowImages);
        }
        if (message.allowPolls !== false) {
            writer.uint32(80).bool(message.allowPolls);
        }
        if (message.allowPostCrossposts !== false) {
            writer.uint32(88).bool(message.allowPostCrossposts);
        }
        if (message.allowPredictionContributors !== false) {
            writer.uint32(96).bool(message.allowPredictionContributors);
        }
        if (message.allowPredictions !== false) {
            writer.uint32(104).bool(message.allowPredictions);
        }
        if (message.allowPredictionsTournament !== false) {
            writer.uint32(112).bool(message.allowPredictionsTournament);
        }
        if (message.allowTalks !== false) {
            writer.uint32(120).bool(message.allowTalks);
        }
        if (message.allowTop !== false) {
            writer.uint32(128).bool(message.allowTop);
        }
        if (message.allowVideos !== false) {
            writer.uint32(136).bool(message.allowVideos);
        }
        if (message.banEvasionThreshold !== 0) {
            writer.uint32(144).int64(message.banEvasionThreshold);
        }
        if (message.collapseDeletedComments !== false) {
            writer.uint32(152).bool(message.collapseDeletedComments);
        }
        if (message.commentScoreHideMins !== 0) {
            writer.uint32(168).int32(message.commentScoreHideMins);
        }
        if (message.crowdControlFilter !== false) {
            writer.uint32(176).bool(message.crowdControlFilter);
        }
        if (message.crowdControlLevel !== 0) {
            writer.uint32(184).int64(message.crowdControlLevel);
        }
        if (message.crowdControlMode !== false) {
            writer.uint32(192).bool(message.crowdControlMode);
        }
        if (message.crowdControlPostLevel !== 0) {
            writer.uint32(200).int64(message.crowdControlPostLevel);
        }
        if (message.description !== "") {
            writer.uint32(210).string(message.description);
        }
        if (message.disableContributorRequests !== false) {
            writer.uint32(216).bool(message.disableContributorRequests);
        }
        if (message.excludeBannedModqueue !== false) {
            writer.uint32(224).bool(message.excludeBannedModqueue);
        }
        if (message.freeFormReports !== false) {
            writer.uint32(232).bool(message.freeFormReports);
        }
        if (message.gRecaptchaResponse !== "") {
            writer.uint32(242).string(message.gRecaptchaResponse);
        }
        if (message.hatefulContentThresholdAbuse !== 0) {
            writer.uint32(248).int64(message.hatefulContentThresholdAbuse);
        }
        if (message.hatefulContentThresholdIdentity !== 0) {
            writer.uint32(256).int64(message.hatefulContentThresholdIdentity);
        }
        if (message.headerTitle !== "") {
            writer.uint32(266).string(message.headerTitle);
        }
        if (message.keyColor !== "") {
            writer.uint32(274).string(message.keyColor);
        }
        if (message.linkType !== "") {
            writer.uint32(290).string(message.linkType);
        }
        if (message.name !== "") {
            writer.uint32(298).string(message.name);
        }
        if (message.newPinnedPostPnsEnabled !== false) {
            writer.uint32(304).bool(message.newPinnedPostPnsEnabled);
        }
        if (message.originalContentTagEnabled !== false) {
            writer.uint32(312).bool(message.originalContentTagEnabled);
        }
        if (message.over18 !== false) {
            writer.uint32(320).bool(message.over18);
        }
        if (message.predictionLeaderboardEntryType !== 0) {
            writer.uint32(328).int64(message.predictionLeaderboardEntryType);
        }
        if (message.publicDescription !== "") {
            writer.uint32(338).string(message.publicDescription);
        }
        if (message.restrictCommenting !== false) {
            writer.uint32(344).bool(message.restrictCommenting);
        }
        if (message.restrictPosting !== false) {
            writer.uint32(352).bool(message.restrictPosting);
        }
        if (message.shouldArchivePosts !== false) {
            writer.uint32(360).bool(message.shouldArchivePosts);
        }
        if (message.showMedia !== false) {
            writer.uint32(368).bool(message.showMedia);
        }
        if (message.showMediaPreview !== false) {
            writer.uint32(376).bool(message.showMediaPreview);
        }
        if (message.spamComments !== "") {
            writer.uint32(386).string(message.spamComments);
        }
        if (message.spamLinks !== "") {
            writer.uint32(394).string(message.spamLinks);
        }
        if (message.spamSelfposts !== "") {
            writer.uint32(402).string(message.spamSelfposts);
        }
        if (message.spoilersEnabled !== false) {
            writer.uint32(408).bool(message.spoilersEnabled);
        }
        if (message.sr !== "") {
            writer.uint32(418).string(message.sr);
        }
        if (message.submitLinkLabel !== "") {
            writer.uint32(426).string(message.submitLinkLabel);
        }
        if (message.submitText !== "") {
            writer.uint32(434).string(message.submitText);
        }
        if (message.submitTextLabel !== "") {
            writer.uint32(442).string(message.submitTextLabel);
        }
        if (message.suggestedCommentSort !== "") {
            writer.uint32(450).string(message.suggestedCommentSort);
        }
        if (message.title !== "") {
            writer.uint32(458).string(message.title);
        }
        if (message.toxicityThresholdChatLevel !== 0) {
            writer.uint32(464).int64(message.toxicityThresholdChatLevel);
        }
        if (message.type !== "") {
            writer.uint32(474).string(message.type);
        }
        if (message.userFlairPnsEnabled !== false) {
            writer.uint32(480).bool(message.userFlairPnsEnabled);
        }
        if (message.welcomeMessageEnabled !== false) {
            writer.uint32(488).bool(message.welcomeMessageEnabled);
        }
        if (message.welcomeMessageText !== "") {
            writer.uint32(498).string(message.welcomeMessageText);
        }
        if (message.wikiEditAge !== 0) {
            writer.uint32(504).int64(message.wikiEditAge);
        }
        if (message.wikiEditKarma !== 0) {
            writer.uint32(512).int64(message.wikiEditKarma);
        }
        if (message.wikimode !== "") {
            writer.uint32(522).string(message.wikimode);
        }
        if (message.crowdControlChatLevel !== 0) {
            writer.uint32(528).int64(message.crowdControlChatLevel);
        }
        if (message.hideAds !== false) {
            writer.uint32(536).bool(message.hideAds);
        }
        if (message.modmailHarassmentFilterEnabled !== false) {
            writer.uint32(544).bool(message.modmailHarassmentFilterEnabled);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSiteAdminRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.acceptFollowers = reader.bool();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.adminOverrideSpamComments = reader.bool();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.adminOverrideSpamLinks = reader.bool();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.adminOverrideSpamSelfposts = reader.bool();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.allOriginalContent = reader.bool();
                    continue;
                case 6:
                    if (tag !== 48) {
                        break;
                    }
                    message.allowChatPostCreation = reader.bool();
                    continue;
                case 7:
                    if (tag !== 56) {
                        break;
                    }
                    message.allowDiscovery = reader.bool();
                    continue;
                case 8:
                    if (tag !== 64) {
                        break;
                    }
                    message.allowGalleries = reader.bool();
                    continue;
                case 9:
                    if (tag !== 72) {
                        break;
                    }
                    message.allowImages = reader.bool();
                    continue;
                case 10:
                    if (tag !== 80) {
                        break;
                    }
                    message.allowPolls = reader.bool();
                    continue;
                case 11:
                    if (tag !== 88) {
                        break;
                    }
                    message.allowPostCrossposts = reader.bool();
                    continue;
                case 12:
                    if (tag !== 96) {
                        break;
                    }
                    message.allowPredictionContributors = reader.bool();
                    continue;
                case 13:
                    if (tag !== 104) {
                        break;
                    }
                    message.allowPredictions = reader.bool();
                    continue;
                case 14:
                    if (tag !== 112) {
                        break;
                    }
                    message.allowPredictionsTournament = reader.bool();
                    continue;
                case 15:
                    if (tag !== 120) {
                        break;
                    }
                    message.allowTalks = reader.bool();
                    continue;
                case 16:
                    if (tag !== 128) {
                        break;
                    }
                    message.allowTop = reader.bool();
                    continue;
                case 17:
                    if (tag !== 136) {
                        break;
                    }
                    message.allowVideos = reader.bool();
                    continue;
                case 18:
                    if (tag !== 144) {
                        break;
                    }
                    message.banEvasionThreshold = longToNumber(reader.int64());
                    continue;
                case 19:
                    if (tag !== 152) {
                        break;
                    }
                    message.collapseDeletedComments = reader.bool();
                    continue;
                case 21:
                    if (tag !== 168) {
                        break;
                    }
                    message.commentScoreHideMins = reader.int32();
                    continue;
                case 22:
                    if (tag !== 176) {
                        break;
                    }
                    message.crowdControlFilter = reader.bool();
                    continue;
                case 23:
                    if (tag !== 184) {
                        break;
                    }
                    message.crowdControlLevel = longToNumber(reader.int64());
                    continue;
                case 24:
                    if (tag !== 192) {
                        break;
                    }
                    message.crowdControlMode = reader.bool();
                    continue;
                case 25:
                    if (tag !== 200) {
                        break;
                    }
                    message.crowdControlPostLevel = longToNumber(reader.int64());
                    continue;
                case 26:
                    if (tag !== 210) {
                        break;
                    }
                    message.description = reader.string();
                    continue;
                case 27:
                    if (tag !== 216) {
                        break;
                    }
                    message.disableContributorRequests = reader.bool();
                    continue;
                case 28:
                    if (tag !== 224) {
                        break;
                    }
                    message.excludeBannedModqueue = reader.bool();
                    continue;
                case 29:
                    if (tag !== 232) {
                        break;
                    }
                    message.freeFormReports = reader.bool();
                    continue;
                case 30:
                    if (tag !== 242) {
                        break;
                    }
                    message.gRecaptchaResponse = reader.string();
                    continue;
                case 31:
                    if (tag !== 248) {
                        break;
                    }
                    message.hatefulContentThresholdAbuse = longToNumber(reader.int64());
                    continue;
                case 32:
                    if (tag !== 256) {
                        break;
                    }
                    message.hatefulContentThresholdIdentity = longToNumber(reader.int64());
                    continue;
                case 33:
                    if (tag !== 266) {
                        break;
                    }
                    message.headerTitle = reader.string();
                    continue;
                case 34:
                    if (tag !== 274) {
                        break;
                    }
                    message.keyColor = reader.string();
                    continue;
                case 36:
                    if (tag !== 290) {
                        break;
                    }
                    message.linkType = reader.string();
                    continue;
                case 37:
                    if (tag !== 298) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 38:
                    if (tag !== 304) {
                        break;
                    }
                    message.newPinnedPostPnsEnabled = reader.bool();
                    continue;
                case 39:
                    if (tag !== 312) {
                        break;
                    }
                    message.originalContentTagEnabled = reader.bool();
                    continue;
                case 40:
                    if (tag !== 320) {
                        break;
                    }
                    message.over18 = reader.bool();
                    continue;
                case 41:
                    if (tag !== 328) {
                        break;
                    }
                    message.predictionLeaderboardEntryType = longToNumber(reader.int64());
                    continue;
                case 42:
                    if (tag !== 338) {
                        break;
                    }
                    message.publicDescription = reader.string();
                    continue;
                case 43:
                    if (tag !== 344) {
                        break;
                    }
                    message.restrictCommenting = reader.bool();
                    continue;
                case 44:
                    if (tag !== 352) {
                        break;
                    }
                    message.restrictPosting = reader.bool();
                    continue;
                case 45:
                    if (tag !== 360) {
                        break;
                    }
                    message.shouldArchivePosts = reader.bool();
                    continue;
                case 46:
                    if (tag !== 368) {
                        break;
                    }
                    message.showMedia = reader.bool();
                    continue;
                case 47:
                    if (tag !== 376) {
                        break;
                    }
                    message.showMediaPreview = reader.bool();
                    continue;
                case 48:
                    if (tag !== 386) {
                        break;
                    }
                    message.spamComments = reader.string();
                    continue;
                case 49:
                    if (tag !== 394) {
                        break;
                    }
                    message.spamLinks = reader.string();
                    continue;
                case 50:
                    if (tag !== 402) {
                        break;
                    }
                    message.spamSelfposts = reader.string();
                    continue;
                case 51:
                    if (tag !== 408) {
                        break;
                    }
                    message.spoilersEnabled = reader.bool();
                    continue;
                case 52:
                    if (tag !== 418) {
                        break;
                    }
                    message.sr = reader.string();
                    continue;
                case 53:
                    if (tag !== 426) {
                        break;
                    }
                    message.submitLinkLabel = reader.string();
                    continue;
                case 54:
                    if (tag !== 434) {
                        break;
                    }
                    message.submitText = reader.string();
                    continue;
                case 55:
                    if (tag !== 442) {
                        break;
                    }
                    message.submitTextLabel = reader.string();
                    continue;
                case 56:
                    if (tag !== 450) {
                        break;
                    }
                    message.suggestedCommentSort = reader.string();
                    continue;
                case 57:
                    if (tag !== 458) {
                        break;
                    }
                    message.title = reader.string();
                    continue;
                case 58:
                    if (tag !== 464) {
                        break;
                    }
                    message.toxicityThresholdChatLevel = longToNumber(reader.int64());
                    continue;
                case 59:
                    if (tag !== 474) {
                        break;
                    }
                    message.type = reader.string();
                    continue;
                case 60:
                    if (tag !== 480) {
                        break;
                    }
                    message.userFlairPnsEnabled = reader.bool();
                    continue;
                case 61:
                    if (tag !== 488) {
                        break;
                    }
                    message.welcomeMessageEnabled = reader.bool();
                    continue;
                case 62:
                    if (tag !== 498) {
                        break;
                    }
                    message.welcomeMessageText = reader.string();
                    continue;
                case 63:
                    if (tag !== 504) {
                        break;
                    }
                    message.wikiEditAge = longToNumber(reader.int64());
                    continue;
                case 64:
                    if (tag !== 512) {
                        break;
                    }
                    message.wikiEditKarma = longToNumber(reader.int64());
                    continue;
                case 65:
                    if (tag !== 522) {
                        break;
                    }
                    message.wikimode = reader.string();
                    continue;
                case 66:
                    if (tag !== 528) {
                        break;
                    }
                    message.crowdControlChatLevel = longToNumber(reader.int64());
                    continue;
                case 67:
                    if (tag !== 536) {
                        break;
                    }
                    message.hideAds = reader.bool();
                    continue;
                case 68:
                    if (tag !== 544) {
                        break;
                    }
                    message.modmailHarassmentFilterEnabled = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            acceptFollowers: isSet(object.acceptFollowers) ? globalThis.Boolean(object.acceptFollowers) : false,
            adminOverrideSpamComments: isSet(object.adminOverrideSpamComments)
                ? globalThis.Boolean(object.adminOverrideSpamComments)
                : false,
            adminOverrideSpamLinks: isSet(object.adminOverrideSpamLinks)
                ? globalThis.Boolean(object.adminOverrideSpamLinks)
                : false,
            adminOverrideSpamSelfposts: isSet(object.adminOverrideSpamSelfposts)
                ? globalThis.Boolean(object.adminOverrideSpamSelfposts)
                : false,
            allOriginalContent: isSet(object.allOriginalContent) ? globalThis.Boolean(object.allOriginalContent) : false,
            allowChatPostCreation: isSet(object.allowChatPostCreation)
                ? globalThis.Boolean(object.allowChatPostCreation)
                : false,
            allowDiscovery: isSet(object.allowDiscovery) ? globalThis.Boolean(object.allowDiscovery) : false,
            allowGalleries: isSet(object.allowGalleries) ? globalThis.Boolean(object.allowGalleries) : false,
            allowImages: isSet(object.allowImages) ? globalThis.Boolean(object.allowImages) : false,
            allowPolls: isSet(object.allowPolls) ? globalThis.Boolean(object.allowPolls) : false,
            allowPostCrossposts: isSet(object.allowPostCrossposts) ? globalThis.Boolean(object.allowPostCrossposts) : false,
            allowPredictionContributors: isSet(object.allowPredictionContributors)
                ? globalThis.Boolean(object.allowPredictionContributors)
                : false,
            allowPredictions: isSet(object.allowPredictions) ? globalThis.Boolean(object.allowPredictions) : false,
            allowPredictionsTournament: isSet(object.allowPredictionsTournament)
                ? globalThis.Boolean(object.allowPredictionsTournament)
                : false,
            allowTalks: isSet(object.allowTalks) ? globalThis.Boolean(object.allowTalks) : false,
            allowTop: isSet(object.allowTop) ? globalThis.Boolean(object.allowTop) : false,
            allowVideos: isSet(object.allowVideos) ? globalThis.Boolean(object.allowVideos) : false,
            banEvasionThreshold: isSet(object.banEvasionThreshold) ? globalThis.Number(object.banEvasionThreshold) : 0,
            collapseDeletedComments: isSet(object.collapseDeletedComments)
                ? globalThis.Boolean(object.collapseDeletedComments)
                : false,
            commentScoreHideMins: isSet(object.commentScoreHideMins) ? globalThis.Number(object.commentScoreHideMins) : 0,
            crowdControlFilter: isSet(object.crowdControlFilter) ? globalThis.Boolean(object.crowdControlFilter) : false,
            crowdControlLevel: isSet(object.crowdControlLevel) ? globalThis.Number(object.crowdControlLevel) : 0,
            crowdControlMode: isSet(object.crowdControlMode) ? globalThis.Boolean(object.crowdControlMode) : false,
            crowdControlPostLevel: isSet(object.crowdControlPostLevel) ? globalThis.Number(object.crowdControlPostLevel) : 0,
            description: isSet(object.description) ? globalThis.String(object.description) : "",
            disableContributorRequests: isSet(object.disableContributorRequests)
                ? globalThis.Boolean(object.disableContributorRequests)
                : false,
            excludeBannedModqueue: isSet(object.excludeBannedModqueue)
                ? globalThis.Boolean(object.excludeBannedModqueue)
                : false,
            freeFormReports: isSet(object.freeFormReports) ? globalThis.Boolean(object.freeFormReports) : false,
            gRecaptchaResponse: isSet(object.gRecaptchaResponse) ? globalThis.String(object.gRecaptchaResponse) : "",
            hatefulContentThresholdAbuse: isSet(object.hatefulContentThresholdAbuse)
                ? globalThis.Number(object.hatefulContentThresholdAbuse)
                : 0,
            hatefulContentThresholdIdentity: isSet(object.hatefulContentThresholdIdentity)
                ? globalThis.Number(object.hatefulContentThresholdIdentity)
                : 0,
            headerTitle: isSet(object.headerTitle) ? globalThis.String(object.headerTitle) : "",
            keyColor: isSet(object.keyColor) ? globalThis.String(object.keyColor) : "",
            linkType: isSet(object.linkType) ? globalThis.String(object.linkType) : "",
            name: isSet(object.name) ? globalThis.String(object.name) : "",
            newPinnedPostPnsEnabled: isSet(object.newPinnedPostPnsEnabled)
                ? globalThis.Boolean(object.newPinnedPostPnsEnabled)
                : false,
            originalContentTagEnabled: isSet(object.originalContentTagEnabled)
                ? globalThis.Boolean(object.originalContentTagEnabled)
                : false,
            over18: isSet(object.over18) ? globalThis.Boolean(object.over18) : false,
            predictionLeaderboardEntryType: isSet(object.predictionLeaderboardEntryType)
                ? globalThis.Number(object.predictionLeaderboardEntryType)
                : 0,
            publicDescription: isSet(object.publicDescription) ? globalThis.String(object.publicDescription) : "",
            restrictCommenting: isSet(object.restrictCommenting) ? globalThis.Boolean(object.restrictCommenting) : false,
            restrictPosting: isSet(object.restrictPosting) ? globalThis.Boolean(object.restrictPosting) : false,
            shouldArchivePosts: isSet(object.shouldArchivePosts) ? globalThis.Boolean(object.shouldArchivePosts) : false,
            showMedia: isSet(object.showMedia) ? globalThis.Boolean(object.showMedia) : false,
            showMediaPreview: isSet(object.showMediaPreview) ? globalThis.Boolean(object.showMediaPreview) : false,
            spamComments: isSet(object.spamComments) ? globalThis.String(object.spamComments) : "",
            spamLinks: isSet(object.spamLinks) ? globalThis.String(object.spamLinks) : "",
            spamSelfposts: isSet(object.spamSelfposts) ? globalThis.String(object.spamSelfposts) : "",
            spoilersEnabled: isSet(object.spoilersEnabled) ? globalThis.Boolean(object.spoilersEnabled) : false,
            sr: isSet(object.sr) ? globalThis.String(object.sr) : "",
            submitLinkLabel: isSet(object.submitLinkLabel) ? globalThis.String(object.submitLinkLabel) : "",
            submitText: isSet(object.submitText) ? globalThis.String(object.submitText) : "",
            submitTextLabel: isSet(object.submitTextLabel) ? globalThis.String(object.submitTextLabel) : "",
            suggestedCommentSort: isSet(object.suggestedCommentSort) ? globalThis.String(object.suggestedCommentSort) : "",
            title: isSet(object.title) ? globalThis.String(object.title) : "",
            toxicityThresholdChatLevel: isSet(object.toxicityThresholdChatLevel)
                ? globalThis.Number(object.toxicityThresholdChatLevel)
                : 0,
            type: isSet(object.type) ? globalThis.String(object.type) : "",
            userFlairPnsEnabled: isSet(object.userFlairPnsEnabled) ? globalThis.Boolean(object.userFlairPnsEnabled) : false,
            welcomeMessageEnabled: isSet(object.welcomeMessageEnabled)
                ? globalThis.Boolean(object.welcomeMessageEnabled)
                : false,
            welcomeMessageText: isSet(object.welcomeMessageText) ? globalThis.String(object.welcomeMessageText) : "",
            wikiEditAge: isSet(object.wikiEditAge) ? globalThis.Number(object.wikiEditAge) : 0,
            wikiEditKarma: isSet(object.wikiEditKarma) ? globalThis.Number(object.wikiEditKarma) : 0,
            wikimode: isSet(object.wikimode) ? globalThis.String(object.wikimode) : "",
            crowdControlChatLevel: isSet(object.crowdControlChatLevel) ? globalThis.Number(object.crowdControlChatLevel) : 0,
            hideAds: isSet(object.hideAds) ? globalThis.Boolean(object.hideAds) : false,
            modmailHarassmentFilterEnabled: isSet(object.modmailHarassmentFilterEnabled)
                ? globalThis.Boolean(object.modmailHarassmentFilterEnabled)
                : false,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.acceptFollowers !== false) {
            obj.acceptFollowers = message.acceptFollowers;
        }
        if (message.adminOverrideSpamComments !== false) {
            obj.adminOverrideSpamComments = message.adminOverrideSpamComments;
        }
        if (message.adminOverrideSpamLinks !== false) {
            obj.adminOverrideSpamLinks = message.adminOverrideSpamLinks;
        }
        if (message.adminOverrideSpamSelfposts !== false) {
            obj.adminOverrideSpamSelfposts = message.adminOverrideSpamSelfposts;
        }
        if (message.allOriginalContent !== false) {
            obj.allOriginalContent = message.allOriginalContent;
        }
        if (message.allowChatPostCreation !== false) {
            obj.allowChatPostCreation = message.allowChatPostCreation;
        }
        if (message.allowDiscovery !== false) {
            obj.allowDiscovery = message.allowDiscovery;
        }
        if (message.allowGalleries !== false) {
            obj.allowGalleries = message.allowGalleries;
        }
        if (message.allowImages !== false) {
            obj.allowImages = message.allowImages;
        }
        if (message.allowPolls !== false) {
            obj.allowPolls = message.allowPolls;
        }
        if (message.allowPostCrossposts !== false) {
            obj.allowPostCrossposts = message.allowPostCrossposts;
        }
        if (message.allowPredictionContributors !== false) {
            obj.allowPredictionContributors = message.allowPredictionContributors;
        }
        if (message.allowPredictions !== false) {
            obj.allowPredictions = message.allowPredictions;
        }
        if (message.allowPredictionsTournament !== false) {
            obj.allowPredictionsTournament = message.allowPredictionsTournament;
        }
        if (message.allowTalks !== false) {
            obj.allowTalks = message.allowTalks;
        }
        if (message.allowTop !== false) {
            obj.allowTop = message.allowTop;
        }
        if (message.allowVideos !== false) {
            obj.allowVideos = message.allowVideos;
        }
        if (message.banEvasionThreshold !== 0) {
            obj.banEvasionThreshold = Math.round(message.banEvasionThreshold);
        }
        if (message.collapseDeletedComments !== false) {
            obj.collapseDeletedComments = message.collapseDeletedComments;
        }
        if (message.commentScoreHideMins !== 0) {
            obj.commentScoreHideMins = Math.round(message.commentScoreHideMins);
        }
        if (message.crowdControlFilter !== false) {
            obj.crowdControlFilter = message.crowdControlFilter;
        }
        if (message.crowdControlLevel !== 0) {
            obj.crowdControlLevel = Math.round(message.crowdControlLevel);
        }
        if (message.crowdControlMode !== false) {
            obj.crowdControlMode = message.crowdControlMode;
        }
        if (message.crowdControlPostLevel !== 0) {
            obj.crowdControlPostLevel = Math.round(message.crowdControlPostLevel);
        }
        if (message.description !== "") {
            obj.description = message.description;
        }
        if (message.disableContributorRequests !== false) {
            obj.disableContributorRequests = message.disableContributorRequests;
        }
        if (message.excludeBannedModqueue !== false) {
            obj.excludeBannedModqueue = message.excludeBannedModqueue;
        }
        if (message.freeFormReports !== false) {
            obj.freeFormReports = message.freeFormReports;
        }
        if (message.gRecaptchaResponse !== "") {
            obj.gRecaptchaResponse = message.gRecaptchaResponse;
        }
        if (message.hatefulContentThresholdAbuse !== 0) {
            obj.hatefulContentThresholdAbuse = Math.round(message.hatefulContentThresholdAbuse);
        }
        if (message.hatefulContentThresholdIdentity !== 0) {
            obj.hatefulContentThresholdIdentity = Math.round(message.hatefulContentThresholdIdentity);
        }
        if (message.headerTitle !== "") {
            obj.headerTitle = message.headerTitle;
        }
        if (message.keyColor !== "") {
            obj.keyColor = message.keyColor;
        }
        if (message.linkType !== "") {
            obj.linkType = message.linkType;
        }
        if (message.name !== "") {
            obj.name = message.name;
        }
        if (message.newPinnedPostPnsEnabled !== false) {
            obj.newPinnedPostPnsEnabled = message.newPinnedPostPnsEnabled;
        }
        if (message.originalContentTagEnabled !== false) {
            obj.originalContentTagEnabled = message.originalContentTagEnabled;
        }
        if (message.over18 !== false) {
            obj.over18 = message.over18;
        }
        if (message.predictionLeaderboardEntryType !== 0) {
            obj.predictionLeaderboardEntryType = Math.round(message.predictionLeaderboardEntryType);
        }
        if (message.publicDescription !== "") {
            obj.publicDescription = message.publicDescription;
        }
        if (message.restrictCommenting !== false) {
            obj.restrictCommenting = message.restrictCommenting;
        }
        if (message.restrictPosting !== false) {
            obj.restrictPosting = message.restrictPosting;
        }
        if (message.shouldArchivePosts !== false) {
            obj.shouldArchivePosts = message.shouldArchivePosts;
        }
        if (message.showMedia !== false) {
            obj.showMedia = message.showMedia;
        }
        if (message.showMediaPreview !== false) {
            obj.showMediaPreview = message.showMediaPreview;
        }
        if (message.spamComments !== "") {
            obj.spamComments = message.spamComments;
        }
        if (message.spamLinks !== "") {
            obj.spamLinks = message.spamLinks;
        }
        if (message.spamSelfposts !== "") {
            obj.spamSelfposts = message.spamSelfposts;
        }
        if (message.spoilersEnabled !== false) {
            obj.spoilersEnabled = message.spoilersEnabled;
        }
        if (message.sr !== "") {
            obj.sr = message.sr;
        }
        if (message.submitLinkLabel !== "") {
            obj.submitLinkLabel = message.submitLinkLabel;
        }
        if (message.submitText !== "") {
            obj.submitText = message.submitText;
        }
        if (message.submitTextLabel !== "") {
            obj.submitTextLabel = message.submitTextLabel;
        }
        if (message.suggestedCommentSort !== "") {
            obj.suggestedCommentSort = message.suggestedCommentSort;
        }
        if (message.title !== "") {
            obj.title = message.title;
        }
        if (message.toxicityThresholdChatLevel !== 0) {
            obj.toxicityThresholdChatLevel = Math.round(message.toxicityThresholdChatLevel);
        }
        if (message.type !== "") {
            obj.type = message.type;
        }
        if (message.userFlairPnsEnabled !== false) {
            obj.userFlairPnsEnabled = message.userFlairPnsEnabled;
        }
        if (message.welcomeMessageEnabled !== false) {
            obj.welcomeMessageEnabled = message.welcomeMessageEnabled;
        }
        if (message.welcomeMessageText !== "") {
            obj.welcomeMessageText = message.welcomeMessageText;
        }
        if (message.wikiEditAge !== 0) {
            obj.wikiEditAge = Math.round(message.wikiEditAge);
        }
        if (message.wikiEditKarma !== 0) {
            obj.wikiEditKarma = Math.round(message.wikiEditKarma);
        }
        if (message.wikimode !== "") {
            obj.wikimode = message.wikimode;
        }
        if (message.crowdControlChatLevel !== 0) {
            obj.crowdControlChatLevel = Math.round(message.crowdControlChatLevel);
        }
        if (message.hideAds !== false) {
            obj.hideAds = message.hideAds;
        }
        if (message.modmailHarassmentFilterEnabled !== false) {
            obj.modmailHarassmentFilterEnabled = message.modmailHarassmentFilterEnabled;
        }
        return obj;
    },
    create(base) {
        return SiteAdminRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSiteAdminRequest();
        message.acceptFollowers = object.acceptFollowers ?? false;
        message.adminOverrideSpamComments = object.adminOverrideSpamComments ?? false;
        message.adminOverrideSpamLinks = object.adminOverrideSpamLinks ?? false;
        message.adminOverrideSpamSelfposts = object.adminOverrideSpamSelfposts ?? false;
        message.allOriginalContent = object.allOriginalContent ?? false;
        message.allowChatPostCreation = object.allowChatPostCreation ?? false;
        message.allowDiscovery = object.allowDiscovery ?? false;
        message.allowGalleries = object.allowGalleries ?? false;
        message.allowImages = object.allowImages ?? false;
        message.allowPolls = object.allowPolls ?? false;
        message.allowPostCrossposts = object.allowPostCrossposts ?? false;
        message.allowPredictionContributors = object.allowPredictionContributors ?? false;
        message.allowPredictions = object.allowPredictions ?? false;
        message.allowPredictionsTournament = object.allowPredictionsTournament ?? false;
        message.allowTalks = object.allowTalks ?? false;
        message.allowTop = object.allowTop ?? false;
        message.allowVideos = object.allowVideos ?? false;
        message.banEvasionThreshold = object.banEvasionThreshold ?? 0;
        message.collapseDeletedComments = object.collapseDeletedComments ?? false;
        message.commentScoreHideMins = object.commentScoreHideMins ?? 0;
        message.crowdControlFilter = object.crowdControlFilter ?? false;
        message.crowdControlLevel = object.crowdControlLevel ?? 0;
        message.crowdControlMode = object.crowdControlMode ?? false;
        message.crowdControlPostLevel = object.crowdControlPostLevel ?? 0;
        message.description = object.description ?? "";
        message.disableContributorRequests = object.disableContributorRequests ?? false;
        message.excludeBannedModqueue = object.excludeBannedModqueue ?? false;
        message.freeFormReports = object.freeFormReports ?? false;
        message.gRecaptchaResponse = object.gRecaptchaResponse ?? "";
        message.hatefulContentThresholdAbuse = object.hatefulContentThresholdAbuse ?? 0;
        message.hatefulContentThresholdIdentity = object.hatefulContentThresholdIdentity ?? 0;
        message.headerTitle = object.headerTitle ?? "";
        message.keyColor = object.keyColor ?? "";
        message.linkType = object.linkType ?? "";
        message.name = object.name ?? "";
        message.newPinnedPostPnsEnabled = object.newPinnedPostPnsEnabled ?? false;
        message.originalContentTagEnabled = object.originalContentTagEnabled ?? false;
        message.over18 = object.over18 ?? false;
        message.predictionLeaderboardEntryType = object.predictionLeaderboardEntryType ?? 0;
        message.publicDescription = object.publicDescription ?? "";
        message.restrictCommenting = object.restrictCommenting ?? false;
        message.restrictPosting = object.restrictPosting ?? false;
        message.shouldArchivePosts = object.shouldArchivePosts ?? false;
        message.showMedia = object.showMedia ?? false;
        message.showMediaPreview = object.showMediaPreview ?? false;
        message.spamComments = object.spamComments ?? "";
        message.spamLinks = object.spamLinks ?? "";
        message.spamSelfposts = object.spamSelfposts ?? "";
        message.spoilersEnabled = object.spoilersEnabled ?? false;
        message.sr = object.sr ?? "";
        message.submitLinkLabel = object.submitLinkLabel ?? "";
        message.submitText = object.submitText ?? "";
        message.submitTextLabel = object.submitTextLabel ?? "";
        message.suggestedCommentSort = object.suggestedCommentSort ?? "";
        message.title = object.title ?? "";
        message.toxicityThresholdChatLevel = object.toxicityThresholdChatLevel ?? 0;
        message.type = object.type ?? "";
        message.userFlairPnsEnabled = object.userFlairPnsEnabled ?? false;
        message.welcomeMessageEnabled = object.welcomeMessageEnabled ?? false;
        message.welcomeMessageText = object.welcomeMessageText ?? "";
        message.wikiEditAge = object.wikiEditAge ?? 0;
        message.wikiEditKarma = object.wikiEditKarma ?? 0;
        message.wikimode = object.wikimode ?? "";
        message.crowdControlChatLevel = object.crowdControlChatLevel ?? 0;
        message.hideAds = object.hideAds ?? false;
        message.modmailHarassmentFilterEnabled = object.modmailHarassmentFilterEnabled ?? false;
        return message;
    },
};
messageTypeRegistry.set(SiteAdminRequest.$type, SiteAdminRequest);
function createBaseSubredditAutocompleteRequest() {
    return {
        includeOver18: undefined,
        includeProfiles: undefined,
        limit: undefined,
        query: "",
        searchQueryId: undefined,
        typeaheadActive: undefined,
    };
}
export const SubredditAutocompleteRequest = {
    $type: "devvit.plugin.redditapi.subreddits.SubredditAutocompleteRequest",
    encode(message, writer = _m0.Writer.create()) {
        if (message.includeOver18 !== undefined) {
            BoolValue.encode({ value: message.includeOver18 }, writer.uint32(10).fork()).ldelim();
        }
        if (message.includeProfiles !== undefined) {
            BoolValue.encode({ value: message.includeProfiles }, writer.uint32(18).fork()).ldelim();
        }
        if (message.limit !== undefined) {
            Int64Value.encode({ value: message.limit }, writer.uint32(26).fork()).ldelim();
        }
        if (message.query !== "") {
            writer.uint32(34).string(message.query);
        }
        if (message.searchQueryId !== undefined) {
            StringValue.encode({ value: message.searchQueryId }, writer.uint32(42).fork()).ldelim();
        }
        if (message.typeaheadActive !== undefined) {
            BoolValue.encode({ value: message.typeaheadActive }, writer.uint32(50).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSubredditAutocompleteRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.includeOver18 = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.includeProfiles = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.limit = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.query = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.searchQueryId = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.typeaheadActive = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            includeOver18: isSet(object.includeOver18) ? Boolean(object.includeOver18) : undefined,
            includeProfiles: isSet(object.includeProfiles) ? Boolean(object.includeProfiles) : undefined,
            limit: isSet(object.limit) ? Number(object.limit) : undefined,
            query: isSet(object.query) ? globalThis.String(object.query) : "",
            searchQueryId: isSet(object.searchQueryId) ? String(object.searchQueryId) : undefined,
            typeaheadActive: isSet(object.typeaheadActive) ? Boolean(object.typeaheadActive) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.includeOver18 !== undefined) {
            obj.includeOver18 = message.includeOver18;
        }
        if (message.includeProfiles !== undefined) {
            obj.includeProfiles = message.includeProfiles;
        }
        if (message.limit !== undefined) {
            obj.limit = message.limit;
        }
        if (message.query !== "") {
            obj.query = message.query;
        }
        if (message.searchQueryId !== undefined) {
            obj.searchQueryId = message.searchQueryId;
        }
        if (message.typeaheadActive !== undefined) {
            obj.typeaheadActive = message.typeaheadActive;
        }
        return obj;
    },
    create(base) {
        return SubredditAutocompleteRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSubredditAutocompleteRequest();
        message.includeOver18 = object.includeOver18 ?? undefined;
        message.includeProfiles = object.includeProfiles ?? undefined;
        message.limit = object.limit ?? undefined;
        message.query = object.query ?? "";
        message.searchQueryId = object.searchQueryId ?? undefined;
        message.typeaheadActive = object.typeaheadActive ?? undefined;
        return message;
    },
};
messageTypeRegistry.set(SubredditAutocompleteRequest.$type, SubredditAutocompleteRequest);
function createBaseSubredditStylesheetRequest() {
    return { op: "", reason: "", stylesheetContents: "", subreddit: "" };
}
export const SubredditStylesheetRequest = {
    $type: "devvit.plugin.redditapi.subreddits.SubredditStylesheetRequest",
    encode(message, writer = _m0.Writer.create()) {
        if (message.op !== "") {
            writer.uint32(10).string(message.op);
        }
        if (message.reason !== "") {
            writer.uint32(18).string(message.reason);
        }
        if (message.stylesheetContents !== "") {
            writer.uint32(26).string(message.stylesheetContents);
        }
        if (message.subreddit !== "") {
            writer.uint32(34).string(message.subreddit);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSubredditStylesheetRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.op = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.reason = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.stylesheetContents = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.subreddit = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            op: isSet(object.op) ? globalThis.String(object.op) : "",
            reason: isSet(object.reason) ? globalThis.String(object.reason) : "",
            stylesheetContents: isSet(object.stylesheetContents) ? globalThis.String(object.stylesheetContents) : "",
            subreddit: isSet(object.subreddit) ? globalThis.String(object.subreddit) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.op !== "") {
            obj.op = message.op;
        }
        if (message.reason !== "") {
            obj.reason = message.reason;
        }
        if (message.stylesheetContents !== "") {
            obj.stylesheetContents = message.stylesheetContents;
        }
        if (message.subreddit !== "") {
            obj.subreddit = message.subreddit;
        }
        return obj;
    },
    create(base) {
        return SubredditStylesheetRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSubredditStylesheetRequest();
        message.op = object.op ?? "";
        message.reason = object.reason ?? "";
        message.stylesheetContents = object.stylesheetContents ?? "";
        message.subreddit = object.subreddit ?? "";
        return message;
    },
};
messageTypeRegistry.set(SubredditStylesheetRequest.$type, SubredditStylesheetRequest);
function createBaseSubscribeRequest() {
    return { action: "", actionSource: "", skipInitialDefaults: false, sr: "", srName: "" };
}
export const SubscribeRequest = {
    $type: "devvit.plugin.redditapi.subreddits.SubscribeRequest",
    encode(message, writer = _m0.Writer.create()) {
        if (message.action !== "") {
            writer.uint32(10).string(message.action);
        }
        if (message.actionSource !== "") {
            writer.uint32(18).string(message.actionSource);
        }
        if (message.skipInitialDefaults !== false) {
            writer.uint32(24).bool(message.skipInitialDefaults);
        }
        if (message.sr !== "") {
            writer.uint32(34).string(message.sr);
        }
        if (message.srName !== "") {
            writer.uint32(42).string(message.srName);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSubscribeRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.action = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.actionSource = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.skipInitialDefaults = reader.bool();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.sr = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.srName = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            action: isSet(object.action) ? globalThis.String(object.action) : "",
            actionSource: isSet(object.actionSource) ? globalThis.String(object.actionSource) : "",
            skipInitialDefaults: isSet(object.skipInitialDefaults) ? globalThis.Boolean(object.skipInitialDefaults) : false,
            sr: isSet(object.sr) ? globalThis.String(object.sr) : "",
            srName: isSet(object.srName) ? globalThis.String(object.srName) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.action !== "") {
            obj.action = message.action;
        }
        if (message.actionSource !== "") {
            obj.actionSource = message.actionSource;
        }
        if (message.skipInitialDefaults !== false) {
            obj.skipInitialDefaults = message.skipInitialDefaults;
        }
        if (message.sr !== "") {
            obj.sr = message.sr;
        }
        if (message.srName !== "") {
            obj.srName = message.srName;
        }
        return obj;
    },
    create(base) {
        return SubscribeRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSubscribeRequest();
        message.action = object.action ?? "";
        message.actionSource = object.actionSource ?? "";
        message.skipInitialDefaults = object.skipInitialDefaults ?? false;
        message.sr = object.sr ?? "";
        message.srName = object.srName ?? "";
        return message;
    },
};
messageTypeRegistry.set(SubscribeRequest.$type, SubscribeRequest);
function createBaseUploadSrImgRequest() {
    return { file: "", header: 0, imgType: "", name: "", uploadType: "", subreddit: "" };
}
export const UploadSrImgRequest = {
    $type: "devvit.plugin.redditapi.subreddits.UploadSrImgRequest",
    encode(message, writer = _m0.Writer.create()) {
        if (message.file !== "") {
            writer.uint32(10).string(message.file);
        }
        if (message.header !== 0) {
            writer.uint32(16).int64(message.header);
        }
        if (message.imgType !== "") {
            writer.uint32(26).string(message.imgType);
        }
        if (message.name !== "") {
            writer.uint32(34).string(message.name);
        }
        if (message.uploadType !== "") {
            writer.uint32(42).string(message.uploadType);
        }
        if (message.subreddit !== "") {
            writer.uint32(50).string(message.subreddit);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUploadSrImgRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.file = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.header = longToNumber(reader.int64());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.imgType = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.uploadType = reader.string();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.subreddit = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            file: isSet(object.file) ? globalThis.String(object.file) : "",
            header: isSet(object.header) ? globalThis.Number(object.header) : 0,
            imgType: isSet(object.imgType) ? globalThis.String(object.imgType) : "",
            name: isSet(object.name) ? globalThis.String(object.name) : "",
            uploadType: isSet(object.uploadType) ? globalThis.String(object.uploadType) : "",
            subreddit: isSet(object.subreddit) ? globalThis.String(object.subreddit) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.file !== "") {
            obj.file = message.file;
        }
        if (message.header !== 0) {
            obj.header = Math.round(message.header);
        }
        if (message.imgType !== "") {
            obj.imgType = message.imgType;
        }
        if (message.name !== "") {
            obj.name = message.name;
        }
        if (message.uploadType !== "") {
            obj.uploadType = message.uploadType;
        }
        if (message.subreddit !== "") {
            obj.subreddit = message.subreddit;
        }
        return obj;
    },
    create(base) {
        return UploadSrImgRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUploadSrImgRequest();
        message.file = object.file ?? "";
        message.header = object.header ?? 0;
        message.imgType = object.imgType ?? "";
        message.name = object.name ?? "";
        message.uploadType = object.uploadType ?? "";
        message.subreddit = object.subreddit ?? "";
        return message;
    },
};
messageTypeRegistry.set(UploadSrImgRequest.$type, UploadSrImgRequest);
function createBaseSubredditAboutEditRequest() {
    return { created: "", location: "", subreddit: "" };
}
export const SubredditAboutEditRequest = {
    $type: "devvit.plugin.redditapi.subreddits.SubredditAboutEditRequest",
    encode(message, writer = _m0.Writer.create()) {
        if (message.created !== "") {
            writer.uint32(10).string(message.created);
        }
        if (message.location !== "") {
            writer.uint32(18).string(message.location);
        }
        if (message.subreddit !== "") {
            writer.uint32(26).string(message.subreddit);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSubredditAboutEditRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.created = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.location = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.subreddit = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            created: isSet(object.created) ? globalThis.String(object.created) : "",
            location: isSet(object.location) ? globalThis.String(object.location) : "",
            subreddit: isSet(object.subreddit) ? globalThis.String(object.subreddit) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.created !== "") {
            obj.created = message.created;
        }
        if (message.location !== "") {
            obj.location = message.location;
        }
        if (message.subreddit !== "") {
            obj.subreddit = message.subreddit;
        }
        return obj;
    },
    create(base) {
        return SubredditAboutEditRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSubredditAboutEditRequest();
        message.created = object.created ?? "";
        message.location = object.location ?? "";
        message.subreddit = object.subreddit ?? "";
        return message;
    },
};
messageTypeRegistry.set(SubredditAboutEditRequest.$type, SubredditAboutEditRequest);
function createBaseStickyRequest() {
    return { num: 0, subreddit: "" };
}
export const StickyRequest = {
    $type: "devvit.plugin.redditapi.subreddits.StickyRequest",
    encode(message, writer = _m0.Writer.create()) {
        if (message.num !== 0) {
            writer.uint32(8).int64(message.num);
        }
        if (message.subreddit !== "") {
            writer.uint32(18).string(message.subreddit);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseStickyRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.num = longToNumber(reader.int64());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.subreddit = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            num: isSet(object.num) ? globalThis.Number(object.num) : 0,
            subreddit: isSet(object.subreddit) ? globalThis.String(object.subreddit) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.num !== 0) {
            obj.num = Math.round(message.num);
        }
        if (message.subreddit !== "") {
            obj.subreddit = message.subreddit;
        }
        return obj;
    },
    create(base) {
        return StickyRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseStickyRequest();
        message.num = object.num ?? 0;
        message.subreddit = object.subreddit ?? "";
        return message;
    },
};
messageTypeRegistry.set(StickyRequest.$type, StickyRequest);
function createBaseBasicWhereRequest() {
    return { after: undefined, before: undefined, count: undefined, limit: undefined, show: undefined, where: "" };
}
export const BasicWhereRequest = {
    $type: "devvit.plugin.redditapi.subreddits.BasicWhereRequest",
    encode(message, writer = _m0.Writer.create()) {
        if (message.after !== undefined) {
            StringValue.encode({ value: message.after }, writer.uint32(10).fork()).ldelim();
        }
        if (message.before !== undefined) {
            StringValue.encode({ value: message.before }, writer.uint32(18).fork()).ldelim();
        }
        if (message.count !== undefined) {
            Int64Value.encode({ value: message.count }, writer.uint32(26).fork()).ldelim();
        }
        if (message.limit !== undefined) {
            Int64Value.encode({ value: message.limit }, writer.uint32(34).fork()).ldelim();
        }
        if (message.show !== undefined) {
            StringValue.encode({ value: message.show }, writer.uint32(42).fork()).ldelim();
        }
        if (message.where !== "") {
            writer.uint32(58).string(message.where);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBasicWhereRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.after = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.before = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.count = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.limit = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.show = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.where = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            after: isSet(object.after) ? String(object.after) : undefined,
            before: isSet(object.before) ? String(object.before) : undefined,
            count: isSet(object.count) ? Number(object.count) : undefined,
            limit: isSet(object.limit) ? Number(object.limit) : undefined,
            show: isSet(object.show) ? String(object.show) : undefined,
            where: isSet(object.where) ? globalThis.String(object.where) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.after !== undefined) {
            obj.after = message.after;
        }
        if (message.before !== undefined) {
            obj.before = message.before;
        }
        if (message.count !== undefined) {
            obj.count = message.count;
        }
        if (message.limit !== undefined) {
            obj.limit = message.limit;
        }
        if (message.show !== undefined) {
            obj.show = message.show;
        }
        if (message.where !== "") {
            obj.where = message.where;
        }
        return obj;
    },
    create(base) {
        return BasicWhereRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBasicWhereRequest();
        message.after = object.after ?? undefined;
        message.before = object.before ?? undefined;
        message.count = object.count ?? undefined;
        message.limit = object.limit ?? undefined;
        message.show = object.show ?? undefined;
        message.where = object.where ?? "";
        return message;
    },
};
messageTypeRegistry.set(BasicWhereRequest.$type, BasicWhereRequest);
function createBaseSubredditsSearchRequest() {
    return {
        after: undefined,
        before: undefined,
        count: undefined,
        limit: undefined,
        q: "",
        searchQueryId: undefined,
        show: undefined,
        showUsers: undefined,
        sort: undefined,
        typeaheadActive: undefined,
    };
}
export const SubredditsSearchRequest = {
    $type: "devvit.plugin.redditapi.subreddits.SubredditsSearchRequest",
    encode(message, writer = _m0.Writer.create()) {
        if (message.after !== undefined) {
            StringValue.encode({ value: message.after }, writer.uint32(10).fork()).ldelim();
        }
        if (message.before !== undefined) {
            StringValue.encode({ value: message.before }, writer.uint32(18).fork()).ldelim();
        }
        if (message.count !== undefined) {
            Int64Value.encode({ value: message.count }, writer.uint32(26).fork()).ldelim();
        }
        if (message.limit !== undefined) {
            Int64Value.encode({ value: message.limit }, writer.uint32(34).fork()).ldelim();
        }
        if (message.q !== "") {
            writer.uint32(42).string(message.q);
        }
        if (message.searchQueryId !== undefined) {
            StringValue.encode({ value: message.searchQueryId }, writer.uint32(50).fork()).ldelim();
        }
        if (message.show !== undefined) {
            StringValue.encode({ value: message.show }, writer.uint32(58).fork()).ldelim();
        }
        if (message.showUsers !== undefined) {
            BoolValue.encode({ value: message.showUsers }, writer.uint32(66).fork()).ldelim();
        }
        if (message.sort !== undefined) {
            StringValue.encode({ value: message.sort }, writer.uint32(74).fork()).ldelim();
        }
        if (message.typeaheadActive !== undefined) {
            BoolValue.encode({ value: message.typeaheadActive }, writer.uint32(90).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSubredditsSearchRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.after = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.before = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.count = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.limit = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.q = reader.string();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.searchQueryId = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.show = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.showUsers = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 9:
                    if (tag !== 74) {
                        break;
                    }
                    message.sort = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 11:
                    if (tag !== 90) {
                        break;
                    }
                    message.typeaheadActive = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            after: isSet(object.after) ? String(object.after) : undefined,
            before: isSet(object.before) ? String(object.before) : undefined,
            count: isSet(object.count) ? Number(object.count) : undefined,
            limit: isSet(object.limit) ? Number(object.limit) : undefined,
            q: isSet(object.q) ? globalThis.String(object.q) : "",
            searchQueryId: isSet(object.searchQueryId) ? String(object.searchQueryId) : undefined,
            show: isSet(object.show) ? String(object.show) : undefined,
            showUsers: isSet(object.showUsers) ? Boolean(object.showUsers) : undefined,
            sort: isSet(object.sort) ? String(object.sort) : undefined,
            typeaheadActive: isSet(object.typeaheadActive) ? Boolean(object.typeaheadActive) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.after !== undefined) {
            obj.after = message.after;
        }
        if (message.before !== undefined) {
            obj.before = message.before;
        }
        if (message.count !== undefined) {
            obj.count = message.count;
        }
        if (message.limit !== undefined) {
            obj.limit = message.limit;
        }
        if (message.q !== "") {
            obj.q = message.q;
        }
        if (message.searchQueryId !== undefined) {
            obj.searchQueryId = message.searchQueryId;
        }
        if (message.show !== undefined) {
            obj.show = message.show;
        }
        if (message.showUsers !== undefined) {
            obj.showUsers = message.showUsers;
        }
        if (message.sort !== undefined) {
            obj.sort = message.sort;
        }
        if (message.typeaheadActive !== undefined) {
            obj.typeaheadActive = message.typeaheadActive;
        }
        return obj;
    },
    create(base) {
        return SubredditsSearchRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSubredditsSearchRequest();
        message.after = object.after ?? undefined;
        message.before = object.before ?? undefined;
        message.count = object.count ?? undefined;
        message.limit = object.limit ?? undefined;
        message.q = object.q ?? "";
        message.searchQueryId = object.searchQueryId ?? undefined;
        message.show = object.show ?? undefined;
        message.showUsers = object.showUsers ?? undefined;
        message.sort = object.sort ?? undefined;
        message.typeaheadActive = object.typeaheadActive ?? undefined;
        return message;
    },
};
messageTypeRegistry.set(SubredditsSearchRequest.$type, SubredditsSearchRequest);
function createBaseUsersSearchRequest() {
    return {
        after: undefined,
        before: undefined,
        count: undefined,
        limit: undefined,
        q: "",
        searchQueryId: undefined,
        show: undefined,
        sort: undefined,
        typeaheadActive: undefined,
    };
}
export const UsersSearchRequest = {
    $type: "devvit.plugin.redditapi.subreddits.UsersSearchRequest",
    encode(message, writer = _m0.Writer.create()) {
        if (message.after !== undefined) {
            StringValue.encode({ value: message.after }, writer.uint32(10).fork()).ldelim();
        }
        if (message.before !== undefined) {
            StringValue.encode({ value: message.before }, writer.uint32(18).fork()).ldelim();
        }
        if (message.count !== undefined) {
            Int64Value.encode({ value: message.count }, writer.uint32(26).fork()).ldelim();
        }
        if (message.limit !== undefined) {
            Int64Value.encode({ value: message.limit }, writer.uint32(34).fork()).ldelim();
        }
        if (message.q !== "") {
            writer.uint32(42).string(message.q);
        }
        if (message.searchQueryId !== undefined) {
            StringValue.encode({ value: message.searchQueryId }, writer.uint32(50).fork()).ldelim();
        }
        if (message.show !== undefined) {
            StringValue.encode({ value: message.show }, writer.uint32(58).fork()).ldelim();
        }
        if (message.sort !== undefined) {
            StringValue.encode({ value: message.sort }, writer.uint32(66).fork()).ldelim();
        }
        if (message.typeaheadActive !== undefined) {
            BoolValue.encode({ value: message.typeaheadActive }, writer.uint32(82).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUsersSearchRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.after = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.before = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.count = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.limit = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.q = reader.string();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.searchQueryId = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.show = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.sort = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.typeaheadActive = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            after: isSet(object.after) ? String(object.after) : undefined,
            before: isSet(object.before) ? String(object.before) : undefined,
            count: isSet(object.count) ? Number(object.count) : undefined,
            limit: isSet(object.limit) ? Number(object.limit) : undefined,
            q: isSet(object.q) ? globalThis.String(object.q) : "",
            searchQueryId: isSet(object.searchQueryId) ? String(object.searchQueryId) : undefined,
            show: isSet(object.show) ? String(object.show) : undefined,
            sort: isSet(object.sort) ? String(object.sort) : undefined,
            typeaheadActive: isSet(object.typeaheadActive) ? Boolean(object.typeaheadActive) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.after !== undefined) {
            obj.after = message.after;
        }
        if (message.before !== undefined) {
            obj.before = message.before;
        }
        if (message.count !== undefined) {
            obj.count = message.count;
        }
        if (message.limit !== undefined) {
            obj.limit = message.limit;
        }
        if (message.q !== "") {
            obj.q = message.q;
        }
        if (message.searchQueryId !== undefined) {
            obj.searchQueryId = message.searchQueryId;
        }
        if (message.show !== undefined) {
            obj.show = message.show;
        }
        if (message.sort !== undefined) {
            obj.sort = message.sort;
        }
        if (message.typeaheadActive !== undefined) {
            obj.typeaheadActive = message.typeaheadActive;
        }
        return obj;
    },
    create(base) {
        return UsersSearchRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUsersSearchRequest();
        message.after = object.after ?? undefined;
        message.before = object.before ?? undefined;
        message.count = object.count ?? undefined;
        message.limit = object.limit ?? undefined;
        message.q = object.q ?? "";
        message.searchQueryId = object.searchQueryId ?? undefined;
        message.show = object.show ?? undefined;
        message.sort = object.sort ?? undefined;
        message.typeaheadActive = object.typeaheadActive ?? undefined;
        return message;
    },
};
messageTypeRegistry.set(UsersSearchRequest.$type, UsersSearchRequest);
function createBaseSearchRedditNamesResponse() {
    return { names: [] };
}
export const SearchRedditNamesResponse = {
    $type: "devvit.plugin.redditapi.subreddits.SearchRedditNamesResponse",
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.names) {
            StringValue.encode({ value: v }, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSearchRedditNamesResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.names.push(StringValue.decode(reader, reader.uint32()).value);
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { names: globalThis.Array.isArray(object?.names) ? object.names.map((e) => String(e)) : [] };
    },
    toJSON(message) {
        const obj = {};
        if (message.names?.length) {
            obj.names = message.names;
        }
        return obj;
    },
    create(base) {
        return SearchRedditNamesResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSearchRedditNamesResponse();
        message.names = object.names?.map((e) => e) || [];
        return message;
    },
};
messageTypeRegistry.set(SearchRedditNamesResponse.$type, SearchRedditNamesResponse);
function createBaseSearchSubredditsResponse() {
    return { subreddits: [] };
}
export const SearchSubredditsResponse = {
    $type: "devvit.plugin.redditapi.subreddits.SearchSubredditsResponse",
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.subreddits) {
            SearchSubredditsResponse_SubredditData.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSearchSubredditsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.subreddits.push(SearchSubredditsResponse_SubredditData.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            subreddits: globalThis.Array.isArray(object?.subreddits)
                ? object.subreddits.map((e) => SearchSubredditsResponse_SubredditData.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.subreddits?.length) {
            obj.subreddits = message.subreddits.map((e) => SearchSubredditsResponse_SubredditData.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return SearchSubredditsResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSearchSubredditsResponse();
        message.subreddits = object.subreddits?.map((e) => SearchSubredditsResponse_SubredditData.fromPartial(e)) || [];
        return message;
    },
};
messageTypeRegistry.set(SearchSubredditsResponse.$type, SearchSubredditsResponse);
function createBaseSearchSubredditsResponse_SubredditData() {
    return {
        activeUserCount: undefined,
        iconImg: undefined,
        keyColor: undefined,
        name: undefined,
        subscriberCount: undefined,
        isChatPostFeatureEnabled: undefined,
        allowChatPostCreation: undefined,
        allowImages: undefined,
    };
}
export const SearchSubredditsResponse_SubredditData = {
    $type: "devvit.plugin.redditapi.subreddits.SearchSubredditsResponse.SubredditData",
    encode(message, writer = _m0.Writer.create()) {
        if (message.activeUserCount !== undefined) {
            Int32Value.encode({ value: message.activeUserCount }, writer.uint32(10).fork()).ldelim();
        }
        if (message.iconImg !== undefined) {
            StringValue.encode({ value: message.iconImg }, writer.uint32(18).fork()).ldelim();
        }
        if (message.keyColor !== undefined) {
            StringValue.encode({ value: message.keyColor }, writer.uint32(26).fork()).ldelim();
        }
        if (message.name !== undefined) {
            StringValue.encode({ value: message.name }, writer.uint32(34).fork()).ldelim();
        }
        if (message.subscriberCount !== undefined) {
            Int32Value.encode({ value: message.subscriberCount }, writer.uint32(42).fork()).ldelim();
        }
        if (message.isChatPostFeatureEnabled !== undefined) {
            BoolValue.encode({ value: message.isChatPostFeatureEnabled }, writer.uint32(50).fork()).ldelim();
        }
        if (message.allowChatPostCreation !== undefined) {
            BoolValue.encode({ value: message.allowChatPostCreation }, writer.uint32(58).fork()).ldelim();
        }
        if (message.allowImages !== undefined) {
            BoolValue.encode({ value: message.allowImages }, writer.uint32(66).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSearchSubredditsResponse_SubredditData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.activeUserCount = Int32Value.decode(reader, reader.uint32()).value;
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.iconImg = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.keyColor = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.name = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.subscriberCount = Int32Value.decode(reader, reader.uint32()).value;
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.isChatPostFeatureEnabled = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.allowChatPostCreation = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.allowImages = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            activeUserCount: isSet(object.activeUserCount) ? Number(object.activeUserCount) : undefined,
            iconImg: isSet(object.iconImg) ? String(object.iconImg) : undefined,
            keyColor: isSet(object.keyColor) ? String(object.keyColor) : undefined,
            name: isSet(object.name) ? String(object.name) : undefined,
            subscriberCount: isSet(object.subscriberCount) ? Number(object.subscriberCount) : undefined,
            isChatPostFeatureEnabled: isSet(object.isChatPostFeatureEnabled)
                ? Boolean(object.isChatPostFeatureEnabled)
                : undefined,
            allowChatPostCreation: isSet(object.allowChatPostCreation) ? Boolean(object.allowChatPostCreation) : undefined,
            allowImages: isSet(object.allowImages) ? Boolean(object.allowImages) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.activeUserCount !== undefined) {
            obj.activeUserCount = message.activeUserCount;
        }
        if (message.iconImg !== undefined) {
            obj.iconImg = message.iconImg;
        }
        if (message.keyColor !== undefined) {
            obj.keyColor = message.keyColor;
        }
        if (message.name !== undefined) {
            obj.name = message.name;
        }
        if (message.subscriberCount !== undefined) {
            obj.subscriberCount = message.subscriberCount;
        }
        if (message.isChatPostFeatureEnabled !== undefined) {
            obj.isChatPostFeatureEnabled = message.isChatPostFeatureEnabled;
        }
        if (message.allowChatPostCreation !== undefined) {
            obj.allowChatPostCreation = message.allowChatPostCreation;
        }
        if (message.allowImages !== undefined) {
            obj.allowImages = message.allowImages;
        }
        return obj;
    },
    create(base) {
        return SearchSubredditsResponse_SubredditData.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSearchSubredditsResponse_SubredditData();
        message.activeUserCount = object.activeUserCount ?? undefined;
        message.iconImg = object.iconImg ?? undefined;
        message.keyColor = object.keyColor ?? undefined;
        message.name = object.name ?? undefined;
        message.subscriberCount = object.subscriberCount ?? undefined;
        message.isChatPostFeatureEnabled = object.isChatPostFeatureEnabled ?? undefined;
        message.allowChatPostCreation = object.allowChatPostCreation ?? undefined;
        message.allowImages = object.allowImages ?? undefined;
        return message;
    },
};
messageTypeRegistry.set(SearchSubredditsResponse_SubredditData.$type, SearchSubredditsResponse_SubredditData);
function createBaseSubmitTextResponse() {
    return { submitText: undefined, submitTextHtml: undefined };
}
export const SubmitTextResponse = {
    $type: "devvit.plugin.redditapi.subreddits.SubmitTextResponse",
    encode(message, writer = _m0.Writer.create()) {
        if (message.submitText !== undefined) {
            StringValue.encode({ value: message.submitText }, writer.uint32(10).fork()).ldelim();
        }
        if (message.submitTextHtml !== undefined) {
            StringValue.encode({ value: message.submitTextHtml }, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSubmitTextResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.submitText = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.submitTextHtml = StringValue.decode(reader, reader.uint32()).value;
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            submitText: isSet(object.submitText) ? String(object.submitText) : undefined,
            submitTextHtml: isSet(object.submitTextHtml) ? String(object.submitTextHtml) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.submitText !== undefined) {
            obj.submitText = message.submitText;
        }
        if (message.submitTextHtml !== undefined) {
            obj.submitTextHtml = message.submitTextHtml;
        }
        return obj;
    },
    create(base) {
        return SubmitTextResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSubmitTextResponse();
        message.submitText = object.submitText ?? undefined;
        message.submitTextHtml = object.submitTextHtml ?? undefined;
        return message;
    },
};
messageTypeRegistry.set(SubmitTextResponse.$type, SubmitTextResponse);
function createBaseSubredditAutocompleteResponse() {
    return { kind: undefined, data: undefined };
}
export const SubredditAutocompleteResponse = {
    $type: "devvit.plugin.redditapi.subreddits.SubredditAutocompleteResponse",
    encode(message, writer = _m0.Writer.create()) {
        if (message.kind !== undefined) {
            StringValue.encode({ value: message.kind }, writer.uint32(10).fork()).ldelim();
        }
        if (message.data !== undefined) {
            SubredditAutocompleteResponse_AutocompleteResponse.encode(message.data, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSubredditAutocompleteResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.kind = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.data = SubredditAutocompleteResponse_AutocompleteResponse.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            kind: isSet(object.kind) ? String(object.kind) : undefined,
            data: isSet(object.data) ? SubredditAutocompleteResponse_AutocompleteResponse.fromJSON(object.data) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.kind !== undefined) {
            obj.kind = message.kind;
        }
        if (message.data !== undefined) {
            obj.data = SubredditAutocompleteResponse_AutocompleteResponse.toJSON(message.data);
        }
        return obj;
    },
    create(base) {
        return SubredditAutocompleteResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSubredditAutocompleteResponse();
        message.kind = object.kind ?? undefined;
        message.data = (object.data !== undefined && object.data !== null)
            ? SubredditAutocompleteResponse_AutocompleteResponse.fromPartial(object.data)
            : undefined;
        return message;
    },
};
messageTypeRegistry.set(SubredditAutocompleteResponse.$type, SubredditAutocompleteResponse);
function createBaseSubredditAutocompleteResponse_AutocompleteAccount() {
    return {
        isEmployee: undefined,
        isFriend: undefined,
        snoovatarSize: undefined,
        id: undefined,
        verified: undefined,
        isGold: undefined,
        isMod: undefined,
        hasVerifiedEmail: undefined,
        iconImg: undefined,
        hideFromRobots: undefined,
        linkKarma: undefined,
        acceptChats: undefined,
        isBlocked: undefined,
        prefShowSnoovatar: undefined,
        name: undefined,
        created: undefined,
        createdUtc: undefined,
        snoovatarImg: undefined,
        commentKarma: undefined,
        acceptFollowers: undefined,
        hasSubscribed: undefined,
        acceptPms: undefined,
    };
}
export const SubredditAutocompleteResponse_AutocompleteAccount = {
    $type: "devvit.plugin.redditapi.subreddits.SubredditAutocompleteResponse.AutocompleteAccount",
    encode(message, writer = _m0.Writer.create()) {
        if (message.isEmployee !== undefined) {
            BoolValue.encode({ value: message.isEmployee }, writer.uint32(10).fork()).ldelim();
        }
        if (message.isFriend !== undefined) {
            BoolValue.encode({ value: message.isFriend }, writer.uint32(18).fork()).ldelim();
        }
        if (message.snoovatarSize !== undefined) {
            Int32Value.encode({ value: message.snoovatarSize }, writer.uint32(26).fork()).ldelim();
        }
        if (message.id !== undefined) {
            StringValue.encode({ value: message.id }, writer.uint32(34).fork()).ldelim();
        }
        if (message.verified !== undefined) {
            BoolValue.encode({ value: message.verified }, writer.uint32(42).fork()).ldelim();
        }
        if (message.isGold !== undefined) {
            BoolValue.encode({ value: message.isGold }, writer.uint32(50).fork()).ldelim();
        }
        if (message.isMod !== undefined) {
            BoolValue.encode({ value: message.isMod }, writer.uint32(58).fork()).ldelim();
        }
        if (message.hasVerifiedEmail !== undefined) {
            BoolValue.encode({ value: message.hasVerifiedEmail }, writer.uint32(66).fork()).ldelim();
        }
        if (message.iconImg !== undefined) {
            StringValue.encode({ value: message.iconImg }, writer.uint32(74).fork()).ldelim();
        }
        if (message.hideFromRobots !== undefined) {
            BoolValue.encode({ value: message.hideFromRobots }, writer.uint32(82).fork()).ldelim();
        }
        if (message.linkKarma !== undefined) {
            Int32Value.encode({ value: message.linkKarma }, writer.uint32(90).fork()).ldelim();
        }
        if (message.acceptChats !== undefined) {
            BoolValue.encode({ value: message.acceptChats }, writer.uint32(98).fork()).ldelim();
        }
        if (message.isBlocked !== undefined) {
            BoolValue.encode({ value: message.isBlocked }, writer.uint32(106).fork()).ldelim();
        }
        if (message.prefShowSnoovatar !== undefined) {
            BoolValue.encode({ value: message.prefShowSnoovatar }, writer.uint32(114).fork()).ldelim();
        }
        if (message.name !== undefined) {
            StringValue.encode({ value: message.name }, writer.uint32(122).fork()).ldelim();
        }
        if (message.created !== undefined) {
            Int64Value.encode({ value: message.created }, writer.uint32(130).fork()).ldelim();
        }
        if (message.createdUtc !== undefined) {
            Int64Value.encode({ value: message.createdUtc }, writer.uint32(138).fork()).ldelim();
        }
        if (message.snoovatarImg !== undefined) {
            StringValue.encode({ value: message.snoovatarImg }, writer.uint32(146).fork()).ldelim();
        }
        if (message.commentKarma !== undefined) {
            Int64Value.encode({ value: message.commentKarma }, writer.uint32(154).fork()).ldelim();
        }
        if (message.acceptFollowers !== undefined) {
            BoolValue.encode({ value: message.acceptFollowers }, writer.uint32(162).fork()).ldelim();
        }
        if (message.hasSubscribed !== undefined) {
            BoolValue.encode({ value: message.hasSubscribed }, writer.uint32(170).fork()).ldelim();
        }
        if (message.acceptPms !== undefined) {
            BoolValue.encode({ value: message.acceptPms }, writer.uint32(178).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSubredditAutocompleteResponse_AutocompleteAccount();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.isEmployee = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.isFriend = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.snoovatarSize = Int32Value.decode(reader, reader.uint32()).value;
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.id = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.verified = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.isGold = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.isMod = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.hasVerifiedEmail = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 9:
                    if (tag !== 74) {
                        break;
                    }
                    message.iconImg = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.hideFromRobots = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 11:
                    if (tag !== 90) {
                        break;
                    }
                    message.linkKarma = Int32Value.decode(reader, reader.uint32()).value;
                    continue;
                case 12:
                    if (tag !== 98) {
                        break;
                    }
                    message.acceptChats = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 13:
                    if (tag !== 106) {
                        break;
                    }
                    message.isBlocked = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 14:
                    if (tag !== 114) {
                        break;
                    }
                    message.prefShowSnoovatar = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 15:
                    if (tag !== 122) {
                        break;
                    }
                    message.name = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 16:
                    if (tag !== 130) {
                        break;
                    }
                    message.created = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 17:
                    if (tag !== 138) {
                        break;
                    }
                    message.createdUtc = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 18:
                    if (tag !== 146) {
                        break;
                    }
                    message.snoovatarImg = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 19:
                    if (tag !== 154) {
                        break;
                    }
                    message.commentKarma = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 20:
                    if (tag !== 162) {
                        break;
                    }
                    message.acceptFollowers = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 21:
                    if (tag !== 170) {
                        break;
                    }
                    message.hasSubscribed = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 22:
                    if (tag !== 178) {
                        break;
                    }
                    message.acceptPms = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            isEmployee: isSet(object.isEmployee) ? Boolean(object.isEmployee) : undefined,
            isFriend: isSet(object.isFriend) ? Boolean(object.isFriend) : undefined,
            snoovatarSize: isSet(object.snoovatarSize) ? Number(object.snoovatarSize) : undefined,
            id: isSet(object.id) ? String(object.id) : undefined,
            verified: isSet(object.verified) ? Boolean(object.verified) : undefined,
            isGold: isSet(object.isGold) ? Boolean(object.isGold) : undefined,
            isMod: isSet(object.isMod) ? Boolean(object.isMod) : undefined,
            hasVerifiedEmail: isSet(object.hasVerifiedEmail) ? Boolean(object.hasVerifiedEmail) : undefined,
            iconImg: isSet(object.iconImg) ? String(object.iconImg) : undefined,
            hideFromRobots: isSet(object.hideFromRobots) ? Boolean(object.hideFromRobots) : undefined,
            linkKarma: isSet(object.linkKarma) ? Number(object.linkKarma) : undefined,
            acceptChats: isSet(object.acceptChats) ? Boolean(object.acceptChats) : undefined,
            isBlocked: isSet(object.isBlocked) ? Boolean(object.isBlocked) : undefined,
            prefShowSnoovatar: isSet(object.prefShowSnoovatar) ? Boolean(object.prefShowSnoovatar) : undefined,
            name: isSet(object.name) ? String(object.name) : undefined,
            created: isSet(object.created) ? Number(object.created) : undefined,
            createdUtc: isSet(object.createdUtc) ? Number(object.createdUtc) : undefined,
            snoovatarImg: isSet(object.snoovatarImg) ? String(object.snoovatarImg) : undefined,
            commentKarma: isSet(object.commentKarma) ? Number(object.commentKarma) : undefined,
            acceptFollowers: isSet(object.acceptFollowers) ? Boolean(object.acceptFollowers) : undefined,
            hasSubscribed: isSet(object.hasSubscribed) ? Boolean(object.hasSubscribed) : undefined,
            acceptPms: isSet(object.acceptPms) ? Boolean(object.acceptPms) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.isEmployee !== undefined) {
            obj.isEmployee = message.isEmployee;
        }
        if (message.isFriend !== undefined) {
            obj.isFriend = message.isFriend;
        }
        if (message.snoovatarSize !== undefined) {
            obj.snoovatarSize = message.snoovatarSize;
        }
        if (message.id !== undefined) {
            obj.id = message.id;
        }
        if (message.verified !== undefined) {
            obj.verified = message.verified;
        }
        if (message.isGold !== undefined) {
            obj.isGold = message.isGold;
        }
        if (message.isMod !== undefined) {
            obj.isMod = message.isMod;
        }
        if (message.hasVerifiedEmail !== undefined) {
            obj.hasVerifiedEmail = message.hasVerifiedEmail;
        }
        if (message.iconImg !== undefined) {
            obj.iconImg = message.iconImg;
        }
        if (message.hideFromRobots !== undefined) {
            obj.hideFromRobots = message.hideFromRobots;
        }
        if (message.linkKarma !== undefined) {
            obj.linkKarma = message.linkKarma;
        }
        if (message.acceptChats !== undefined) {
            obj.acceptChats = message.acceptChats;
        }
        if (message.isBlocked !== undefined) {
            obj.isBlocked = message.isBlocked;
        }
        if (message.prefShowSnoovatar !== undefined) {
            obj.prefShowSnoovatar = message.prefShowSnoovatar;
        }
        if (message.name !== undefined) {
            obj.name = message.name;
        }
        if (message.created !== undefined) {
            obj.created = message.created;
        }
        if (message.createdUtc !== undefined) {
            obj.createdUtc = message.createdUtc;
        }
        if (message.snoovatarImg !== undefined) {
            obj.snoovatarImg = message.snoovatarImg;
        }
        if (message.commentKarma !== undefined) {
            obj.commentKarma = message.commentKarma;
        }
        if (message.acceptFollowers !== undefined) {
            obj.acceptFollowers = message.acceptFollowers;
        }
        if (message.hasSubscribed !== undefined) {
            obj.hasSubscribed = message.hasSubscribed;
        }
        if (message.acceptPms !== undefined) {
            obj.acceptPms = message.acceptPms;
        }
        return obj;
    },
    create(base) {
        return SubredditAutocompleteResponse_AutocompleteAccount.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSubredditAutocompleteResponse_AutocompleteAccount();
        message.isEmployee = object.isEmployee ?? undefined;
        message.isFriend = object.isFriend ?? undefined;
        message.snoovatarSize = object.snoovatarSize ?? undefined;
        message.id = object.id ?? undefined;
        message.verified = object.verified ?? undefined;
        message.isGold = object.isGold ?? undefined;
        message.isMod = object.isMod ?? undefined;
        message.hasVerifiedEmail = object.hasVerifiedEmail ?? undefined;
        message.iconImg = object.iconImg ?? undefined;
        message.hideFromRobots = object.hideFromRobots ?? undefined;
        message.linkKarma = object.linkKarma ?? undefined;
        message.acceptChats = object.acceptChats ?? undefined;
        message.isBlocked = object.isBlocked ?? undefined;
        message.prefShowSnoovatar = object.prefShowSnoovatar ?? undefined;
        message.name = object.name ?? undefined;
        message.created = object.created ?? undefined;
        message.createdUtc = object.createdUtc ?? undefined;
        message.snoovatarImg = object.snoovatarImg ?? undefined;
        message.commentKarma = object.commentKarma ?? undefined;
        message.acceptFollowers = object.acceptFollowers ?? undefined;
        message.hasSubscribed = object.hasSubscribed ?? undefined;
        message.acceptPms = object.acceptPms ?? undefined;
        return message;
    },
};
messageTypeRegistry.set(SubredditAutocompleteResponse_AutocompleteAccount.$type, SubredditAutocompleteResponse_AutocompleteAccount);
function createBaseSubredditAutocompleteResponse_AutocompleteAccount_Subreddit() {
    return {
        defaultSet: undefined,
        userIsContributor: undefined,
        bannerImg: undefined,
        allowedMediaInComments: [],
        userIsBanned: undefined,
        freeFormReports: undefined,
        communityIcon: undefined,
        showMedia: undefined,
        iconColor: undefined,
        userIsMuted: undefined,
        displayName: undefined,
        headerImg: undefined,
        title: undefined,
        previousNames: [],
        over18: undefined,
        iconSize: [],
        primaryColor: undefined,
        iconImg: undefined,
        description: undefined,
        submitLinkLabel: undefined,
        headerSize: undefined,
        restrictPosting: undefined,
        restrictCommenting: undefined,
        subscribers: undefined,
        submitTextLabel: undefined,
        isDefaultIcon: undefined,
        inkFlairPosition: undefined,
        displayNamePrefixed: undefined,
        keyColor: undefined,
        name: undefined,
        isDefaultBanner: undefined,
        url: undefined,
        quarantine: undefined,
        bannerSize: undefined,
        userIsModerator: undefined,
        acceptFollowers: undefined,
        publicDescription: undefined,
        linkFlairEnabled: undefined,
        disableContributorRequests: undefined,
        subredditType: undefined,
        userIsSubscriber: undefined,
    };
}
export const SubredditAutocompleteResponse_AutocompleteAccount_Subreddit = {
    $type: "devvit.plugin.redditapi.subreddits.SubredditAutocompleteResponse.AutocompleteAccount.Subreddit",
    encode(message, writer = _m0.Writer.create()) {
        if (message.defaultSet !== undefined) {
            BoolValue.encode({ value: message.defaultSet }, writer.uint32(10).fork()).ldelim();
        }
        if (message.userIsContributor !== undefined) {
            BoolValue.encode({ value: message.userIsContributor }, writer.uint32(18).fork()).ldelim();
        }
        if (message.bannerImg !== undefined) {
            StringValue.encode({ value: message.bannerImg }, writer.uint32(26).fork()).ldelim();
        }
        for (const v of message.allowedMediaInComments) {
            StringValue.encode({ value: v }, writer.uint32(34).fork()).ldelim();
        }
        if (message.userIsBanned !== undefined) {
            BoolValue.encode({ value: message.userIsBanned }, writer.uint32(42).fork()).ldelim();
        }
        if (message.freeFormReports !== undefined) {
            BoolValue.encode({ value: message.freeFormReports }, writer.uint32(50).fork()).ldelim();
        }
        if (message.communityIcon !== undefined) {
            StringValue.encode({ value: message.communityIcon }, writer.uint32(58).fork()).ldelim();
        }
        if (message.showMedia !== undefined) {
            BoolValue.encode({ value: message.showMedia }, writer.uint32(66).fork()).ldelim();
        }
        if (message.iconColor !== undefined) {
            StringValue.encode({ value: message.iconColor }, writer.uint32(74).fork()).ldelim();
        }
        if (message.userIsMuted !== undefined) {
            BoolValue.encode({ value: message.userIsMuted }, writer.uint32(82).fork()).ldelim();
        }
        if (message.displayName !== undefined) {
            StringValue.encode({ value: message.displayName }, writer.uint32(90).fork()).ldelim();
        }
        if (message.headerImg !== undefined) {
            StringValue.encode({ value: message.headerImg }, writer.uint32(98).fork()).ldelim();
        }
        if (message.title !== undefined) {
            StringValue.encode({ value: message.title }, writer.uint32(106).fork()).ldelim();
        }
        for (const v of message.previousNames) {
            StringValue.encode({ value: v }, writer.uint32(114).fork()).ldelim();
        }
        if (message.over18 !== undefined) {
            BoolValue.encode({ value: message.over18 }, writer.uint32(122).fork()).ldelim();
        }
        for (const v of message.iconSize) {
            Int32Value.encode({ value: v }, writer.uint32(130).fork()).ldelim();
        }
        if (message.primaryColor !== undefined) {
            StringValue.encode({ value: message.primaryColor }, writer.uint32(138).fork()).ldelim();
        }
        if (message.iconImg !== undefined) {
            StringValue.encode({ value: message.iconImg }, writer.uint32(146).fork()).ldelim();
        }
        if (message.description !== undefined) {
            StringValue.encode({ value: message.description }, writer.uint32(154).fork()).ldelim();
        }
        if (message.submitLinkLabel !== undefined) {
            StringValue.encode({ value: message.submitLinkLabel }, writer.uint32(162).fork()).ldelim();
        }
        if (message.headerSize !== undefined) {
            Int32Value.encode({ value: message.headerSize }, writer.uint32(170).fork()).ldelim();
        }
        if (message.restrictPosting !== undefined) {
            BoolValue.encode({ value: message.restrictPosting }, writer.uint32(178).fork()).ldelim();
        }
        if (message.restrictCommenting !== undefined) {
            BoolValue.encode({ value: message.restrictCommenting }, writer.uint32(186).fork()).ldelim();
        }
        if (message.subscribers !== undefined) {
            Int64Value.encode({ value: message.subscribers }, writer.uint32(194).fork()).ldelim();
        }
        if (message.submitTextLabel !== undefined) {
            StringValue.encode({ value: message.submitTextLabel }, writer.uint32(202).fork()).ldelim();
        }
        if (message.isDefaultIcon !== undefined) {
            BoolValue.encode({ value: message.isDefaultIcon }, writer.uint32(210).fork()).ldelim();
        }
        if (message.inkFlairPosition !== undefined) {
            StringValue.encode({ value: message.inkFlairPosition }, writer.uint32(218).fork()).ldelim();
        }
        if (message.displayNamePrefixed !== undefined) {
            StringValue.encode({ value: message.displayNamePrefixed }, writer.uint32(226).fork()).ldelim();
        }
        if (message.keyColor !== undefined) {
            StringValue.encode({ value: message.keyColor }, writer.uint32(234).fork()).ldelim();
        }
        if (message.name !== undefined) {
            StringValue.encode({ value: message.name }, writer.uint32(242).fork()).ldelim();
        }
        if (message.isDefaultBanner !== undefined) {
            BoolValue.encode({ value: message.isDefaultBanner }, writer.uint32(250).fork()).ldelim();
        }
        if (message.url !== undefined) {
            StringValue.encode({ value: message.url }, writer.uint32(258).fork()).ldelim();
        }
        if (message.quarantine !== undefined) {
            BoolValue.encode({ value: message.quarantine }, writer.uint32(266).fork()).ldelim();
        }
        if (message.bannerSize !== undefined) {
            Int32Value.encode({ value: message.bannerSize }, writer.uint32(274).fork()).ldelim();
        }
        if (message.userIsModerator !== undefined) {
            BoolValue.encode({ value: message.userIsModerator }, writer.uint32(282).fork()).ldelim();
        }
        if (message.acceptFollowers !== undefined) {
            BoolValue.encode({ value: message.acceptFollowers }, writer.uint32(290).fork()).ldelim();
        }
        if (message.publicDescription !== undefined) {
            StringValue.encode({ value: message.publicDescription }, writer.uint32(298).fork()).ldelim();
        }
        if (message.linkFlairEnabled !== undefined) {
            BoolValue.encode({ value: message.linkFlairEnabled }, writer.uint32(306).fork()).ldelim();
        }
        if (message.disableContributorRequests !== undefined) {
            BoolValue.encode({ value: message.disableContributorRequests }, writer.uint32(314).fork()).ldelim();
        }
        if (message.subredditType !== undefined) {
            StringValue.encode({ value: message.subredditType }, writer.uint32(322).fork()).ldelim();
        }
        if (message.userIsSubscriber !== undefined) {
            BoolValue.encode({ value: message.userIsSubscriber }, writer.uint32(330).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSubredditAutocompleteResponse_AutocompleteAccount_Subreddit();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.defaultSet = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.userIsContributor = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.bannerImg = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.allowedMediaInComments.push(StringValue.decode(reader, reader.uint32()).value);
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.userIsBanned = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.freeFormReports = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.communityIcon = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.showMedia = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 9:
                    if (tag !== 74) {
                        break;
                    }
                    message.iconColor = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.userIsMuted = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 11:
                    if (tag !== 90) {
                        break;
                    }
                    message.displayName = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 12:
                    if (tag !== 98) {
                        break;
                    }
                    message.headerImg = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 13:
                    if (tag !== 106) {
                        break;
                    }
                    message.title = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 14:
                    if (tag !== 114) {
                        break;
                    }
                    message.previousNames.push(StringValue.decode(reader, reader.uint32()).value);
                    continue;
                case 15:
                    if (tag !== 122) {
                        break;
                    }
                    message.over18 = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 16:
                    if (tag !== 130) {
                        break;
                    }
                    message.iconSize.push(Int32Value.decode(reader, reader.uint32()).value);
                    continue;
                case 17:
                    if (tag !== 138) {
                        break;
                    }
                    message.primaryColor = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 18:
                    if (tag !== 146) {
                        break;
                    }
                    message.iconImg = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 19:
                    if (tag !== 154) {
                        break;
                    }
                    message.description = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 20:
                    if (tag !== 162) {
                        break;
                    }
                    message.submitLinkLabel = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 21:
                    if (tag !== 170) {
                        break;
                    }
                    message.headerSize = Int32Value.decode(reader, reader.uint32()).value;
                    continue;
                case 22:
                    if (tag !== 178) {
                        break;
                    }
                    message.restrictPosting = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 23:
                    if (tag !== 186) {
                        break;
                    }
                    message.restrictCommenting = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 24:
                    if (tag !== 194) {
                        break;
                    }
                    message.subscribers = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 25:
                    if (tag !== 202) {
                        break;
                    }
                    message.submitTextLabel = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 26:
                    if (tag !== 210) {
                        break;
                    }
                    message.isDefaultIcon = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 27:
                    if (tag !== 218) {
                        break;
                    }
                    message.inkFlairPosition = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 28:
                    if (tag !== 226) {
                        break;
                    }
                    message.displayNamePrefixed = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 29:
                    if (tag !== 234) {
                        break;
                    }
                    message.keyColor = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 30:
                    if (tag !== 242) {
                        break;
                    }
                    message.name = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 31:
                    if (tag !== 250) {
                        break;
                    }
                    message.isDefaultBanner = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 32:
                    if (tag !== 258) {
                        break;
                    }
                    message.url = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 33:
                    if (tag !== 266) {
                        break;
                    }
                    message.quarantine = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 34:
                    if (tag !== 274) {
                        break;
                    }
                    message.bannerSize = Int32Value.decode(reader, reader.uint32()).value;
                    continue;
                case 35:
                    if (tag !== 282) {
                        break;
                    }
                    message.userIsModerator = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 36:
                    if (tag !== 290) {
                        break;
                    }
                    message.acceptFollowers = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 37:
                    if (tag !== 298) {
                        break;
                    }
                    message.publicDescription = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 38:
                    if (tag !== 306) {
                        break;
                    }
                    message.linkFlairEnabled = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 39:
                    if (tag !== 314) {
                        break;
                    }
                    message.disableContributorRequests = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 40:
                    if (tag !== 322) {
                        break;
                    }
                    message.subredditType = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 41:
                    if (tag !== 330) {
                        break;
                    }
                    message.userIsSubscriber = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            defaultSet: isSet(object.defaultSet) ? Boolean(object.defaultSet) : undefined,
            userIsContributor: isSet(object.userIsContributor) ? Boolean(object.userIsContributor) : undefined,
            bannerImg: isSet(object.bannerImg) ? String(object.bannerImg) : undefined,
            allowedMediaInComments: globalThis.Array.isArray(object?.allowedMediaInComments)
                ? object.allowedMediaInComments.map((e) => String(e))
                : [],
            userIsBanned: isSet(object.userIsBanned) ? Boolean(object.userIsBanned) : undefined,
            freeFormReports: isSet(object.freeFormReports) ? Boolean(object.freeFormReports) : undefined,
            communityIcon: isSet(object.communityIcon) ? String(object.communityIcon) : undefined,
            showMedia: isSet(object.showMedia) ? Boolean(object.showMedia) : undefined,
            iconColor: isSet(object.iconColor) ? String(object.iconColor) : undefined,
            userIsMuted: isSet(object.userIsMuted) ? Boolean(object.userIsMuted) : undefined,
            displayName: isSet(object.displayName) ? String(object.displayName) : undefined,
            headerImg: isSet(object.headerImg) ? String(object.headerImg) : undefined,
            title: isSet(object.title) ? String(object.title) : undefined,
            previousNames: globalThis.Array.isArray(object?.previousNames)
                ? object.previousNames.map((e) => String(e))
                : [],
            over18: isSet(object.over18) ? Boolean(object.over18) : undefined,
            iconSize: globalThis.Array.isArray(object?.iconSize) ? object.iconSize.map((e) => Number(e)) : [],
            primaryColor: isSet(object.primaryColor) ? String(object.primaryColor) : undefined,
            iconImg: isSet(object.iconImg) ? String(object.iconImg) : undefined,
            description: isSet(object.description) ? String(object.description) : undefined,
            submitLinkLabel: isSet(object.submitLinkLabel) ? String(object.submitLinkLabel) : undefined,
            headerSize: isSet(object.headerSize) ? Number(object.headerSize) : undefined,
            restrictPosting: isSet(object.restrictPosting) ? Boolean(object.restrictPosting) : undefined,
            restrictCommenting: isSet(object.restrictCommenting) ? Boolean(object.restrictCommenting) : undefined,
            subscribers: isSet(object.subscribers) ? Number(object.subscribers) : undefined,
            submitTextLabel: isSet(object.submitTextLabel) ? String(object.submitTextLabel) : undefined,
            isDefaultIcon: isSet(object.isDefaultIcon) ? Boolean(object.isDefaultIcon) : undefined,
            inkFlairPosition: isSet(object.inkFlairPosition) ? String(object.inkFlairPosition) : undefined,
            displayNamePrefixed: isSet(object.displayNamePrefixed) ? String(object.displayNamePrefixed) : undefined,
            keyColor: isSet(object.keyColor) ? String(object.keyColor) : undefined,
            name: isSet(object.name) ? String(object.name) : undefined,
            isDefaultBanner: isSet(object.isDefaultBanner) ? Boolean(object.isDefaultBanner) : undefined,
            url: isSet(object.url) ? String(object.url) : undefined,
            quarantine: isSet(object.quarantine) ? Boolean(object.quarantine) : undefined,
            bannerSize: isSet(object.bannerSize) ? Number(object.bannerSize) : undefined,
            userIsModerator: isSet(object.userIsModerator) ? Boolean(object.userIsModerator) : undefined,
            acceptFollowers: isSet(object.acceptFollowers) ? Boolean(object.acceptFollowers) : undefined,
            publicDescription: isSet(object.publicDescription) ? String(object.publicDescription) : undefined,
            linkFlairEnabled: isSet(object.linkFlairEnabled) ? Boolean(object.linkFlairEnabled) : undefined,
            disableContributorRequests: isSet(object.disableContributorRequests)
                ? Boolean(object.disableContributorRequests)
                : undefined,
            subredditType: isSet(object.subredditType) ? String(object.subredditType) : undefined,
            userIsSubscriber: isSet(object.userIsSubscriber) ? Boolean(object.userIsSubscriber) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.defaultSet !== undefined) {
            obj.defaultSet = message.defaultSet;
        }
        if (message.userIsContributor !== undefined) {
            obj.userIsContributor = message.userIsContributor;
        }
        if (message.bannerImg !== undefined) {
            obj.bannerImg = message.bannerImg;
        }
        if (message.allowedMediaInComments?.length) {
            obj.allowedMediaInComments = message.allowedMediaInComments;
        }
        if (message.userIsBanned !== undefined) {
            obj.userIsBanned = message.userIsBanned;
        }
        if (message.freeFormReports !== undefined) {
            obj.freeFormReports = message.freeFormReports;
        }
        if (message.communityIcon !== undefined) {
            obj.communityIcon = message.communityIcon;
        }
        if (message.showMedia !== undefined) {
            obj.showMedia = message.showMedia;
        }
        if (message.iconColor !== undefined) {
            obj.iconColor = message.iconColor;
        }
        if (message.userIsMuted !== undefined) {
            obj.userIsMuted = message.userIsMuted;
        }
        if (message.displayName !== undefined) {
            obj.displayName = message.displayName;
        }
        if (message.headerImg !== undefined) {
            obj.headerImg = message.headerImg;
        }
        if (message.title !== undefined) {
            obj.title = message.title;
        }
        if (message.previousNames?.length) {
            obj.previousNames = message.previousNames;
        }
        if (message.over18 !== undefined) {
            obj.over18 = message.over18;
        }
        if (message.iconSize?.length) {
            obj.iconSize = message.iconSize;
        }
        if (message.primaryColor !== undefined) {
            obj.primaryColor = message.primaryColor;
        }
        if (message.iconImg !== undefined) {
            obj.iconImg = message.iconImg;
        }
        if (message.description !== undefined) {
            obj.description = message.description;
        }
        if (message.submitLinkLabel !== undefined) {
            obj.submitLinkLabel = message.submitLinkLabel;
        }
        if (message.headerSize !== undefined) {
            obj.headerSize = message.headerSize;
        }
        if (message.restrictPosting !== undefined) {
            obj.restrictPosting = message.restrictPosting;
        }
        if (message.restrictCommenting !== undefined) {
            obj.restrictCommenting = message.restrictCommenting;
        }
        if (message.subscribers !== undefined) {
            obj.subscribers = message.subscribers;
        }
        if (message.submitTextLabel !== undefined) {
            obj.submitTextLabel = message.submitTextLabel;
        }
        if (message.isDefaultIcon !== undefined) {
            obj.isDefaultIcon = message.isDefaultIcon;
        }
        if (message.inkFlairPosition !== undefined) {
            obj.inkFlairPosition = message.inkFlairPosition;
        }
        if (message.displayNamePrefixed !== undefined) {
            obj.displayNamePrefixed = message.displayNamePrefixed;
        }
        if (message.keyColor !== undefined) {
            obj.keyColor = message.keyColor;
        }
        if (message.name !== undefined) {
            obj.name = message.name;
        }
        if (message.isDefaultBanner !== undefined) {
            obj.isDefaultBanner = message.isDefaultBanner;
        }
        if (message.url !== undefined) {
            obj.url = message.url;
        }
        if (message.quarantine !== undefined) {
            obj.quarantine = message.quarantine;
        }
        if (message.bannerSize !== undefined) {
            obj.bannerSize = message.bannerSize;
        }
        if (message.userIsModerator !== undefined) {
            obj.userIsModerator = message.userIsModerator;
        }
        if (message.acceptFollowers !== undefined) {
            obj.acceptFollowers = message.acceptFollowers;
        }
        if (message.publicDescription !== undefined) {
            obj.publicDescription = message.publicDescription;
        }
        if (message.linkFlairEnabled !== undefined) {
            obj.linkFlairEnabled = message.linkFlairEnabled;
        }
        if (message.disableContributorRequests !== undefined) {
            obj.disableContributorRequests = message.disableContributorRequests;
        }
        if (message.subredditType !== undefined) {
            obj.subredditType = message.subredditType;
        }
        if (message.userIsSubscriber !== undefined) {
            obj.userIsSubscriber = message.userIsSubscriber;
        }
        return obj;
    },
    create(base) {
        return SubredditAutocompleteResponse_AutocompleteAccount_Subreddit.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSubredditAutocompleteResponse_AutocompleteAccount_Subreddit();
        message.defaultSet = object.defaultSet ?? undefined;
        message.userIsContributor = object.userIsContributor ?? undefined;
        message.bannerImg = object.bannerImg ?? undefined;
        message.allowedMediaInComments = object.allowedMediaInComments?.map((e) => e) || [];
        message.userIsBanned = object.userIsBanned ?? undefined;
        message.freeFormReports = object.freeFormReports ?? undefined;
        message.communityIcon = object.communityIcon ?? undefined;
        message.showMedia = object.showMedia ?? undefined;
        message.iconColor = object.iconColor ?? undefined;
        message.userIsMuted = object.userIsMuted ?? undefined;
        message.displayName = object.displayName ?? undefined;
        message.headerImg = object.headerImg ?? undefined;
        message.title = object.title ?? undefined;
        message.previousNames = object.previousNames?.map((e) => e) || [];
        message.over18 = object.over18 ?? undefined;
        message.iconSize = object.iconSize?.map((e) => e) || [];
        message.primaryColor = object.primaryColor ?? undefined;
        message.iconImg = object.iconImg ?? undefined;
        message.description = object.description ?? undefined;
        message.submitLinkLabel = object.submitLinkLabel ?? undefined;
        message.headerSize = object.headerSize ?? undefined;
        message.restrictPosting = object.restrictPosting ?? undefined;
        message.restrictCommenting = object.restrictCommenting ?? undefined;
        message.subscribers = object.subscribers ?? undefined;
        message.submitTextLabel = object.submitTextLabel ?? undefined;
        message.isDefaultIcon = object.isDefaultIcon ?? undefined;
        message.inkFlairPosition = object.inkFlairPosition ?? undefined;
        message.displayNamePrefixed = object.displayNamePrefixed ?? undefined;
        message.keyColor = object.keyColor ?? undefined;
        message.name = object.name ?? undefined;
        message.isDefaultBanner = object.isDefaultBanner ?? undefined;
        message.url = object.url ?? undefined;
        message.quarantine = object.quarantine ?? undefined;
        message.bannerSize = object.bannerSize ?? undefined;
        message.userIsModerator = object.userIsModerator ?? undefined;
        message.acceptFollowers = object.acceptFollowers ?? undefined;
        message.publicDescription = object.publicDescription ?? undefined;
        message.linkFlairEnabled = object.linkFlairEnabled ?? undefined;
        message.disableContributorRequests = object.disableContributorRequests ?? undefined;
        message.subredditType = object.subredditType ?? undefined;
        message.userIsSubscriber = object.userIsSubscriber ?? undefined;
        return message;
    },
};
messageTypeRegistry.set(SubredditAutocompleteResponse_AutocompleteAccount_Subreddit.$type, SubredditAutocompleteResponse_AutocompleteAccount_Subreddit);
function createBaseSubredditAutocompleteResponse_WrappedAutoCompleteSubreddit() {
    return { kind: "", data: undefined };
}
export const SubredditAutocompleteResponse_WrappedAutoCompleteSubreddit = {
    $type: "devvit.plugin.redditapi.subreddits.SubredditAutocompleteResponse.WrappedAutoCompleteSubreddit",
    encode(message, writer = _m0.Writer.create()) {
        if (message.kind !== "") {
            writer.uint32(10).string(message.kind);
        }
        if (message.data !== undefined) {
            FullSubredditObject.encode(message.data, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSubredditAutocompleteResponse_WrappedAutoCompleteSubreddit();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.kind = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.data = FullSubredditObject.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            kind: isSet(object.kind) ? globalThis.String(object.kind) : "",
            data: isSet(object.data) ? FullSubredditObject.fromJSON(object.data) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.kind !== "") {
            obj.kind = message.kind;
        }
        if (message.data !== undefined) {
            obj.data = FullSubredditObject.toJSON(message.data);
        }
        return obj;
    },
    create(base) {
        return SubredditAutocompleteResponse_WrappedAutoCompleteSubreddit.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSubredditAutocompleteResponse_WrappedAutoCompleteSubreddit();
        message.kind = object.kind ?? "";
        message.data = (object.data !== undefined && object.data !== null)
            ? FullSubredditObject.fromPartial(object.data)
            : undefined;
        return message;
    },
};
messageTypeRegistry.set(SubredditAutocompleteResponse_WrappedAutoCompleteSubreddit.$type, SubredditAutocompleteResponse_WrappedAutoCompleteSubreddit);
function createBaseSubredditAutocompleteResponse_WrappedAutoCompleteAccount() {
    return { kind: "", data: undefined };
}
export const SubredditAutocompleteResponse_WrappedAutoCompleteAccount = {
    $type: "devvit.plugin.redditapi.subreddits.SubredditAutocompleteResponse.WrappedAutoCompleteAccount",
    encode(message, writer = _m0.Writer.create()) {
        if (message.kind !== "") {
            writer.uint32(10).string(message.kind);
        }
        if (message.data !== undefined) {
            SubredditAutocompleteResponse_AutocompleteAccount.encode(message.data, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSubredditAutocompleteResponse_WrappedAutoCompleteAccount();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.kind = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.data = SubredditAutocompleteResponse_AutocompleteAccount.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            kind: isSet(object.kind) ? globalThis.String(object.kind) : "",
            data: isSet(object.data) ? SubredditAutocompleteResponse_AutocompleteAccount.fromJSON(object.data) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.kind !== "") {
            obj.kind = message.kind;
        }
        if (message.data !== undefined) {
            obj.data = SubredditAutocompleteResponse_AutocompleteAccount.toJSON(message.data);
        }
        return obj;
    },
    create(base) {
        return SubredditAutocompleteResponse_WrappedAutoCompleteAccount.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSubredditAutocompleteResponse_WrappedAutoCompleteAccount();
        message.kind = object.kind ?? "";
        message.data = (object.data !== undefined && object.data !== null)
            ? SubredditAutocompleteResponse_AutocompleteAccount.fromPartial(object.data)
            : undefined;
        return message;
    },
};
messageTypeRegistry.set(SubredditAutocompleteResponse_WrappedAutoCompleteAccount.$type, SubredditAutocompleteResponse_WrappedAutoCompleteAccount);
function createBaseSubredditAutocompleteResponse_AutocompleteResponse() {
    return { after: undefined, before: undefined, dist: undefined, childrenSubreddits: [], childrenAccounts: [] };
}
export const SubredditAutocompleteResponse_AutocompleteResponse = {
    $type: "devvit.plugin.redditapi.subreddits.SubredditAutocompleteResponse.AutocompleteResponse",
    encode(message, writer = _m0.Writer.create()) {
        if (message.after !== undefined) {
            StringValue.encode({ value: message.after }, writer.uint32(10).fork()).ldelim();
        }
        if (message.before !== undefined) {
            StringValue.encode({ value: message.before }, writer.uint32(18).fork()).ldelim();
        }
        if (message.dist !== undefined) {
            Int32Value.encode({ value: message.dist }, writer.uint32(26).fork()).ldelim();
        }
        for (const v of message.childrenSubreddits) {
            SubredditAutocompleteResponse_WrappedAutoCompleteSubreddit.encode(v, writer.uint32(34).fork()).ldelim();
        }
        for (const v of message.childrenAccounts) {
            SubredditAutocompleteResponse_WrappedAutoCompleteAccount.encode(v, writer.uint32(42).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSubredditAutocompleteResponse_AutocompleteResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.after = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.before = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.dist = Int32Value.decode(reader, reader.uint32()).value;
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.childrenSubreddits.push(SubredditAutocompleteResponse_WrappedAutoCompleteSubreddit.decode(reader, reader.uint32()));
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.childrenAccounts.push(SubredditAutocompleteResponse_WrappedAutoCompleteAccount.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            after: isSet(object.after) ? String(object.after) : undefined,
            before: isSet(object.before) ? String(object.before) : undefined,
            dist: isSet(object.dist) ? Number(object.dist) : undefined,
            childrenSubreddits: globalThis.Array.isArray(object?.childrenSubreddits)
                ? object.childrenSubreddits.map((e) => SubredditAutocompleteResponse_WrappedAutoCompleteSubreddit.fromJSON(e))
                : [],
            childrenAccounts: globalThis.Array.isArray(object?.childrenAccounts)
                ? object.childrenAccounts.map((e) => SubredditAutocompleteResponse_WrappedAutoCompleteAccount.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.after !== undefined) {
            obj.after = message.after;
        }
        if (message.before !== undefined) {
            obj.before = message.before;
        }
        if (message.dist !== undefined) {
            obj.dist = message.dist;
        }
        if (message.childrenSubreddits?.length) {
            obj.childrenSubreddits = message.childrenSubreddits.map((e) => SubredditAutocompleteResponse_WrappedAutoCompleteSubreddit.toJSON(e));
        }
        if (message.childrenAccounts?.length) {
            obj.childrenAccounts = message.childrenAccounts.map((e) => SubredditAutocompleteResponse_WrappedAutoCompleteAccount.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return SubredditAutocompleteResponse_AutocompleteResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSubredditAutocompleteResponse_AutocompleteResponse();
        message.after = object.after ?? undefined;
        message.before = object.before ?? undefined;
        message.dist = object.dist ?? undefined;
        message.childrenSubreddits =
            object.childrenSubreddits?.map((e) => SubredditAutocompleteResponse_WrappedAutoCompleteSubreddit.fromPartial(e)) || [];
        message.childrenAccounts =
            object.childrenAccounts?.map((e) => SubredditAutocompleteResponse_WrappedAutoCompleteAccount.fromPartial(e)) ||
                [];
        return message;
    },
};
messageTypeRegistry.set(SubredditAutocompleteResponse_AutocompleteResponse.$type, SubredditAutocompleteResponse_AutocompleteResponse);
function createBaseUploadSrImgResponse() {
    return { errors: [], imgSrc: undefined, errorsValues: [] };
}
export const UploadSrImgResponse = {
    $type: "devvit.plugin.redditapi.subreddits.UploadSrImgResponse",
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.errors) {
            StringValue.encode({ value: v }, writer.uint32(10).fork()).ldelim();
        }
        if (message.imgSrc !== undefined) {
            StringValue.encode({ value: message.imgSrc }, writer.uint32(18).fork()).ldelim();
        }
        for (const v of message.errorsValues) {
            StringValue.encode({ value: v }, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUploadSrImgResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.errors.push(StringValue.decode(reader, reader.uint32()).value);
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.imgSrc = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.errorsValues.push(StringValue.decode(reader, reader.uint32()).value);
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            errors: globalThis.Array.isArray(object?.errors) ? object.errors.map((e) => String(e)) : [],
            imgSrc: isSet(object.imgSrc) ? String(object.imgSrc) : undefined,
            errorsValues: globalThis.Array.isArray(object?.errorsValues)
                ? object.errorsValues.map((e) => String(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.errors?.length) {
            obj.errors = message.errors;
        }
        if (message.imgSrc !== undefined) {
            obj.imgSrc = message.imgSrc;
        }
        if (message.errorsValues?.length) {
            obj.errorsValues = message.errorsValues;
        }
        return obj;
    },
    create(base) {
        return UploadSrImgResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUploadSrImgResponse();
        message.errors = object.errors?.map((e) => e) || [];
        message.imgSrc = object.imgSrc ?? undefined;
        message.errorsValues = object.errorsValues?.map((e) => e) || [];
        return message;
    },
};
messageTypeRegistry.set(UploadSrImgResponse.$type, UploadSrImgResponse);
function createBaseSubredditPostRequirementsResponse() {
    return {
        titleRegexes: [],
        bodyBlacklistedStrings: [],
        titleBlacklistedStrings: [],
        bodyTextMaxLength: undefined,
        titleRequiredStrings: [],
        guidelinesText: undefined,
        galleryMinItems: undefined,
        domainBlacklist: [],
        domainWhitelist: [],
        titleTextMaxLength: undefined,
        bodyRestrictionPolicy: undefined,
        linkRestrictionPolicy: undefined,
        guidelinesDisplayPolicy: undefined,
        bodyRequiredStrings: [],
        titleTextMinLength: undefined,
        galleryCaptionsRequirement: undefined,
        isFlairRequired: undefined,
        galleryMaxItems: undefined,
        galleryUrlsRequirement: undefined,
        bodyRegexes: [],
        linkRepostAge: undefined,
        bodyTextMinLength: undefined,
    };
}
export const SubredditPostRequirementsResponse = {
    $type: "devvit.plugin.redditapi.subreddits.SubredditPostRequirementsResponse",
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.titleRegexes) {
            StringValue.encode({ value: v }, writer.uint32(10).fork()).ldelim();
        }
        for (const v of message.bodyBlacklistedStrings) {
            StringValue.encode({ value: v }, writer.uint32(18).fork()).ldelim();
        }
        for (const v of message.titleBlacklistedStrings) {
            StringValue.encode({ value: v }, writer.uint32(26).fork()).ldelim();
        }
        if (message.bodyTextMaxLength !== undefined) {
            Int32Value.encode({ value: message.bodyTextMaxLength }, writer.uint32(34).fork()).ldelim();
        }
        for (const v of message.titleRequiredStrings) {
            StringValue.encode({ value: v }, writer.uint32(42).fork()).ldelim();
        }
        if (message.guidelinesText !== undefined) {
            StringValue.encode({ value: message.guidelinesText }, writer.uint32(50).fork()).ldelim();
        }
        if (message.galleryMinItems !== undefined) {
            Int32Value.encode({ value: message.galleryMinItems }, writer.uint32(58).fork()).ldelim();
        }
        for (const v of message.domainBlacklist) {
            StringValue.encode({ value: v }, writer.uint32(66).fork()).ldelim();
        }
        for (const v of message.domainWhitelist) {
            StringValue.encode({ value: v }, writer.uint32(74).fork()).ldelim();
        }
        if (message.titleTextMaxLength !== undefined) {
            Int32Value.encode({ value: message.titleTextMaxLength }, writer.uint32(82).fork()).ldelim();
        }
        if (message.bodyRestrictionPolicy !== undefined) {
            StringValue.encode({ value: message.bodyRestrictionPolicy }, writer.uint32(90).fork()).ldelim();
        }
        if (message.linkRestrictionPolicy !== undefined) {
            StringValue.encode({ value: message.linkRestrictionPolicy }, writer.uint32(98).fork()).ldelim();
        }
        if (message.guidelinesDisplayPolicy !== undefined) {
            StringValue.encode({ value: message.guidelinesDisplayPolicy }, writer.uint32(106).fork()).ldelim();
        }
        for (const v of message.bodyRequiredStrings) {
            StringValue.encode({ value: v }, writer.uint32(114).fork()).ldelim();
        }
        if (message.titleTextMinLength !== undefined) {
            Int32Value.encode({ value: message.titleTextMinLength }, writer.uint32(122).fork()).ldelim();
        }
        if (message.galleryCaptionsRequirement !== undefined) {
            StringValue.encode({ value: message.galleryCaptionsRequirement }, writer.uint32(130).fork()).ldelim();
        }
        if (message.isFlairRequired !== undefined) {
            BoolValue.encode({ value: message.isFlairRequired }, writer.uint32(138).fork()).ldelim();
        }
        if (message.galleryMaxItems !== undefined) {
            Int32Value.encode({ value: message.galleryMaxItems }, writer.uint32(146).fork()).ldelim();
        }
        if (message.galleryUrlsRequirement !== undefined) {
            StringValue.encode({ value: message.galleryUrlsRequirement }, writer.uint32(154).fork()).ldelim();
        }
        for (const v of message.bodyRegexes) {
            StringValue.encode({ value: v }, writer.uint32(162).fork()).ldelim();
        }
        if (message.linkRepostAge !== undefined) {
            Int32Value.encode({ value: message.linkRepostAge }, writer.uint32(170).fork()).ldelim();
        }
        if (message.bodyTextMinLength !== undefined) {
            Int32Value.encode({ value: message.bodyTextMinLength }, writer.uint32(178).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSubredditPostRequirementsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.titleRegexes.push(StringValue.decode(reader, reader.uint32()).value);
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.bodyBlacklistedStrings.push(StringValue.decode(reader, reader.uint32()).value);
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.titleBlacklistedStrings.push(StringValue.decode(reader, reader.uint32()).value);
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.bodyTextMaxLength = Int32Value.decode(reader, reader.uint32()).value;
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.titleRequiredStrings.push(StringValue.decode(reader, reader.uint32()).value);
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.guidelinesText = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.galleryMinItems = Int32Value.decode(reader, reader.uint32()).value;
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.domainBlacklist.push(StringValue.decode(reader, reader.uint32()).value);
                    continue;
                case 9:
                    if (tag !== 74) {
                        break;
                    }
                    message.domainWhitelist.push(StringValue.decode(reader, reader.uint32()).value);
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.titleTextMaxLength = Int32Value.decode(reader, reader.uint32()).value;
                    continue;
                case 11:
                    if (tag !== 90) {
                        break;
                    }
                    message.bodyRestrictionPolicy = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 12:
                    if (tag !== 98) {
                        break;
                    }
                    message.linkRestrictionPolicy = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 13:
                    if (tag !== 106) {
                        break;
                    }
                    message.guidelinesDisplayPolicy = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 14:
                    if (tag !== 114) {
                        break;
                    }
                    message.bodyRequiredStrings.push(StringValue.decode(reader, reader.uint32()).value);
                    continue;
                case 15:
                    if (tag !== 122) {
                        break;
                    }
                    message.titleTextMinLength = Int32Value.decode(reader, reader.uint32()).value;
                    continue;
                case 16:
                    if (tag !== 130) {
                        break;
                    }
                    message.galleryCaptionsRequirement = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 17:
                    if (tag !== 138) {
                        break;
                    }
                    message.isFlairRequired = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 18:
                    if (tag !== 146) {
                        break;
                    }
                    message.galleryMaxItems = Int32Value.decode(reader, reader.uint32()).value;
                    continue;
                case 19:
                    if (tag !== 154) {
                        break;
                    }
                    message.galleryUrlsRequirement = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 20:
                    if (tag !== 162) {
                        break;
                    }
                    message.bodyRegexes.push(StringValue.decode(reader, reader.uint32()).value);
                    continue;
                case 21:
                    if (tag !== 170) {
                        break;
                    }
                    message.linkRepostAge = Int32Value.decode(reader, reader.uint32()).value;
                    continue;
                case 22:
                    if (tag !== 178) {
                        break;
                    }
                    message.bodyTextMinLength = Int32Value.decode(reader, reader.uint32()).value;
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            titleRegexes: globalThis.Array.isArray(object?.titleRegexes)
                ? object.titleRegexes.map((e) => String(e))
                : [],
            bodyBlacklistedStrings: globalThis.Array.isArray(object?.bodyBlacklistedStrings)
                ? object.bodyBlacklistedStrings.map((e) => String(e))
                : [],
            titleBlacklistedStrings: globalThis.Array.isArray(object?.titleBlacklistedStrings)
                ? object.titleBlacklistedStrings.map((e) => String(e))
                : [],
            bodyTextMaxLength: isSet(object.bodyTextMaxLength) ? Number(object.bodyTextMaxLength) : undefined,
            titleRequiredStrings: globalThis.Array.isArray(object?.titleRequiredStrings)
                ? object.titleRequiredStrings.map((e) => String(e))
                : [],
            guidelinesText: isSet(object.guidelinesText) ? String(object.guidelinesText) : undefined,
            galleryMinItems: isSet(object.galleryMinItems) ? Number(object.galleryMinItems) : undefined,
            domainBlacklist: globalThis.Array.isArray(object?.domainBlacklist)
                ? object.domainBlacklist.map((e) => String(e))
                : [],
            domainWhitelist: globalThis.Array.isArray(object?.domainWhitelist)
                ? object.domainWhitelist.map((e) => String(e))
                : [],
            titleTextMaxLength: isSet(object.titleTextMaxLength) ? Number(object.titleTextMaxLength) : undefined,
            bodyRestrictionPolicy: isSet(object.bodyRestrictionPolicy) ? String(object.bodyRestrictionPolicy) : undefined,
            linkRestrictionPolicy: isSet(object.linkRestrictionPolicy) ? String(object.linkRestrictionPolicy) : undefined,
            guidelinesDisplayPolicy: isSet(object.guidelinesDisplayPolicy)
                ? String(object.guidelinesDisplayPolicy)
                : undefined,
            bodyRequiredStrings: globalThis.Array.isArray(object?.bodyRequiredStrings)
                ? object.bodyRequiredStrings.map((e) => String(e))
                : [],
            titleTextMinLength: isSet(object.titleTextMinLength) ? Number(object.titleTextMinLength) : undefined,
            galleryCaptionsRequirement: isSet(object.galleryCaptionsRequirement)
                ? String(object.galleryCaptionsRequirement)
                : undefined,
            isFlairRequired: isSet(object.isFlairRequired) ? Boolean(object.isFlairRequired) : undefined,
            galleryMaxItems: isSet(object.galleryMaxItems) ? Number(object.galleryMaxItems) : undefined,
            galleryUrlsRequirement: isSet(object.galleryUrlsRequirement) ? String(object.galleryUrlsRequirement) : undefined,
            bodyRegexes: globalThis.Array.isArray(object?.bodyRegexes)
                ? object.bodyRegexes.map((e) => String(e))
                : [],
            linkRepostAge: isSet(object.linkRepostAge) ? Number(object.linkRepostAge) : undefined,
            bodyTextMinLength: isSet(object.bodyTextMinLength) ? Number(object.bodyTextMinLength) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.titleRegexes?.length) {
            obj.titleRegexes = message.titleRegexes;
        }
        if (message.bodyBlacklistedStrings?.length) {
            obj.bodyBlacklistedStrings = message.bodyBlacklistedStrings;
        }
        if (message.titleBlacklistedStrings?.length) {
            obj.titleBlacklistedStrings = message.titleBlacklistedStrings;
        }
        if (message.bodyTextMaxLength !== undefined) {
            obj.bodyTextMaxLength = message.bodyTextMaxLength;
        }
        if (message.titleRequiredStrings?.length) {
            obj.titleRequiredStrings = message.titleRequiredStrings;
        }
        if (message.guidelinesText !== undefined) {
            obj.guidelinesText = message.guidelinesText;
        }
        if (message.galleryMinItems !== undefined) {
            obj.galleryMinItems = message.galleryMinItems;
        }
        if (message.domainBlacklist?.length) {
            obj.domainBlacklist = message.domainBlacklist;
        }
        if (message.domainWhitelist?.length) {
            obj.domainWhitelist = message.domainWhitelist;
        }
        if (message.titleTextMaxLength !== undefined) {
            obj.titleTextMaxLength = message.titleTextMaxLength;
        }
        if (message.bodyRestrictionPolicy !== undefined) {
            obj.bodyRestrictionPolicy = message.bodyRestrictionPolicy;
        }
        if (message.linkRestrictionPolicy !== undefined) {
            obj.linkRestrictionPolicy = message.linkRestrictionPolicy;
        }
        if (message.guidelinesDisplayPolicy !== undefined) {
            obj.guidelinesDisplayPolicy = message.guidelinesDisplayPolicy;
        }
        if (message.bodyRequiredStrings?.length) {
            obj.bodyRequiredStrings = message.bodyRequiredStrings;
        }
        if (message.titleTextMinLength !== undefined) {
            obj.titleTextMinLength = message.titleTextMinLength;
        }
        if (message.galleryCaptionsRequirement !== undefined) {
            obj.galleryCaptionsRequirement = message.galleryCaptionsRequirement;
        }
        if (message.isFlairRequired !== undefined) {
            obj.isFlairRequired = message.isFlairRequired;
        }
        if (message.galleryMaxItems !== undefined) {
            obj.galleryMaxItems = message.galleryMaxItems;
        }
        if (message.galleryUrlsRequirement !== undefined) {
            obj.galleryUrlsRequirement = message.galleryUrlsRequirement;
        }
        if (message.bodyRegexes?.length) {
            obj.bodyRegexes = message.bodyRegexes;
        }
        if (message.linkRepostAge !== undefined) {
            obj.linkRepostAge = message.linkRepostAge;
        }
        if (message.bodyTextMinLength !== undefined) {
            obj.bodyTextMinLength = message.bodyTextMinLength;
        }
        return obj;
    },
    create(base) {
        return SubredditPostRequirementsResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSubredditPostRequirementsResponse();
        message.titleRegexes = object.titleRegexes?.map((e) => e) || [];
        message.bodyBlacklistedStrings = object.bodyBlacklistedStrings?.map((e) => e) || [];
        message.titleBlacklistedStrings = object.titleBlacklistedStrings?.map((e) => e) || [];
        message.bodyTextMaxLength = object.bodyTextMaxLength ?? undefined;
        message.titleRequiredStrings = object.titleRequiredStrings?.map((e) => e) || [];
        message.guidelinesText = object.guidelinesText ?? undefined;
        message.galleryMinItems = object.galleryMinItems ?? undefined;
        message.domainBlacklist = object.domainBlacklist?.map((e) => e) || [];
        message.domainWhitelist = object.domainWhitelist?.map((e) => e) || [];
        message.titleTextMaxLength = object.titleTextMaxLength ?? undefined;
        message.bodyRestrictionPolicy = object.bodyRestrictionPolicy ?? undefined;
        message.linkRestrictionPolicy = object.linkRestrictionPolicy ?? undefined;
        message.guidelinesDisplayPolicy = object.guidelinesDisplayPolicy ?? undefined;
        message.bodyRequiredStrings = object.bodyRequiredStrings?.map((e) => e) || [];
        message.titleTextMinLength = object.titleTextMinLength ?? undefined;
        message.galleryCaptionsRequirement = object.galleryCaptionsRequirement ?? undefined;
        message.isFlairRequired = object.isFlairRequired ?? undefined;
        message.galleryMaxItems = object.galleryMaxItems ?? undefined;
        message.galleryUrlsRequirement = object.galleryUrlsRequirement ?? undefined;
        message.bodyRegexes = object.bodyRegexes?.map((e) => e) || [];
        message.linkRepostAge = object.linkRepostAge ?? undefined;
        message.bodyTextMinLength = object.bodyTextMinLength ?? undefined;
        return message;
    },
};
messageTypeRegistry.set(SubredditPostRequirementsResponse.$type, SubredditPostRequirementsResponse);
function createBaseSubredditAboutResponse() {
    return { kind: undefined, data: undefined };
}
export const SubredditAboutResponse = {
    $type: "devvit.plugin.redditapi.subreddits.SubredditAboutResponse",
    encode(message, writer = _m0.Writer.create()) {
        if (message.kind !== undefined) {
            StringValue.encode({ value: message.kind }, writer.uint32(10).fork()).ldelim();
        }
        if (message.data !== undefined) {
            SubredditAboutResponse_AboutData.encode(message.data, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSubredditAboutResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.kind = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.data = SubredditAboutResponse_AboutData.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            kind: isSet(object.kind) ? String(object.kind) : undefined,
            data: isSet(object.data) ? SubredditAboutResponse_AboutData.fromJSON(object.data) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.kind !== undefined) {
            obj.kind = message.kind;
        }
        if (message.data !== undefined) {
            obj.data = SubredditAboutResponse_AboutData.toJSON(message.data);
        }
        return obj;
    },
    create(base) {
        return SubredditAboutResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSubredditAboutResponse();
        message.kind = object.kind ?? undefined;
        message.data = (object.data !== undefined && object.data !== null)
            ? SubredditAboutResponse_AboutData.fromPartial(object.data)
            : undefined;
        return message;
    },
};
messageTypeRegistry.set(SubredditAboutResponse.$type, SubredditAboutResponse);
function createBaseSubredditAboutResponse_AboutData() {
    return {
        userFlairBackgroundColor: undefined,
        submitTextHtml: undefined,
        restrictPosting: undefined,
        userIsBanned: undefined,
        freeFormReports: undefined,
        wikiEnabled: undefined,
        userIsMuted: undefined,
        userCanFlairInSr: undefined,
        displayName: undefined,
        headerImg: undefined,
        title: undefined,
        allowGalleries: undefined,
        primaryColor: undefined,
        activeUserCount: undefined,
        iconImg: undefined,
        displayNamePrefixed: undefined,
        accountsActive: undefined,
        publicTraffic: undefined,
        subscribers: undefined,
        userFlairRichtext: [],
        name: undefined,
        quarantine: undefined,
        hideAds: undefined,
        emojisEnabled: undefined,
        advertiserCategory: undefined,
        publicDescription: undefined,
        commentScoreHideMins: undefined,
        allowPredictions: undefined,
        userHasFavorited: undefined,
        userFlairTemplateId: undefined,
        communityIcon: undefined,
        bannerBackgroundImage: undefined,
        originalContentTagEnabled: undefined,
        communityReviewed: undefined,
        submitText: undefined,
        descriptionHtml: undefined,
        spoilersEnabled: undefined,
        commentContributionSettings: undefined,
        allowTalks: undefined,
        userFlairPosition: undefined,
        allOriginalContent: undefined,
        collectionsEnabled: undefined,
        isEnrolledInNewModmail: undefined,
        keyColor: undefined,
        eventPostsEnabled: undefined,
        canAssignUserFlair: undefined,
        created: undefined,
        showMediaPreview: undefined,
        submissionType: undefined,
        userIsSubscriber: undefined,
        allowedMediaInComments: [],
        allowVideogifs: undefined,
        shouldArchivePosts: undefined,
        userFlairType: undefined,
        allowPolls: undefined,
        collapseDeletedComments: undefined,
        coins: undefined,
        publicDescriptionHtml: undefined,
        allowVideos: undefined,
        isCrosspostableSubreddit: undefined,
        notificationLevel: undefined,
        shouldShowMediaInCommentsSetting: undefined,
        canAssignLinkFlair: undefined,
        hasMenuWidget: undefined,
        accountsActiveIsFuzzed: undefined,
        allowPredictionContributors: undefined,
        submitTextLabel: undefined,
        linkFlairPosition: undefined,
        userSrFlairEnabled: undefined,
        userFlairEnabledInSr: undefined,
        allowChatPostCreation: undefined,
        allowDiscovery: undefined,
        acceptFollowers: undefined,
        userSrThemeEnabled: undefined,
        linkFlairEnabled: undefined,
        disableContributorRequests: undefined,
        subredditType: undefined,
        suggestedCommentSort: undefined,
        bannerImg: undefined,
        userFlairText: undefined,
        bannerBackgroundColor: undefined,
        showMedia: undefined,
        id: undefined,
        userIsModerator: undefined,
        over18: undefined,
        headerTitle: undefined,
        description: undefined,
        isChatPostFeatureEnabled: undefined,
        submitLinkLabel: undefined,
        userFlairTextColor: undefined,
        restrictCommenting: undefined,
        userFlairCssClass: undefined,
        allowImages: undefined,
        lang: undefined,
        url: undefined,
        createdUtc: undefined,
        bannerSize: [],
        mobileBannerImage: undefined,
        userIsContributor: undefined,
        allowPredictionsTournament: undefined,
        iconSize: [],
        headerSize: [],
        wls: undefined,
        whitelistStatus: undefined,
        emojisCustomSize: [],
    };
}
export const SubredditAboutResponse_AboutData = {
    $type: "devvit.plugin.redditapi.subreddits.SubredditAboutResponse.AboutData",
    encode(message, writer = _m0.Writer.create()) {
        if (message.userFlairBackgroundColor !== undefined) {
            StringValue.encode({ value: message.userFlairBackgroundColor }, writer.uint32(10).fork()).ldelim();
        }
        if (message.submitTextHtml !== undefined) {
            StringValue.encode({ value: message.submitTextHtml }, writer.uint32(18).fork()).ldelim();
        }
        if (message.restrictPosting !== undefined) {
            BoolValue.encode({ value: message.restrictPosting }, writer.uint32(26).fork()).ldelim();
        }
        if (message.userIsBanned !== undefined) {
            BoolValue.encode({ value: message.userIsBanned }, writer.uint32(34).fork()).ldelim();
        }
        if (message.freeFormReports !== undefined) {
            BoolValue.encode({ value: message.freeFormReports }, writer.uint32(42).fork()).ldelim();
        }
        if (message.wikiEnabled !== undefined) {
            BoolValue.encode({ value: message.wikiEnabled }, writer.uint32(50).fork()).ldelim();
        }
        if (message.userIsMuted !== undefined) {
            BoolValue.encode({ value: message.userIsMuted }, writer.uint32(58).fork()).ldelim();
        }
        if (message.userCanFlairInSr !== undefined) {
            BoolValue.encode({ value: message.userCanFlairInSr }, writer.uint32(66).fork()).ldelim();
        }
        if (message.displayName !== undefined) {
            StringValue.encode({ value: message.displayName }, writer.uint32(74).fork()).ldelim();
        }
        if (message.headerImg !== undefined) {
            StringValue.encode({ value: message.headerImg }, writer.uint32(82).fork()).ldelim();
        }
        if (message.title !== undefined) {
            StringValue.encode({ value: message.title }, writer.uint32(90).fork()).ldelim();
        }
        if (message.allowGalleries !== undefined) {
            BoolValue.encode({ value: message.allowGalleries }, writer.uint32(98).fork()).ldelim();
        }
        if (message.primaryColor !== undefined) {
            StringValue.encode({ value: message.primaryColor }, writer.uint32(114).fork()).ldelim();
        }
        if (message.activeUserCount !== undefined) {
            Int64Value.encode({ value: message.activeUserCount }, writer.uint32(122).fork()).ldelim();
        }
        if (message.iconImg !== undefined) {
            StringValue.encode({ value: message.iconImg }, writer.uint32(130).fork()).ldelim();
        }
        if (message.displayNamePrefixed !== undefined) {
            StringValue.encode({ value: message.displayNamePrefixed }, writer.uint32(138).fork()).ldelim();
        }
        if (message.accountsActive !== undefined) {
            Int64Value.encode({ value: message.accountsActive }, writer.uint32(146).fork()).ldelim();
        }
        if (message.publicTraffic !== undefined) {
            BoolValue.encode({ value: message.publicTraffic }, writer.uint32(154).fork()).ldelim();
        }
        if (message.subscribers !== undefined) {
            Int64Value.encode({ value: message.subscribers }, writer.uint32(162).fork()).ldelim();
        }
        for (const v of message.userFlairRichtext) {
            UserFlairRichtext.encode(v, writer.uint32(170).fork()).ldelim();
        }
        if (message.name !== undefined) {
            StringValue.encode({ value: message.name }, writer.uint32(178).fork()).ldelim();
        }
        if (message.quarantine !== undefined) {
            BoolValue.encode({ value: message.quarantine }, writer.uint32(186).fork()).ldelim();
        }
        if (message.hideAds !== undefined) {
            BoolValue.encode({ value: message.hideAds }, writer.uint32(194).fork()).ldelim();
        }
        if (message.emojisEnabled !== undefined) {
            BoolValue.encode({ value: message.emojisEnabled }, writer.uint32(210).fork()).ldelim();
        }
        if (message.advertiserCategory !== undefined) {
            StringValue.encode({ value: message.advertiserCategory }, writer.uint32(218).fork()).ldelim();
        }
        if (message.publicDescription !== undefined) {
            StringValue.encode({ value: message.publicDescription }, writer.uint32(226).fork()).ldelim();
        }
        if (message.commentScoreHideMins !== undefined) {
            Int32Value.encode({ value: message.commentScoreHideMins }, writer.uint32(234).fork()).ldelim();
        }
        if (message.allowPredictions !== undefined) {
            BoolValue.encode({ value: message.allowPredictions }, writer.uint32(242).fork()).ldelim();
        }
        if (message.userHasFavorited !== undefined) {
            BoolValue.encode({ value: message.userHasFavorited }, writer.uint32(250).fork()).ldelim();
        }
        if (message.userFlairTemplateId !== undefined) {
            StringValue.encode({ value: message.userFlairTemplateId }, writer.uint32(258).fork()).ldelim();
        }
        if (message.communityIcon !== undefined) {
            StringValue.encode({ value: message.communityIcon }, writer.uint32(266).fork()).ldelim();
        }
        if (message.bannerBackgroundImage !== undefined) {
            StringValue.encode({ value: message.bannerBackgroundImage }, writer.uint32(274).fork()).ldelim();
        }
        if (message.originalContentTagEnabled !== undefined) {
            BoolValue.encode({ value: message.originalContentTagEnabled }, writer.uint32(282).fork()).ldelim();
        }
        if (message.communityReviewed !== undefined) {
            BoolValue.encode({ value: message.communityReviewed }, writer.uint32(290).fork()).ldelim();
        }
        if (message.submitText !== undefined) {
            StringValue.encode({ value: message.submitText }, writer.uint32(298).fork()).ldelim();
        }
        if (message.descriptionHtml !== undefined) {
            StringValue.encode({ value: message.descriptionHtml }, writer.uint32(306).fork()).ldelim();
        }
        if (message.spoilersEnabled !== undefined) {
            BoolValue.encode({ value: message.spoilersEnabled }, writer.uint32(314).fork()).ldelim();
        }
        if (message.commentContributionSettings !== undefined) {
            CommentContributionSettings.encode(message.commentContributionSettings, writer.uint32(322).fork()).ldelim();
        }
        if (message.allowTalks !== undefined) {
            BoolValue.encode({ value: message.allowTalks }, writer.uint32(330).fork()).ldelim();
        }
        if (message.userFlairPosition !== undefined) {
            StringValue.encode({ value: message.userFlairPosition }, writer.uint32(346).fork()).ldelim();
        }
        if (message.allOriginalContent !== undefined) {
            BoolValue.encode({ value: message.allOriginalContent }, writer.uint32(354).fork()).ldelim();
        }
        if (message.collectionsEnabled !== undefined) {
            BoolValue.encode({ value: message.collectionsEnabled }, writer.uint32(362).fork()).ldelim();
        }
        if (message.isEnrolledInNewModmail !== undefined) {
            BoolValue.encode({ value: message.isEnrolledInNewModmail }, writer.uint32(370).fork()).ldelim();
        }
        if (message.keyColor !== undefined) {
            StringValue.encode({ value: message.keyColor }, writer.uint32(378).fork()).ldelim();
        }
        if (message.eventPostsEnabled !== undefined) {
            BoolValue.encode({ value: message.eventPostsEnabled }, writer.uint32(386).fork()).ldelim();
        }
        if (message.canAssignUserFlair !== undefined) {
            BoolValue.encode({ value: message.canAssignUserFlair }, writer.uint32(394).fork()).ldelim();
        }
        if (message.created !== undefined) {
            Int64Value.encode({ value: message.created }, writer.uint32(402).fork()).ldelim();
        }
        if (message.showMediaPreview !== undefined) {
            BoolValue.encode({ value: message.showMediaPreview }, writer.uint32(418).fork()).ldelim();
        }
        if (message.submissionType !== undefined) {
            StringValue.encode({ value: message.submissionType }, writer.uint32(426).fork()).ldelim();
        }
        if (message.userIsSubscriber !== undefined) {
            BoolValue.encode({ value: message.userIsSubscriber }, writer.uint32(434).fork()).ldelim();
        }
        for (const v of message.allowedMediaInComments) {
            StringValue.encode({ value: v }, writer.uint32(442).fork()).ldelim();
        }
        if (message.allowVideogifs !== undefined) {
            BoolValue.encode({ value: message.allowVideogifs }, writer.uint32(450).fork()).ldelim();
        }
        if (message.shouldArchivePosts !== undefined) {
            BoolValue.encode({ value: message.shouldArchivePosts }, writer.uint32(458).fork()).ldelim();
        }
        if (message.userFlairType !== undefined) {
            StringValue.encode({ value: message.userFlairType }, writer.uint32(466).fork()).ldelim();
        }
        if (message.allowPolls !== undefined) {
            BoolValue.encode({ value: message.allowPolls }, writer.uint32(474).fork()).ldelim();
        }
        if (message.collapseDeletedComments !== undefined) {
            BoolValue.encode({ value: message.collapseDeletedComments }, writer.uint32(482).fork()).ldelim();
        }
        if (message.coins !== undefined) {
            Int64Value.encode({ value: message.coins }, writer.uint32(490).fork()).ldelim();
        }
        if (message.publicDescriptionHtml !== undefined) {
            StringValue.encode({ value: message.publicDescriptionHtml }, writer.uint32(506).fork()).ldelim();
        }
        if (message.allowVideos !== undefined) {
            BoolValue.encode({ value: message.allowVideos }, writer.uint32(514).fork()).ldelim();
        }
        if (message.isCrosspostableSubreddit !== undefined) {
            BoolValue.encode({ value: message.isCrosspostableSubreddit }, writer.uint32(522).fork()).ldelim();
        }
        if (message.notificationLevel !== undefined) {
            StringValue.encode({ value: message.notificationLevel }, writer.uint32(530).fork()).ldelim();
        }
        if (message.shouldShowMediaInCommentsSetting !== undefined) {
            BoolValue.encode({ value: message.shouldShowMediaInCommentsSetting }, writer.uint32(538).fork()).ldelim();
        }
        if (message.canAssignLinkFlair !== undefined) {
            BoolValue.encode({ value: message.canAssignLinkFlair }, writer.uint32(546).fork()).ldelim();
        }
        if (message.hasMenuWidget !== undefined) {
            BoolValue.encode({ value: message.hasMenuWidget }, writer.uint32(554).fork()).ldelim();
        }
        if (message.accountsActiveIsFuzzed !== undefined) {
            BoolValue.encode({ value: message.accountsActiveIsFuzzed }, writer.uint32(562).fork()).ldelim();
        }
        if (message.allowPredictionContributors !== undefined) {
            BoolValue.encode({ value: message.allowPredictionContributors }, writer.uint32(570).fork()).ldelim();
        }
        if (message.submitTextLabel !== undefined) {
            StringValue.encode({ value: message.submitTextLabel }, writer.uint32(578).fork()).ldelim();
        }
        if (message.linkFlairPosition !== undefined) {
            StringValue.encode({ value: message.linkFlairPosition }, writer.uint32(586).fork()).ldelim();
        }
        if (message.userSrFlairEnabled !== undefined) {
            BoolValue.encode({ value: message.userSrFlairEnabled }, writer.uint32(594).fork()).ldelim();
        }
        if (message.userFlairEnabledInSr !== undefined) {
            BoolValue.encode({ value: message.userFlairEnabledInSr }, writer.uint32(602).fork()).ldelim();
        }
        if (message.allowChatPostCreation !== undefined) {
            BoolValue.encode({ value: message.allowChatPostCreation }, writer.uint32(610).fork()).ldelim();
        }
        if (message.allowDiscovery !== undefined) {
            BoolValue.encode({ value: message.allowDiscovery }, writer.uint32(618).fork()).ldelim();
        }
        if (message.acceptFollowers !== undefined) {
            BoolValue.encode({ value: message.acceptFollowers }, writer.uint32(626).fork()).ldelim();
        }
        if (message.userSrThemeEnabled !== undefined) {
            BoolValue.encode({ value: message.userSrThemeEnabled }, writer.uint32(634).fork()).ldelim();
        }
        if (message.linkFlairEnabled !== undefined) {
            BoolValue.encode({ value: message.linkFlairEnabled }, writer.uint32(642).fork()).ldelim();
        }
        if (message.disableContributorRequests !== undefined) {
            BoolValue.encode({ value: message.disableContributorRequests }, writer.uint32(650).fork()).ldelim();
        }
        if (message.subredditType !== undefined) {
            StringValue.encode({ value: message.subredditType }, writer.uint32(658).fork()).ldelim();
        }
        if (message.suggestedCommentSort !== undefined) {
            StringValue.encode({ value: message.suggestedCommentSort }, writer.uint32(666).fork()).ldelim();
        }
        if (message.bannerImg !== undefined) {
            StringValue.encode({ value: message.bannerImg }, writer.uint32(674).fork()).ldelim();
        }
        if (message.userFlairText !== undefined) {
            StringValue.encode({ value: message.userFlairText }, writer.uint32(682).fork()).ldelim();
        }
        if (message.bannerBackgroundColor !== undefined) {
            StringValue.encode({ value: message.bannerBackgroundColor }, writer.uint32(690).fork()).ldelim();
        }
        if (message.showMedia !== undefined) {
            BoolValue.encode({ value: message.showMedia }, writer.uint32(698).fork()).ldelim();
        }
        if (message.id !== undefined) {
            StringValue.encode({ value: message.id }, writer.uint32(706).fork()).ldelim();
        }
        if (message.userIsModerator !== undefined) {
            BoolValue.encode({ value: message.userIsModerator }, writer.uint32(714).fork()).ldelim();
        }
        if (message.over18 !== undefined) {
            BoolValue.encode({ value: message.over18 }, writer.uint32(722).fork()).ldelim();
        }
        if (message.headerTitle !== undefined) {
            StringValue.encode({ value: message.headerTitle }, writer.uint32(730).fork()).ldelim();
        }
        if (message.description !== undefined) {
            StringValue.encode({ value: message.description }, writer.uint32(738).fork()).ldelim();
        }
        if (message.isChatPostFeatureEnabled !== undefined) {
            BoolValue.encode({ value: message.isChatPostFeatureEnabled }, writer.uint32(746).fork()).ldelim();
        }
        if (message.submitLinkLabel !== undefined) {
            StringValue.encode({ value: message.submitLinkLabel }, writer.uint32(754).fork()).ldelim();
        }
        if (message.userFlairTextColor !== undefined) {
            StringValue.encode({ value: message.userFlairTextColor }, writer.uint32(762).fork()).ldelim();
        }
        if (message.restrictCommenting !== undefined) {
            BoolValue.encode({ value: message.restrictCommenting }, writer.uint32(770).fork()).ldelim();
        }
        if (message.userFlairCssClass !== undefined) {
            StringValue.encode({ value: message.userFlairCssClass }, writer.uint32(778).fork()).ldelim();
        }
        if (message.allowImages !== undefined) {
            BoolValue.encode({ value: message.allowImages }, writer.uint32(786).fork()).ldelim();
        }
        if (message.lang !== undefined) {
            StringValue.encode({ value: message.lang }, writer.uint32(794).fork()).ldelim();
        }
        if (message.url !== undefined) {
            StringValue.encode({ value: message.url }, writer.uint32(810).fork()).ldelim();
        }
        if (message.createdUtc !== undefined) {
            Int64Value.encode({ value: message.createdUtc }, writer.uint32(818).fork()).ldelim();
        }
        for (const v of message.bannerSize) {
            Int64Value.encode({ value: v }, writer.uint32(826).fork()).ldelim();
        }
        if (message.mobileBannerImage !== undefined) {
            StringValue.encode({ value: message.mobileBannerImage }, writer.uint32(834).fork()).ldelim();
        }
        if (message.userIsContributor !== undefined) {
            BoolValue.encode({ value: message.userIsContributor }, writer.uint32(842).fork()).ldelim();
        }
        if (message.allowPredictionsTournament !== undefined) {
            BoolValue.encode({ value: message.allowPredictionsTournament }, writer.uint32(850).fork()).ldelim();
        }
        for (const v of message.iconSize) {
            Int64Value.encode({ value: v }, writer.uint32(858).fork()).ldelim();
        }
        for (const v of message.headerSize) {
            Int64Value.encode({ value: v }, writer.uint32(866).fork()).ldelim();
        }
        if (message.wls !== undefined) {
            Int32Value.encode({ value: message.wls }, writer.uint32(874).fork()).ldelim();
        }
        if (message.whitelistStatus !== undefined) {
            StringValue.encode({ value: message.whitelistStatus }, writer.uint32(882).fork()).ldelim();
        }
        for (const v of message.emojisCustomSize) {
            Int64Value.encode({ value: v }, writer.uint32(890).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSubredditAboutResponse_AboutData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.userFlairBackgroundColor = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.submitTextHtml = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.restrictPosting = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.userIsBanned = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.freeFormReports = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.wikiEnabled = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.userIsMuted = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.userCanFlairInSr = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 9:
                    if (tag !== 74) {
                        break;
                    }
                    message.displayName = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.headerImg = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 11:
                    if (tag !== 90) {
                        break;
                    }
                    message.title = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 12:
                    if (tag !== 98) {
                        break;
                    }
                    message.allowGalleries = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 14:
                    if (tag !== 114) {
                        break;
                    }
                    message.primaryColor = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 15:
                    if (tag !== 122) {
                        break;
                    }
                    message.activeUserCount = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 16:
                    if (tag !== 130) {
                        break;
                    }
                    message.iconImg = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 17:
                    if (tag !== 138) {
                        break;
                    }
                    message.displayNamePrefixed = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 18:
                    if (tag !== 146) {
                        break;
                    }
                    message.accountsActive = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 19:
                    if (tag !== 154) {
                        break;
                    }
                    message.publicTraffic = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 20:
                    if (tag !== 162) {
                        break;
                    }
                    message.subscribers = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 21:
                    if (tag !== 170) {
                        break;
                    }
                    message.userFlairRichtext.push(UserFlairRichtext.decode(reader, reader.uint32()));
                    continue;
                case 22:
                    if (tag !== 178) {
                        break;
                    }
                    message.name = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 23:
                    if (tag !== 186) {
                        break;
                    }
                    message.quarantine = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 24:
                    if (tag !== 194) {
                        break;
                    }
                    message.hideAds = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 26:
                    if (tag !== 210) {
                        break;
                    }
                    message.emojisEnabled = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 27:
                    if (tag !== 218) {
                        break;
                    }
                    message.advertiserCategory = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 28:
                    if (tag !== 226) {
                        break;
                    }
                    message.publicDescription = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 29:
                    if (tag !== 234) {
                        break;
                    }
                    message.commentScoreHideMins = Int32Value.decode(reader, reader.uint32()).value;
                    continue;
                case 30:
                    if (tag !== 242) {
                        break;
                    }
                    message.allowPredictions = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 31:
                    if (tag !== 250) {
                        break;
                    }
                    message.userHasFavorited = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 32:
                    if (tag !== 258) {
                        break;
                    }
                    message.userFlairTemplateId = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 33:
                    if (tag !== 266) {
                        break;
                    }
                    message.communityIcon = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 34:
                    if (tag !== 274) {
                        break;
                    }
                    message.bannerBackgroundImage = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 35:
                    if (tag !== 282) {
                        break;
                    }
                    message.originalContentTagEnabled = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 36:
                    if (tag !== 290) {
                        break;
                    }
                    message.communityReviewed = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 37:
                    if (tag !== 298) {
                        break;
                    }
                    message.submitText = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 38:
                    if (tag !== 306) {
                        break;
                    }
                    message.descriptionHtml = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 39:
                    if (tag !== 314) {
                        break;
                    }
                    message.spoilersEnabled = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 40:
                    if (tag !== 322) {
                        break;
                    }
                    message.commentContributionSettings = CommentContributionSettings.decode(reader, reader.uint32());
                    continue;
                case 41:
                    if (tag !== 330) {
                        break;
                    }
                    message.allowTalks = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 43:
                    if (tag !== 346) {
                        break;
                    }
                    message.userFlairPosition = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 44:
                    if (tag !== 354) {
                        break;
                    }
                    message.allOriginalContent = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 45:
                    if (tag !== 362) {
                        break;
                    }
                    message.collectionsEnabled = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 46:
                    if (tag !== 370) {
                        break;
                    }
                    message.isEnrolledInNewModmail = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 47:
                    if (tag !== 378) {
                        break;
                    }
                    message.keyColor = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 48:
                    if (tag !== 386) {
                        break;
                    }
                    message.eventPostsEnabled = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 49:
                    if (tag !== 394) {
                        break;
                    }
                    message.canAssignUserFlair = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 50:
                    if (tag !== 402) {
                        break;
                    }
                    message.created = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 52:
                    if (tag !== 418) {
                        break;
                    }
                    message.showMediaPreview = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 53:
                    if (tag !== 426) {
                        break;
                    }
                    message.submissionType = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 54:
                    if (tag !== 434) {
                        break;
                    }
                    message.userIsSubscriber = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 55:
                    if (tag !== 442) {
                        break;
                    }
                    message.allowedMediaInComments.push(StringValue.decode(reader, reader.uint32()).value);
                    continue;
                case 56:
                    if (tag !== 450) {
                        break;
                    }
                    message.allowVideogifs = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 57:
                    if (tag !== 458) {
                        break;
                    }
                    message.shouldArchivePosts = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 58:
                    if (tag !== 466) {
                        break;
                    }
                    message.userFlairType = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 59:
                    if (tag !== 474) {
                        break;
                    }
                    message.allowPolls = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 60:
                    if (tag !== 482) {
                        break;
                    }
                    message.collapseDeletedComments = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 61:
                    if (tag !== 490) {
                        break;
                    }
                    message.coins = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 63:
                    if (tag !== 506) {
                        break;
                    }
                    message.publicDescriptionHtml = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 64:
                    if (tag !== 514) {
                        break;
                    }
                    message.allowVideos = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 65:
                    if (tag !== 522) {
                        break;
                    }
                    message.isCrosspostableSubreddit = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 66:
                    if (tag !== 530) {
                        break;
                    }
                    message.notificationLevel = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 67:
                    if (tag !== 538) {
                        break;
                    }
                    message.shouldShowMediaInCommentsSetting = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 68:
                    if (tag !== 546) {
                        break;
                    }
                    message.canAssignLinkFlair = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 69:
                    if (tag !== 554) {
                        break;
                    }
                    message.hasMenuWidget = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 70:
                    if (tag !== 562) {
                        break;
                    }
                    message.accountsActiveIsFuzzed = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 71:
                    if (tag !== 570) {
                        break;
                    }
                    message.allowPredictionContributors = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 72:
                    if (tag !== 578) {
                        break;
                    }
                    message.submitTextLabel = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 73:
                    if (tag !== 586) {
                        break;
                    }
                    message.linkFlairPosition = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 74:
                    if (tag !== 594) {
                        break;
                    }
                    message.userSrFlairEnabled = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 75:
                    if (tag !== 602) {
                        break;
                    }
                    message.userFlairEnabledInSr = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 76:
                    if (tag !== 610) {
                        break;
                    }
                    message.allowChatPostCreation = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 77:
                    if (tag !== 618) {
                        break;
                    }
                    message.allowDiscovery = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 78:
                    if (tag !== 626) {
                        break;
                    }
                    message.acceptFollowers = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 79:
                    if (tag !== 634) {
                        break;
                    }
                    message.userSrThemeEnabled = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 80:
                    if (tag !== 642) {
                        break;
                    }
                    message.linkFlairEnabled = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 81:
                    if (tag !== 650) {
                        break;
                    }
                    message.disableContributorRequests = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 82:
                    if (tag !== 658) {
                        break;
                    }
                    message.subredditType = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 83:
                    if (tag !== 666) {
                        break;
                    }
                    message.suggestedCommentSort = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 84:
                    if (tag !== 674) {
                        break;
                    }
                    message.bannerImg = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 85:
                    if (tag !== 682) {
                        break;
                    }
                    message.userFlairText = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 86:
                    if (tag !== 690) {
                        break;
                    }
                    message.bannerBackgroundColor = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 87:
                    if (tag !== 698) {
                        break;
                    }
                    message.showMedia = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 88:
                    if (tag !== 706) {
                        break;
                    }
                    message.id = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 89:
                    if (tag !== 714) {
                        break;
                    }
                    message.userIsModerator = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 90:
                    if (tag !== 722) {
                        break;
                    }
                    message.over18 = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 91:
                    if (tag !== 730) {
                        break;
                    }
                    message.headerTitle = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 92:
                    if (tag !== 738) {
                        break;
                    }
                    message.description = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 93:
                    if (tag !== 746) {
                        break;
                    }
                    message.isChatPostFeatureEnabled = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 94:
                    if (tag !== 754) {
                        break;
                    }
                    message.submitLinkLabel = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 95:
                    if (tag !== 762) {
                        break;
                    }
                    message.userFlairTextColor = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 96:
                    if (tag !== 770) {
                        break;
                    }
                    message.restrictCommenting = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 97:
                    if (tag !== 778) {
                        break;
                    }
                    message.userFlairCssClass = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 98:
                    if (tag !== 786) {
                        break;
                    }
                    message.allowImages = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 99:
                    if (tag !== 794) {
                        break;
                    }
                    message.lang = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 101:
                    if (tag !== 810) {
                        break;
                    }
                    message.url = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 102:
                    if (tag !== 818) {
                        break;
                    }
                    message.createdUtc = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 103:
                    if (tag !== 826) {
                        break;
                    }
                    message.bannerSize.push(Int64Value.decode(reader, reader.uint32()).value);
                    continue;
                case 104:
                    if (tag !== 834) {
                        break;
                    }
                    message.mobileBannerImage = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 105:
                    if (tag !== 842) {
                        break;
                    }
                    message.userIsContributor = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 106:
                    if (tag !== 850) {
                        break;
                    }
                    message.allowPredictionsTournament = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 107:
                    if (tag !== 858) {
                        break;
                    }
                    message.iconSize.push(Int64Value.decode(reader, reader.uint32()).value);
                    continue;
                case 108:
                    if (tag !== 866) {
                        break;
                    }
                    message.headerSize.push(Int64Value.decode(reader, reader.uint32()).value);
                    continue;
                case 109:
                    if (tag !== 874) {
                        break;
                    }
                    message.wls = Int32Value.decode(reader, reader.uint32()).value;
                    continue;
                case 110:
                    if (tag !== 882) {
                        break;
                    }
                    message.whitelistStatus = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 111:
                    if (tag !== 890) {
                        break;
                    }
                    message.emojisCustomSize.push(Int64Value.decode(reader, reader.uint32()).value);
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            userFlairBackgroundColor: isSet(object.userFlairBackgroundColor)
                ? String(object.userFlairBackgroundColor)
                : undefined,
            submitTextHtml: isSet(object.submitTextHtml) ? String(object.submitTextHtml) : undefined,
            restrictPosting: isSet(object.restrictPosting) ? Boolean(object.restrictPosting) : undefined,
            userIsBanned: isSet(object.userIsBanned) ? Boolean(object.userIsBanned) : undefined,
            freeFormReports: isSet(object.freeFormReports) ? Boolean(object.freeFormReports) : undefined,
            wikiEnabled: isSet(object.wikiEnabled) ? Boolean(object.wikiEnabled) : undefined,
            userIsMuted: isSet(object.userIsMuted) ? Boolean(object.userIsMuted) : undefined,
            userCanFlairInSr: isSet(object.userCanFlairInSr) ? Boolean(object.userCanFlairInSr) : undefined,
            displayName: isSet(object.displayName) ? String(object.displayName) : undefined,
            headerImg: isSet(object.headerImg) ? String(object.headerImg) : undefined,
            title: isSet(object.title) ? String(object.title) : undefined,
            allowGalleries: isSet(object.allowGalleries) ? Boolean(object.allowGalleries) : undefined,
            primaryColor: isSet(object.primaryColor) ? String(object.primaryColor) : undefined,
            activeUserCount: isSet(object.activeUserCount) ? Number(object.activeUserCount) : undefined,
            iconImg: isSet(object.iconImg) ? String(object.iconImg) : undefined,
            displayNamePrefixed: isSet(object.displayNamePrefixed) ? String(object.displayNamePrefixed) : undefined,
            accountsActive: isSet(object.accountsActive) ? Number(object.accountsActive) : undefined,
            publicTraffic: isSet(object.publicTraffic) ? Boolean(object.publicTraffic) : undefined,
            subscribers: isSet(object.subscribers) ? Number(object.subscribers) : undefined,
            userFlairRichtext: globalThis.Array.isArray(object?.userFlairRichtext)
                ? object.userFlairRichtext.map((e) => UserFlairRichtext.fromJSON(e))
                : [],
            name: isSet(object.name) ? String(object.name) : undefined,
            quarantine: isSet(object.quarantine) ? Boolean(object.quarantine) : undefined,
            hideAds: isSet(object.hideAds) ? Boolean(object.hideAds) : undefined,
            emojisEnabled: isSet(object.emojisEnabled) ? Boolean(object.emojisEnabled) : undefined,
            advertiserCategory: isSet(object.advertiserCategory) ? String(object.advertiserCategory) : undefined,
            publicDescription: isSet(object.publicDescription) ? String(object.publicDescription) : undefined,
            commentScoreHideMins: isSet(object.commentScoreHideMins) ? Number(object.commentScoreHideMins) : undefined,
            allowPredictions: isSet(object.allowPredictions) ? Boolean(object.allowPredictions) : undefined,
            userHasFavorited: isSet(object.userHasFavorited) ? Boolean(object.userHasFavorited) : undefined,
            userFlairTemplateId: isSet(object.userFlairTemplateId) ? String(object.userFlairTemplateId) : undefined,
            communityIcon: isSet(object.communityIcon) ? String(object.communityIcon) : undefined,
            bannerBackgroundImage: isSet(object.bannerBackgroundImage) ? String(object.bannerBackgroundImage) : undefined,
            originalContentTagEnabled: isSet(object.originalContentTagEnabled)
                ? Boolean(object.originalContentTagEnabled)
                : undefined,
            communityReviewed: isSet(object.communityReviewed) ? Boolean(object.communityReviewed) : undefined,
            submitText: isSet(object.submitText) ? String(object.submitText) : undefined,
            descriptionHtml: isSet(object.descriptionHtml) ? String(object.descriptionHtml) : undefined,
            spoilersEnabled: isSet(object.spoilersEnabled) ? Boolean(object.spoilersEnabled) : undefined,
            commentContributionSettings: isSet(object.commentContributionSettings)
                ? CommentContributionSettings.fromJSON(object.commentContributionSettings)
                : undefined,
            allowTalks: isSet(object.allowTalks) ? Boolean(object.allowTalks) : undefined,
            userFlairPosition: isSet(object.userFlairPosition) ? String(object.userFlairPosition) : undefined,
            allOriginalContent: isSet(object.allOriginalContent) ? Boolean(object.allOriginalContent) : undefined,
            collectionsEnabled: isSet(object.collectionsEnabled) ? Boolean(object.collectionsEnabled) : undefined,
            isEnrolledInNewModmail: isSet(object.isEnrolledInNewModmail) ? Boolean(object.isEnrolledInNewModmail) : undefined,
            keyColor: isSet(object.keyColor) ? String(object.keyColor) : undefined,
            eventPostsEnabled: isSet(object.eventPostsEnabled) ? Boolean(object.eventPostsEnabled) : undefined,
            canAssignUserFlair: isSet(object.canAssignUserFlair) ? Boolean(object.canAssignUserFlair) : undefined,
            created: isSet(object.created) ? Number(object.created) : undefined,
            showMediaPreview: isSet(object.showMediaPreview) ? Boolean(object.showMediaPreview) : undefined,
            submissionType: isSet(object.submissionType) ? String(object.submissionType) : undefined,
            userIsSubscriber: isSet(object.userIsSubscriber) ? Boolean(object.userIsSubscriber) : undefined,
            allowedMediaInComments: globalThis.Array.isArray(object?.allowedMediaInComments)
                ? object.allowedMediaInComments.map((e) => String(e))
                : [],
            allowVideogifs: isSet(object.allowVideogifs) ? Boolean(object.allowVideogifs) : undefined,
            shouldArchivePosts: isSet(object.shouldArchivePosts) ? Boolean(object.shouldArchivePosts) : undefined,
            userFlairType: isSet(object.userFlairType) ? String(object.userFlairType) : undefined,
            allowPolls: isSet(object.allowPolls) ? Boolean(object.allowPolls) : undefined,
            collapseDeletedComments: isSet(object.collapseDeletedComments)
                ? Boolean(object.collapseDeletedComments)
                : undefined,
            coins: isSet(object.coins) ? Number(object.coins) : undefined,
            publicDescriptionHtml: isSet(object.publicDescriptionHtml) ? String(object.publicDescriptionHtml) : undefined,
            allowVideos: isSet(object.allowVideos) ? Boolean(object.allowVideos) : undefined,
            isCrosspostableSubreddit: isSet(object.isCrosspostableSubreddit)
                ? Boolean(object.isCrosspostableSubreddit)
                : undefined,
            notificationLevel: isSet(object.notificationLevel) ? String(object.notificationLevel) : undefined,
            shouldShowMediaInCommentsSetting: isSet(object.shouldShowMediaInCommentsSetting)
                ? Boolean(object.shouldShowMediaInCommentsSetting)
                : undefined,
            canAssignLinkFlair: isSet(object.canAssignLinkFlair) ? Boolean(object.canAssignLinkFlair) : undefined,
            hasMenuWidget: isSet(object.hasMenuWidget) ? Boolean(object.hasMenuWidget) : undefined,
            accountsActiveIsFuzzed: isSet(object.accountsActiveIsFuzzed) ? Boolean(object.accountsActiveIsFuzzed) : undefined,
            allowPredictionContributors: isSet(object.allowPredictionContributors)
                ? Boolean(object.allowPredictionContributors)
                : undefined,
            submitTextLabel: isSet(object.submitTextLabel) ? String(object.submitTextLabel) : undefined,
            linkFlairPosition: isSet(object.linkFlairPosition) ? String(object.linkFlairPosition) : undefined,
            userSrFlairEnabled: isSet(object.userSrFlairEnabled) ? Boolean(object.userSrFlairEnabled) : undefined,
            userFlairEnabledInSr: isSet(object.userFlairEnabledInSr) ? Boolean(object.userFlairEnabledInSr) : undefined,
            allowChatPostCreation: isSet(object.allowChatPostCreation) ? Boolean(object.allowChatPostCreation) : undefined,
            allowDiscovery: isSet(object.allowDiscovery) ? Boolean(object.allowDiscovery) : undefined,
            acceptFollowers: isSet(object.acceptFollowers) ? Boolean(object.acceptFollowers) : undefined,
            userSrThemeEnabled: isSet(object.userSrThemeEnabled) ? Boolean(object.userSrThemeEnabled) : undefined,
            linkFlairEnabled: isSet(object.linkFlairEnabled) ? Boolean(object.linkFlairEnabled) : undefined,
            disableContributorRequests: isSet(object.disableContributorRequests)
                ? Boolean(object.disableContributorRequests)
                : undefined,
            subredditType: isSet(object.subredditType) ? String(object.subredditType) : undefined,
            suggestedCommentSort: isSet(object.suggestedCommentSort) ? String(object.suggestedCommentSort) : undefined,
            bannerImg: isSet(object.bannerImg) ? String(object.bannerImg) : undefined,
            userFlairText: isSet(object.userFlairText) ? String(object.userFlairText) : undefined,
            bannerBackgroundColor: isSet(object.bannerBackgroundColor) ? String(object.bannerBackgroundColor) : undefined,
            showMedia: isSet(object.showMedia) ? Boolean(object.showMedia) : undefined,
            id: isSet(object.id) ? String(object.id) : undefined,
            userIsModerator: isSet(object.userIsModerator) ? Boolean(object.userIsModerator) : undefined,
            over18: isSet(object.over18) ? Boolean(object.over18) : undefined,
            headerTitle: isSet(object.headerTitle) ? String(object.headerTitle) : undefined,
            description: isSet(object.description) ? String(object.description) : undefined,
            isChatPostFeatureEnabled: isSet(object.isChatPostFeatureEnabled)
                ? Boolean(object.isChatPostFeatureEnabled)
                : undefined,
            submitLinkLabel: isSet(object.submitLinkLabel) ? String(object.submitLinkLabel) : undefined,
            userFlairTextColor: isSet(object.userFlairTextColor) ? String(object.userFlairTextColor) : undefined,
            restrictCommenting: isSet(object.restrictCommenting) ? Boolean(object.restrictCommenting) : undefined,
            userFlairCssClass: isSet(object.userFlairCssClass) ? String(object.userFlairCssClass) : undefined,
            allowImages: isSet(object.allowImages) ? Boolean(object.allowImages) : undefined,
            lang: isSet(object.lang) ? String(object.lang) : undefined,
            url: isSet(object.url) ? String(object.url) : undefined,
            createdUtc: isSet(object.createdUtc) ? Number(object.createdUtc) : undefined,
            bannerSize: globalThis.Array.isArray(object?.bannerSize)
                ? object.bannerSize.map((e) => Number(e))
                : [],
            mobileBannerImage: isSet(object.mobileBannerImage) ? String(object.mobileBannerImage) : undefined,
            userIsContributor: isSet(object.userIsContributor) ? Boolean(object.userIsContributor) : undefined,
            allowPredictionsTournament: isSet(object.allowPredictionsTournament)
                ? Boolean(object.allowPredictionsTournament)
                : undefined,
            iconSize: globalThis.Array.isArray(object?.iconSize)
                ? object.iconSize.map((e) => Number(e))
                : [],
            headerSize: globalThis.Array.isArray(object?.headerSize)
                ? object.headerSize.map((e) => Number(e))
                : [],
            wls: isSet(object.wls) ? Number(object.wls) : undefined,
            whitelistStatus: isSet(object.whitelistStatus) ? String(object.whitelistStatus) : undefined,
            emojisCustomSize: globalThis.Array.isArray(object?.emojisCustomSize)
                ? object.emojisCustomSize.map((e) => Number(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.userFlairBackgroundColor !== undefined) {
            obj.userFlairBackgroundColor = message.userFlairBackgroundColor;
        }
        if (message.submitTextHtml !== undefined) {
            obj.submitTextHtml = message.submitTextHtml;
        }
        if (message.restrictPosting !== undefined) {
            obj.restrictPosting = message.restrictPosting;
        }
        if (message.userIsBanned !== undefined) {
            obj.userIsBanned = message.userIsBanned;
        }
        if (message.freeFormReports !== undefined) {
            obj.freeFormReports = message.freeFormReports;
        }
        if (message.wikiEnabled !== undefined) {
            obj.wikiEnabled = message.wikiEnabled;
        }
        if (message.userIsMuted !== undefined) {
            obj.userIsMuted = message.userIsMuted;
        }
        if (message.userCanFlairInSr !== undefined) {
            obj.userCanFlairInSr = message.userCanFlairInSr;
        }
        if (message.displayName !== undefined) {
            obj.displayName = message.displayName;
        }
        if (message.headerImg !== undefined) {
            obj.headerImg = message.headerImg;
        }
        if (message.title !== undefined) {
            obj.title = message.title;
        }
        if (message.allowGalleries !== undefined) {
            obj.allowGalleries = message.allowGalleries;
        }
        if (message.primaryColor !== undefined) {
            obj.primaryColor = message.primaryColor;
        }
        if (message.activeUserCount !== undefined) {
            obj.activeUserCount = message.activeUserCount;
        }
        if (message.iconImg !== undefined) {
            obj.iconImg = message.iconImg;
        }
        if (message.displayNamePrefixed !== undefined) {
            obj.displayNamePrefixed = message.displayNamePrefixed;
        }
        if (message.accountsActive !== undefined) {
            obj.accountsActive = message.accountsActive;
        }
        if (message.publicTraffic !== undefined) {
            obj.publicTraffic = message.publicTraffic;
        }
        if (message.subscribers !== undefined) {
            obj.subscribers = message.subscribers;
        }
        if (message.userFlairRichtext?.length) {
            obj.userFlairRichtext = message.userFlairRichtext.map((e) => UserFlairRichtext.toJSON(e));
        }
        if (message.name !== undefined) {
            obj.name = message.name;
        }
        if (message.quarantine !== undefined) {
            obj.quarantine = message.quarantine;
        }
        if (message.hideAds !== undefined) {
            obj.hideAds = message.hideAds;
        }
        if (message.emojisEnabled !== undefined) {
            obj.emojisEnabled = message.emojisEnabled;
        }
        if (message.advertiserCategory !== undefined) {
            obj.advertiserCategory = message.advertiserCategory;
        }
        if (message.publicDescription !== undefined) {
            obj.publicDescription = message.publicDescription;
        }
        if (message.commentScoreHideMins !== undefined) {
            obj.commentScoreHideMins = message.commentScoreHideMins;
        }
        if (message.allowPredictions !== undefined) {
            obj.allowPredictions = message.allowPredictions;
        }
        if (message.userHasFavorited !== undefined) {
            obj.userHasFavorited = message.userHasFavorited;
        }
        if (message.userFlairTemplateId !== undefined) {
            obj.userFlairTemplateId = message.userFlairTemplateId;
        }
        if (message.communityIcon !== undefined) {
            obj.communityIcon = message.communityIcon;
        }
        if (message.bannerBackgroundImage !== undefined) {
            obj.bannerBackgroundImage = message.bannerBackgroundImage;
        }
        if (message.originalContentTagEnabled !== undefined) {
            obj.originalContentTagEnabled = message.originalContentTagEnabled;
        }
        if (message.communityReviewed !== undefined) {
            obj.communityReviewed = message.communityReviewed;
        }
        if (message.submitText !== undefined) {
            obj.submitText = message.submitText;
        }
        if (message.descriptionHtml !== undefined) {
            obj.descriptionHtml = message.descriptionHtml;
        }
        if (message.spoilersEnabled !== undefined) {
            obj.spoilersEnabled = message.spoilersEnabled;
        }
        if (message.commentContributionSettings !== undefined) {
            obj.commentContributionSettings = CommentContributionSettings.toJSON(message.commentContributionSettings);
        }
        if (message.allowTalks !== undefined) {
            obj.allowTalks = message.allowTalks;
        }
        if (message.userFlairPosition !== undefined) {
            obj.userFlairPosition = message.userFlairPosition;
        }
        if (message.allOriginalContent !== undefined) {
            obj.allOriginalContent = message.allOriginalContent;
        }
        if (message.collectionsEnabled !== undefined) {
            obj.collectionsEnabled = message.collectionsEnabled;
        }
        if (message.isEnrolledInNewModmail !== undefined) {
            obj.isEnrolledInNewModmail = message.isEnrolledInNewModmail;
        }
        if (message.keyColor !== undefined) {
            obj.keyColor = message.keyColor;
        }
        if (message.eventPostsEnabled !== undefined) {
            obj.eventPostsEnabled = message.eventPostsEnabled;
        }
        if (message.canAssignUserFlair !== undefined) {
            obj.canAssignUserFlair = message.canAssignUserFlair;
        }
        if (message.created !== undefined) {
            obj.created = message.created;
        }
        if (message.showMediaPreview !== undefined) {
            obj.showMediaPreview = message.showMediaPreview;
        }
        if (message.submissionType !== undefined) {
            obj.submissionType = message.submissionType;
        }
        if (message.userIsSubscriber !== undefined) {
            obj.userIsSubscriber = message.userIsSubscriber;
        }
        if (message.allowedMediaInComments?.length) {
            obj.allowedMediaInComments = message.allowedMediaInComments;
        }
        if (message.allowVideogifs !== undefined) {
            obj.allowVideogifs = message.allowVideogifs;
        }
        if (message.shouldArchivePosts !== undefined) {
            obj.shouldArchivePosts = message.shouldArchivePosts;
        }
        if (message.userFlairType !== undefined) {
            obj.userFlairType = message.userFlairType;
        }
        if (message.allowPolls !== undefined) {
            obj.allowPolls = message.allowPolls;
        }
        if (message.collapseDeletedComments !== undefined) {
            obj.collapseDeletedComments = message.collapseDeletedComments;
        }
        if (message.coins !== undefined) {
            obj.coins = message.coins;
        }
        if (message.publicDescriptionHtml !== undefined) {
            obj.publicDescriptionHtml = message.publicDescriptionHtml;
        }
        if (message.allowVideos !== undefined) {
            obj.allowVideos = message.allowVideos;
        }
        if (message.isCrosspostableSubreddit !== undefined) {
            obj.isCrosspostableSubreddit = message.isCrosspostableSubreddit;
        }
        if (message.notificationLevel !== undefined) {
            obj.notificationLevel = message.notificationLevel;
        }
        if (message.shouldShowMediaInCommentsSetting !== undefined) {
            obj.shouldShowMediaInCommentsSetting = message.shouldShowMediaInCommentsSetting;
        }
        if (message.canAssignLinkFlair !== undefined) {
            obj.canAssignLinkFlair = message.canAssignLinkFlair;
        }
        if (message.hasMenuWidget !== undefined) {
            obj.hasMenuWidget = message.hasMenuWidget;
        }
        if (message.accountsActiveIsFuzzed !== undefined) {
            obj.accountsActiveIsFuzzed = message.accountsActiveIsFuzzed;
        }
        if (message.allowPredictionContributors !== undefined) {
            obj.allowPredictionContributors = message.allowPredictionContributors;
        }
        if (message.submitTextLabel !== undefined) {
            obj.submitTextLabel = message.submitTextLabel;
        }
        if (message.linkFlairPosition !== undefined) {
            obj.linkFlairPosition = message.linkFlairPosition;
        }
        if (message.userSrFlairEnabled !== undefined) {
            obj.userSrFlairEnabled = message.userSrFlairEnabled;
        }
        if (message.userFlairEnabledInSr !== undefined) {
            obj.userFlairEnabledInSr = message.userFlairEnabledInSr;
        }
        if (message.allowChatPostCreation !== undefined) {
            obj.allowChatPostCreation = message.allowChatPostCreation;
        }
        if (message.allowDiscovery !== undefined) {
            obj.allowDiscovery = message.allowDiscovery;
        }
        if (message.acceptFollowers !== undefined) {
            obj.acceptFollowers = message.acceptFollowers;
        }
        if (message.userSrThemeEnabled !== undefined) {
            obj.userSrThemeEnabled = message.userSrThemeEnabled;
        }
        if (message.linkFlairEnabled !== undefined) {
            obj.linkFlairEnabled = message.linkFlairEnabled;
        }
        if (message.disableContributorRequests !== undefined) {
            obj.disableContributorRequests = message.disableContributorRequests;
        }
        if (message.subredditType !== undefined) {
            obj.subredditType = message.subredditType;
        }
        if (message.suggestedCommentSort !== undefined) {
            obj.suggestedCommentSort = message.suggestedCommentSort;
        }
        if (message.bannerImg !== undefined) {
            obj.bannerImg = message.bannerImg;
        }
        if (message.userFlairText !== undefined) {
            obj.userFlairText = message.userFlairText;
        }
        if (message.bannerBackgroundColor !== undefined) {
            obj.bannerBackgroundColor = message.bannerBackgroundColor;
        }
        if (message.showMedia !== undefined) {
            obj.showMedia = message.showMedia;
        }
        if (message.id !== undefined) {
            obj.id = message.id;
        }
        if (message.userIsModerator !== undefined) {
            obj.userIsModerator = message.userIsModerator;
        }
        if (message.over18 !== undefined) {
            obj.over18 = message.over18;
        }
        if (message.headerTitle !== undefined) {
            obj.headerTitle = message.headerTitle;
        }
        if (message.description !== undefined) {
            obj.description = message.description;
        }
        if (message.isChatPostFeatureEnabled !== undefined) {
            obj.isChatPostFeatureEnabled = message.isChatPostFeatureEnabled;
        }
        if (message.submitLinkLabel !== undefined) {
            obj.submitLinkLabel = message.submitLinkLabel;
        }
        if (message.userFlairTextColor !== undefined) {
            obj.userFlairTextColor = message.userFlairTextColor;
        }
        if (message.restrictCommenting !== undefined) {
            obj.restrictCommenting = message.restrictCommenting;
        }
        if (message.userFlairCssClass !== undefined) {
            obj.userFlairCssClass = message.userFlairCssClass;
        }
        if (message.allowImages !== undefined) {
            obj.allowImages = message.allowImages;
        }
        if (message.lang !== undefined) {
            obj.lang = message.lang;
        }
        if (message.url !== undefined) {
            obj.url = message.url;
        }
        if (message.createdUtc !== undefined) {
            obj.createdUtc = message.createdUtc;
        }
        if (message.bannerSize?.length) {
            obj.bannerSize = message.bannerSize;
        }
        if (message.mobileBannerImage !== undefined) {
            obj.mobileBannerImage = message.mobileBannerImage;
        }
        if (message.userIsContributor !== undefined) {
            obj.userIsContributor = message.userIsContributor;
        }
        if (message.allowPredictionsTournament !== undefined) {
            obj.allowPredictionsTournament = message.allowPredictionsTournament;
        }
        if (message.iconSize?.length) {
            obj.iconSize = message.iconSize;
        }
        if (message.headerSize?.length) {
            obj.headerSize = message.headerSize;
        }
        if (message.wls !== undefined) {
            obj.wls = message.wls;
        }
        if (message.whitelistStatus !== undefined) {
            obj.whitelistStatus = message.whitelistStatus;
        }
        if (message.emojisCustomSize?.length) {
            obj.emojisCustomSize = message.emojisCustomSize;
        }
        return obj;
    },
    create(base) {
        return SubredditAboutResponse_AboutData.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSubredditAboutResponse_AboutData();
        message.userFlairBackgroundColor = object.userFlairBackgroundColor ?? undefined;
        message.submitTextHtml = object.submitTextHtml ?? undefined;
        message.restrictPosting = object.restrictPosting ?? undefined;
        message.userIsBanned = object.userIsBanned ?? undefined;
        message.freeFormReports = object.freeFormReports ?? undefined;
        message.wikiEnabled = object.wikiEnabled ?? undefined;
        message.userIsMuted = object.userIsMuted ?? undefined;
        message.userCanFlairInSr = object.userCanFlairInSr ?? undefined;
        message.displayName = object.displayName ?? undefined;
        message.headerImg = object.headerImg ?? undefined;
        message.title = object.title ?? undefined;
        message.allowGalleries = object.allowGalleries ?? undefined;
        message.primaryColor = object.primaryColor ?? undefined;
        message.activeUserCount = object.activeUserCount ?? undefined;
        message.iconImg = object.iconImg ?? undefined;
        message.displayNamePrefixed = object.displayNamePrefixed ?? undefined;
        message.accountsActive = object.accountsActive ?? undefined;
        message.publicTraffic = object.publicTraffic ?? undefined;
        message.subscribers = object.subscribers ?? undefined;
        message.userFlairRichtext = object.userFlairRichtext?.map((e) => UserFlairRichtext.fromPartial(e)) || [];
        message.name = object.name ?? undefined;
        message.quarantine = object.quarantine ?? undefined;
        message.hideAds = object.hideAds ?? undefined;
        message.emojisEnabled = object.emojisEnabled ?? undefined;
        message.advertiserCategory = object.advertiserCategory ?? undefined;
        message.publicDescription = object.publicDescription ?? undefined;
        message.commentScoreHideMins = object.commentScoreHideMins ?? undefined;
        message.allowPredictions = object.allowPredictions ?? undefined;
        message.userHasFavorited = object.userHasFavorited ?? undefined;
        message.userFlairTemplateId = object.userFlairTemplateId ?? undefined;
        message.communityIcon = object.communityIcon ?? undefined;
        message.bannerBackgroundImage = object.bannerBackgroundImage ?? undefined;
        message.originalContentTagEnabled = object.originalContentTagEnabled ?? undefined;
        message.communityReviewed = object.communityReviewed ?? undefined;
        message.submitText = object.submitText ?? undefined;
        message.descriptionHtml = object.descriptionHtml ?? undefined;
        message.spoilersEnabled = object.spoilersEnabled ?? undefined;
        message.commentContributionSettings =
            (object.commentContributionSettings !== undefined && object.commentContributionSettings !== null)
                ? CommentContributionSettings.fromPartial(object.commentContributionSettings)
                : undefined;
        message.allowTalks = object.allowTalks ?? undefined;
        message.userFlairPosition = object.userFlairPosition ?? undefined;
        message.allOriginalContent = object.allOriginalContent ?? undefined;
        message.collectionsEnabled = object.collectionsEnabled ?? undefined;
        message.isEnrolledInNewModmail = object.isEnrolledInNewModmail ?? undefined;
        message.keyColor = object.keyColor ?? undefined;
        message.eventPostsEnabled = object.eventPostsEnabled ?? undefined;
        message.canAssignUserFlair = object.canAssignUserFlair ?? undefined;
        message.created = object.created ?? undefined;
        message.showMediaPreview = object.showMediaPreview ?? undefined;
        message.submissionType = object.submissionType ?? undefined;
        message.userIsSubscriber = object.userIsSubscriber ?? undefined;
        message.allowedMediaInComments = object.allowedMediaInComments?.map((e) => e) || [];
        message.allowVideogifs = object.allowVideogifs ?? undefined;
        message.shouldArchivePosts = object.shouldArchivePosts ?? undefined;
        message.userFlairType = object.userFlairType ?? undefined;
        message.allowPolls = object.allowPolls ?? undefined;
        message.collapseDeletedComments = object.collapseDeletedComments ?? undefined;
        message.coins = object.coins ?? undefined;
        message.publicDescriptionHtml = object.publicDescriptionHtml ?? undefined;
        message.allowVideos = object.allowVideos ?? undefined;
        message.isCrosspostableSubreddit = object.isCrosspostableSubreddit ?? undefined;
        message.notificationLevel = object.notificationLevel ?? undefined;
        message.shouldShowMediaInCommentsSetting = object.shouldShowMediaInCommentsSetting ?? undefined;
        message.canAssignLinkFlair = object.canAssignLinkFlair ?? undefined;
        message.hasMenuWidget = object.hasMenuWidget ?? undefined;
        message.accountsActiveIsFuzzed = object.accountsActiveIsFuzzed ?? undefined;
        message.allowPredictionContributors = object.allowPredictionContributors ?? undefined;
        message.submitTextLabel = object.submitTextLabel ?? undefined;
        message.linkFlairPosition = object.linkFlairPosition ?? undefined;
        message.userSrFlairEnabled = object.userSrFlairEnabled ?? undefined;
        message.userFlairEnabledInSr = object.userFlairEnabledInSr ?? undefined;
        message.allowChatPostCreation = object.allowChatPostCreation ?? undefined;
        message.allowDiscovery = object.allowDiscovery ?? undefined;
        message.acceptFollowers = object.acceptFollowers ?? undefined;
        message.userSrThemeEnabled = object.userSrThemeEnabled ?? undefined;
        message.linkFlairEnabled = object.linkFlairEnabled ?? undefined;
        message.disableContributorRequests = object.disableContributorRequests ?? undefined;
        message.subredditType = object.subredditType ?? undefined;
        message.suggestedCommentSort = object.suggestedCommentSort ?? undefined;
        message.bannerImg = object.bannerImg ?? undefined;
        message.userFlairText = object.userFlairText ?? undefined;
        message.bannerBackgroundColor = object.bannerBackgroundColor ?? undefined;
        message.showMedia = object.showMedia ?? undefined;
        message.id = object.id ?? undefined;
        message.userIsModerator = object.userIsModerator ?? undefined;
        message.over18 = object.over18 ?? undefined;
        message.headerTitle = object.headerTitle ?? undefined;
        message.description = object.description ?? undefined;
        message.isChatPostFeatureEnabled = object.isChatPostFeatureEnabled ?? undefined;
        message.submitLinkLabel = object.submitLinkLabel ?? undefined;
        message.userFlairTextColor = object.userFlairTextColor ?? undefined;
        message.restrictCommenting = object.restrictCommenting ?? undefined;
        message.userFlairCssClass = object.userFlairCssClass ?? undefined;
        message.allowImages = object.allowImages ?? undefined;
        message.lang = object.lang ?? undefined;
        message.url = object.url ?? undefined;
        message.createdUtc = object.createdUtc ?? undefined;
        message.bannerSize = object.bannerSize?.map((e) => e) || [];
        message.mobileBannerImage = object.mobileBannerImage ?? undefined;
        message.userIsContributor = object.userIsContributor ?? undefined;
        message.allowPredictionsTournament = object.allowPredictionsTournament ?? undefined;
        message.iconSize = object.iconSize?.map((e) => e) || [];
        message.headerSize = object.headerSize?.map((e) => e) || [];
        message.wls = object.wls ?? undefined;
        message.whitelistStatus = object.whitelistStatus ?? undefined;
        message.emojisCustomSize = object.emojisCustomSize?.map((e) => e) || [];
        return message;
    },
};
messageTypeRegistry.set(SubredditAboutResponse_AboutData.$type, SubredditAboutResponse_AboutData);
function createBaseSubredditAboutEditResponse() {
    return { kind: undefined, data: undefined };
}
export const SubredditAboutEditResponse = {
    $type: "devvit.plugin.redditapi.subreddits.SubredditAboutEditResponse",
    encode(message, writer = _m0.Writer.create()) {
        if (message.kind !== undefined) {
            StringValue.encode({ value: message.kind }, writer.uint32(10).fork()).ldelim();
        }
        if (message.data !== undefined) {
            SubredditAboutEditResponse_SubredditSettings.encode(message.data, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSubredditAboutEditResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.kind = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.data = SubredditAboutEditResponse_SubredditSettings.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            kind: isSet(object.kind) ? String(object.kind) : undefined,
            data: isSet(object.data) ? SubredditAboutEditResponse_SubredditSettings.fromJSON(object.data) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.kind !== undefined) {
            obj.kind = message.kind;
        }
        if (message.data !== undefined) {
            obj.data = SubredditAboutEditResponse_SubredditSettings.toJSON(message.data);
        }
        return obj;
    },
    create(base) {
        return SubredditAboutEditResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSubredditAboutEditResponse();
        message.kind = object.kind ?? undefined;
        message.data = (object.data !== undefined && object.data !== null)
            ? SubredditAboutEditResponse_SubredditSettings.fromPartial(object.data)
            : undefined;
        return message;
    },
};
messageTypeRegistry.set(SubredditAboutEditResponse.$type, SubredditAboutEditResponse);
function createBaseSubredditAboutEditResponse_SubredditSettings() {
    return {
        defaultSet: undefined,
        toxicityThresholdChatLevel: undefined,
        crowdControlChatLevel: undefined,
        restrictPosting: undefined,
        publicDescription: undefined,
        subredditId: undefined,
        allowImages: undefined,
        freeFormReports: undefined,
        domain: undefined,
        originalContentTagEnabled: undefined,
        showMedia: undefined,
        excludeBannedModqueue: undefined,
        shouldArchivePosts: undefined,
        submitText: undefined,
        spamLinks: undefined,
        title: undefined,
        collapseDeletedComments: undefined,
        wikimode: undefined,
        over18: undefined,
        allowVideos: undefined,
        allowGalleries: undefined,
        crowdControlLevel: undefined,
        banEvasionThreshold: undefined,
        crowdControlMode: undefined,
        welcomeMessageEnabled: undefined,
        welcomeMessageText: undefined,
        suggestedCommentSort: undefined,
        disableContributorRequests: undefined,
        allowTalks: undefined,
        description: undefined,
        submitLinkLabel: undefined,
        spoilersEnabled: undefined,
        allowPostCrossposts: undefined,
        spamComments: undefined,
        publicTraffic: undefined,
        restrictCommenting: undefined,
        allowPolls: undefined,
        commentContributionSettings: undefined,
        submitTextLabel: undefined,
        commentScoreHideMins: undefined,
        allOriginalContent: undefined,
        spamSelfposts: undefined,
        keyColor: undefined,
        language: undefined,
        newPinnedPostPnsEnabled: undefined,
        hideAds: undefined,
        predictionLeaderboardEntryType: undefined,
        headerHoverText: undefined,
        wikiEditAge: undefined,
        allowChatPostCreation: undefined,
        allowPredictionContributors: undefined,
        allowDiscovery: undefined,
        acceptFollowers: undefined,
        crowdControlPostLevel: undefined,
        allowPredictionsTournament: undefined,
        wikiEditKarma: undefined,
        showMediaPreview: undefined,
        crowdControlFilter: undefined,
        subredditType: undefined,
        allowPredictions: undefined,
        userFlairPnsEnabled: undefined,
        contentOptions: undefined,
    };
}
export const SubredditAboutEditResponse_SubredditSettings = {
    $type: "devvit.plugin.redditapi.subreddits.SubredditAboutEditResponse.SubredditSettings",
    encode(message, writer = _m0.Writer.create()) {
        if (message.defaultSet !== undefined) {
            BoolValue.encode({ value: message.defaultSet }, writer.uint32(10).fork()).ldelim();
        }
        if (message.toxicityThresholdChatLevel !== undefined) {
            Int32Value.encode({ value: message.toxicityThresholdChatLevel }, writer.uint32(18).fork()).ldelim();
        }
        if (message.crowdControlChatLevel !== undefined) {
            Int32Value.encode({ value: message.crowdControlChatLevel }, writer.uint32(26).fork()).ldelim();
        }
        if (message.restrictPosting !== undefined) {
            BoolValue.encode({ value: message.restrictPosting }, writer.uint32(34).fork()).ldelim();
        }
        if (message.publicDescription !== undefined) {
            StringValue.encode({ value: message.publicDescription }, writer.uint32(42).fork()).ldelim();
        }
        if (message.subredditId !== undefined) {
            StringValue.encode({ value: message.subredditId }, writer.uint32(50).fork()).ldelim();
        }
        if (message.allowImages !== undefined) {
            BoolValue.encode({ value: message.allowImages }, writer.uint32(58).fork()).ldelim();
        }
        if (message.freeFormReports !== undefined) {
            BoolValue.encode({ value: message.freeFormReports }, writer.uint32(66).fork()).ldelim();
        }
        if (message.domain !== undefined) {
            StringValue.encode({ value: message.domain }, writer.uint32(74).fork()).ldelim();
        }
        if (message.originalContentTagEnabled !== undefined) {
            BoolValue.encode({ value: message.originalContentTagEnabled }, writer.uint32(82).fork()).ldelim();
        }
        if (message.showMedia !== undefined) {
            BoolValue.encode({ value: message.showMedia }, writer.uint32(90).fork()).ldelim();
        }
        if (message.excludeBannedModqueue !== undefined) {
            BoolValue.encode({ value: message.excludeBannedModqueue }, writer.uint32(98).fork()).ldelim();
        }
        if (message.shouldArchivePosts !== undefined) {
            BoolValue.encode({ value: message.shouldArchivePosts }, writer.uint32(106).fork()).ldelim();
        }
        if (message.submitText !== undefined) {
            StringValue.encode({ value: message.submitText }, writer.uint32(114).fork()).ldelim();
        }
        if (message.spamLinks !== undefined) {
            StringValue.encode({ value: message.spamLinks }, writer.uint32(122).fork()).ldelim();
        }
        if (message.title !== undefined) {
            StringValue.encode({ value: message.title }, writer.uint32(130).fork()).ldelim();
        }
        if (message.collapseDeletedComments !== undefined) {
            BoolValue.encode({ value: message.collapseDeletedComments }, writer.uint32(138).fork()).ldelim();
        }
        if (message.wikimode !== undefined) {
            StringValue.encode({ value: message.wikimode }, writer.uint32(146).fork()).ldelim();
        }
        if (message.over18 !== undefined) {
            BoolValue.encode({ value: message.over18 }, writer.uint32(154).fork()).ldelim();
        }
        if (message.allowVideos !== undefined) {
            BoolValue.encode({ value: message.allowVideos }, writer.uint32(162).fork()).ldelim();
        }
        if (message.allowGalleries !== undefined) {
            BoolValue.encode({ value: message.allowGalleries }, writer.uint32(170).fork()).ldelim();
        }
        if (message.crowdControlLevel !== undefined) {
            Int32Value.encode({ value: message.crowdControlLevel }, writer.uint32(178).fork()).ldelim();
        }
        if (message.banEvasionThreshold !== undefined) {
            Int32Value.encode({ value: message.banEvasionThreshold }, writer.uint32(186).fork()).ldelim();
        }
        if (message.crowdControlMode !== undefined) {
            BoolValue.encode({ value: message.crowdControlMode }, writer.uint32(194).fork()).ldelim();
        }
        if (message.welcomeMessageEnabled !== undefined) {
            BoolValue.encode({ value: message.welcomeMessageEnabled }, writer.uint32(202).fork()).ldelim();
        }
        if (message.welcomeMessageText !== undefined) {
            StringValue.encode({ value: message.welcomeMessageText }, writer.uint32(210).fork()).ldelim();
        }
        if (message.suggestedCommentSort !== undefined) {
            BoolValue.encode({ value: message.suggestedCommentSort }, writer.uint32(218).fork()).ldelim();
        }
        if (message.disableContributorRequests !== undefined) {
            BoolValue.encode({ value: message.disableContributorRequests }, writer.uint32(226).fork()).ldelim();
        }
        if (message.allowTalks !== undefined) {
            BoolValue.encode({ value: message.allowTalks }, writer.uint32(234).fork()).ldelim();
        }
        if (message.description !== undefined) {
            StringValue.encode({ value: message.description }, writer.uint32(242).fork()).ldelim();
        }
        if (message.submitLinkLabel !== undefined) {
            StringValue.encode({ value: message.submitLinkLabel }, writer.uint32(250).fork()).ldelim();
        }
        if (message.spoilersEnabled !== undefined) {
            BoolValue.encode({ value: message.spoilersEnabled }, writer.uint32(258).fork()).ldelim();
        }
        if (message.allowPostCrossposts !== undefined) {
            BoolValue.encode({ value: message.allowPostCrossposts }, writer.uint32(266).fork()).ldelim();
        }
        if (message.spamComments !== undefined) {
            StringValue.encode({ value: message.spamComments }, writer.uint32(274).fork()).ldelim();
        }
        if (message.publicTraffic !== undefined) {
            BoolValue.encode({ value: message.publicTraffic }, writer.uint32(282).fork()).ldelim();
        }
        if (message.restrictCommenting !== undefined) {
            BoolValue.encode({ value: message.restrictCommenting }, writer.uint32(290).fork()).ldelim();
        }
        if (message.allowPolls !== undefined) {
            BoolValue.encode({ value: message.allowPolls }, writer.uint32(298).fork()).ldelim();
        }
        if (message.commentContributionSettings !== undefined) {
            CommentContributionSettings.encode(message.commentContributionSettings, writer.uint32(306).fork()).ldelim();
        }
        if (message.submitTextLabel !== undefined) {
            StringValue.encode({ value: message.submitTextLabel }, writer.uint32(314).fork()).ldelim();
        }
        if (message.commentScoreHideMins !== undefined) {
            Int32Value.encode({ value: message.commentScoreHideMins }, writer.uint32(322).fork()).ldelim();
        }
        if (message.allOriginalContent !== undefined) {
            BoolValue.encode({ value: message.allOriginalContent }, writer.uint32(330).fork()).ldelim();
        }
        if (message.spamSelfposts !== undefined) {
            StringValue.encode({ value: message.spamSelfposts }, writer.uint32(338).fork()).ldelim();
        }
        if (message.keyColor !== undefined) {
            StringValue.encode({ value: message.keyColor }, writer.uint32(346).fork()).ldelim();
        }
        if (message.language !== undefined) {
            StringValue.encode({ value: message.language }, writer.uint32(354).fork()).ldelim();
        }
        if (message.newPinnedPostPnsEnabled !== undefined) {
            BoolValue.encode({ value: message.newPinnedPostPnsEnabled }, writer.uint32(362).fork()).ldelim();
        }
        if (message.hideAds !== undefined) {
            BoolValue.encode({ value: message.hideAds }, writer.uint32(370).fork()).ldelim();
        }
        if (message.predictionLeaderboardEntryType !== undefined) {
            Int32Value.encode({ value: message.predictionLeaderboardEntryType }, writer.uint32(378).fork()).ldelim();
        }
        if (message.headerHoverText !== undefined) {
            StringValue.encode({ value: message.headerHoverText }, writer.uint32(386).fork()).ldelim();
        }
        if (message.wikiEditAge !== undefined) {
            Int32Value.encode({ value: message.wikiEditAge }, writer.uint32(394).fork()).ldelim();
        }
        if (message.allowChatPostCreation !== undefined) {
            BoolValue.encode({ value: message.allowChatPostCreation }, writer.uint32(402).fork()).ldelim();
        }
        if (message.allowPredictionContributors !== undefined) {
            BoolValue.encode({ value: message.allowPredictionContributors }, writer.uint32(410).fork()).ldelim();
        }
        if (message.allowDiscovery !== undefined) {
            BoolValue.encode({ value: message.allowDiscovery }, writer.uint32(418).fork()).ldelim();
        }
        if (message.acceptFollowers !== undefined) {
            BoolValue.encode({ value: message.acceptFollowers }, writer.uint32(426).fork()).ldelim();
        }
        if (message.crowdControlPostLevel !== undefined) {
            Int32Value.encode({ value: message.crowdControlPostLevel }, writer.uint32(434).fork()).ldelim();
        }
        if (message.allowPredictionsTournament !== undefined) {
            BoolValue.encode({ value: message.allowPredictionsTournament }, writer.uint32(442).fork()).ldelim();
        }
        if (message.wikiEditKarma !== undefined) {
            Int32Value.encode({ value: message.wikiEditKarma }, writer.uint32(450).fork()).ldelim();
        }
        if (message.showMediaPreview !== undefined) {
            BoolValue.encode({ value: message.showMediaPreview }, writer.uint32(458).fork()).ldelim();
        }
        if (message.crowdControlFilter !== undefined) {
            BoolValue.encode({ value: message.crowdControlFilter }, writer.uint32(466).fork()).ldelim();
        }
        if (message.subredditType !== undefined) {
            StringValue.encode({ value: message.subredditType }, writer.uint32(474).fork()).ldelim();
        }
        if (message.allowPredictions !== undefined) {
            BoolValue.encode({ value: message.allowPredictions }, writer.uint32(482).fork()).ldelim();
        }
        if (message.userFlairPnsEnabled !== undefined) {
            BoolValue.encode({ value: message.userFlairPnsEnabled }, writer.uint32(490).fork()).ldelim();
        }
        if (message.contentOptions !== undefined) {
            StringValue.encode({ value: message.contentOptions }, writer.uint32(498).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSubredditAboutEditResponse_SubredditSettings();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.defaultSet = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.toxicityThresholdChatLevel = Int32Value.decode(reader, reader.uint32()).value;
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.crowdControlChatLevel = Int32Value.decode(reader, reader.uint32()).value;
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.restrictPosting = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.publicDescription = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.subredditId = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.allowImages = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.freeFormReports = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 9:
                    if (tag !== 74) {
                        break;
                    }
                    message.domain = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.originalContentTagEnabled = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 11:
                    if (tag !== 90) {
                        break;
                    }
                    message.showMedia = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 12:
                    if (tag !== 98) {
                        break;
                    }
                    message.excludeBannedModqueue = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 13:
                    if (tag !== 106) {
                        break;
                    }
                    message.shouldArchivePosts = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 14:
                    if (tag !== 114) {
                        break;
                    }
                    message.submitText = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 15:
                    if (tag !== 122) {
                        break;
                    }
                    message.spamLinks = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 16:
                    if (tag !== 130) {
                        break;
                    }
                    message.title = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 17:
                    if (tag !== 138) {
                        break;
                    }
                    message.collapseDeletedComments = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 18:
                    if (tag !== 146) {
                        break;
                    }
                    message.wikimode = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 19:
                    if (tag !== 154) {
                        break;
                    }
                    message.over18 = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 20:
                    if (tag !== 162) {
                        break;
                    }
                    message.allowVideos = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 21:
                    if (tag !== 170) {
                        break;
                    }
                    message.allowGalleries = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 22:
                    if (tag !== 178) {
                        break;
                    }
                    message.crowdControlLevel = Int32Value.decode(reader, reader.uint32()).value;
                    continue;
                case 23:
                    if (tag !== 186) {
                        break;
                    }
                    message.banEvasionThreshold = Int32Value.decode(reader, reader.uint32()).value;
                    continue;
                case 24:
                    if (tag !== 194) {
                        break;
                    }
                    message.crowdControlMode = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 25:
                    if (tag !== 202) {
                        break;
                    }
                    message.welcomeMessageEnabled = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 26:
                    if (tag !== 210) {
                        break;
                    }
                    message.welcomeMessageText = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 27:
                    if (tag !== 218) {
                        break;
                    }
                    message.suggestedCommentSort = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 28:
                    if (tag !== 226) {
                        break;
                    }
                    message.disableContributorRequests = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 29:
                    if (tag !== 234) {
                        break;
                    }
                    message.allowTalks = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 30:
                    if (tag !== 242) {
                        break;
                    }
                    message.description = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 31:
                    if (tag !== 250) {
                        break;
                    }
                    message.submitLinkLabel = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 32:
                    if (tag !== 258) {
                        break;
                    }
                    message.spoilersEnabled = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 33:
                    if (tag !== 266) {
                        break;
                    }
                    message.allowPostCrossposts = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 34:
                    if (tag !== 274) {
                        break;
                    }
                    message.spamComments = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 35:
                    if (tag !== 282) {
                        break;
                    }
                    message.publicTraffic = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 36:
                    if (tag !== 290) {
                        break;
                    }
                    message.restrictCommenting = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 37:
                    if (tag !== 298) {
                        break;
                    }
                    message.allowPolls = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 38:
                    if (tag !== 306) {
                        break;
                    }
                    message.commentContributionSettings = CommentContributionSettings.decode(reader, reader.uint32());
                    continue;
                case 39:
                    if (tag !== 314) {
                        break;
                    }
                    message.submitTextLabel = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 40:
                    if (tag !== 322) {
                        break;
                    }
                    message.commentScoreHideMins = Int32Value.decode(reader, reader.uint32()).value;
                    continue;
                case 41:
                    if (tag !== 330) {
                        break;
                    }
                    message.allOriginalContent = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 42:
                    if (tag !== 338) {
                        break;
                    }
                    message.spamSelfposts = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 43:
                    if (tag !== 346) {
                        break;
                    }
                    message.keyColor = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 44:
                    if (tag !== 354) {
                        break;
                    }
                    message.language = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 45:
                    if (tag !== 362) {
                        break;
                    }
                    message.newPinnedPostPnsEnabled = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 46:
                    if (tag !== 370) {
                        break;
                    }
                    message.hideAds = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 47:
                    if (tag !== 378) {
                        break;
                    }
                    message.predictionLeaderboardEntryType = Int32Value.decode(reader, reader.uint32()).value;
                    continue;
                case 48:
                    if (tag !== 386) {
                        break;
                    }
                    message.headerHoverText = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 49:
                    if (tag !== 394) {
                        break;
                    }
                    message.wikiEditAge = Int32Value.decode(reader, reader.uint32()).value;
                    continue;
                case 50:
                    if (tag !== 402) {
                        break;
                    }
                    message.allowChatPostCreation = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 51:
                    if (tag !== 410) {
                        break;
                    }
                    message.allowPredictionContributors = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 52:
                    if (tag !== 418) {
                        break;
                    }
                    message.allowDiscovery = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 53:
                    if (tag !== 426) {
                        break;
                    }
                    message.acceptFollowers = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 54:
                    if (tag !== 434) {
                        break;
                    }
                    message.crowdControlPostLevel = Int32Value.decode(reader, reader.uint32()).value;
                    continue;
                case 55:
                    if (tag !== 442) {
                        break;
                    }
                    message.allowPredictionsTournament = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 56:
                    if (tag !== 450) {
                        break;
                    }
                    message.wikiEditKarma = Int32Value.decode(reader, reader.uint32()).value;
                    continue;
                case 57:
                    if (tag !== 458) {
                        break;
                    }
                    message.showMediaPreview = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 58:
                    if (tag !== 466) {
                        break;
                    }
                    message.crowdControlFilter = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 59:
                    if (tag !== 474) {
                        break;
                    }
                    message.subredditType = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 60:
                    if (tag !== 482) {
                        break;
                    }
                    message.allowPredictions = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 61:
                    if (tag !== 490) {
                        break;
                    }
                    message.userFlairPnsEnabled = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 62:
                    if (tag !== 498) {
                        break;
                    }
                    message.contentOptions = StringValue.decode(reader, reader.uint32()).value;
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            defaultSet: isSet(object.defaultSet) ? Boolean(object.defaultSet) : undefined,
            toxicityThresholdChatLevel: isSet(object.toxicityThresholdChatLevel)
                ? Number(object.toxicityThresholdChatLevel)
                : undefined,
            crowdControlChatLevel: isSet(object.crowdControlChatLevel) ? Number(object.crowdControlChatLevel) : undefined,
            restrictPosting: isSet(object.restrictPosting) ? Boolean(object.restrictPosting) : undefined,
            publicDescription: isSet(object.publicDescription) ? String(object.publicDescription) : undefined,
            subredditId: isSet(object.subredditId) ? String(object.subredditId) : undefined,
            allowImages: isSet(object.allowImages) ? Boolean(object.allowImages) : undefined,
            freeFormReports: isSet(object.freeFormReports) ? Boolean(object.freeFormReports) : undefined,
            domain: isSet(object.domain) ? String(object.domain) : undefined,
            originalContentTagEnabled: isSet(object.originalContentTagEnabled)
                ? Boolean(object.originalContentTagEnabled)
                : undefined,
            showMedia: isSet(object.showMedia) ? Boolean(object.showMedia) : undefined,
            excludeBannedModqueue: isSet(object.excludeBannedModqueue) ? Boolean(object.excludeBannedModqueue) : undefined,
            shouldArchivePosts: isSet(object.shouldArchivePosts) ? Boolean(object.shouldArchivePosts) : undefined,
            submitText: isSet(object.submitText) ? String(object.submitText) : undefined,
            spamLinks: isSet(object.spamLinks) ? String(object.spamLinks) : undefined,
            title: isSet(object.title) ? String(object.title) : undefined,
            collapseDeletedComments: isSet(object.collapseDeletedComments)
                ? Boolean(object.collapseDeletedComments)
                : undefined,
            wikimode: isSet(object.wikimode) ? String(object.wikimode) : undefined,
            over18: isSet(object.over18) ? Boolean(object.over18) : undefined,
            allowVideos: isSet(object.allowVideos) ? Boolean(object.allowVideos) : undefined,
            allowGalleries: isSet(object.allowGalleries) ? Boolean(object.allowGalleries) : undefined,
            crowdControlLevel: isSet(object.crowdControlLevel) ? Number(object.crowdControlLevel) : undefined,
            banEvasionThreshold: isSet(object.banEvasionThreshold) ? Number(object.banEvasionThreshold) : undefined,
            crowdControlMode: isSet(object.crowdControlMode) ? Boolean(object.crowdControlMode) : undefined,
            welcomeMessageEnabled: isSet(object.welcomeMessageEnabled) ? Boolean(object.welcomeMessageEnabled) : undefined,
            welcomeMessageText: isSet(object.welcomeMessageText) ? String(object.welcomeMessageText) : undefined,
            suggestedCommentSort: isSet(object.suggestedCommentSort) ? Boolean(object.suggestedCommentSort) : undefined,
            disableContributorRequests: isSet(object.disableContributorRequests)
                ? Boolean(object.disableContributorRequests)
                : undefined,
            allowTalks: isSet(object.allowTalks) ? Boolean(object.allowTalks) : undefined,
            description: isSet(object.description) ? String(object.description) : undefined,
            submitLinkLabel: isSet(object.submitLinkLabel) ? String(object.submitLinkLabel) : undefined,
            spoilersEnabled: isSet(object.spoilersEnabled) ? Boolean(object.spoilersEnabled) : undefined,
            allowPostCrossposts: isSet(object.allowPostCrossposts) ? Boolean(object.allowPostCrossposts) : undefined,
            spamComments: isSet(object.spamComments) ? String(object.spamComments) : undefined,
            publicTraffic: isSet(object.publicTraffic) ? Boolean(object.publicTraffic) : undefined,
            restrictCommenting: isSet(object.restrictCommenting) ? Boolean(object.restrictCommenting) : undefined,
            allowPolls: isSet(object.allowPolls) ? Boolean(object.allowPolls) : undefined,
            commentContributionSettings: isSet(object.commentContributionSettings)
                ? CommentContributionSettings.fromJSON(object.commentContributionSettings)
                : undefined,
            submitTextLabel: isSet(object.submitTextLabel) ? String(object.submitTextLabel) : undefined,
            commentScoreHideMins: isSet(object.commentScoreHideMins) ? Number(object.commentScoreHideMins) : undefined,
            allOriginalContent: isSet(object.allOriginalContent) ? Boolean(object.allOriginalContent) : undefined,
            spamSelfposts: isSet(object.spamSelfposts) ? String(object.spamSelfposts) : undefined,
            keyColor: isSet(object.keyColor) ? String(object.keyColor) : undefined,
            language: isSet(object.language) ? String(object.language) : undefined,
            newPinnedPostPnsEnabled: isSet(object.newPinnedPostPnsEnabled)
                ? Boolean(object.newPinnedPostPnsEnabled)
                : undefined,
            hideAds: isSet(object.hideAds) ? Boolean(object.hideAds) : undefined,
            predictionLeaderboardEntryType: isSet(object.predictionLeaderboardEntryType)
                ? Number(object.predictionLeaderboardEntryType)
                : undefined,
            headerHoverText: isSet(object.headerHoverText) ? String(object.headerHoverText) : undefined,
            wikiEditAge: isSet(object.wikiEditAge) ? Number(object.wikiEditAge) : undefined,
            allowChatPostCreation: isSet(object.allowChatPostCreation) ? Boolean(object.allowChatPostCreation) : undefined,
            allowPredictionContributors: isSet(object.allowPredictionContributors)
                ? Boolean(object.allowPredictionContributors)
                : undefined,
            allowDiscovery: isSet(object.allowDiscovery) ? Boolean(object.allowDiscovery) : undefined,
            acceptFollowers: isSet(object.acceptFollowers) ? Boolean(object.acceptFollowers) : undefined,
            crowdControlPostLevel: isSet(object.crowdControlPostLevel) ? Number(object.crowdControlPostLevel) : undefined,
            allowPredictionsTournament: isSet(object.allowPredictionsTournament)
                ? Boolean(object.allowPredictionsTournament)
                : undefined,
            wikiEditKarma: isSet(object.wikiEditKarma) ? Number(object.wikiEditKarma) : undefined,
            showMediaPreview: isSet(object.showMediaPreview) ? Boolean(object.showMediaPreview) : undefined,
            crowdControlFilter: isSet(object.crowdControlFilter) ? Boolean(object.crowdControlFilter) : undefined,
            subredditType: isSet(object.subredditType) ? String(object.subredditType) : undefined,
            allowPredictions: isSet(object.allowPredictions) ? Boolean(object.allowPredictions) : undefined,
            userFlairPnsEnabled: isSet(object.userFlairPnsEnabled) ? Boolean(object.userFlairPnsEnabled) : undefined,
            contentOptions: isSet(object.contentOptions) ? String(object.contentOptions) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.defaultSet !== undefined) {
            obj.defaultSet = message.defaultSet;
        }
        if (message.toxicityThresholdChatLevel !== undefined) {
            obj.toxicityThresholdChatLevel = message.toxicityThresholdChatLevel;
        }
        if (message.crowdControlChatLevel !== undefined) {
            obj.crowdControlChatLevel = message.crowdControlChatLevel;
        }
        if (message.restrictPosting !== undefined) {
            obj.restrictPosting = message.restrictPosting;
        }
        if (message.publicDescription !== undefined) {
            obj.publicDescription = message.publicDescription;
        }
        if (message.subredditId !== undefined) {
            obj.subredditId = message.subredditId;
        }
        if (message.allowImages !== undefined) {
            obj.allowImages = message.allowImages;
        }
        if (message.freeFormReports !== undefined) {
            obj.freeFormReports = message.freeFormReports;
        }
        if (message.domain !== undefined) {
            obj.domain = message.domain;
        }
        if (message.originalContentTagEnabled !== undefined) {
            obj.originalContentTagEnabled = message.originalContentTagEnabled;
        }
        if (message.showMedia !== undefined) {
            obj.showMedia = message.showMedia;
        }
        if (message.excludeBannedModqueue !== undefined) {
            obj.excludeBannedModqueue = message.excludeBannedModqueue;
        }
        if (message.shouldArchivePosts !== undefined) {
            obj.shouldArchivePosts = message.shouldArchivePosts;
        }
        if (message.submitText !== undefined) {
            obj.submitText = message.submitText;
        }
        if (message.spamLinks !== undefined) {
            obj.spamLinks = message.spamLinks;
        }
        if (message.title !== undefined) {
            obj.title = message.title;
        }
        if (message.collapseDeletedComments !== undefined) {
            obj.collapseDeletedComments = message.collapseDeletedComments;
        }
        if (message.wikimode !== undefined) {
            obj.wikimode = message.wikimode;
        }
        if (message.over18 !== undefined) {
            obj.over18 = message.over18;
        }
        if (message.allowVideos !== undefined) {
            obj.allowVideos = message.allowVideos;
        }
        if (message.allowGalleries !== undefined) {
            obj.allowGalleries = message.allowGalleries;
        }
        if (message.crowdControlLevel !== undefined) {
            obj.crowdControlLevel = message.crowdControlLevel;
        }
        if (message.banEvasionThreshold !== undefined) {
            obj.banEvasionThreshold = message.banEvasionThreshold;
        }
        if (message.crowdControlMode !== undefined) {
            obj.crowdControlMode = message.crowdControlMode;
        }
        if (message.welcomeMessageEnabled !== undefined) {
            obj.welcomeMessageEnabled = message.welcomeMessageEnabled;
        }
        if (message.welcomeMessageText !== undefined) {
            obj.welcomeMessageText = message.welcomeMessageText;
        }
        if (message.suggestedCommentSort !== undefined) {
            obj.suggestedCommentSort = message.suggestedCommentSort;
        }
        if (message.disableContributorRequests !== undefined) {
            obj.disableContributorRequests = message.disableContributorRequests;
        }
        if (message.allowTalks !== undefined) {
            obj.allowTalks = message.allowTalks;
        }
        if (message.description !== undefined) {
            obj.description = message.description;
        }
        if (message.submitLinkLabel !== undefined) {
            obj.submitLinkLabel = message.submitLinkLabel;
        }
        if (message.spoilersEnabled !== undefined) {
            obj.spoilersEnabled = message.spoilersEnabled;
        }
        if (message.allowPostCrossposts !== undefined) {
            obj.allowPostCrossposts = message.allowPostCrossposts;
        }
        if (message.spamComments !== undefined) {
            obj.spamComments = message.spamComments;
        }
        if (message.publicTraffic !== undefined) {
            obj.publicTraffic = message.publicTraffic;
        }
        if (message.restrictCommenting !== undefined) {
            obj.restrictCommenting = message.restrictCommenting;
        }
        if (message.allowPolls !== undefined) {
            obj.allowPolls = message.allowPolls;
        }
        if (message.commentContributionSettings !== undefined) {
            obj.commentContributionSettings = CommentContributionSettings.toJSON(message.commentContributionSettings);
        }
        if (message.submitTextLabel !== undefined) {
            obj.submitTextLabel = message.submitTextLabel;
        }
        if (message.commentScoreHideMins !== undefined) {
            obj.commentScoreHideMins = message.commentScoreHideMins;
        }
        if (message.allOriginalContent !== undefined) {
            obj.allOriginalContent = message.allOriginalContent;
        }
        if (message.spamSelfposts !== undefined) {
            obj.spamSelfposts = message.spamSelfposts;
        }
        if (message.keyColor !== undefined) {
            obj.keyColor = message.keyColor;
        }
        if (message.language !== undefined) {
            obj.language = message.language;
        }
        if (message.newPinnedPostPnsEnabled !== undefined) {
            obj.newPinnedPostPnsEnabled = message.newPinnedPostPnsEnabled;
        }
        if (message.hideAds !== undefined) {
            obj.hideAds = message.hideAds;
        }
        if (message.predictionLeaderboardEntryType !== undefined) {
            obj.predictionLeaderboardEntryType = message.predictionLeaderboardEntryType;
        }
        if (message.headerHoverText !== undefined) {
            obj.headerHoverText = message.headerHoverText;
        }
        if (message.wikiEditAge !== undefined) {
            obj.wikiEditAge = message.wikiEditAge;
        }
        if (message.allowChatPostCreation !== undefined) {
            obj.allowChatPostCreation = message.allowChatPostCreation;
        }
        if (message.allowPredictionContributors !== undefined) {
            obj.allowPredictionContributors = message.allowPredictionContributors;
        }
        if (message.allowDiscovery !== undefined) {
            obj.allowDiscovery = message.allowDiscovery;
        }
        if (message.acceptFollowers !== undefined) {
            obj.acceptFollowers = message.acceptFollowers;
        }
        if (message.crowdControlPostLevel !== undefined) {
            obj.crowdControlPostLevel = message.crowdControlPostLevel;
        }
        if (message.allowPredictionsTournament !== undefined) {
            obj.allowPredictionsTournament = message.allowPredictionsTournament;
        }
        if (message.wikiEditKarma !== undefined) {
            obj.wikiEditKarma = message.wikiEditKarma;
        }
        if (message.showMediaPreview !== undefined) {
            obj.showMediaPreview = message.showMediaPreview;
        }
        if (message.crowdControlFilter !== undefined) {
            obj.crowdControlFilter = message.crowdControlFilter;
        }
        if (message.subredditType !== undefined) {
            obj.subredditType = message.subredditType;
        }
        if (message.allowPredictions !== undefined) {
            obj.allowPredictions = message.allowPredictions;
        }
        if (message.userFlairPnsEnabled !== undefined) {
            obj.userFlairPnsEnabled = message.userFlairPnsEnabled;
        }
        if (message.contentOptions !== undefined) {
            obj.contentOptions = message.contentOptions;
        }
        return obj;
    },
    create(base) {
        return SubredditAboutEditResponse_SubredditSettings.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSubredditAboutEditResponse_SubredditSettings();
        message.defaultSet = object.defaultSet ?? undefined;
        message.toxicityThresholdChatLevel = object.toxicityThresholdChatLevel ?? undefined;
        message.crowdControlChatLevel = object.crowdControlChatLevel ?? undefined;
        message.restrictPosting = object.restrictPosting ?? undefined;
        message.publicDescription = object.publicDescription ?? undefined;
        message.subredditId = object.subredditId ?? undefined;
        message.allowImages = object.allowImages ?? undefined;
        message.freeFormReports = object.freeFormReports ?? undefined;
        message.domain = object.domain ?? undefined;
        message.originalContentTagEnabled = object.originalContentTagEnabled ?? undefined;
        message.showMedia = object.showMedia ?? undefined;
        message.excludeBannedModqueue = object.excludeBannedModqueue ?? undefined;
        message.shouldArchivePosts = object.shouldArchivePosts ?? undefined;
        message.submitText = object.submitText ?? undefined;
        message.spamLinks = object.spamLinks ?? undefined;
        message.title = object.title ?? undefined;
        message.collapseDeletedComments = object.collapseDeletedComments ?? undefined;
        message.wikimode = object.wikimode ?? undefined;
        message.over18 = object.over18 ?? undefined;
        message.allowVideos = object.allowVideos ?? undefined;
        message.allowGalleries = object.allowGalleries ?? undefined;
        message.crowdControlLevel = object.crowdControlLevel ?? undefined;
        message.banEvasionThreshold = object.banEvasionThreshold ?? undefined;
        message.crowdControlMode = object.crowdControlMode ?? undefined;
        message.welcomeMessageEnabled = object.welcomeMessageEnabled ?? undefined;
        message.welcomeMessageText = object.welcomeMessageText ?? undefined;
        message.suggestedCommentSort = object.suggestedCommentSort ?? undefined;
        message.disableContributorRequests = object.disableContributorRequests ?? undefined;
        message.allowTalks = object.allowTalks ?? undefined;
        message.description = object.description ?? undefined;
        message.submitLinkLabel = object.submitLinkLabel ?? undefined;
        message.spoilersEnabled = object.spoilersEnabled ?? undefined;
        message.allowPostCrossposts = object.allowPostCrossposts ?? undefined;
        message.spamComments = object.spamComments ?? undefined;
        message.publicTraffic = object.publicTraffic ?? undefined;
        message.restrictCommenting = object.restrictCommenting ?? undefined;
        message.allowPolls = object.allowPolls ?? undefined;
        message.commentContributionSettings =
            (object.commentContributionSettings !== undefined && object.commentContributionSettings !== null)
                ? CommentContributionSettings.fromPartial(object.commentContributionSettings)
                : undefined;
        message.submitTextLabel = object.submitTextLabel ?? undefined;
        message.commentScoreHideMins = object.commentScoreHideMins ?? undefined;
        message.allOriginalContent = object.allOriginalContent ?? undefined;
        message.spamSelfposts = object.spamSelfposts ?? undefined;
        message.keyColor = object.keyColor ?? undefined;
        message.language = object.language ?? undefined;
        message.newPinnedPostPnsEnabled = object.newPinnedPostPnsEnabled ?? undefined;
        message.hideAds = object.hideAds ?? undefined;
        message.predictionLeaderboardEntryType = object.predictionLeaderboardEntryType ?? undefined;
        message.headerHoverText = object.headerHoverText ?? undefined;
        message.wikiEditAge = object.wikiEditAge ?? undefined;
        message.allowChatPostCreation = object.allowChatPostCreation ?? undefined;
        message.allowPredictionContributors = object.allowPredictionContributors ?? undefined;
        message.allowDiscovery = object.allowDiscovery ?? undefined;
        message.acceptFollowers = object.acceptFollowers ?? undefined;
        message.crowdControlPostLevel = object.crowdControlPostLevel ?? undefined;
        message.allowPredictionsTournament = object.allowPredictionsTournament ?? undefined;
        message.wikiEditKarma = object.wikiEditKarma ?? undefined;
        message.showMediaPreview = object.showMediaPreview ?? undefined;
        message.crowdControlFilter = object.crowdControlFilter ?? undefined;
        message.subredditType = object.subredditType ?? undefined;
        message.allowPredictions = object.allowPredictions ?? undefined;
        message.userFlairPnsEnabled = object.userFlairPnsEnabled ?? undefined;
        message.contentOptions = object.contentOptions ?? undefined;
        return message;
    },
};
messageTypeRegistry.set(SubredditAboutEditResponse_SubredditSettings.$type, SubredditAboutEditResponse_SubredditSettings);
function createBaseSubredditAboutRulesResponse() {
    return { rules: [], siteRules: [], siteRulesFlow: [] };
}
export const SubredditAboutRulesResponse = {
    $type: "devvit.plugin.redditapi.subreddits.SubredditAboutRulesResponse",
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.rules) {
            SubredditAboutRulesResponse_SubredditRule.encode(v, writer.uint32(10).fork()).ldelim();
        }
        for (const v of message.siteRules) {
            StringValue.encode({ value: v }, writer.uint32(18).fork()).ldelim();
        }
        for (const v of message.siteRulesFlow) {
            SubredditAboutRulesResponse_RuleFlow.encode(v, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSubredditAboutRulesResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.rules.push(SubredditAboutRulesResponse_SubredditRule.decode(reader, reader.uint32()));
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.siteRules.push(StringValue.decode(reader, reader.uint32()).value);
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.siteRulesFlow.push(SubredditAboutRulesResponse_RuleFlow.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            rules: globalThis.Array.isArray(object?.rules)
                ? object.rules.map((e) => SubredditAboutRulesResponse_SubredditRule.fromJSON(e))
                : [],
            siteRules: globalThis.Array.isArray(object?.siteRules) ? object.siteRules.map((e) => String(e)) : [],
            siteRulesFlow: globalThis.Array.isArray(object?.siteRulesFlow)
                ? object.siteRulesFlow.map((e) => SubredditAboutRulesResponse_RuleFlow.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.rules?.length) {
            obj.rules = message.rules.map((e) => SubredditAboutRulesResponse_SubredditRule.toJSON(e));
        }
        if (message.siteRules?.length) {
            obj.siteRules = message.siteRules;
        }
        if (message.siteRulesFlow?.length) {
            obj.siteRulesFlow = message.siteRulesFlow.map((e) => SubredditAboutRulesResponse_RuleFlow.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return SubredditAboutRulesResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSubredditAboutRulesResponse();
        message.rules = object.rules?.map((e) => SubredditAboutRulesResponse_SubredditRule.fromPartial(e)) || [];
        message.siteRules = object.siteRules?.map((e) => e) || [];
        message.siteRulesFlow = object.siteRulesFlow?.map((e) => SubredditAboutRulesResponse_RuleFlow.fromPartial(e)) || [];
        return message;
    },
};
messageTypeRegistry.set(SubredditAboutRulesResponse.$type, SubredditAboutRulesResponse);
function createBaseSubredditAboutRulesResponse_SubredditRule() {
    return {
        kind: undefined,
        description: undefined,
        shortName: undefined,
        violationReason: undefined,
        createdUtc: undefined,
        priority: undefined,
        descriptionHtml: undefined,
    };
}
export const SubredditAboutRulesResponse_SubredditRule = {
    $type: "devvit.plugin.redditapi.subreddits.SubredditAboutRulesResponse.SubredditRule",
    encode(message, writer = _m0.Writer.create()) {
        if (message.kind !== undefined) {
            StringValue.encode({ value: message.kind }, writer.uint32(10).fork()).ldelim();
        }
        if (message.description !== undefined) {
            StringValue.encode({ value: message.description }, writer.uint32(18).fork()).ldelim();
        }
        if (message.shortName !== undefined) {
            StringValue.encode({ value: message.shortName }, writer.uint32(26).fork()).ldelim();
        }
        if (message.violationReason !== undefined) {
            StringValue.encode({ value: message.violationReason }, writer.uint32(34).fork()).ldelim();
        }
        if (message.createdUtc !== undefined) {
            Int64Value.encode({ value: message.createdUtc }, writer.uint32(42).fork()).ldelim();
        }
        if (message.priority !== undefined) {
            Int32Value.encode({ value: message.priority }, writer.uint32(50).fork()).ldelim();
        }
        if (message.descriptionHtml !== undefined) {
            StringValue.encode({ value: message.descriptionHtml }, writer.uint32(58).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSubredditAboutRulesResponse_SubredditRule();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.kind = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.description = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.shortName = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.violationReason = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.createdUtc = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.priority = Int32Value.decode(reader, reader.uint32()).value;
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.descriptionHtml = StringValue.decode(reader, reader.uint32()).value;
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            kind: isSet(object.kind) ? String(object.kind) : undefined,
            description: isSet(object.description) ? String(object.description) : undefined,
            shortName: isSet(object.shortName) ? String(object.shortName) : undefined,
            violationReason: isSet(object.violationReason) ? String(object.violationReason) : undefined,
            createdUtc: isSet(object.createdUtc) ? Number(object.createdUtc) : undefined,
            priority: isSet(object.priority) ? Number(object.priority) : undefined,
            descriptionHtml: isSet(object.descriptionHtml) ? String(object.descriptionHtml) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.kind !== undefined) {
            obj.kind = message.kind;
        }
        if (message.description !== undefined) {
            obj.description = message.description;
        }
        if (message.shortName !== undefined) {
            obj.shortName = message.shortName;
        }
        if (message.violationReason !== undefined) {
            obj.violationReason = message.violationReason;
        }
        if (message.createdUtc !== undefined) {
            obj.createdUtc = message.createdUtc;
        }
        if (message.priority !== undefined) {
            obj.priority = message.priority;
        }
        if (message.descriptionHtml !== undefined) {
            obj.descriptionHtml = message.descriptionHtml;
        }
        return obj;
    },
    create(base) {
        return SubredditAboutRulesResponse_SubredditRule.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSubredditAboutRulesResponse_SubredditRule();
        message.kind = object.kind ?? undefined;
        message.description = object.description ?? undefined;
        message.shortName = object.shortName ?? undefined;
        message.violationReason = object.violationReason ?? undefined;
        message.createdUtc = object.createdUtc ?? undefined;
        message.priority = object.priority ?? undefined;
        message.descriptionHtml = object.descriptionHtml ?? undefined;
        return message;
    },
};
messageTypeRegistry.set(SubredditAboutRulesResponse_SubredditRule.$type, SubredditAboutRulesResponse_SubredditRule);
function createBaseSubredditAboutRulesResponse_RuleFlow() {
    return {
        reasonTextToShow: undefined,
        reasonText: undefined,
        nextStepHeader: undefined,
        nextStepReasons: [],
        complaintButtonText: undefined,
        complaintUrl: undefined,
        complaintPageTitle: undefined,
        fileComplaint: undefined,
        complaintPrompt: undefined,
        canWriteNotes: undefined,
        isAbuseOfReportButton: undefined,
        notesInputTitle: undefined,
        usernamesInputTitle: undefined,
        canSpecifyUsernames: undefined,
        requestCrisisSupport: undefined,
        oneUsername: undefined,
    };
}
export const SubredditAboutRulesResponse_RuleFlow = {
    $type: "devvit.plugin.redditapi.subreddits.SubredditAboutRulesResponse.RuleFlow",
    encode(message, writer = _m0.Writer.create()) {
        if (message.reasonTextToShow !== undefined) {
            StringValue.encode({ value: message.reasonTextToShow }, writer.uint32(10).fork()).ldelim();
        }
        if (message.reasonText !== undefined) {
            StringValue.encode({ value: message.reasonText }, writer.uint32(18).fork()).ldelim();
        }
        if (message.nextStepHeader !== undefined) {
            StringValue.encode({ value: message.nextStepHeader }, writer.uint32(26).fork()).ldelim();
        }
        for (const v of message.nextStepReasons) {
            SubredditAboutRulesResponse_RuleFlow.encode(v, writer.uint32(34).fork()).ldelim();
        }
        if (message.complaintButtonText !== undefined) {
            StringValue.encode({ value: message.complaintButtonText }, writer.uint32(42).fork()).ldelim();
        }
        if (message.complaintUrl !== undefined) {
            StringValue.encode({ value: message.complaintUrl }, writer.uint32(50).fork()).ldelim();
        }
        if (message.complaintPageTitle !== undefined) {
            StringValue.encode({ value: message.complaintPageTitle }, writer.uint32(58).fork()).ldelim();
        }
        if (message.fileComplaint !== undefined) {
            BoolValue.encode({ value: message.fileComplaint }, writer.uint32(66).fork()).ldelim();
        }
        if (message.complaintPrompt !== undefined) {
            StringValue.encode({ value: message.complaintPrompt }, writer.uint32(74).fork()).ldelim();
        }
        if (message.canWriteNotes !== undefined) {
            BoolValue.encode({ value: message.canWriteNotes }, writer.uint32(82).fork()).ldelim();
        }
        if (message.isAbuseOfReportButton !== undefined) {
            BoolValue.encode({ value: message.isAbuseOfReportButton }, writer.uint32(90).fork()).ldelim();
        }
        if (message.notesInputTitle !== undefined) {
            StringValue.encode({ value: message.notesInputTitle }, writer.uint32(98).fork()).ldelim();
        }
        if (message.usernamesInputTitle !== undefined) {
            StringValue.encode({ value: message.usernamesInputTitle }, writer.uint32(106).fork()).ldelim();
        }
        if (message.canSpecifyUsernames !== undefined) {
            BoolValue.encode({ value: message.canSpecifyUsernames }, writer.uint32(114).fork()).ldelim();
        }
        if (message.requestCrisisSupport !== undefined) {
            BoolValue.encode({ value: message.requestCrisisSupport }, writer.uint32(122).fork()).ldelim();
        }
        if (message.oneUsername !== undefined) {
            BoolValue.encode({ value: message.oneUsername }, writer.uint32(130).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSubredditAboutRulesResponse_RuleFlow();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.reasonTextToShow = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.reasonText = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.nextStepHeader = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.nextStepReasons.push(SubredditAboutRulesResponse_RuleFlow.decode(reader, reader.uint32()));
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.complaintButtonText = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.complaintUrl = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.complaintPageTitle = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.fileComplaint = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 9:
                    if (tag !== 74) {
                        break;
                    }
                    message.complaintPrompt = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.canWriteNotes = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 11:
                    if (tag !== 90) {
                        break;
                    }
                    message.isAbuseOfReportButton = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 12:
                    if (tag !== 98) {
                        break;
                    }
                    message.notesInputTitle = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 13:
                    if (tag !== 106) {
                        break;
                    }
                    message.usernamesInputTitle = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 14:
                    if (tag !== 114) {
                        break;
                    }
                    message.canSpecifyUsernames = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 15:
                    if (tag !== 122) {
                        break;
                    }
                    message.requestCrisisSupport = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 16:
                    if (tag !== 130) {
                        break;
                    }
                    message.oneUsername = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            reasonTextToShow: isSet(object.reasonTextToShow) ? String(object.reasonTextToShow) : undefined,
            reasonText: isSet(object.reasonText) ? String(object.reasonText) : undefined,
            nextStepHeader: isSet(object.nextStepHeader) ? String(object.nextStepHeader) : undefined,
            nextStepReasons: globalThis.Array.isArray(object?.nextStepReasons)
                ? object.nextStepReasons.map((e) => SubredditAboutRulesResponse_RuleFlow.fromJSON(e))
                : [],
            complaintButtonText: isSet(object.complaintButtonText) ? String(object.complaintButtonText) : undefined,
            complaintUrl: isSet(object.complaintUrl) ? String(object.complaintUrl) : undefined,
            complaintPageTitle: isSet(object.complaintPageTitle) ? String(object.complaintPageTitle) : undefined,
            fileComplaint: isSet(object.fileComplaint) ? Boolean(object.fileComplaint) : undefined,
            complaintPrompt: isSet(object.complaintPrompt) ? String(object.complaintPrompt) : undefined,
            canWriteNotes: isSet(object.canWriteNotes) ? Boolean(object.canWriteNotes) : undefined,
            isAbuseOfReportButton: isSet(object.isAbuseOfReportButton) ? Boolean(object.isAbuseOfReportButton) : undefined,
            notesInputTitle: isSet(object.notesInputTitle) ? String(object.notesInputTitle) : undefined,
            usernamesInputTitle: isSet(object.usernamesInputTitle) ? String(object.usernamesInputTitle) : undefined,
            canSpecifyUsernames: isSet(object.canSpecifyUsernames) ? Boolean(object.canSpecifyUsernames) : undefined,
            requestCrisisSupport: isSet(object.requestCrisisSupport) ? Boolean(object.requestCrisisSupport) : undefined,
            oneUsername: isSet(object.oneUsername) ? Boolean(object.oneUsername) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.reasonTextToShow !== undefined) {
            obj.reasonTextToShow = message.reasonTextToShow;
        }
        if (message.reasonText !== undefined) {
            obj.reasonText = message.reasonText;
        }
        if (message.nextStepHeader !== undefined) {
            obj.nextStepHeader = message.nextStepHeader;
        }
        if (message.nextStepReasons?.length) {
            obj.nextStepReasons = message.nextStepReasons.map((e) => SubredditAboutRulesResponse_RuleFlow.toJSON(e));
        }
        if (message.complaintButtonText !== undefined) {
            obj.complaintButtonText = message.complaintButtonText;
        }
        if (message.complaintUrl !== undefined) {
            obj.complaintUrl = message.complaintUrl;
        }
        if (message.complaintPageTitle !== undefined) {
            obj.complaintPageTitle = message.complaintPageTitle;
        }
        if (message.fileComplaint !== undefined) {
            obj.fileComplaint = message.fileComplaint;
        }
        if (message.complaintPrompt !== undefined) {
            obj.complaintPrompt = message.complaintPrompt;
        }
        if (message.canWriteNotes !== undefined) {
            obj.canWriteNotes = message.canWriteNotes;
        }
        if (message.isAbuseOfReportButton !== undefined) {
            obj.isAbuseOfReportButton = message.isAbuseOfReportButton;
        }
        if (message.notesInputTitle !== undefined) {
            obj.notesInputTitle = message.notesInputTitle;
        }
        if (message.usernamesInputTitle !== undefined) {
            obj.usernamesInputTitle = message.usernamesInputTitle;
        }
        if (message.canSpecifyUsernames !== undefined) {
            obj.canSpecifyUsernames = message.canSpecifyUsernames;
        }
        if (message.requestCrisisSupport !== undefined) {
            obj.requestCrisisSupport = message.requestCrisisSupport;
        }
        if (message.oneUsername !== undefined) {
            obj.oneUsername = message.oneUsername;
        }
        return obj;
    },
    create(base) {
        return SubredditAboutRulesResponse_RuleFlow.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSubredditAboutRulesResponse_RuleFlow();
        message.reasonTextToShow = object.reasonTextToShow ?? undefined;
        message.reasonText = object.reasonText ?? undefined;
        message.nextStepHeader = object.nextStepHeader ?? undefined;
        message.nextStepReasons = object.nextStepReasons?.map((e) => SubredditAboutRulesResponse_RuleFlow.fromPartial(e)) ||
            [];
        message.complaintButtonText = object.complaintButtonText ?? undefined;
        message.complaintUrl = object.complaintUrl ?? undefined;
        message.complaintPageTitle = object.complaintPageTitle ?? undefined;
        message.fileComplaint = object.fileComplaint ?? undefined;
        message.complaintPrompt = object.complaintPrompt ?? undefined;
        message.canWriteNotes = object.canWriteNotes ?? undefined;
        message.isAbuseOfReportButton = object.isAbuseOfReportButton ?? undefined;
        message.notesInputTitle = object.notesInputTitle ?? undefined;
        message.usernamesInputTitle = object.usernamesInputTitle ?? undefined;
        message.canSpecifyUsernames = object.canSpecifyUsernames ?? undefined;
        message.requestCrisisSupport = object.requestCrisisSupport ?? undefined;
        message.oneUsername = object.oneUsername ?? undefined;
        return message;
    },
};
messageTypeRegistry.set(SubredditAboutRulesResponse_RuleFlow.$type, SubredditAboutRulesResponse_RuleFlow);
function createBaseAddSubredditRuleRequest() {
    return { r: "", shortName: "", description: "", kind: "", violationReason: "" };
}
export const AddSubredditRuleRequest = {
    $type: "devvit.plugin.redditapi.subreddits.AddSubredditRuleRequest",
    encode(message, writer = _m0.Writer.create()) {
        if (message.r !== "") {
            writer.uint32(10).string(message.r);
        }
        if (message.shortName !== "") {
            writer.uint32(18).string(message.shortName);
        }
        if (message.description !== "") {
            writer.uint32(26).string(message.description);
        }
        if (message.kind !== "") {
            writer.uint32(34).string(message.kind);
        }
        if (message.violationReason !== "") {
            writer.uint32(42).string(message.violationReason);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAddSubredditRuleRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.r = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.shortName = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.description = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.kind = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.violationReason = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            r: isSet(object.r) ? globalThis.String(object.r) : "",
            shortName: isSet(object.shortName) ? globalThis.String(object.shortName) : "",
            description: isSet(object.description) ? globalThis.String(object.description) : "",
            kind: isSet(object.kind) ? globalThis.String(object.kind) : "",
            violationReason: isSet(object.violationReason) ? globalThis.String(object.violationReason) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.r !== "") {
            obj.r = message.r;
        }
        if (message.shortName !== "") {
            obj.shortName = message.shortName;
        }
        if (message.description !== "") {
            obj.description = message.description;
        }
        if (message.kind !== "") {
            obj.kind = message.kind;
        }
        if (message.violationReason !== "") {
            obj.violationReason = message.violationReason;
        }
        return obj;
    },
    create(base) {
        return AddSubredditRuleRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAddSubredditRuleRequest();
        message.r = object.r ?? "";
        message.shortName = object.shortName ?? "";
        message.description = object.description ?? "";
        message.kind = object.kind ?? "";
        message.violationReason = object.violationReason ?? "";
        return message;
    },
};
messageTypeRegistry.set(AddSubredditRuleRequest.$type, AddSubredditRuleRequest);
function createBaseUpdateSubredditRuleRequest() {
    return { r: "", oldShortName: "", shortName: "", description: "", kind: "", violationReason: "" };
}
export const UpdateSubredditRuleRequest = {
    $type: "devvit.plugin.redditapi.subreddits.UpdateSubredditRuleRequest",
    encode(message, writer = _m0.Writer.create()) {
        if (message.r !== "") {
            writer.uint32(10).string(message.r);
        }
        if (message.oldShortName !== "") {
            writer.uint32(18).string(message.oldShortName);
        }
        if (message.shortName !== "") {
            writer.uint32(26).string(message.shortName);
        }
        if (message.description !== "") {
            writer.uint32(34).string(message.description);
        }
        if (message.kind !== "") {
            writer.uint32(42).string(message.kind);
        }
        if (message.violationReason !== "") {
            writer.uint32(50).string(message.violationReason);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUpdateSubredditRuleRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.r = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.oldShortName = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.shortName = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.description = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.kind = reader.string();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.violationReason = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            r: isSet(object.r) ? globalThis.String(object.r) : "",
            oldShortName: isSet(object.oldShortName) ? globalThis.String(object.oldShortName) : "",
            shortName: isSet(object.shortName) ? globalThis.String(object.shortName) : "",
            description: isSet(object.description) ? globalThis.String(object.description) : "",
            kind: isSet(object.kind) ? globalThis.String(object.kind) : "",
            violationReason: isSet(object.violationReason) ? globalThis.String(object.violationReason) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.r !== "") {
            obj.r = message.r;
        }
        if (message.oldShortName !== "") {
            obj.oldShortName = message.oldShortName;
        }
        if (message.shortName !== "") {
            obj.shortName = message.shortName;
        }
        if (message.description !== "") {
            obj.description = message.description;
        }
        if (message.kind !== "") {
            obj.kind = message.kind;
        }
        if (message.violationReason !== "") {
            obj.violationReason = message.violationReason;
        }
        return obj;
    },
    create(base) {
        return UpdateSubredditRuleRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUpdateSubredditRuleRequest();
        message.r = object.r ?? "";
        message.oldShortName = object.oldShortName ?? "";
        message.shortName = object.shortName ?? "";
        message.description = object.description ?? "";
        message.kind = object.kind ?? "";
        message.violationReason = object.violationReason ?? "";
        return message;
    },
};
messageTypeRegistry.set(UpdateSubredditRuleRequest.$type, UpdateSubredditRuleRequest);
function createBaseRemoveSubredditRuleRequest() {
    return { r: "", shortName: "" };
}
export const RemoveSubredditRuleRequest = {
    $type: "devvit.plugin.redditapi.subreddits.RemoveSubredditRuleRequest",
    encode(message, writer = _m0.Writer.create()) {
        if (message.r !== "") {
            writer.uint32(10).string(message.r);
        }
        if (message.shortName !== "") {
            writer.uint32(18).string(message.shortName);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRemoveSubredditRuleRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.r = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.shortName = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            r: isSet(object.r) ? globalThis.String(object.r) : "",
            shortName: isSet(object.shortName) ? globalThis.String(object.shortName) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.r !== "") {
            obj.r = message.r;
        }
        if (message.shortName !== "") {
            obj.shortName = message.shortName;
        }
        return obj;
    },
    create(base) {
        return RemoveSubredditRuleRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRemoveSubredditRuleRequest();
        message.r = object.r ?? "";
        message.shortName = object.shortName ?? "";
        return message;
    },
};
messageTypeRegistry.set(RemoveSubredditRuleRequest.$type, RemoveSubredditRuleRequest);
function createBaseReorderSubredditRulesRequest() {
    return { r: "", newRuleOrder: "" };
}
export const ReorderSubredditRulesRequest = {
    $type: "devvit.plugin.redditapi.subreddits.ReorderSubredditRulesRequest",
    encode(message, writer = _m0.Writer.create()) {
        if (message.r !== "") {
            writer.uint32(10).string(message.r);
        }
        if (message.newRuleOrder !== "") {
            writer.uint32(18).string(message.newRuleOrder);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseReorderSubredditRulesRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.r = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.newRuleOrder = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            r: isSet(object.r) ? globalThis.String(object.r) : "",
            newRuleOrder: isSet(object.newRuleOrder) ? globalThis.String(object.newRuleOrder) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.r !== "") {
            obj.r = message.r;
        }
        if (message.newRuleOrder !== "") {
            obj.newRuleOrder = message.newRuleOrder;
        }
        return obj;
    },
    create(base) {
        return ReorderSubredditRulesRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseReorderSubredditRulesRequest();
        message.r = object.r ?? "";
        message.newRuleOrder = object.newRuleOrder ?? "";
        return message;
    },
};
messageTypeRegistry.set(ReorderSubredditRulesRequest.$type, ReorderSubredditRulesRequest);
function createBaseSubredditAboutTrafficResponse() {
    return { day: [], hour: [], month: [] };
}
export const SubredditAboutTrafficResponse = {
    $type: "devvit.plugin.redditapi.subreddits.SubredditAboutTrafficResponse",
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.day) {
            SubredditAboutTrafficResponse_Data.encode(v, writer.uint32(10).fork()).ldelim();
        }
        for (const v of message.hour) {
            SubredditAboutTrafficResponse_Data.encode(v, writer.uint32(18).fork()).ldelim();
        }
        for (const v of message.month) {
            SubredditAboutTrafficResponse_Data.encode(v, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSubredditAboutTrafficResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.day.push(SubredditAboutTrafficResponse_Data.decode(reader, reader.uint32()));
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.hour.push(SubredditAboutTrafficResponse_Data.decode(reader, reader.uint32()));
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.month.push(SubredditAboutTrafficResponse_Data.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            day: globalThis.Array.isArray(object?.day)
                ? object.day.map((e) => SubredditAboutTrafficResponse_Data.fromJSON(e))
                : [],
            hour: globalThis.Array.isArray(object?.hour)
                ? object.hour.map((e) => SubredditAboutTrafficResponse_Data.fromJSON(e))
                : [],
            month: globalThis.Array.isArray(object?.month)
                ? object.month.map((e) => SubredditAboutTrafficResponse_Data.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.day?.length) {
            obj.day = message.day.map((e) => SubredditAboutTrafficResponse_Data.toJSON(e));
        }
        if (message.hour?.length) {
            obj.hour = message.hour.map((e) => SubredditAboutTrafficResponse_Data.toJSON(e));
        }
        if (message.month?.length) {
            obj.month = message.month.map((e) => SubredditAboutTrafficResponse_Data.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return SubredditAboutTrafficResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSubredditAboutTrafficResponse();
        message.day = object.day?.map((e) => SubredditAboutTrafficResponse_Data.fromPartial(e)) || [];
        message.hour = object.hour?.map((e) => SubredditAboutTrafficResponse_Data.fromPartial(e)) || [];
        message.month = object.month?.map((e) => SubredditAboutTrafficResponse_Data.fromPartial(e)) || [];
        return message;
    },
};
messageTypeRegistry.set(SubredditAboutTrafficResponse.$type, SubredditAboutTrafficResponse);
function createBaseSubredditAboutTrafficResponse_Data() {
    return { values: [] };
}
export const SubredditAboutTrafficResponse_Data = {
    $type: "devvit.plugin.redditapi.subreddits.SubredditAboutTrafficResponse.Data",
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.values) {
            Int64Value.encode({ value: v }, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSubredditAboutTrafficResponse_Data();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.values.push(Int64Value.decode(reader, reader.uint32()).value);
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { values: globalThis.Array.isArray(object?.values) ? object.values.map((e) => Number(e)) : [] };
    },
    toJSON(message) {
        const obj = {};
        if (message.values?.length) {
            obj.values = message.values;
        }
        return obj;
    },
    create(base) {
        return SubredditAboutTrafficResponse_Data.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSubredditAboutTrafficResponse_Data();
        message.values = object.values?.map((e) => e) || [];
        return message;
    },
};
messageTypeRegistry.set(SubredditAboutTrafficResponse_Data.$type, SubredditAboutTrafficResponse_Data);
function createBaseStickyResponse() {
    return { kind: undefined, data: undefined };
}
export const StickyResponse = {
    $type: "devvit.plugin.redditapi.subreddits.StickyResponse",
    encode(message, writer = _m0.Writer.create()) {
        if (message.kind !== undefined) {
            StringValue.encode({ value: message.kind }, writer.uint32(10).fork()).ldelim();
        }
        if (message.data !== undefined) {
            StickyResponse_StickyResponseData.encode(message.data, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseStickyResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.kind = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.data = StickyResponse_StickyResponseData.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            kind: isSet(object.kind) ? String(object.kind) : undefined,
            data: isSet(object.data) ? StickyResponse_StickyResponseData.fromJSON(object.data) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.kind !== undefined) {
            obj.kind = message.kind;
        }
        if (message.data !== undefined) {
            obj.data = StickyResponse_StickyResponseData.toJSON(message.data);
        }
        return obj;
    },
    create(base) {
        return StickyResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseStickyResponse();
        message.kind = object.kind ?? undefined;
        message.data = (object.data !== undefined && object.data !== null)
            ? StickyResponse_StickyResponseData.fromPartial(object.data)
            : undefined;
        return message;
    },
};
messageTypeRegistry.set(StickyResponse.$type, StickyResponse);
function createBaseStickyResponse_LinkData() {
    return {
        authorFlairBackgroundColor: undefined,
        approvedAtUtc: undefined,
        subreddit: undefined,
        selftext: undefined,
        userReports: [],
        saved: undefined,
        modReasonTitle: undefined,
        gilded: undefined,
        clicked: undefined,
        title: undefined,
        linkFlairRichtext: [],
        subredditNamePrefixed: undefined,
        hidden: undefined,
        pwls: undefined,
        linkFlairCssClass: undefined,
        downs: undefined,
        thumbnailHeight: undefined,
        topAwardedType: undefined,
        parentWhitelistStatus: undefined,
        hideScore: undefined,
        name: undefined,
        quarantine: undefined,
        linkFlairTextColor: undefined,
        upvoteRatio: undefined,
        ignoreReports: undefined,
        ups: undefined,
        domain: undefined,
        mediaEmbed: undefined,
        thumbnailWidth: undefined,
        authorFlairTemplateId: undefined,
        isOriginalContent: undefined,
        authorFullname: undefined,
        secureMedia: undefined,
        isRedditMediaDomain: undefined,
        isMeta: undefined,
        category: undefined,
        secureMediaEmbed: undefined,
        linkFlairText: undefined,
        canModPost: undefined,
        score: undefined,
        approvedBy: undefined,
        isCreatedFromAdsUi: undefined,
        authorPremium: undefined,
        thumbnail: undefined,
        edited: undefined,
        authorFlairCssClass: undefined,
        previousVisits: [],
        authorFlairRichtext: [],
        gildings: undefined,
        contentCategories: undefined,
        isSelf: undefined,
        subredditType: undefined,
        created: undefined,
        linkFlairType: undefined,
        wls: undefined,
        removedByCategory: undefined,
        bannedBy: undefined,
        authorFlairType: undefined,
        totalAwardsReceived: undefined,
        allowLiveComments: undefined,
        selftextHtml: undefined,
        likes: undefined,
        suggestedSort: undefined,
        bannedAtUtc: undefined,
        viewCount: undefined,
        archived: undefined,
        noFollow: undefined,
        spam: undefined,
        isCrosspostable: undefined,
        pinned: undefined,
        over18: undefined,
        allAwardings: [],
        awarders: [],
        mediaOnly: undefined,
        canGild: undefined,
        removed: undefined,
        spoiler: undefined,
        locked: undefined,
        authorFlairText: undefined,
        treatmentTags: [],
        rteMode: undefined,
        visited: undefined,
        removedBy: undefined,
        modNote: undefined,
        distinguished: undefined,
        subredditId: undefined,
        authorIsBlocked: undefined,
        modReasonBy: undefined,
        numReports: undefined,
        removalReason: undefined,
        linkFlairBackgroundColor: undefined,
        id: undefined,
        isRobotIndexable: undefined,
        numDuplicates: undefined,
        reportReasons: [],
        author: undefined,
        discussionType: undefined,
        numComments: undefined,
        sendReplies: undefined,
        media: undefined,
        contestMode: undefined,
        authorPatreonFlair: undefined,
        approved: undefined,
        authorFlairTextColor: undefined,
        permalink: undefined,
        whitelistStatus: undefined,
        stickied: undefined,
        url: undefined,
        subredditSubscribers: undefined,
        createdUtc: undefined,
        numCrossposts: undefined,
        modReports: [],
        isVideo: undefined,
    };
}
export const StickyResponse_LinkData = {
    $type: "devvit.plugin.redditapi.subreddits.StickyResponse.LinkData",
    encode(message, writer = _m0.Writer.create()) {
        if (message.authorFlairBackgroundColor !== undefined) {
            StringValue.encode({ value: message.authorFlairBackgroundColor }, writer.uint32(10).fork()).ldelim();
        }
        if (message.approvedAtUtc !== undefined) {
            Int32Value.encode({ value: message.approvedAtUtc }, writer.uint32(18).fork()).ldelim();
        }
        if (message.subreddit !== undefined) {
            StringValue.encode({ value: message.subreddit }, writer.uint32(26).fork()).ldelim();
        }
        if (message.selftext !== undefined) {
            StringValue.encode({ value: message.selftext }, writer.uint32(34).fork()).ldelim();
        }
        for (const v of message.userReports) {
            StringValue.encode({ value: v }, writer.uint32(42).fork()).ldelim();
        }
        if (message.saved !== undefined) {
            BoolValue.encode({ value: message.saved }, writer.uint32(50).fork()).ldelim();
        }
        if (message.modReasonTitle !== undefined) {
            StringValue.encode({ value: message.modReasonTitle }, writer.uint32(58).fork()).ldelim();
        }
        if (message.gilded !== undefined) {
            Int64Value.encode({ value: message.gilded }, writer.uint32(66).fork()).ldelim();
        }
        if (message.clicked !== undefined) {
            BoolValue.encode({ value: message.clicked }, writer.uint32(74).fork()).ldelim();
        }
        if (message.title !== undefined) {
            StringValue.encode({ value: message.title }, writer.uint32(82).fork()).ldelim();
        }
        for (const v of message.linkFlairRichtext) {
            StringValue.encode({ value: v }, writer.uint32(90).fork()).ldelim();
        }
        if (message.subredditNamePrefixed !== undefined) {
            StringValue.encode({ value: message.subredditNamePrefixed }, writer.uint32(98).fork()).ldelim();
        }
        if (message.hidden !== undefined) {
            BoolValue.encode({ value: message.hidden }, writer.uint32(106).fork()).ldelim();
        }
        if (message.pwls !== undefined) {
            StringValue.encode({ value: message.pwls }, writer.uint32(114).fork()).ldelim();
        }
        if (message.linkFlairCssClass !== undefined) {
            StringValue.encode({ value: message.linkFlairCssClass }, writer.uint32(122).fork()).ldelim();
        }
        if (message.downs !== undefined) {
            Int64Value.encode({ value: message.downs }, writer.uint32(130).fork()).ldelim();
        }
        if (message.thumbnailHeight !== undefined) {
            Int32Value.encode({ value: message.thumbnailHeight }, writer.uint32(138).fork()).ldelim();
        }
        if (message.topAwardedType !== undefined) {
            StringValue.encode({ value: message.topAwardedType }, writer.uint32(146).fork()).ldelim();
        }
        if (message.parentWhitelistStatus !== undefined) {
            BoolValue.encode({ value: message.parentWhitelistStatus }, writer.uint32(154).fork()).ldelim();
        }
        if (message.hideScore !== undefined) {
            BoolValue.encode({ value: message.hideScore }, writer.uint32(162).fork()).ldelim();
        }
        if (message.name !== undefined) {
            StringValue.encode({ value: message.name }, writer.uint32(170).fork()).ldelim();
        }
        if (message.quarantine !== undefined) {
            BoolValue.encode({ value: message.quarantine }, writer.uint32(178).fork()).ldelim();
        }
        if (message.linkFlairTextColor !== undefined) {
            StringValue.encode({ value: message.linkFlairTextColor }, writer.uint32(186).fork()).ldelim();
        }
        if (message.upvoteRatio !== undefined) {
            Int64Value.encode({ value: message.upvoteRatio }, writer.uint32(194).fork()).ldelim();
        }
        if (message.ignoreReports !== undefined) {
            BoolValue.encode({ value: message.ignoreReports }, writer.uint32(202).fork()).ldelim();
        }
        if (message.ups !== undefined) {
            Int64Value.encode({ value: message.ups }, writer.uint32(210).fork()).ldelim();
        }
        if (message.domain !== undefined) {
            StringValue.encode({ value: message.domain }, writer.uint32(218).fork()).ldelim();
        }
        if (message.mediaEmbed !== undefined) {
            MediaEmbed.encode(message.mediaEmbed, writer.uint32(226).fork()).ldelim();
        }
        if (message.thumbnailWidth !== undefined) {
            Int32Value.encode({ value: message.thumbnailWidth }, writer.uint32(234).fork()).ldelim();
        }
        if (message.authorFlairTemplateId !== undefined) {
            StringValue.encode({ value: message.authorFlairTemplateId }, writer.uint32(242).fork()).ldelim();
        }
        if (message.isOriginalContent !== undefined) {
            BoolValue.encode({ value: message.isOriginalContent }, writer.uint32(250).fork()).ldelim();
        }
        if (message.authorFullname !== undefined) {
            StringValue.encode({ value: message.authorFullname }, writer.uint32(258).fork()).ldelim();
        }
        if (message.secureMedia !== undefined) {
            BoolValue.encode({ value: message.secureMedia }, writer.uint32(266).fork()).ldelim();
        }
        if (message.isRedditMediaDomain !== undefined) {
            BoolValue.encode({ value: message.isRedditMediaDomain }, writer.uint32(274).fork()).ldelim();
        }
        if (message.isMeta !== undefined) {
            BoolValue.encode({ value: message.isMeta }, writer.uint32(282).fork()).ldelim();
        }
        if (message.category !== undefined) {
            StringValue.encode({ value: message.category }, writer.uint32(290).fork()).ldelim();
        }
        if (message.secureMediaEmbed !== undefined) {
            MediaEmbed.encode(message.secureMediaEmbed, writer.uint32(298).fork()).ldelim();
        }
        if (message.linkFlairText !== undefined) {
            StringValue.encode({ value: message.linkFlairText }, writer.uint32(306).fork()).ldelim();
        }
        if (message.canModPost !== undefined) {
            BoolValue.encode({ value: message.canModPost }, writer.uint32(314).fork()).ldelim();
        }
        if (message.score !== undefined) {
            Int64Value.encode({ value: message.score }, writer.uint32(322).fork()).ldelim();
        }
        if (message.approvedBy !== undefined) {
            StringValue.encode({ value: message.approvedBy }, writer.uint32(330).fork()).ldelim();
        }
        if (message.isCreatedFromAdsUi !== undefined) {
            BoolValue.encode({ value: message.isCreatedFromAdsUi }, writer.uint32(338).fork()).ldelim();
        }
        if (message.authorPremium !== undefined) {
            BoolValue.encode({ value: message.authorPremium }, writer.uint32(346).fork()).ldelim();
        }
        if (message.thumbnail !== undefined) {
            StringValue.encode({ value: message.thumbnail }, writer.uint32(354).fork()).ldelim();
        }
        if (message.edited !== undefined) {
            BoolValue.encode({ value: message.edited }, writer.uint32(362).fork()).ldelim();
        }
        if (message.authorFlairCssClass !== undefined) {
            StringValue.encode({ value: message.authorFlairCssClass }, writer.uint32(370).fork()).ldelim();
        }
        for (const v of message.previousVisits) {
            Int64Value.encode({ value: v }, writer.uint32(378).fork()).ldelim();
        }
        for (const v of message.authorFlairRichtext) {
            StringValue.encode({ value: v }, writer.uint32(386).fork()).ldelim();
        }
        if (message.gildings !== undefined) {
            Any.encode(message.gildings, writer.uint32(394).fork()).ldelim();
        }
        if (message.contentCategories !== undefined) {
            StringValue.encode({ value: message.contentCategories }, writer.uint32(402).fork()).ldelim();
        }
        if (message.isSelf !== undefined) {
            BoolValue.encode({ value: message.isSelf }, writer.uint32(410).fork()).ldelim();
        }
        if (message.subredditType !== undefined) {
            StringValue.encode({ value: message.subredditType }, writer.uint32(418).fork()).ldelim();
        }
        if (message.created !== undefined) {
            Int64Value.encode({ value: message.created }, writer.uint32(426).fork()).ldelim();
        }
        if (message.linkFlairType !== undefined) {
            StringValue.encode({ value: message.linkFlairType }, writer.uint32(434).fork()).ldelim();
        }
        if (message.wls !== undefined) {
            StringValue.encode({ value: message.wls }, writer.uint32(442).fork()).ldelim();
        }
        if (message.removedByCategory !== undefined) {
            StringValue.encode({ value: message.removedByCategory }, writer.uint32(450).fork()).ldelim();
        }
        if (message.bannedBy !== undefined) {
            StringValue.encode({ value: message.bannedBy }, writer.uint32(458).fork()).ldelim();
        }
        if (message.authorFlairType !== undefined) {
            StringValue.encode({ value: message.authorFlairType }, writer.uint32(466).fork()).ldelim();
        }
        if (message.totalAwardsReceived !== undefined) {
            Int64Value.encode({ value: message.totalAwardsReceived }, writer.uint32(474).fork()).ldelim();
        }
        if (message.allowLiveComments !== undefined) {
            BoolValue.encode({ value: message.allowLiveComments }, writer.uint32(482).fork()).ldelim();
        }
        if (message.selftextHtml !== undefined) {
            StringValue.encode({ value: message.selftextHtml }, writer.uint32(490).fork()).ldelim();
        }
        if (message.likes !== undefined) {
            BoolValue.encode({ value: message.likes }, writer.uint32(498).fork()).ldelim();
        }
        if (message.suggestedSort !== undefined) {
            StringValue.encode({ value: message.suggestedSort }, writer.uint32(506).fork()).ldelim();
        }
        if (message.bannedAtUtc !== undefined) {
            Int32Value.encode({ value: message.bannedAtUtc }, writer.uint32(514).fork()).ldelim();
        }
        if (message.viewCount !== undefined) {
            Int32Value.encode({ value: message.viewCount }, writer.uint32(522).fork()).ldelim();
        }
        if (message.archived !== undefined) {
            BoolValue.encode({ value: message.archived }, writer.uint32(530).fork()).ldelim();
        }
        if (message.noFollow !== undefined) {
            BoolValue.encode({ value: message.noFollow }, writer.uint32(538).fork()).ldelim();
        }
        if (message.spam !== undefined) {
            BoolValue.encode({ value: message.spam }, writer.uint32(546).fork()).ldelim();
        }
        if (message.isCrosspostable !== undefined) {
            BoolValue.encode({ value: message.isCrosspostable }, writer.uint32(554).fork()).ldelim();
        }
        if (message.pinned !== undefined) {
            BoolValue.encode({ value: message.pinned }, writer.uint32(562).fork()).ldelim();
        }
        if (message.over18 !== undefined) {
            BoolValue.encode({ value: message.over18 }, writer.uint32(570).fork()).ldelim();
        }
        for (const v of message.allAwardings) {
            Any.encode(v, writer.uint32(578).fork()).ldelim();
        }
        for (const v of message.awarders) {
            StringValue.encode({ value: v }, writer.uint32(586).fork()).ldelim();
        }
        if (message.mediaOnly !== undefined) {
            BoolValue.encode({ value: message.mediaOnly }, writer.uint32(594).fork()).ldelim();
        }
        if (message.canGild !== undefined) {
            BoolValue.encode({ value: message.canGild }, writer.uint32(602).fork()).ldelim();
        }
        if (message.removed !== undefined) {
            BoolValue.encode({ value: message.removed }, writer.uint32(610).fork()).ldelim();
        }
        if (message.spoiler !== undefined) {
            BoolValue.encode({ value: message.spoiler }, writer.uint32(618).fork()).ldelim();
        }
        if (message.locked !== undefined) {
            BoolValue.encode({ value: message.locked }, writer.uint32(626).fork()).ldelim();
        }
        if (message.authorFlairText !== undefined) {
            StringValue.encode({ value: message.authorFlairText }, writer.uint32(634).fork()).ldelim();
        }
        for (const v of message.treatmentTags) {
            Any.encode(v, writer.uint32(642).fork()).ldelim();
        }
        if (message.rteMode !== undefined) {
            StringValue.encode({ value: message.rteMode }, writer.uint32(650).fork()).ldelim();
        }
        if (message.visited !== undefined) {
            BoolValue.encode({ value: message.visited }, writer.uint32(658).fork()).ldelim();
        }
        if (message.removedBy !== undefined) {
            StringValue.encode({ value: message.removedBy }, writer.uint32(666).fork()).ldelim();
        }
        if (message.modNote !== undefined) {
            StringValue.encode({ value: message.modNote }, writer.uint32(674).fork()).ldelim();
        }
        if (message.distinguished !== undefined) {
            StringValue.encode({ value: message.distinguished }, writer.uint32(682).fork()).ldelim();
        }
        if (message.subredditId !== undefined) {
            StringValue.encode({ value: message.subredditId }, writer.uint32(690).fork()).ldelim();
        }
        if (message.authorIsBlocked !== undefined) {
            BoolValue.encode({ value: message.authorIsBlocked }, writer.uint32(698).fork()).ldelim();
        }
        if (message.modReasonBy !== undefined) {
            StringValue.encode({ value: message.modReasonBy }, writer.uint32(706).fork()).ldelim();
        }
        if (message.numReports !== undefined) {
            Int64Value.encode({ value: message.numReports }, writer.uint32(714).fork()).ldelim();
        }
        if (message.removalReason !== undefined) {
            StringValue.encode({ value: message.removalReason }, writer.uint32(722).fork()).ldelim();
        }
        if (message.linkFlairBackgroundColor !== undefined) {
            StringValue.encode({ value: message.linkFlairBackgroundColor }, writer.uint32(730).fork()).ldelim();
        }
        if (message.id !== undefined) {
            StringValue.encode({ value: message.id }, writer.uint32(738).fork()).ldelim();
        }
        if (message.isRobotIndexable !== undefined) {
            BoolValue.encode({ value: message.isRobotIndexable }, writer.uint32(746).fork()).ldelim();
        }
        if (message.numDuplicates !== undefined) {
            Int32Value.encode({ value: message.numDuplicates }, writer.uint32(754).fork()).ldelim();
        }
        for (const v of message.reportReasons) {
            Any.encode(v, writer.uint32(762).fork()).ldelim();
        }
        if (message.author !== undefined) {
            StringValue.encode({ value: message.author }, writer.uint32(770).fork()).ldelim();
        }
        if (message.discussionType !== undefined) {
            StringValue.encode({ value: message.discussionType }, writer.uint32(778).fork()).ldelim();
        }
        if (message.numComments !== undefined) {
            Int64Value.encode({ value: message.numComments }, writer.uint32(786).fork()).ldelim();
        }
        if (message.sendReplies !== undefined) {
            BoolValue.encode({ value: message.sendReplies }, writer.uint32(794).fork()).ldelim();
        }
        if (message.media !== undefined) {
            StringValue.encode({ value: message.media }, writer.uint32(802).fork()).ldelim();
        }
        if (message.contestMode !== undefined) {
            BoolValue.encode({ value: message.contestMode }, writer.uint32(810).fork()).ldelim();
        }
        if (message.authorPatreonFlair !== undefined) {
            BoolValue.encode({ value: message.authorPatreonFlair }, writer.uint32(818).fork()).ldelim();
        }
        if (message.approved !== undefined) {
            BoolValue.encode({ value: message.approved }, writer.uint32(826).fork()).ldelim();
        }
        if (message.authorFlairTextColor !== undefined) {
            StringValue.encode({ value: message.authorFlairTextColor }, writer.uint32(834).fork()).ldelim();
        }
        if (message.permalink !== undefined) {
            StringValue.encode({ value: message.permalink }, writer.uint32(842).fork()).ldelim();
        }
        if (message.whitelistStatus !== undefined) {
            BoolValue.encode({ value: message.whitelistStatus }, writer.uint32(850).fork()).ldelim();
        }
        if (message.stickied !== undefined) {
            BoolValue.encode({ value: message.stickied }, writer.uint32(858).fork()).ldelim();
        }
        if (message.url !== undefined) {
            StringValue.encode({ value: message.url }, writer.uint32(866).fork()).ldelim();
        }
        if (message.subredditSubscribers !== undefined) {
            Int64Value.encode({ value: message.subredditSubscribers }, writer.uint32(874).fork()).ldelim();
        }
        if (message.createdUtc !== undefined) {
            Int64Value.encode({ value: message.createdUtc }, writer.uint32(882).fork()).ldelim();
        }
        if (message.numCrossposts !== undefined) {
            Int64Value.encode({ value: message.numCrossposts }, writer.uint32(890).fork()).ldelim();
        }
        for (const v of message.modReports) {
            Any.encode(v, writer.uint32(898).fork()).ldelim();
        }
        if (message.isVideo !== undefined) {
            BoolValue.encode({ value: message.isVideo }, writer.uint32(906).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseStickyResponse_LinkData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.authorFlairBackgroundColor = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.approvedAtUtc = Int32Value.decode(reader, reader.uint32()).value;
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.subreddit = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.selftext = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.userReports.push(StringValue.decode(reader, reader.uint32()).value);
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.saved = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.modReasonTitle = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.gilded = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 9:
                    if (tag !== 74) {
                        break;
                    }
                    message.clicked = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.title = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 11:
                    if (tag !== 90) {
                        break;
                    }
                    message.linkFlairRichtext.push(StringValue.decode(reader, reader.uint32()).value);
                    continue;
                case 12:
                    if (tag !== 98) {
                        break;
                    }
                    message.subredditNamePrefixed = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 13:
                    if (tag !== 106) {
                        break;
                    }
                    message.hidden = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 14:
                    if (tag !== 114) {
                        break;
                    }
                    message.pwls = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 15:
                    if (tag !== 122) {
                        break;
                    }
                    message.linkFlairCssClass = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 16:
                    if (tag !== 130) {
                        break;
                    }
                    message.downs = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 17:
                    if (tag !== 138) {
                        break;
                    }
                    message.thumbnailHeight = Int32Value.decode(reader, reader.uint32()).value;
                    continue;
                case 18:
                    if (tag !== 146) {
                        break;
                    }
                    message.topAwardedType = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 19:
                    if (tag !== 154) {
                        break;
                    }
                    message.parentWhitelistStatus = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 20:
                    if (tag !== 162) {
                        break;
                    }
                    message.hideScore = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 21:
                    if (tag !== 170) {
                        break;
                    }
                    message.name = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 22:
                    if (tag !== 178) {
                        break;
                    }
                    message.quarantine = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 23:
                    if (tag !== 186) {
                        break;
                    }
                    message.linkFlairTextColor = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 24:
                    if (tag !== 194) {
                        break;
                    }
                    message.upvoteRatio = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 25:
                    if (tag !== 202) {
                        break;
                    }
                    message.ignoreReports = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 26:
                    if (tag !== 210) {
                        break;
                    }
                    message.ups = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 27:
                    if (tag !== 218) {
                        break;
                    }
                    message.domain = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 28:
                    if (tag !== 226) {
                        break;
                    }
                    message.mediaEmbed = MediaEmbed.decode(reader, reader.uint32());
                    continue;
                case 29:
                    if (tag !== 234) {
                        break;
                    }
                    message.thumbnailWidth = Int32Value.decode(reader, reader.uint32()).value;
                    continue;
                case 30:
                    if (tag !== 242) {
                        break;
                    }
                    message.authorFlairTemplateId = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 31:
                    if (tag !== 250) {
                        break;
                    }
                    message.isOriginalContent = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 32:
                    if (tag !== 258) {
                        break;
                    }
                    message.authorFullname = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 33:
                    if (tag !== 266) {
                        break;
                    }
                    message.secureMedia = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 34:
                    if (tag !== 274) {
                        break;
                    }
                    message.isRedditMediaDomain = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 35:
                    if (tag !== 282) {
                        break;
                    }
                    message.isMeta = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 36:
                    if (tag !== 290) {
                        break;
                    }
                    message.category = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 37:
                    if (tag !== 298) {
                        break;
                    }
                    message.secureMediaEmbed = MediaEmbed.decode(reader, reader.uint32());
                    continue;
                case 38:
                    if (tag !== 306) {
                        break;
                    }
                    message.linkFlairText = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 39:
                    if (tag !== 314) {
                        break;
                    }
                    message.canModPost = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 40:
                    if (tag !== 322) {
                        break;
                    }
                    message.score = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 41:
                    if (tag !== 330) {
                        break;
                    }
                    message.approvedBy = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 42:
                    if (tag !== 338) {
                        break;
                    }
                    message.isCreatedFromAdsUi = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 43:
                    if (tag !== 346) {
                        break;
                    }
                    message.authorPremium = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 44:
                    if (tag !== 354) {
                        break;
                    }
                    message.thumbnail = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 45:
                    if (tag !== 362) {
                        break;
                    }
                    message.edited = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 46:
                    if (tag !== 370) {
                        break;
                    }
                    message.authorFlairCssClass = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 47:
                    if (tag !== 378) {
                        break;
                    }
                    message.previousVisits.push(Int64Value.decode(reader, reader.uint32()).value);
                    continue;
                case 48:
                    if (tag !== 386) {
                        break;
                    }
                    message.authorFlairRichtext.push(StringValue.decode(reader, reader.uint32()).value);
                    continue;
                case 49:
                    if (tag !== 394) {
                        break;
                    }
                    message.gildings = Any.decode(reader, reader.uint32());
                    continue;
                case 50:
                    if (tag !== 402) {
                        break;
                    }
                    message.contentCategories = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 51:
                    if (tag !== 410) {
                        break;
                    }
                    message.isSelf = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 52:
                    if (tag !== 418) {
                        break;
                    }
                    message.subredditType = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 53:
                    if (tag !== 426) {
                        break;
                    }
                    message.created = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 54:
                    if (tag !== 434) {
                        break;
                    }
                    message.linkFlairType = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 55:
                    if (tag !== 442) {
                        break;
                    }
                    message.wls = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 56:
                    if (tag !== 450) {
                        break;
                    }
                    message.removedByCategory = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 57:
                    if (tag !== 458) {
                        break;
                    }
                    message.bannedBy = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 58:
                    if (tag !== 466) {
                        break;
                    }
                    message.authorFlairType = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 59:
                    if (tag !== 474) {
                        break;
                    }
                    message.totalAwardsReceived = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 60:
                    if (tag !== 482) {
                        break;
                    }
                    message.allowLiveComments = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 61:
                    if (tag !== 490) {
                        break;
                    }
                    message.selftextHtml = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 62:
                    if (tag !== 498) {
                        break;
                    }
                    message.likes = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 63:
                    if (tag !== 506) {
                        break;
                    }
                    message.suggestedSort = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 64:
                    if (tag !== 514) {
                        break;
                    }
                    message.bannedAtUtc = Int32Value.decode(reader, reader.uint32()).value;
                    continue;
                case 65:
                    if (tag !== 522) {
                        break;
                    }
                    message.viewCount = Int32Value.decode(reader, reader.uint32()).value;
                    continue;
                case 66:
                    if (tag !== 530) {
                        break;
                    }
                    message.archived = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 67:
                    if (tag !== 538) {
                        break;
                    }
                    message.noFollow = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 68:
                    if (tag !== 546) {
                        break;
                    }
                    message.spam = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 69:
                    if (tag !== 554) {
                        break;
                    }
                    message.isCrosspostable = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 70:
                    if (tag !== 562) {
                        break;
                    }
                    message.pinned = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 71:
                    if (tag !== 570) {
                        break;
                    }
                    message.over18 = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 72:
                    if (tag !== 578) {
                        break;
                    }
                    message.allAwardings.push(Any.decode(reader, reader.uint32()));
                    continue;
                case 73:
                    if (tag !== 586) {
                        break;
                    }
                    message.awarders.push(StringValue.decode(reader, reader.uint32()).value);
                    continue;
                case 74:
                    if (tag !== 594) {
                        break;
                    }
                    message.mediaOnly = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 75:
                    if (tag !== 602) {
                        break;
                    }
                    message.canGild = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 76:
                    if (tag !== 610) {
                        break;
                    }
                    message.removed = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 77:
                    if (tag !== 618) {
                        break;
                    }
                    message.spoiler = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 78:
                    if (tag !== 626) {
                        break;
                    }
                    message.locked = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 79:
                    if (tag !== 634) {
                        break;
                    }
                    message.authorFlairText = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 80:
                    if (tag !== 642) {
                        break;
                    }
                    message.treatmentTags.push(Any.decode(reader, reader.uint32()));
                    continue;
                case 81:
                    if (tag !== 650) {
                        break;
                    }
                    message.rteMode = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 82:
                    if (tag !== 658) {
                        break;
                    }
                    message.visited = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 83:
                    if (tag !== 666) {
                        break;
                    }
                    message.removedBy = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 84:
                    if (tag !== 674) {
                        break;
                    }
                    message.modNote = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 85:
                    if (tag !== 682) {
                        break;
                    }
                    message.distinguished = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 86:
                    if (tag !== 690) {
                        break;
                    }
                    message.subredditId = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 87:
                    if (tag !== 698) {
                        break;
                    }
                    message.authorIsBlocked = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 88:
                    if (tag !== 706) {
                        break;
                    }
                    message.modReasonBy = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 89:
                    if (tag !== 714) {
                        break;
                    }
                    message.numReports = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 90:
                    if (tag !== 722) {
                        break;
                    }
                    message.removalReason = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 91:
                    if (tag !== 730) {
                        break;
                    }
                    message.linkFlairBackgroundColor = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 92:
                    if (tag !== 738) {
                        break;
                    }
                    message.id = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 93:
                    if (tag !== 746) {
                        break;
                    }
                    message.isRobotIndexable = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 94:
                    if (tag !== 754) {
                        break;
                    }
                    message.numDuplicates = Int32Value.decode(reader, reader.uint32()).value;
                    continue;
                case 95:
                    if (tag !== 762) {
                        break;
                    }
                    message.reportReasons.push(Any.decode(reader, reader.uint32()));
                    continue;
                case 96:
                    if (tag !== 770) {
                        break;
                    }
                    message.author = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 97:
                    if (tag !== 778) {
                        break;
                    }
                    message.discussionType = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 98:
                    if (tag !== 786) {
                        break;
                    }
                    message.numComments = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 99:
                    if (tag !== 794) {
                        break;
                    }
                    message.sendReplies = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 100:
                    if (tag !== 802) {
                        break;
                    }
                    message.media = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 101:
                    if (tag !== 810) {
                        break;
                    }
                    message.contestMode = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 102:
                    if (tag !== 818) {
                        break;
                    }
                    message.authorPatreonFlair = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 103:
                    if (tag !== 826) {
                        break;
                    }
                    message.approved = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 104:
                    if (tag !== 834) {
                        break;
                    }
                    message.authorFlairTextColor = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 105:
                    if (tag !== 842) {
                        break;
                    }
                    message.permalink = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 106:
                    if (tag !== 850) {
                        break;
                    }
                    message.whitelistStatus = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 107:
                    if (tag !== 858) {
                        break;
                    }
                    message.stickied = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 108:
                    if (tag !== 866) {
                        break;
                    }
                    message.url = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 109:
                    if (tag !== 874) {
                        break;
                    }
                    message.subredditSubscribers = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 110:
                    if (tag !== 882) {
                        break;
                    }
                    message.createdUtc = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 111:
                    if (tag !== 890) {
                        break;
                    }
                    message.numCrossposts = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 112:
                    if (tag !== 898) {
                        break;
                    }
                    message.modReports.push(Any.decode(reader, reader.uint32()));
                    continue;
                case 113:
                    if (tag !== 906) {
                        break;
                    }
                    message.isVideo = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            authorFlairBackgroundColor: isSet(object.authorFlairBackgroundColor)
                ? String(object.authorFlairBackgroundColor)
                : undefined,
            approvedAtUtc: isSet(object.approvedAtUtc) ? Number(object.approvedAtUtc) : undefined,
            subreddit: isSet(object.subreddit) ? String(object.subreddit) : undefined,
            selftext: isSet(object.selftext) ? String(object.selftext) : undefined,
            userReports: globalThis.Array.isArray(object?.userReports) ? object.userReports.map((e) => String(e)) : [],
            saved: isSet(object.saved) ? Boolean(object.saved) : undefined,
            modReasonTitle: isSet(object.modReasonTitle) ? String(object.modReasonTitle) : undefined,
            gilded: isSet(object.gilded) ? Number(object.gilded) : undefined,
            clicked: isSet(object.clicked) ? Boolean(object.clicked) : undefined,
            title: isSet(object.title) ? String(object.title) : undefined,
            linkFlairRichtext: globalThis.Array.isArray(object?.linkFlairRichtext)
                ? object.linkFlairRichtext.map((e) => String(e))
                : [],
            subredditNamePrefixed: isSet(object.subredditNamePrefixed) ? String(object.subredditNamePrefixed) : undefined,
            hidden: isSet(object.hidden) ? Boolean(object.hidden) : undefined,
            pwls: isSet(object.pwls) ? String(object.pwls) : undefined,
            linkFlairCssClass: isSet(object.linkFlairCssClass) ? String(object.linkFlairCssClass) : undefined,
            downs: isSet(object.downs) ? Number(object.downs) : undefined,
            thumbnailHeight: isSet(object.thumbnailHeight) ? Number(object.thumbnailHeight) : undefined,
            topAwardedType: isSet(object.topAwardedType) ? String(object.topAwardedType) : undefined,
            parentWhitelistStatus: isSet(object.parentWhitelistStatus) ? Boolean(object.parentWhitelistStatus) : undefined,
            hideScore: isSet(object.hideScore) ? Boolean(object.hideScore) : undefined,
            name: isSet(object.name) ? String(object.name) : undefined,
            quarantine: isSet(object.quarantine) ? Boolean(object.quarantine) : undefined,
            linkFlairTextColor: isSet(object.linkFlairTextColor) ? String(object.linkFlairTextColor) : undefined,
            upvoteRatio: isSet(object.upvoteRatio) ? Number(object.upvoteRatio) : undefined,
            ignoreReports: isSet(object.ignoreReports) ? Boolean(object.ignoreReports) : undefined,
            ups: isSet(object.ups) ? Number(object.ups) : undefined,
            domain: isSet(object.domain) ? String(object.domain) : undefined,
            mediaEmbed: isSet(object.mediaEmbed) ? MediaEmbed.fromJSON(object.mediaEmbed) : undefined,
            thumbnailWidth: isSet(object.thumbnailWidth) ? Number(object.thumbnailWidth) : undefined,
            authorFlairTemplateId: isSet(object.authorFlairTemplateId) ? String(object.authorFlairTemplateId) : undefined,
            isOriginalContent: isSet(object.isOriginalContent) ? Boolean(object.isOriginalContent) : undefined,
            authorFullname: isSet(object.authorFullname) ? String(object.authorFullname) : undefined,
            secureMedia: isSet(object.secureMedia) ? Boolean(object.secureMedia) : undefined,
            isRedditMediaDomain: isSet(object.isRedditMediaDomain) ? Boolean(object.isRedditMediaDomain) : undefined,
            isMeta: isSet(object.isMeta) ? Boolean(object.isMeta) : undefined,
            category: isSet(object.category) ? String(object.category) : undefined,
            secureMediaEmbed: isSet(object.secureMediaEmbed) ? MediaEmbed.fromJSON(object.secureMediaEmbed) : undefined,
            linkFlairText: isSet(object.linkFlairText) ? String(object.linkFlairText) : undefined,
            canModPost: isSet(object.canModPost) ? Boolean(object.canModPost) : undefined,
            score: isSet(object.score) ? Number(object.score) : undefined,
            approvedBy: isSet(object.approvedBy) ? String(object.approvedBy) : undefined,
            isCreatedFromAdsUi: isSet(object.isCreatedFromAdsUi) ? Boolean(object.isCreatedFromAdsUi) : undefined,
            authorPremium: isSet(object.authorPremium) ? Boolean(object.authorPremium) : undefined,
            thumbnail: isSet(object.thumbnail) ? String(object.thumbnail) : undefined,
            edited: isSet(object.edited) ? Boolean(object.edited) : undefined,
            authorFlairCssClass: isSet(object.authorFlairCssClass) ? String(object.authorFlairCssClass) : undefined,
            previousVisits: globalThis.Array.isArray(object?.previousVisits)
                ? object.previousVisits.map((e) => Number(e))
                : [],
            authorFlairRichtext: globalThis.Array.isArray(object?.authorFlairRichtext)
                ? object.authorFlairRichtext.map((e) => String(e))
                : [],
            gildings: isSet(object.gildings) ? Any.fromJSON(object.gildings) : undefined,
            contentCategories: isSet(object.contentCategories) ? String(object.contentCategories) : undefined,
            isSelf: isSet(object.isSelf) ? Boolean(object.isSelf) : undefined,
            subredditType: isSet(object.subredditType) ? String(object.subredditType) : undefined,
            created: isSet(object.created) ? Number(object.created) : undefined,
            linkFlairType: isSet(object.linkFlairType) ? String(object.linkFlairType) : undefined,
            wls: isSet(object.wls) ? String(object.wls) : undefined,
            removedByCategory: isSet(object.removedByCategory) ? String(object.removedByCategory) : undefined,
            bannedBy: isSet(object.bannedBy) ? String(object.bannedBy) : undefined,
            authorFlairType: isSet(object.authorFlairType) ? String(object.authorFlairType) : undefined,
            totalAwardsReceived: isSet(object.totalAwardsReceived) ? Number(object.totalAwardsReceived) : undefined,
            allowLiveComments: isSet(object.allowLiveComments) ? Boolean(object.allowLiveComments) : undefined,
            selftextHtml: isSet(object.selftextHtml) ? String(object.selftextHtml) : undefined,
            likes: isSet(object.likes) ? Boolean(object.likes) : undefined,
            suggestedSort: isSet(object.suggestedSort) ? String(object.suggestedSort) : undefined,
            bannedAtUtc: isSet(object.bannedAtUtc) ? Number(object.bannedAtUtc) : undefined,
            viewCount: isSet(object.viewCount) ? Number(object.viewCount) : undefined,
            archived: isSet(object.archived) ? Boolean(object.archived) : undefined,
            noFollow: isSet(object.noFollow) ? Boolean(object.noFollow) : undefined,
            spam: isSet(object.spam) ? Boolean(object.spam) : undefined,
            isCrosspostable: isSet(object.isCrosspostable) ? Boolean(object.isCrosspostable) : undefined,
            pinned: isSet(object.pinned) ? Boolean(object.pinned) : undefined,
            over18: isSet(object.over18) ? Boolean(object.over18) : undefined,
            allAwardings: globalThis.Array.isArray(object?.allAwardings)
                ? object.allAwardings.map((e) => Any.fromJSON(e))
                : [],
            awarders: globalThis.Array.isArray(object?.awarders) ? object.awarders.map((e) => String(e)) : [],
            mediaOnly: isSet(object.mediaOnly) ? Boolean(object.mediaOnly) : undefined,
            canGild: isSet(object.canGild) ? Boolean(object.canGild) : undefined,
            removed: isSet(object.removed) ? Boolean(object.removed) : undefined,
            spoiler: isSet(object.spoiler) ? Boolean(object.spoiler) : undefined,
            locked: isSet(object.locked) ? Boolean(object.locked) : undefined,
            authorFlairText: isSet(object.authorFlairText) ? String(object.authorFlairText) : undefined,
            treatmentTags: globalThis.Array.isArray(object?.treatmentTags)
                ? object.treatmentTags.map((e) => Any.fromJSON(e))
                : [],
            rteMode: isSet(object.rteMode) ? String(object.rteMode) : undefined,
            visited: isSet(object.visited) ? Boolean(object.visited) : undefined,
            removedBy: isSet(object.removedBy) ? String(object.removedBy) : undefined,
            modNote: isSet(object.modNote) ? String(object.modNote) : undefined,
            distinguished: isSet(object.distinguished) ? String(object.distinguished) : undefined,
            subredditId: isSet(object.subredditId) ? String(object.subredditId) : undefined,
            authorIsBlocked: isSet(object.authorIsBlocked) ? Boolean(object.authorIsBlocked) : undefined,
            modReasonBy: isSet(object.modReasonBy) ? String(object.modReasonBy) : undefined,
            numReports: isSet(object.numReports) ? Number(object.numReports) : undefined,
            removalReason: isSet(object.removalReason) ? String(object.removalReason) : undefined,
            linkFlairBackgroundColor: isSet(object.linkFlairBackgroundColor)
                ? String(object.linkFlairBackgroundColor)
                : undefined,
            id: isSet(object.id) ? String(object.id) : undefined,
            isRobotIndexable: isSet(object.isRobotIndexable) ? Boolean(object.isRobotIndexable) : undefined,
            numDuplicates: isSet(object.numDuplicates) ? Number(object.numDuplicates) : undefined,
            reportReasons: globalThis.Array.isArray(object?.reportReasons)
                ? object.reportReasons.map((e) => Any.fromJSON(e))
                : [],
            author: isSet(object.author) ? String(object.author) : undefined,
            discussionType: isSet(object.discussionType) ? String(object.discussionType) : undefined,
            numComments: isSet(object.numComments) ? Number(object.numComments) : undefined,
            sendReplies: isSet(object.sendReplies) ? Boolean(object.sendReplies) : undefined,
            media: isSet(object.media) ? String(object.media) : undefined,
            contestMode: isSet(object.contestMode) ? Boolean(object.contestMode) : undefined,
            authorPatreonFlair: isSet(object.authorPatreonFlair) ? Boolean(object.authorPatreonFlair) : undefined,
            approved: isSet(object.approved) ? Boolean(object.approved) : undefined,
            authorFlairTextColor: isSet(object.authorFlairTextColor) ? String(object.authorFlairTextColor) : undefined,
            permalink: isSet(object.permalink) ? String(object.permalink) : undefined,
            whitelistStatus: isSet(object.whitelistStatus) ? Boolean(object.whitelistStatus) : undefined,
            stickied: isSet(object.stickied) ? Boolean(object.stickied) : undefined,
            url: isSet(object.url) ? String(object.url) : undefined,
            subredditSubscribers: isSet(object.subredditSubscribers) ? Number(object.subredditSubscribers) : undefined,
            createdUtc: isSet(object.createdUtc) ? Number(object.createdUtc) : undefined,
            numCrossposts: isSet(object.numCrossposts) ? Number(object.numCrossposts) : undefined,
            modReports: globalThis.Array.isArray(object?.modReports)
                ? object.modReports.map((e) => Any.fromJSON(e))
                : [],
            isVideo: isSet(object.isVideo) ? Boolean(object.isVideo) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.authorFlairBackgroundColor !== undefined) {
            obj.authorFlairBackgroundColor = message.authorFlairBackgroundColor;
        }
        if (message.approvedAtUtc !== undefined) {
            obj.approvedAtUtc = message.approvedAtUtc;
        }
        if (message.subreddit !== undefined) {
            obj.subreddit = message.subreddit;
        }
        if (message.selftext !== undefined) {
            obj.selftext = message.selftext;
        }
        if (message.userReports?.length) {
            obj.userReports = message.userReports;
        }
        if (message.saved !== undefined) {
            obj.saved = message.saved;
        }
        if (message.modReasonTitle !== undefined) {
            obj.modReasonTitle = message.modReasonTitle;
        }
        if (message.gilded !== undefined) {
            obj.gilded = message.gilded;
        }
        if (message.clicked !== undefined) {
            obj.clicked = message.clicked;
        }
        if (message.title !== undefined) {
            obj.title = message.title;
        }
        if (message.linkFlairRichtext?.length) {
            obj.linkFlairRichtext = message.linkFlairRichtext;
        }
        if (message.subredditNamePrefixed !== undefined) {
            obj.subredditNamePrefixed = message.subredditNamePrefixed;
        }
        if (message.hidden !== undefined) {
            obj.hidden = message.hidden;
        }
        if (message.pwls !== undefined) {
            obj.pwls = message.pwls;
        }
        if (message.linkFlairCssClass !== undefined) {
            obj.linkFlairCssClass = message.linkFlairCssClass;
        }
        if (message.downs !== undefined) {
            obj.downs = message.downs;
        }
        if (message.thumbnailHeight !== undefined) {
            obj.thumbnailHeight = message.thumbnailHeight;
        }
        if (message.topAwardedType !== undefined) {
            obj.topAwardedType = message.topAwardedType;
        }
        if (message.parentWhitelistStatus !== undefined) {
            obj.parentWhitelistStatus = message.parentWhitelistStatus;
        }
        if (message.hideScore !== undefined) {
            obj.hideScore = message.hideScore;
        }
        if (message.name !== undefined) {
            obj.name = message.name;
        }
        if (message.quarantine !== undefined) {
            obj.quarantine = message.quarantine;
        }
        if (message.linkFlairTextColor !== undefined) {
            obj.linkFlairTextColor = message.linkFlairTextColor;
        }
        if (message.upvoteRatio !== undefined) {
            obj.upvoteRatio = message.upvoteRatio;
        }
        if (message.ignoreReports !== undefined) {
            obj.ignoreReports = message.ignoreReports;
        }
        if (message.ups !== undefined) {
            obj.ups = message.ups;
        }
        if (message.domain !== undefined) {
            obj.domain = message.domain;
        }
        if (message.mediaEmbed !== undefined) {
            obj.mediaEmbed = MediaEmbed.toJSON(message.mediaEmbed);
        }
        if (message.thumbnailWidth !== undefined) {
            obj.thumbnailWidth = message.thumbnailWidth;
        }
        if (message.authorFlairTemplateId !== undefined) {
            obj.authorFlairTemplateId = message.authorFlairTemplateId;
        }
        if (message.isOriginalContent !== undefined) {
            obj.isOriginalContent = message.isOriginalContent;
        }
        if (message.authorFullname !== undefined) {
            obj.authorFullname = message.authorFullname;
        }
        if (message.secureMedia !== undefined) {
            obj.secureMedia = message.secureMedia;
        }
        if (message.isRedditMediaDomain !== undefined) {
            obj.isRedditMediaDomain = message.isRedditMediaDomain;
        }
        if (message.isMeta !== undefined) {
            obj.isMeta = message.isMeta;
        }
        if (message.category !== undefined) {
            obj.category = message.category;
        }
        if (message.secureMediaEmbed !== undefined) {
            obj.secureMediaEmbed = MediaEmbed.toJSON(message.secureMediaEmbed);
        }
        if (message.linkFlairText !== undefined) {
            obj.linkFlairText = message.linkFlairText;
        }
        if (message.canModPost !== undefined) {
            obj.canModPost = message.canModPost;
        }
        if (message.score !== undefined) {
            obj.score = message.score;
        }
        if (message.approvedBy !== undefined) {
            obj.approvedBy = message.approvedBy;
        }
        if (message.isCreatedFromAdsUi !== undefined) {
            obj.isCreatedFromAdsUi = message.isCreatedFromAdsUi;
        }
        if (message.authorPremium !== undefined) {
            obj.authorPremium = message.authorPremium;
        }
        if (message.thumbnail !== undefined) {
            obj.thumbnail = message.thumbnail;
        }
        if (message.edited !== undefined) {
            obj.edited = message.edited;
        }
        if (message.authorFlairCssClass !== undefined) {
            obj.authorFlairCssClass = message.authorFlairCssClass;
        }
        if (message.previousVisits?.length) {
            obj.previousVisits = message.previousVisits;
        }
        if (message.authorFlairRichtext?.length) {
            obj.authorFlairRichtext = message.authorFlairRichtext;
        }
        if (message.gildings !== undefined) {
            obj.gildings = Any.toJSON(message.gildings);
        }
        if (message.contentCategories !== undefined) {
            obj.contentCategories = message.contentCategories;
        }
        if (message.isSelf !== undefined) {
            obj.isSelf = message.isSelf;
        }
        if (message.subredditType !== undefined) {
            obj.subredditType = message.subredditType;
        }
        if (message.created !== undefined) {
            obj.created = message.created;
        }
        if (message.linkFlairType !== undefined) {
            obj.linkFlairType = message.linkFlairType;
        }
        if (message.wls !== undefined) {
            obj.wls = message.wls;
        }
        if (message.removedByCategory !== undefined) {
            obj.removedByCategory = message.removedByCategory;
        }
        if (message.bannedBy !== undefined) {
            obj.bannedBy = message.bannedBy;
        }
        if (message.authorFlairType !== undefined) {
            obj.authorFlairType = message.authorFlairType;
        }
        if (message.totalAwardsReceived !== undefined) {
            obj.totalAwardsReceived = message.totalAwardsReceived;
        }
        if (message.allowLiveComments !== undefined) {
            obj.allowLiveComments = message.allowLiveComments;
        }
        if (message.selftextHtml !== undefined) {
            obj.selftextHtml = message.selftextHtml;
        }
        if (message.likes !== undefined) {
            obj.likes = message.likes;
        }
        if (message.suggestedSort !== undefined) {
            obj.suggestedSort = message.suggestedSort;
        }
        if (message.bannedAtUtc !== undefined) {
            obj.bannedAtUtc = message.bannedAtUtc;
        }
        if (message.viewCount !== undefined) {
            obj.viewCount = message.viewCount;
        }
        if (message.archived !== undefined) {
            obj.archived = message.archived;
        }
        if (message.noFollow !== undefined) {
            obj.noFollow = message.noFollow;
        }
        if (message.spam !== undefined) {
            obj.spam = message.spam;
        }
        if (message.isCrosspostable !== undefined) {
            obj.isCrosspostable = message.isCrosspostable;
        }
        if (message.pinned !== undefined) {
            obj.pinned = message.pinned;
        }
        if (message.over18 !== undefined) {
            obj.over18 = message.over18;
        }
        if (message.allAwardings?.length) {
            obj.allAwardings = message.allAwardings.map((e) => Any.toJSON(e));
        }
        if (message.awarders?.length) {
            obj.awarders = message.awarders;
        }
        if (message.mediaOnly !== undefined) {
            obj.mediaOnly = message.mediaOnly;
        }
        if (message.canGild !== undefined) {
            obj.canGild = message.canGild;
        }
        if (message.removed !== undefined) {
            obj.removed = message.removed;
        }
        if (message.spoiler !== undefined) {
            obj.spoiler = message.spoiler;
        }
        if (message.locked !== undefined) {
            obj.locked = message.locked;
        }
        if (message.authorFlairText !== undefined) {
            obj.authorFlairText = message.authorFlairText;
        }
        if (message.treatmentTags?.length) {
            obj.treatmentTags = message.treatmentTags.map((e) => Any.toJSON(e));
        }
        if (message.rteMode !== undefined) {
            obj.rteMode = message.rteMode;
        }
        if (message.visited !== undefined) {
            obj.visited = message.visited;
        }
        if (message.removedBy !== undefined) {
            obj.removedBy = message.removedBy;
        }
        if (message.modNote !== undefined) {
            obj.modNote = message.modNote;
        }
        if (message.distinguished !== undefined) {
            obj.distinguished = message.distinguished;
        }
        if (message.subredditId !== undefined) {
            obj.subredditId = message.subredditId;
        }
        if (message.authorIsBlocked !== undefined) {
            obj.authorIsBlocked = message.authorIsBlocked;
        }
        if (message.modReasonBy !== undefined) {
            obj.modReasonBy = message.modReasonBy;
        }
        if (message.numReports !== undefined) {
            obj.numReports = message.numReports;
        }
        if (message.removalReason !== undefined) {
            obj.removalReason = message.removalReason;
        }
        if (message.linkFlairBackgroundColor !== undefined) {
            obj.linkFlairBackgroundColor = message.linkFlairBackgroundColor;
        }
        if (message.id !== undefined) {
            obj.id = message.id;
        }
        if (message.isRobotIndexable !== undefined) {
            obj.isRobotIndexable = message.isRobotIndexable;
        }
        if (message.numDuplicates !== undefined) {
            obj.numDuplicates = message.numDuplicates;
        }
        if (message.reportReasons?.length) {
            obj.reportReasons = message.reportReasons.map((e) => Any.toJSON(e));
        }
        if (message.author !== undefined) {
            obj.author = message.author;
        }
        if (message.discussionType !== undefined) {
            obj.discussionType = message.discussionType;
        }
        if (message.numComments !== undefined) {
            obj.numComments = message.numComments;
        }
        if (message.sendReplies !== undefined) {
            obj.sendReplies = message.sendReplies;
        }
        if (message.media !== undefined) {
            obj.media = message.media;
        }
        if (message.contestMode !== undefined) {
            obj.contestMode = message.contestMode;
        }
        if (message.authorPatreonFlair !== undefined) {
            obj.authorPatreonFlair = message.authorPatreonFlair;
        }
        if (message.approved !== undefined) {
            obj.approved = message.approved;
        }
        if (message.authorFlairTextColor !== undefined) {
            obj.authorFlairTextColor = message.authorFlairTextColor;
        }
        if (message.permalink !== undefined) {
            obj.permalink = message.permalink;
        }
        if (message.whitelistStatus !== undefined) {
            obj.whitelistStatus = message.whitelistStatus;
        }
        if (message.stickied !== undefined) {
            obj.stickied = message.stickied;
        }
        if (message.url !== undefined) {
            obj.url = message.url;
        }
        if (message.subredditSubscribers !== undefined) {
            obj.subredditSubscribers = message.subredditSubscribers;
        }
        if (message.createdUtc !== undefined) {
            obj.createdUtc = message.createdUtc;
        }
        if (message.numCrossposts !== undefined) {
            obj.numCrossposts = message.numCrossposts;
        }
        if (message.modReports?.length) {
            obj.modReports = message.modReports.map((e) => Any.toJSON(e));
        }
        if (message.isVideo !== undefined) {
            obj.isVideo = message.isVideo;
        }
        return obj;
    },
    create(base) {
        return StickyResponse_LinkData.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseStickyResponse_LinkData();
        message.authorFlairBackgroundColor = object.authorFlairBackgroundColor ?? undefined;
        message.approvedAtUtc = object.approvedAtUtc ?? undefined;
        message.subreddit = object.subreddit ?? undefined;
        message.selftext = object.selftext ?? undefined;
        message.userReports = object.userReports?.map((e) => e) || [];
        message.saved = object.saved ?? undefined;
        message.modReasonTitle = object.modReasonTitle ?? undefined;
        message.gilded = object.gilded ?? undefined;
        message.clicked = object.clicked ?? undefined;
        message.title = object.title ?? undefined;
        message.linkFlairRichtext = object.linkFlairRichtext?.map((e) => e) || [];
        message.subredditNamePrefixed = object.subredditNamePrefixed ?? undefined;
        message.hidden = object.hidden ?? undefined;
        message.pwls = object.pwls ?? undefined;
        message.linkFlairCssClass = object.linkFlairCssClass ?? undefined;
        message.downs = object.downs ?? undefined;
        message.thumbnailHeight = object.thumbnailHeight ?? undefined;
        message.topAwardedType = object.topAwardedType ?? undefined;
        message.parentWhitelistStatus = object.parentWhitelistStatus ?? undefined;
        message.hideScore = object.hideScore ?? undefined;
        message.name = object.name ?? undefined;
        message.quarantine = object.quarantine ?? undefined;
        message.linkFlairTextColor = object.linkFlairTextColor ?? undefined;
        message.upvoteRatio = object.upvoteRatio ?? undefined;
        message.ignoreReports = object.ignoreReports ?? undefined;
        message.ups = object.ups ?? undefined;
        message.domain = object.domain ?? undefined;
        message.mediaEmbed = (object.mediaEmbed !== undefined && object.mediaEmbed !== null)
            ? MediaEmbed.fromPartial(object.mediaEmbed)
            : undefined;
        message.thumbnailWidth = object.thumbnailWidth ?? undefined;
        message.authorFlairTemplateId = object.authorFlairTemplateId ?? undefined;
        message.isOriginalContent = object.isOriginalContent ?? undefined;
        message.authorFullname = object.authorFullname ?? undefined;
        message.secureMedia = object.secureMedia ?? undefined;
        message.isRedditMediaDomain = object.isRedditMediaDomain ?? undefined;
        message.isMeta = object.isMeta ?? undefined;
        message.category = object.category ?? undefined;
        message.secureMediaEmbed = (object.secureMediaEmbed !== undefined && object.secureMediaEmbed !== null)
            ? MediaEmbed.fromPartial(object.secureMediaEmbed)
            : undefined;
        message.linkFlairText = object.linkFlairText ?? undefined;
        message.canModPost = object.canModPost ?? undefined;
        message.score = object.score ?? undefined;
        message.approvedBy = object.approvedBy ?? undefined;
        message.isCreatedFromAdsUi = object.isCreatedFromAdsUi ?? undefined;
        message.authorPremium = object.authorPremium ?? undefined;
        message.thumbnail = object.thumbnail ?? undefined;
        message.edited = object.edited ?? undefined;
        message.authorFlairCssClass = object.authorFlairCssClass ?? undefined;
        message.previousVisits = object.previousVisits?.map((e) => e) || [];
        message.authorFlairRichtext = object.authorFlairRichtext?.map((e) => e) || [];
        message.gildings = (object.gildings !== undefined && object.gildings !== null)
            ? Any.fromPartial(object.gildings)
            : undefined;
        message.contentCategories = object.contentCategories ?? undefined;
        message.isSelf = object.isSelf ?? undefined;
        message.subredditType = object.subredditType ?? undefined;
        message.created = object.created ?? undefined;
        message.linkFlairType = object.linkFlairType ?? undefined;
        message.wls = object.wls ?? undefined;
        message.removedByCategory = object.removedByCategory ?? undefined;
        message.bannedBy = object.bannedBy ?? undefined;
        message.authorFlairType = object.authorFlairType ?? undefined;
        message.totalAwardsReceived = object.totalAwardsReceived ?? undefined;
        message.allowLiveComments = object.allowLiveComments ?? undefined;
        message.selftextHtml = object.selftextHtml ?? undefined;
        message.likes = object.likes ?? undefined;
        message.suggestedSort = object.suggestedSort ?? undefined;
        message.bannedAtUtc = object.bannedAtUtc ?? undefined;
        message.viewCount = object.viewCount ?? undefined;
        message.archived = object.archived ?? undefined;
        message.noFollow = object.noFollow ?? undefined;
        message.spam = object.spam ?? undefined;
        message.isCrosspostable = object.isCrosspostable ?? undefined;
        message.pinned = object.pinned ?? undefined;
        message.over18 = object.over18 ?? undefined;
        message.allAwardings = object.allAwardings?.map((e) => Any.fromPartial(e)) || [];
        message.awarders = object.awarders?.map((e) => e) || [];
        message.mediaOnly = object.mediaOnly ?? undefined;
        message.canGild = object.canGild ?? undefined;
        message.removed = object.removed ?? undefined;
        message.spoiler = object.spoiler ?? undefined;
        message.locked = object.locked ?? undefined;
        message.authorFlairText = object.authorFlairText ?? undefined;
        message.treatmentTags = object.treatmentTags?.map((e) => Any.fromPartial(e)) || [];
        message.rteMode = object.rteMode ?? undefined;
        message.visited = object.visited ?? undefined;
        message.removedBy = object.removedBy ?? undefined;
        message.modNote = object.modNote ?? undefined;
        message.distinguished = object.distinguished ?? undefined;
        message.subredditId = object.subredditId ?? undefined;
        message.authorIsBlocked = object.authorIsBlocked ?? undefined;
        message.modReasonBy = object.modReasonBy ?? undefined;
        message.numReports = object.numReports ?? undefined;
        message.removalReason = object.removalReason ?? undefined;
        message.linkFlairBackgroundColor = object.linkFlairBackgroundColor ?? undefined;
        message.id = object.id ?? undefined;
        message.isRobotIndexable = object.isRobotIndexable ?? undefined;
        message.numDuplicates = object.numDuplicates ?? undefined;
        message.reportReasons = object.reportReasons?.map((e) => Any.fromPartial(e)) || [];
        message.author = object.author ?? undefined;
        message.discussionType = object.discussionType ?? undefined;
        message.numComments = object.numComments ?? undefined;
        message.sendReplies = object.sendReplies ?? undefined;
        message.media = object.media ?? undefined;
        message.contestMode = object.contestMode ?? undefined;
        message.authorPatreonFlair = object.authorPatreonFlair ?? undefined;
        message.approved = object.approved ?? undefined;
        message.authorFlairTextColor = object.authorFlairTextColor ?? undefined;
        message.permalink = object.permalink ?? undefined;
        message.whitelistStatus = object.whitelistStatus ?? undefined;
        message.stickied = object.stickied ?? undefined;
        message.url = object.url ?? undefined;
        message.subredditSubscribers = object.subredditSubscribers ?? undefined;
        message.createdUtc = object.createdUtc ?? undefined;
        message.numCrossposts = object.numCrossposts ?? undefined;
        message.modReports = object.modReports?.map((e) => Any.fromPartial(e)) || [];
        message.isVideo = object.isVideo ?? undefined;
        return message;
    },
};
messageTypeRegistry.set(StickyResponse_LinkData.$type, StickyResponse_LinkData);
function createBaseStickyResponse_WrappedStickyListing() {
    return { kind: undefined, data: undefined };
}
export const StickyResponse_WrappedStickyListing = {
    $type: "devvit.plugin.redditapi.subreddits.StickyResponse.WrappedStickyListing",
    encode(message, writer = _m0.Writer.create()) {
        if (message.kind !== undefined) {
            StringValue.encode({ value: message.kind }, writer.uint32(10).fork()).ldelim();
        }
        if (message.data !== undefined) {
            StickyResponse_LinkData.encode(message.data, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseStickyResponse_WrappedStickyListing();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.kind = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.data = StickyResponse_LinkData.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            kind: isSet(object.kind) ? String(object.kind) : undefined,
            data: isSet(object.data) ? StickyResponse_LinkData.fromJSON(object.data) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.kind !== undefined) {
            obj.kind = message.kind;
        }
        if (message.data !== undefined) {
            obj.data = StickyResponse_LinkData.toJSON(message.data);
        }
        return obj;
    },
    create(base) {
        return StickyResponse_WrappedStickyListing.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseStickyResponse_WrappedStickyListing();
        message.kind = object.kind ?? undefined;
        message.data = (object.data !== undefined && object.data !== null)
            ? StickyResponse_LinkData.fromPartial(object.data)
            : undefined;
        return message;
    },
};
messageTypeRegistry.set(StickyResponse_WrappedStickyListing.$type, StickyResponse_WrappedStickyListing);
function createBaseStickyResponse_StickyResponseData() {
    return {
        after: undefined,
        before: undefined,
        dist: undefined,
        modhash: undefined,
        geoFilter: undefined,
        children: [],
    };
}
export const StickyResponse_StickyResponseData = {
    $type: "devvit.plugin.redditapi.subreddits.StickyResponse.StickyResponseData",
    encode(message, writer = _m0.Writer.create()) {
        if (message.after !== undefined) {
            StringValue.encode({ value: message.after }, writer.uint32(10).fork()).ldelim();
        }
        if (message.before !== undefined) {
            StringValue.encode({ value: message.before }, writer.uint32(18).fork()).ldelim();
        }
        if (message.dist !== undefined) {
            Int32Value.encode({ value: message.dist }, writer.uint32(26).fork()).ldelim();
        }
        if (message.modhash !== undefined) {
            StringValue.encode({ value: message.modhash }, writer.uint32(34).fork()).ldelim();
        }
        if (message.geoFilter !== undefined) {
            StringValue.encode({ value: message.geoFilter }, writer.uint32(42).fork()).ldelim();
        }
        for (const v of message.children) {
            StickyResponse_WrappedStickyListing.encode(v, writer.uint32(50).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseStickyResponse_StickyResponseData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.after = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.before = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.dist = Int32Value.decode(reader, reader.uint32()).value;
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.modhash = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.geoFilter = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.children.push(StickyResponse_WrappedStickyListing.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            after: isSet(object.after) ? String(object.after) : undefined,
            before: isSet(object.before) ? String(object.before) : undefined,
            dist: isSet(object.dist) ? Number(object.dist) : undefined,
            modhash: isSet(object.modhash) ? String(object.modhash) : undefined,
            geoFilter: isSet(object.geoFilter) ? String(object.geoFilter) : undefined,
            children: globalThis.Array.isArray(object?.children)
                ? object.children.map((e) => StickyResponse_WrappedStickyListing.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.after !== undefined) {
            obj.after = message.after;
        }
        if (message.before !== undefined) {
            obj.before = message.before;
        }
        if (message.dist !== undefined) {
            obj.dist = message.dist;
        }
        if (message.modhash !== undefined) {
            obj.modhash = message.modhash;
        }
        if (message.geoFilter !== undefined) {
            obj.geoFilter = message.geoFilter;
        }
        if (message.children?.length) {
            obj.children = message.children.map((e) => StickyResponse_WrappedStickyListing.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return StickyResponse_StickyResponseData.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseStickyResponse_StickyResponseData();
        message.after = object.after ?? undefined;
        message.before = object.before ?? undefined;
        message.dist = object.dist ?? undefined;
        message.modhash = object.modhash ?? undefined;
        message.geoFilter = object.geoFilter ?? undefined;
        message.children = object.children?.map((e) => StickyResponse_WrappedStickyListing.fromPartial(e)) || [];
        return message;
    },
};
messageTypeRegistry.set(StickyResponse_StickyResponseData.$type, StickyResponse_StickyResponseData);
function createBaseFullSubredditObject() {
    return {
        userFlairBackgroundColor: undefined,
        submitTextHtml: undefined,
        restrictPosting: undefined,
        userIsBanned: undefined,
        freeFormReports: undefined,
        wikiEnabled: undefined,
        userIsMuted: undefined,
        userCanFlairInSr: undefined,
        displayName: undefined,
        headerImg: undefined,
        title: undefined,
        allowGalleries: undefined,
        iconSize: [],
        primaryColor: undefined,
        activeUserCount: undefined,
        iconImg: undefined,
        displayNamePrefixed: undefined,
        accountsActive: undefined,
        publicTraffic: undefined,
        subscribers: undefined,
        userFlairRichtext: [],
        videostreamLinksCount: undefined,
        name: undefined,
        quarantine: undefined,
        hideAds: undefined,
        emojisEnabled: undefined,
        advertiserCategory: undefined,
        publicDescription: undefined,
        commentScoreHideMins: undefined,
        allowPredictions: undefined,
        userHasFavorited: undefined,
        userFlairTemplateId: undefined,
        communityIcon: undefined,
        bannerBackgroundImage: undefined,
        originalContentTagEnabled: undefined,
        communityReviewed: undefined,
        submitText: undefined,
        descriptionHtml: undefined,
        spoilersEnabled: undefined,
        commentContributionSettings: undefined,
        allowTalks: undefined,
        headerSize: [],
        userFlairPosition: undefined,
        allOriginalContent: undefined,
        hasMenuWidget: undefined,
        isEnrolledInNewModmail: undefined,
        keyColor: undefined,
        canAssignUserFlair: undefined,
        created: undefined,
        wls: undefined,
        showMediaPreview: undefined,
        submissionType: undefined,
        userIsSubscriber: undefined,
        allowedMediaInComments: [],
        allowVideogifs: undefined,
        shouldArchivePosts: undefined,
        userFlairType: undefined,
        allowPolls: undefined,
        collapseDeletedComments: undefined,
        emojisCustomSize: [],
        publicDescriptionHtml: undefined,
        allowVideos: undefined,
        isCrosspostableSubreddit: undefined,
        notificationLevel: undefined,
        shouldShowMediaInCommentsSetting: undefined,
        canAssignLinkFlair: undefined,
        accountsActiveIsFuzzed: undefined,
        allowPredictionContributors: undefined,
        submitTextLabel: undefined,
        linkFlairPosition: undefined,
        userSrFlairEnabled: undefined,
        userFlairEnabledInSr: undefined,
        allowChatPostCreation: undefined,
        allowDiscovery: undefined,
        acceptFollowers: undefined,
        userSrThemeEnabled: undefined,
        linkFlairEnabled: undefined,
        disableContributorRequests: undefined,
        subredditType: undefined,
        suggestedCommentSort: undefined,
        bannerImg: undefined,
        userFlairText: undefined,
        contentCategory: undefined,
        bannerBackgroundColor: undefined,
        showMedia: undefined,
        id: undefined,
        userIsModerator: undefined,
        over18: undefined,
        headerTitle: undefined,
        description: undefined,
        isChatPostFeatureEnabled: undefined,
        submitLinkLabel: undefined,
        userFlairTextColor: undefined,
        restrictCommenting: undefined,
        userFlairCssClass: undefined,
        allowImages: undefined,
        lang: undefined,
        whitelistStatus: undefined,
        url: undefined,
        createdUtc: undefined,
        bannerSize: [],
        mobileBannerImage: undefined,
        userIsContributor: undefined,
        allowPredictionsTournament: undefined,
    };
}
export const FullSubredditObject = {
    $type: "devvit.plugin.redditapi.subreddits.FullSubredditObject",
    encode(message, writer = _m0.Writer.create()) {
        if (message.userFlairBackgroundColor !== undefined) {
            StringValue.encode({ value: message.userFlairBackgroundColor }, writer.uint32(10).fork()).ldelim();
        }
        if (message.submitTextHtml !== undefined) {
            StringValue.encode({ value: message.submitTextHtml }, writer.uint32(18).fork()).ldelim();
        }
        if (message.restrictPosting !== undefined) {
            BoolValue.encode({ value: message.restrictPosting }, writer.uint32(26).fork()).ldelim();
        }
        if (message.userIsBanned !== undefined) {
            BoolValue.encode({ value: message.userIsBanned }, writer.uint32(34).fork()).ldelim();
        }
        if (message.freeFormReports !== undefined) {
            BoolValue.encode({ value: message.freeFormReports }, writer.uint32(42).fork()).ldelim();
        }
        if (message.wikiEnabled !== undefined) {
            BoolValue.encode({ value: message.wikiEnabled }, writer.uint32(50).fork()).ldelim();
        }
        if (message.userIsMuted !== undefined) {
            BoolValue.encode({ value: message.userIsMuted }, writer.uint32(58).fork()).ldelim();
        }
        if (message.userCanFlairInSr !== undefined) {
            BoolValue.encode({ value: message.userCanFlairInSr }, writer.uint32(66).fork()).ldelim();
        }
        if (message.displayName !== undefined) {
            StringValue.encode({ value: message.displayName }, writer.uint32(74).fork()).ldelim();
        }
        if (message.headerImg !== undefined) {
            StringValue.encode({ value: message.headerImg }, writer.uint32(82).fork()).ldelim();
        }
        if (message.title !== undefined) {
            StringValue.encode({ value: message.title }, writer.uint32(90).fork()).ldelim();
        }
        if (message.allowGalleries !== undefined) {
            BoolValue.encode({ value: message.allowGalleries }, writer.uint32(98).fork()).ldelim();
        }
        for (const v of message.iconSize) {
            Int64Value.encode({ value: v }, writer.uint32(106).fork()).ldelim();
        }
        if (message.primaryColor !== undefined) {
            StringValue.encode({ value: message.primaryColor }, writer.uint32(114).fork()).ldelim();
        }
        if (message.activeUserCount !== undefined) {
            Int64Value.encode({ value: message.activeUserCount }, writer.uint32(122).fork()).ldelim();
        }
        if (message.iconImg !== undefined) {
            StringValue.encode({ value: message.iconImg }, writer.uint32(130).fork()).ldelim();
        }
        if (message.displayNamePrefixed !== undefined) {
            StringValue.encode({ value: message.displayNamePrefixed }, writer.uint32(138).fork()).ldelim();
        }
        if (message.accountsActive !== undefined) {
            Int64Value.encode({ value: message.accountsActive }, writer.uint32(146).fork()).ldelim();
        }
        if (message.publicTraffic !== undefined) {
            BoolValue.encode({ value: message.publicTraffic }, writer.uint32(154).fork()).ldelim();
        }
        if (message.subscribers !== undefined) {
            Int64Value.encode({ value: message.subscribers }, writer.uint32(162).fork()).ldelim();
        }
        for (const v of message.userFlairRichtext) {
            StringValue.encode({ value: v }, writer.uint32(170).fork()).ldelim();
        }
        if (message.videostreamLinksCount !== undefined) {
            Int64Value.encode({ value: message.videostreamLinksCount }, writer.uint32(178).fork()).ldelim();
        }
        if (message.name !== undefined) {
            StringValue.encode({ value: message.name }, writer.uint32(186).fork()).ldelim();
        }
        if (message.quarantine !== undefined) {
            BoolValue.encode({ value: message.quarantine }, writer.uint32(194).fork()).ldelim();
        }
        if (message.hideAds !== undefined) {
            BoolValue.encode({ value: message.hideAds }, writer.uint32(202).fork()).ldelim();
        }
        if (message.emojisEnabled !== undefined) {
            BoolValue.encode({ value: message.emojisEnabled }, writer.uint32(218).fork()).ldelim();
        }
        if (message.advertiserCategory !== undefined) {
            StringValue.encode({ value: message.advertiserCategory }, writer.uint32(226).fork()).ldelim();
        }
        if (message.publicDescription !== undefined) {
            StringValue.encode({ value: message.publicDescription }, writer.uint32(234).fork()).ldelim();
        }
        if (message.commentScoreHideMins !== undefined) {
            Int32Value.encode({ value: message.commentScoreHideMins }, writer.uint32(242).fork()).ldelim();
        }
        if (message.allowPredictions !== undefined) {
            BoolValue.encode({ value: message.allowPredictions }, writer.uint32(250).fork()).ldelim();
        }
        if (message.userHasFavorited !== undefined) {
            BoolValue.encode({ value: message.userHasFavorited }, writer.uint32(258).fork()).ldelim();
        }
        if (message.userFlairTemplateId !== undefined) {
            StringValue.encode({ value: message.userFlairTemplateId }, writer.uint32(266).fork()).ldelim();
        }
        if (message.communityIcon !== undefined) {
            StringValue.encode({ value: message.communityIcon }, writer.uint32(274).fork()).ldelim();
        }
        if (message.bannerBackgroundImage !== undefined) {
            StringValue.encode({ value: message.bannerBackgroundImage }, writer.uint32(282).fork()).ldelim();
        }
        if (message.originalContentTagEnabled !== undefined) {
            BoolValue.encode({ value: message.originalContentTagEnabled }, writer.uint32(290).fork()).ldelim();
        }
        if (message.communityReviewed !== undefined) {
            BoolValue.encode({ value: message.communityReviewed }, writer.uint32(298).fork()).ldelim();
        }
        if (message.submitText !== undefined) {
            StringValue.encode({ value: message.submitText }, writer.uint32(314).fork()).ldelim();
        }
        if (message.descriptionHtml !== undefined) {
            StringValue.encode({ value: message.descriptionHtml }, writer.uint32(322).fork()).ldelim();
        }
        if (message.spoilersEnabled !== undefined) {
            BoolValue.encode({ value: message.spoilersEnabled }, writer.uint32(330).fork()).ldelim();
        }
        if (message.commentContributionSettings !== undefined) {
            CommentContributionSettings.encode(message.commentContributionSettings, writer.uint32(338).fork()).ldelim();
        }
        if (message.allowTalks !== undefined) {
            BoolValue.encode({ value: message.allowTalks }, writer.uint32(346).fork()).ldelim();
        }
        for (const v of message.headerSize) {
            Int64Value.encode({ value: v }, writer.uint32(354).fork()).ldelim();
        }
        if (message.userFlairPosition !== undefined) {
            StringValue.encode({ value: message.userFlairPosition }, writer.uint32(362).fork()).ldelim();
        }
        if (message.allOriginalContent !== undefined) {
            BoolValue.encode({ value: message.allOriginalContent }, writer.uint32(370).fork()).ldelim();
        }
        if (message.hasMenuWidget !== undefined) {
            BoolValue.encode({ value: message.hasMenuWidget }, writer.uint32(378).fork()).ldelim();
        }
        if (message.isEnrolledInNewModmail !== undefined) {
            BoolValue.encode({ value: message.isEnrolledInNewModmail }, writer.uint32(386).fork()).ldelim();
        }
        if (message.keyColor !== undefined) {
            StringValue.encode({ value: message.keyColor }, writer.uint32(394).fork()).ldelim();
        }
        if (message.canAssignUserFlair !== undefined) {
            BoolValue.encode({ value: message.canAssignUserFlair }, writer.uint32(402).fork()).ldelim();
        }
        if (message.created !== undefined) {
            Int64Value.encode({ value: message.created }, writer.uint32(410).fork()).ldelim();
        }
        if (message.wls !== undefined) {
            Int32Value.encode({ value: message.wls }, writer.uint32(418).fork()).ldelim();
        }
        if (message.showMediaPreview !== undefined) {
            BoolValue.encode({ value: message.showMediaPreview }, writer.uint32(426).fork()).ldelim();
        }
        if (message.submissionType !== undefined) {
            StringValue.encode({ value: message.submissionType }, writer.uint32(434).fork()).ldelim();
        }
        if (message.userIsSubscriber !== undefined) {
            BoolValue.encode({ value: message.userIsSubscriber }, writer.uint32(442).fork()).ldelim();
        }
        for (const v of message.allowedMediaInComments) {
            StringValue.encode({ value: v }, writer.uint32(450).fork()).ldelim();
        }
        if (message.allowVideogifs !== undefined) {
            BoolValue.encode({ value: message.allowVideogifs }, writer.uint32(458).fork()).ldelim();
        }
        if (message.shouldArchivePosts !== undefined) {
            BoolValue.encode({ value: message.shouldArchivePosts }, writer.uint32(466).fork()).ldelim();
        }
        if (message.userFlairType !== undefined) {
            StringValue.encode({ value: message.userFlairType }, writer.uint32(474).fork()).ldelim();
        }
        if (message.allowPolls !== undefined) {
            BoolValue.encode({ value: message.allowPolls }, writer.uint32(482).fork()).ldelim();
        }
        if (message.collapseDeletedComments !== undefined) {
            BoolValue.encode({ value: message.collapseDeletedComments }, writer.uint32(490).fork()).ldelim();
        }
        for (const v of message.emojisCustomSize) {
            Int64Value.encode({ value: v }, writer.uint32(498).fork()).ldelim();
        }
        if (message.publicDescriptionHtml !== undefined) {
            StringValue.encode({ value: message.publicDescriptionHtml }, writer.uint32(506).fork()).ldelim();
        }
        if (message.allowVideos !== undefined) {
            BoolValue.encode({ value: message.allowVideos }, writer.uint32(514).fork()).ldelim();
        }
        if (message.isCrosspostableSubreddit !== undefined) {
            BoolValue.encode({ value: message.isCrosspostableSubreddit }, writer.uint32(522).fork()).ldelim();
        }
        if (message.notificationLevel !== undefined) {
            StringValue.encode({ value: message.notificationLevel }, writer.uint32(530).fork()).ldelim();
        }
        if (message.shouldShowMediaInCommentsSetting !== undefined) {
            BoolValue.encode({ value: message.shouldShowMediaInCommentsSetting }, writer.uint32(538).fork()).ldelim();
        }
        if (message.canAssignLinkFlair !== undefined) {
            BoolValue.encode({ value: message.canAssignLinkFlair }, writer.uint32(546).fork()).ldelim();
        }
        if (message.accountsActiveIsFuzzed !== undefined) {
            BoolValue.encode({ value: message.accountsActiveIsFuzzed }, writer.uint32(554).fork()).ldelim();
        }
        if (message.allowPredictionContributors !== undefined) {
            BoolValue.encode({ value: message.allowPredictionContributors }, writer.uint32(562).fork()).ldelim();
        }
        if (message.submitTextLabel !== undefined) {
            StringValue.encode({ value: message.submitTextLabel }, writer.uint32(570).fork()).ldelim();
        }
        if (message.linkFlairPosition !== undefined) {
            StringValue.encode({ value: message.linkFlairPosition }, writer.uint32(578).fork()).ldelim();
        }
        if (message.userSrFlairEnabled !== undefined) {
            BoolValue.encode({ value: message.userSrFlairEnabled }, writer.uint32(586).fork()).ldelim();
        }
        if (message.userFlairEnabledInSr !== undefined) {
            BoolValue.encode({ value: message.userFlairEnabledInSr }, writer.uint32(594).fork()).ldelim();
        }
        if (message.allowChatPostCreation !== undefined) {
            BoolValue.encode({ value: message.allowChatPostCreation }, writer.uint32(602).fork()).ldelim();
        }
        if (message.allowDiscovery !== undefined) {
            BoolValue.encode({ value: message.allowDiscovery }, writer.uint32(610).fork()).ldelim();
        }
        if (message.acceptFollowers !== undefined) {
            BoolValue.encode({ value: message.acceptFollowers }, writer.uint32(618).fork()).ldelim();
        }
        if (message.userSrThemeEnabled !== undefined) {
            BoolValue.encode({ value: message.userSrThemeEnabled }, writer.uint32(626).fork()).ldelim();
        }
        if (message.linkFlairEnabled !== undefined) {
            BoolValue.encode({ value: message.linkFlairEnabled }, writer.uint32(634).fork()).ldelim();
        }
        if (message.disableContributorRequests !== undefined) {
            BoolValue.encode({ value: message.disableContributorRequests }, writer.uint32(642).fork()).ldelim();
        }
        if (message.subredditType !== undefined) {
            StringValue.encode({ value: message.subredditType }, writer.uint32(650).fork()).ldelim();
        }
        if (message.suggestedCommentSort !== undefined) {
            StringValue.encode({ value: message.suggestedCommentSort }, writer.uint32(658).fork()).ldelim();
        }
        if (message.bannerImg !== undefined) {
            StringValue.encode({ value: message.bannerImg }, writer.uint32(666).fork()).ldelim();
        }
        if (message.userFlairText !== undefined) {
            StringValue.encode({ value: message.userFlairText }, writer.uint32(674).fork()).ldelim();
        }
        if (message.contentCategory !== undefined) {
            StringValue.encode({ value: message.contentCategory }, writer.uint32(682).fork()).ldelim();
        }
        if (message.bannerBackgroundColor !== undefined) {
            StringValue.encode({ value: message.bannerBackgroundColor }, writer.uint32(690).fork()).ldelim();
        }
        if (message.showMedia !== undefined) {
            BoolValue.encode({ value: message.showMedia }, writer.uint32(698).fork()).ldelim();
        }
        if (message.id !== undefined) {
            StringValue.encode({ value: message.id }, writer.uint32(706).fork()).ldelim();
        }
        if (message.userIsModerator !== undefined) {
            BoolValue.encode({ value: message.userIsModerator }, writer.uint32(714).fork()).ldelim();
        }
        if (message.over18 !== undefined) {
            BoolValue.encode({ value: message.over18 }, writer.uint32(722).fork()).ldelim();
        }
        if (message.headerTitle !== undefined) {
            StringValue.encode({ value: message.headerTitle }, writer.uint32(730).fork()).ldelim();
        }
        if (message.description !== undefined) {
            StringValue.encode({ value: message.description }, writer.uint32(738).fork()).ldelim();
        }
        if (message.isChatPostFeatureEnabled !== undefined) {
            BoolValue.encode({ value: message.isChatPostFeatureEnabled }, writer.uint32(746).fork()).ldelim();
        }
        if (message.submitLinkLabel !== undefined) {
            StringValue.encode({ value: message.submitLinkLabel }, writer.uint32(754).fork()).ldelim();
        }
        if (message.userFlairTextColor !== undefined) {
            StringValue.encode({ value: message.userFlairTextColor }, writer.uint32(762).fork()).ldelim();
        }
        if (message.restrictCommenting !== undefined) {
            BoolValue.encode({ value: message.restrictCommenting }, writer.uint32(770).fork()).ldelim();
        }
        if (message.userFlairCssClass !== undefined) {
            StringValue.encode({ value: message.userFlairCssClass }, writer.uint32(778).fork()).ldelim();
        }
        if (message.allowImages !== undefined) {
            BoolValue.encode({ value: message.allowImages }, writer.uint32(786).fork()).ldelim();
        }
        if (message.lang !== undefined) {
            StringValue.encode({ value: message.lang }, writer.uint32(794).fork()).ldelim();
        }
        if (message.whitelistStatus !== undefined) {
            StringValue.encode({ value: message.whitelistStatus }, writer.uint32(802).fork()).ldelim();
        }
        if (message.url !== undefined) {
            StringValue.encode({ value: message.url }, writer.uint32(810).fork()).ldelim();
        }
        if (message.createdUtc !== undefined) {
            Int64Value.encode({ value: message.createdUtc }, writer.uint32(818).fork()).ldelim();
        }
        for (const v of message.bannerSize) {
            Int32Value.encode({ value: v }, writer.uint32(826).fork()).ldelim();
        }
        if (message.mobileBannerImage !== undefined) {
            StringValue.encode({ value: message.mobileBannerImage }, writer.uint32(834).fork()).ldelim();
        }
        if (message.userIsContributor !== undefined) {
            BoolValue.encode({ value: message.userIsContributor }, writer.uint32(842).fork()).ldelim();
        }
        if (message.allowPredictionsTournament !== undefined) {
            BoolValue.encode({ value: message.allowPredictionsTournament }, writer.uint32(850).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFullSubredditObject();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.userFlairBackgroundColor = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.submitTextHtml = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.restrictPosting = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.userIsBanned = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.freeFormReports = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.wikiEnabled = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.userIsMuted = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.userCanFlairInSr = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 9:
                    if (tag !== 74) {
                        break;
                    }
                    message.displayName = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.headerImg = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 11:
                    if (tag !== 90) {
                        break;
                    }
                    message.title = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 12:
                    if (tag !== 98) {
                        break;
                    }
                    message.allowGalleries = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 13:
                    if (tag !== 106) {
                        break;
                    }
                    message.iconSize.push(Int64Value.decode(reader, reader.uint32()).value);
                    continue;
                case 14:
                    if (tag !== 114) {
                        break;
                    }
                    message.primaryColor = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 15:
                    if (tag !== 122) {
                        break;
                    }
                    message.activeUserCount = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 16:
                    if (tag !== 130) {
                        break;
                    }
                    message.iconImg = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 17:
                    if (tag !== 138) {
                        break;
                    }
                    message.displayNamePrefixed = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 18:
                    if (tag !== 146) {
                        break;
                    }
                    message.accountsActive = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 19:
                    if (tag !== 154) {
                        break;
                    }
                    message.publicTraffic = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 20:
                    if (tag !== 162) {
                        break;
                    }
                    message.subscribers = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 21:
                    if (tag !== 170) {
                        break;
                    }
                    message.userFlairRichtext.push(StringValue.decode(reader, reader.uint32()).value);
                    continue;
                case 22:
                    if (tag !== 178) {
                        break;
                    }
                    message.videostreamLinksCount = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 23:
                    if (tag !== 186) {
                        break;
                    }
                    message.name = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 24:
                    if (tag !== 194) {
                        break;
                    }
                    message.quarantine = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 25:
                    if (tag !== 202) {
                        break;
                    }
                    message.hideAds = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 27:
                    if (tag !== 218) {
                        break;
                    }
                    message.emojisEnabled = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 28:
                    if (tag !== 226) {
                        break;
                    }
                    message.advertiserCategory = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 29:
                    if (tag !== 234) {
                        break;
                    }
                    message.publicDescription = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 30:
                    if (tag !== 242) {
                        break;
                    }
                    message.commentScoreHideMins = Int32Value.decode(reader, reader.uint32()).value;
                    continue;
                case 31:
                    if (tag !== 250) {
                        break;
                    }
                    message.allowPredictions = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 32:
                    if (tag !== 258) {
                        break;
                    }
                    message.userHasFavorited = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 33:
                    if (tag !== 266) {
                        break;
                    }
                    message.userFlairTemplateId = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 34:
                    if (tag !== 274) {
                        break;
                    }
                    message.communityIcon = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 35:
                    if (tag !== 282) {
                        break;
                    }
                    message.bannerBackgroundImage = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 36:
                    if (tag !== 290) {
                        break;
                    }
                    message.originalContentTagEnabled = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 37:
                    if (tag !== 298) {
                        break;
                    }
                    message.communityReviewed = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 39:
                    if (tag !== 314) {
                        break;
                    }
                    message.submitText = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 40:
                    if (tag !== 322) {
                        break;
                    }
                    message.descriptionHtml = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 41:
                    if (tag !== 330) {
                        break;
                    }
                    message.spoilersEnabled = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 42:
                    if (tag !== 338) {
                        break;
                    }
                    message.commentContributionSettings = CommentContributionSettings.decode(reader, reader.uint32());
                    continue;
                case 43:
                    if (tag !== 346) {
                        break;
                    }
                    message.allowTalks = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 44:
                    if (tag !== 354) {
                        break;
                    }
                    message.headerSize.push(Int64Value.decode(reader, reader.uint32()).value);
                    continue;
                case 45:
                    if (tag !== 362) {
                        break;
                    }
                    message.userFlairPosition = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 46:
                    if (tag !== 370) {
                        break;
                    }
                    message.allOriginalContent = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 47:
                    if (tag !== 378) {
                        break;
                    }
                    message.hasMenuWidget = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 48:
                    if (tag !== 386) {
                        break;
                    }
                    message.isEnrolledInNewModmail = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 49:
                    if (tag !== 394) {
                        break;
                    }
                    message.keyColor = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 50:
                    if (tag !== 402) {
                        break;
                    }
                    message.canAssignUserFlair = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 51:
                    if (tag !== 410) {
                        break;
                    }
                    message.created = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 52:
                    if (tag !== 418) {
                        break;
                    }
                    message.wls = Int32Value.decode(reader, reader.uint32()).value;
                    continue;
                case 53:
                    if (tag !== 426) {
                        break;
                    }
                    message.showMediaPreview = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 54:
                    if (tag !== 434) {
                        break;
                    }
                    message.submissionType = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 55:
                    if (tag !== 442) {
                        break;
                    }
                    message.userIsSubscriber = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 56:
                    if (tag !== 450) {
                        break;
                    }
                    message.allowedMediaInComments.push(StringValue.decode(reader, reader.uint32()).value);
                    continue;
                case 57:
                    if (tag !== 458) {
                        break;
                    }
                    message.allowVideogifs = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 58:
                    if (tag !== 466) {
                        break;
                    }
                    message.shouldArchivePosts = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 59:
                    if (tag !== 474) {
                        break;
                    }
                    message.userFlairType = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 60:
                    if (tag !== 482) {
                        break;
                    }
                    message.allowPolls = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 61:
                    if (tag !== 490) {
                        break;
                    }
                    message.collapseDeletedComments = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 62:
                    if (tag !== 498) {
                        break;
                    }
                    message.emojisCustomSize.push(Int64Value.decode(reader, reader.uint32()).value);
                    continue;
                case 63:
                    if (tag !== 506) {
                        break;
                    }
                    message.publicDescriptionHtml = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 64:
                    if (tag !== 514) {
                        break;
                    }
                    message.allowVideos = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 65:
                    if (tag !== 522) {
                        break;
                    }
                    message.isCrosspostableSubreddit = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 66:
                    if (tag !== 530) {
                        break;
                    }
                    message.notificationLevel = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 67:
                    if (tag !== 538) {
                        break;
                    }
                    message.shouldShowMediaInCommentsSetting = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 68:
                    if (tag !== 546) {
                        break;
                    }
                    message.canAssignLinkFlair = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 69:
                    if (tag !== 554) {
                        break;
                    }
                    message.accountsActiveIsFuzzed = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 70:
                    if (tag !== 562) {
                        break;
                    }
                    message.allowPredictionContributors = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 71:
                    if (tag !== 570) {
                        break;
                    }
                    message.submitTextLabel = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 72:
                    if (tag !== 578) {
                        break;
                    }
                    message.linkFlairPosition = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 73:
                    if (tag !== 586) {
                        break;
                    }
                    message.userSrFlairEnabled = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 74:
                    if (tag !== 594) {
                        break;
                    }
                    message.userFlairEnabledInSr = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 75:
                    if (tag !== 602) {
                        break;
                    }
                    message.allowChatPostCreation = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 76:
                    if (tag !== 610) {
                        break;
                    }
                    message.allowDiscovery = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 77:
                    if (tag !== 618) {
                        break;
                    }
                    message.acceptFollowers = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 78:
                    if (tag !== 626) {
                        break;
                    }
                    message.userSrThemeEnabled = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 79:
                    if (tag !== 634) {
                        break;
                    }
                    message.linkFlairEnabled = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 80:
                    if (tag !== 642) {
                        break;
                    }
                    message.disableContributorRequests = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 81:
                    if (tag !== 650) {
                        break;
                    }
                    message.subredditType = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 82:
                    if (tag !== 658) {
                        break;
                    }
                    message.suggestedCommentSort = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 83:
                    if (tag !== 666) {
                        break;
                    }
                    message.bannerImg = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 84:
                    if (tag !== 674) {
                        break;
                    }
                    message.userFlairText = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 85:
                    if (tag !== 682) {
                        break;
                    }
                    message.contentCategory = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 86:
                    if (tag !== 690) {
                        break;
                    }
                    message.bannerBackgroundColor = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 87:
                    if (tag !== 698) {
                        break;
                    }
                    message.showMedia = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 88:
                    if (tag !== 706) {
                        break;
                    }
                    message.id = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 89:
                    if (tag !== 714) {
                        break;
                    }
                    message.userIsModerator = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 90:
                    if (tag !== 722) {
                        break;
                    }
                    message.over18 = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 91:
                    if (tag !== 730) {
                        break;
                    }
                    message.headerTitle = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 92:
                    if (tag !== 738) {
                        break;
                    }
                    message.description = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 93:
                    if (tag !== 746) {
                        break;
                    }
                    message.isChatPostFeatureEnabled = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 94:
                    if (tag !== 754) {
                        break;
                    }
                    message.submitLinkLabel = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 95:
                    if (tag !== 762) {
                        break;
                    }
                    message.userFlairTextColor = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 96:
                    if (tag !== 770) {
                        break;
                    }
                    message.restrictCommenting = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 97:
                    if (tag !== 778) {
                        break;
                    }
                    message.userFlairCssClass = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 98:
                    if (tag !== 786) {
                        break;
                    }
                    message.allowImages = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 99:
                    if (tag !== 794) {
                        break;
                    }
                    message.lang = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 100:
                    if (tag !== 802) {
                        break;
                    }
                    message.whitelistStatus = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 101:
                    if (tag !== 810) {
                        break;
                    }
                    message.url = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 102:
                    if (tag !== 818) {
                        break;
                    }
                    message.createdUtc = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 103:
                    if (tag !== 826) {
                        break;
                    }
                    message.bannerSize.push(Int32Value.decode(reader, reader.uint32()).value);
                    continue;
                case 104:
                    if (tag !== 834) {
                        break;
                    }
                    message.mobileBannerImage = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 105:
                    if (tag !== 842) {
                        break;
                    }
                    message.userIsContributor = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 106:
                    if (tag !== 850) {
                        break;
                    }
                    message.allowPredictionsTournament = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            userFlairBackgroundColor: isSet(object.userFlairBackgroundColor)
                ? String(object.userFlairBackgroundColor)
                : undefined,
            submitTextHtml: isSet(object.submitTextHtml) ? String(object.submitTextHtml) : undefined,
            restrictPosting: isSet(object.restrictPosting) ? Boolean(object.restrictPosting) : undefined,
            userIsBanned: isSet(object.userIsBanned) ? Boolean(object.userIsBanned) : undefined,
            freeFormReports: isSet(object.freeFormReports) ? Boolean(object.freeFormReports) : undefined,
            wikiEnabled: isSet(object.wikiEnabled) ? Boolean(object.wikiEnabled) : undefined,
            userIsMuted: isSet(object.userIsMuted) ? Boolean(object.userIsMuted) : undefined,
            userCanFlairInSr: isSet(object.userCanFlairInSr) ? Boolean(object.userCanFlairInSr) : undefined,
            displayName: isSet(object.displayName) ? String(object.displayName) : undefined,
            headerImg: isSet(object.headerImg) ? String(object.headerImg) : undefined,
            title: isSet(object.title) ? String(object.title) : undefined,
            allowGalleries: isSet(object.allowGalleries) ? Boolean(object.allowGalleries) : undefined,
            iconSize: globalThis.Array.isArray(object?.iconSize) ? object.iconSize.map((e) => Number(e)) : [],
            primaryColor: isSet(object.primaryColor) ? String(object.primaryColor) : undefined,
            activeUserCount: isSet(object.activeUserCount) ? Number(object.activeUserCount) : undefined,
            iconImg: isSet(object.iconImg) ? String(object.iconImg) : undefined,
            displayNamePrefixed: isSet(object.displayNamePrefixed) ? String(object.displayNamePrefixed) : undefined,
            accountsActive: isSet(object.accountsActive) ? Number(object.accountsActive) : undefined,
            publicTraffic: isSet(object.publicTraffic) ? Boolean(object.publicTraffic) : undefined,
            subscribers: isSet(object.subscribers) ? Number(object.subscribers) : undefined,
            userFlairRichtext: globalThis.Array.isArray(object?.userFlairRichtext)
                ? object.userFlairRichtext.map((e) => String(e))
                : [],
            videostreamLinksCount: isSet(object.videostreamLinksCount) ? Number(object.videostreamLinksCount) : undefined,
            name: isSet(object.name) ? String(object.name) : undefined,
            quarantine: isSet(object.quarantine) ? Boolean(object.quarantine) : undefined,
            hideAds: isSet(object.hideAds) ? Boolean(object.hideAds) : undefined,
            emojisEnabled: isSet(object.emojisEnabled) ? Boolean(object.emojisEnabled) : undefined,
            advertiserCategory: isSet(object.advertiserCategory) ? String(object.advertiserCategory) : undefined,
            publicDescription: isSet(object.publicDescription) ? String(object.publicDescription) : undefined,
            commentScoreHideMins: isSet(object.commentScoreHideMins) ? Number(object.commentScoreHideMins) : undefined,
            allowPredictions: isSet(object.allowPredictions) ? Boolean(object.allowPredictions) : undefined,
            userHasFavorited: isSet(object.userHasFavorited) ? Boolean(object.userHasFavorited) : undefined,
            userFlairTemplateId: isSet(object.userFlairTemplateId) ? String(object.userFlairTemplateId) : undefined,
            communityIcon: isSet(object.communityIcon) ? String(object.communityIcon) : undefined,
            bannerBackgroundImage: isSet(object.bannerBackgroundImage) ? String(object.bannerBackgroundImage) : undefined,
            originalContentTagEnabled: isSet(object.originalContentTagEnabled)
                ? Boolean(object.originalContentTagEnabled)
                : undefined,
            communityReviewed: isSet(object.communityReviewed) ? Boolean(object.communityReviewed) : undefined,
            submitText: isSet(object.submitText) ? String(object.submitText) : undefined,
            descriptionHtml: isSet(object.descriptionHtml) ? String(object.descriptionHtml) : undefined,
            spoilersEnabled: isSet(object.spoilersEnabled) ? Boolean(object.spoilersEnabled) : undefined,
            commentContributionSettings: isSet(object.commentContributionSettings)
                ? CommentContributionSettings.fromJSON(object.commentContributionSettings)
                : undefined,
            allowTalks: isSet(object.allowTalks) ? Boolean(object.allowTalks) : undefined,
            headerSize: globalThis.Array.isArray(object?.headerSize) ? object.headerSize.map((e) => Number(e)) : [],
            userFlairPosition: isSet(object.userFlairPosition) ? String(object.userFlairPosition) : undefined,
            allOriginalContent: isSet(object.allOriginalContent) ? Boolean(object.allOriginalContent) : undefined,
            hasMenuWidget: isSet(object.hasMenuWidget) ? Boolean(object.hasMenuWidget) : undefined,
            isEnrolledInNewModmail: isSet(object.isEnrolledInNewModmail) ? Boolean(object.isEnrolledInNewModmail) : undefined,
            keyColor: isSet(object.keyColor) ? String(object.keyColor) : undefined,
            canAssignUserFlair: isSet(object.canAssignUserFlair) ? Boolean(object.canAssignUserFlair) : undefined,
            created: isSet(object.created) ? Number(object.created) : undefined,
            wls: isSet(object.wls) ? Number(object.wls) : undefined,
            showMediaPreview: isSet(object.showMediaPreview) ? Boolean(object.showMediaPreview) : undefined,
            submissionType: isSet(object.submissionType) ? String(object.submissionType) : undefined,
            userIsSubscriber: isSet(object.userIsSubscriber) ? Boolean(object.userIsSubscriber) : undefined,
            allowedMediaInComments: globalThis.Array.isArray(object?.allowedMediaInComments)
                ? object.allowedMediaInComments.map((e) => String(e))
                : [],
            allowVideogifs: isSet(object.allowVideogifs) ? Boolean(object.allowVideogifs) : undefined,
            shouldArchivePosts: isSet(object.shouldArchivePosts) ? Boolean(object.shouldArchivePosts) : undefined,
            userFlairType: isSet(object.userFlairType) ? String(object.userFlairType) : undefined,
            allowPolls: isSet(object.allowPolls) ? Boolean(object.allowPolls) : undefined,
            collapseDeletedComments: isSet(object.collapseDeletedComments)
                ? Boolean(object.collapseDeletedComments)
                : undefined,
            emojisCustomSize: globalThis.Array.isArray(object?.emojisCustomSize)
                ? object.emojisCustomSize.map((e) => Number(e))
                : [],
            publicDescriptionHtml: isSet(object.publicDescriptionHtml) ? String(object.publicDescriptionHtml) : undefined,
            allowVideos: isSet(object.allowVideos) ? Boolean(object.allowVideos) : undefined,
            isCrosspostableSubreddit: isSet(object.isCrosspostableSubreddit)
                ? Boolean(object.isCrosspostableSubreddit)
                : undefined,
            notificationLevel: isSet(object.notificationLevel) ? String(object.notificationLevel) : undefined,
            shouldShowMediaInCommentsSetting: isSet(object.shouldShowMediaInCommentsSetting)
                ? Boolean(object.shouldShowMediaInCommentsSetting)
                : undefined,
            canAssignLinkFlair: isSet(object.canAssignLinkFlair) ? Boolean(object.canAssignLinkFlair) : undefined,
            accountsActiveIsFuzzed: isSet(object.accountsActiveIsFuzzed) ? Boolean(object.accountsActiveIsFuzzed) : undefined,
            allowPredictionContributors: isSet(object.allowPredictionContributors)
                ? Boolean(object.allowPredictionContributors)
                : undefined,
            submitTextLabel: isSet(object.submitTextLabel) ? String(object.submitTextLabel) : undefined,
            linkFlairPosition: isSet(object.linkFlairPosition) ? String(object.linkFlairPosition) : undefined,
            userSrFlairEnabled: isSet(object.userSrFlairEnabled) ? Boolean(object.userSrFlairEnabled) : undefined,
            userFlairEnabledInSr: isSet(object.userFlairEnabledInSr) ? Boolean(object.userFlairEnabledInSr) : undefined,
            allowChatPostCreation: isSet(object.allowChatPostCreation) ? Boolean(object.allowChatPostCreation) : undefined,
            allowDiscovery: isSet(object.allowDiscovery) ? Boolean(object.allowDiscovery) : undefined,
            acceptFollowers: isSet(object.acceptFollowers) ? Boolean(object.acceptFollowers) : undefined,
            userSrThemeEnabled: isSet(object.userSrThemeEnabled) ? Boolean(object.userSrThemeEnabled) : undefined,
            linkFlairEnabled: isSet(object.linkFlairEnabled) ? Boolean(object.linkFlairEnabled) : undefined,
            disableContributorRequests: isSet(object.disableContributorRequests)
                ? Boolean(object.disableContributorRequests)
                : undefined,
            subredditType: isSet(object.subredditType) ? String(object.subredditType) : undefined,
            suggestedCommentSort: isSet(object.suggestedCommentSort) ? String(object.suggestedCommentSort) : undefined,
            bannerImg: isSet(object.bannerImg) ? String(object.bannerImg) : undefined,
            userFlairText: isSet(object.userFlairText) ? String(object.userFlairText) : undefined,
            contentCategory: isSet(object.contentCategory) ? String(object.contentCategory) : undefined,
            bannerBackgroundColor: isSet(object.bannerBackgroundColor) ? String(object.bannerBackgroundColor) : undefined,
            showMedia: isSet(object.showMedia) ? Boolean(object.showMedia) : undefined,
            id: isSet(object.id) ? String(object.id) : undefined,
            userIsModerator: isSet(object.userIsModerator) ? Boolean(object.userIsModerator) : undefined,
            over18: isSet(object.over18) ? Boolean(object.over18) : undefined,
            headerTitle: isSet(object.headerTitle) ? String(object.headerTitle) : undefined,
            description: isSet(object.description) ? String(object.description) : undefined,
            isChatPostFeatureEnabled: isSet(object.isChatPostFeatureEnabled)
                ? Boolean(object.isChatPostFeatureEnabled)
                : undefined,
            submitLinkLabel: isSet(object.submitLinkLabel) ? String(object.submitLinkLabel) : undefined,
            userFlairTextColor: isSet(object.userFlairTextColor) ? String(object.userFlairTextColor) : undefined,
            restrictCommenting: isSet(object.restrictCommenting) ? Boolean(object.restrictCommenting) : undefined,
            userFlairCssClass: isSet(object.userFlairCssClass) ? String(object.userFlairCssClass) : undefined,
            allowImages: isSet(object.allowImages) ? Boolean(object.allowImages) : undefined,
            lang: isSet(object.lang) ? String(object.lang) : undefined,
            whitelistStatus: isSet(object.whitelistStatus) ? String(object.whitelistStatus) : undefined,
            url: isSet(object.url) ? String(object.url) : undefined,
            createdUtc: isSet(object.createdUtc) ? Number(object.createdUtc) : undefined,
            bannerSize: globalThis.Array.isArray(object?.bannerSize)
                ? object.bannerSize.map((e) => Number(e))
                : [],
            mobileBannerImage: isSet(object.mobileBannerImage) ? String(object.mobileBannerImage) : undefined,
            userIsContributor: isSet(object.userIsContributor) ? Boolean(object.userIsContributor) : undefined,
            allowPredictionsTournament: isSet(object.allowPredictionsTournament)
                ? Boolean(object.allowPredictionsTournament)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.userFlairBackgroundColor !== undefined) {
            obj.userFlairBackgroundColor = message.userFlairBackgroundColor;
        }
        if (message.submitTextHtml !== undefined) {
            obj.submitTextHtml = message.submitTextHtml;
        }
        if (message.restrictPosting !== undefined) {
            obj.restrictPosting = message.restrictPosting;
        }
        if (message.userIsBanned !== undefined) {
            obj.userIsBanned = message.userIsBanned;
        }
        if (message.freeFormReports !== undefined) {
            obj.freeFormReports = message.freeFormReports;
        }
        if (message.wikiEnabled !== undefined) {
            obj.wikiEnabled = message.wikiEnabled;
        }
        if (message.userIsMuted !== undefined) {
            obj.userIsMuted = message.userIsMuted;
        }
        if (message.userCanFlairInSr !== undefined) {
            obj.userCanFlairInSr = message.userCanFlairInSr;
        }
        if (message.displayName !== undefined) {
            obj.displayName = message.displayName;
        }
        if (message.headerImg !== undefined) {
            obj.headerImg = message.headerImg;
        }
        if (message.title !== undefined) {
            obj.title = message.title;
        }
        if (message.allowGalleries !== undefined) {
            obj.allowGalleries = message.allowGalleries;
        }
        if (message.iconSize?.length) {
            obj.iconSize = message.iconSize;
        }
        if (message.primaryColor !== undefined) {
            obj.primaryColor = message.primaryColor;
        }
        if (message.activeUserCount !== undefined) {
            obj.activeUserCount = message.activeUserCount;
        }
        if (message.iconImg !== undefined) {
            obj.iconImg = message.iconImg;
        }
        if (message.displayNamePrefixed !== undefined) {
            obj.displayNamePrefixed = message.displayNamePrefixed;
        }
        if (message.accountsActive !== undefined) {
            obj.accountsActive = message.accountsActive;
        }
        if (message.publicTraffic !== undefined) {
            obj.publicTraffic = message.publicTraffic;
        }
        if (message.subscribers !== undefined) {
            obj.subscribers = message.subscribers;
        }
        if (message.userFlairRichtext?.length) {
            obj.userFlairRichtext = message.userFlairRichtext;
        }
        if (message.videostreamLinksCount !== undefined) {
            obj.videostreamLinksCount = message.videostreamLinksCount;
        }
        if (message.name !== undefined) {
            obj.name = message.name;
        }
        if (message.quarantine !== undefined) {
            obj.quarantine = message.quarantine;
        }
        if (message.hideAds !== undefined) {
            obj.hideAds = message.hideAds;
        }
        if (message.emojisEnabled !== undefined) {
            obj.emojisEnabled = message.emojisEnabled;
        }
        if (message.advertiserCategory !== undefined) {
            obj.advertiserCategory = message.advertiserCategory;
        }
        if (message.publicDescription !== undefined) {
            obj.publicDescription = message.publicDescription;
        }
        if (message.commentScoreHideMins !== undefined) {
            obj.commentScoreHideMins = message.commentScoreHideMins;
        }
        if (message.allowPredictions !== undefined) {
            obj.allowPredictions = message.allowPredictions;
        }
        if (message.userHasFavorited !== undefined) {
            obj.userHasFavorited = message.userHasFavorited;
        }
        if (message.userFlairTemplateId !== undefined) {
            obj.userFlairTemplateId = message.userFlairTemplateId;
        }
        if (message.communityIcon !== undefined) {
            obj.communityIcon = message.communityIcon;
        }
        if (message.bannerBackgroundImage !== undefined) {
            obj.bannerBackgroundImage = message.bannerBackgroundImage;
        }
        if (message.originalContentTagEnabled !== undefined) {
            obj.originalContentTagEnabled = message.originalContentTagEnabled;
        }
        if (message.communityReviewed !== undefined) {
            obj.communityReviewed = message.communityReviewed;
        }
        if (message.submitText !== undefined) {
            obj.submitText = message.submitText;
        }
        if (message.descriptionHtml !== undefined) {
            obj.descriptionHtml = message.descriptionHtml;
        }
        if (message.spoilersEnabled !== undefined) {
            obj.spoilersEnabled = message.spoilersEnabled;
        }
        if (message.commentContributionSettings !== undefined) {
            obj.commentContributionSettings = CommentContributionSettings.toJSON(message.commentContributionSettings);
        }
        if (message.allowTalks !== undefined) {
            obj.allowTalks = message.allowTalks;
        }
        if (message.headerSize?.length) {
            obj.headerSize = message.headerSize;
        }
        if (message.userFlairPosition !== undefined) {
            obj.userFlairPosition = message.userFlairPosition;
        }
        if (message.allOriginalContent !== undefined) {
            obj.allOriginalContent = message.allOriginalContent;
        }
        if (message.hasMenuWidget !== undefined) {
            obj.hasMenuWidget = message.hasMenuWidget;
        }
        if (message.isEnrolledInNewModmail !== undefined) {
            obj.isEnrolledInNewModmail = message.isEnrolledInNewModmail;
        }
        if (message.keyColor !== undefined) {
            obj.keyColor = message.keyColor;
        }
        if (message.canAssignUserFlair !== undefined) {
            obj.canAssignUserFlair = message.canAssignUserFlair;
        }
        if (message.created !== undefined) {
            obj.created = message.created;
        }
        if (message.wls !== undefined) {
            obj.wls = message.wls;
        }
        if (message.showMediaPreview !== undefined) {
            obj.showMediaPreview = message.showMediaPreview;
        }
        if (message.submissionType !== undefined) {
            obj.submissionType = message.submissionType;
        }
        if (message.userIsSubscriber !== undefined) {
            obj.userIsSubscriber = message.userIsSubscriber;
        }
        if (message.allowedMediaInComments?.length) {
            obj.allowedMediaInComments = message.allowedMediaInComments;
        }
        if (message.allowVideogifs !== undefined) {
            obj.allowVideogifs = message.allowVideogifs;
        }
        if (message.shouldArchivePosts !== undefined) {
            obj.shouldArchivePosts = message.shouldArchivePosts;
        }
        if (message.userFlairType !== undefined) {
            obj.userFlairType = message.userFlairType;
        }
        if (message.allowPolls !== undefined) {
            obj.allowPolls = message.allowPolls;
        }
        if (message.collapseDeletedComments !== undefined) {
            obj.collapseDeletedComments = message.collapseDeletedComments;
        }
        if (message.emojisCustomSize?.length) {
            obj.emojisCustomSize = message.emojisCustomSize;
        }
        if (message.publicDescriptionHtml !== undefined) {
            obj.publicDescriptionHtml = message.publicDescriptionHtml;
        }
        if (message.allowVideos !== undefined) {
            obj.allowVideos = message.allowVideos;
        }
        if (message.isCrosspostableSubreddit !== undefined) {
            obj.isCrosspostableSubreddit = message.isCrosspostableSubreddit;
        }
        if (message.notificationLevel !== undefined) {
            obj.notificationLevel = message.notificationLevel;
        }
        if (message.shouldShowMediaInCommentsSetting !== undefined) {
            obj.shouldShowMediaInCommentsSetting = message.shouldShowMediaInCommentsSetting;
        }
        if (message.canAssignLinkFlair !== undefined) {
            obj.canAssignLinkFlair = message.canAssignLinkFlair;
        }
        if (message.accountsActiveIsFuzzed !== undefined) {
            obj.accountsActiveIsFuzzed = message.accountsActiveIsFuzzed;
        }
        if (message.allowPredictionContributors !== undefined) {
            obj.allowPredictionContributors = message.allowPredictionContributors;
        }
        if (message.submitTextLabel !== undefined) {
            obj.submitTextLabel = message.submitTextLabel;
        }
        if (message.linkFlairPosition !== undefined) {
            obj.linkFlairPosition = message.linkFlairPosition;
        }
        if (message.userSrFlairEnabled !== undefined) {
            obj.userSrFlairEnabled = message.userSrFlairEnabled;
        }
        if (message.userFlairEnabledInSr !== undefined) {
            obj.userFlairEnabledInSr = message.userFlairEnabledInSr;
        }
        if (message.allowChatPostCreation !== undefined) {
            obj.allowChatPostCreation = message.allowChatPostCreation;
        }
        if (message.allowDiscovery !== undefined) {
            obj.allowDiscovery = message.allowDiscovery;
        }
        if (message.acceptFollowers !== undefined) {
            obj.acceptFollowers = message.acceptFollowers;
        }
        if (message.userSrThemeEnabled !== undefined) {
            obj.userSrThemeEnabled = message.userSrThemeEnabled;
        }
        if (message.linkFlairEnabled !== undefined) {
            obj.linkFlairEnabled = message.linkFlairEnabled;
        }
        if (message.disableContributorRequests !== undefined) {
            obj.disableContributorRequests = message.disableContributorRequests;
        }
        if (message.subredditType !== undefined) {
            obj.subredditType = message.subredditType;
        }
        if (message.suggestedCommentSort !== undefined) {
            obj.suggestedCommentSort = message.suggestedCommentSort;
        }
        if (message.bannerImg !== undefined) {
            obj.bannerImg = message.bannerImg;
        }
        if (message.userFlairText !== undefined) {
            obj.userFlairText = message.userFlairText;
        }
        if (message.contentCategory !== undefined) {
            obj.contentCategory = message.contentCategory;
        }
        if (message.bannerBackgroundColor !== undefined) {
            obj.bannerBackgroundColor = message.bannerBackgroundColor;
        }
        if (message.showMedia !== undefined) {
            obj.showMedia = message.showMedia;
        }
        if (message.id !== undefined) {
            obj.id = message.id;
        }
        if (message.userIsModerator !== undefined) {
            obj.userIsModerator = message.userIsModerator;
        }
        if (message.over18 !== undefined) {
            obj.over18 = message.over18;
        }
        if (message.headerTitle !== undefined) {
            obj.headerTitle = message.headerTitle;
        }
        if (message.description !== undefined) {
            obj.description = message.description;
        }
        if (message.isChatPostFeatureEnabled !== undefined) {
            obj.isChatPostFeatureEnabled = message.isChatPostFeatureEnabled;
        }
        if (message.submitLinkLabel !== undefined) {
            obj.submitLinkLabel = message.submitLinkLabel;
        }
        if (message.userFlairTextColor !== undefined) {
            obj.userFlairTextColor = message.userFlairTextColor;
        }
        if (message.restrictCommenting !== undefined) {
            obj.restrictCommenting = message.restrictCommenting;
        }
        if (message.userFlairCssClass !== undefined) {
            obj.userFlairCssClass = message.userFlairCssClass;
        }
        if (message.allowImages !== undefined) {
            obj.allowImages = message.allowImages;
        }
        if (message.lang !== undefined) {
            obj.lang = message.lang;
        }
        if (message.whitelistStatus !== undefined) {
            obj.whitelistStatus = message.whitelistStatus;
        }
        if (message.url !== undefined) {
            obj.url = message.url;
        }
        if (message.createdUtc !== undefined) {
            obj.createdUtc = message.createdUtc;
        }
        if (message.bannerSize?.length) {
            obj.bannerSize = message.bannerSize;
        }
        if (message.mobileBannerImage !== undefined) {
            obj.mobileBannerImage = message.mobileBannerImage;
        }
        if (message.userIsContributor !== undefined) {
            obj.userIsContributor = message.userIsContributor;
        }
        if (message.allowPredictionsTournament !== undefined) {
            obj.allowPredictionsTournament = message.allowPredictionsTournament;
        }
        return obj;
    },
    create(base) {
        return FullSubredditObject.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFullSubredditObject();
        message.userFlairBackgroundColor = object.userFlairBackgroundColor ?? undefined;
        message.submitTextHtml = object.submitTextHtml ?? undefined;
        message.restrictPosting = object.restrictPosting ?? undefined;
        message.userIsBanned = object.userIsBanned ?? undefined;
        message.freeFormReports = object.freeFormReports ?? undefined;
        message.wikiEnabled = object.wikiEnabled ?? undefined;
        message.userIsMuted = object.userIsMuted ?? undefined;
        message.userCanFlairInSr = object.userCanFlairInSr ?? undefined;
        message.displayName = object.displayName ?? undefined;
        message.headerImg = object.headerImg ?? undefined;
        message.title = object.title ?? undefined;
        message.allowGalleries = object.allowGalleries ?? undefined;
        message.iconSize = object.iconSize?.map((e) => e) || [];
        message.primaryColor = object.primaryColor ?? undefined;
        message.activeUserCount = object.activeUserCount ?? undefined;
        message.iconImg = object.iconImg ?? undefined;
        message.displayNamePrefixed = object.displayNamePrefixed ?? undefined;
        message.accountsActive = object.accountsActive ?? undefined;
        message.publicTraffic = object.publicTraffic ?? undefined;
        message.subscribers = object.subscribers ?? undefined;
        message.userFlairRichtext = object.userFlairRichtext?.map((e) => e) || [];
        message.videostreamLinksCount = object.videostreamLinksCount ?? undefined;
        message.name = object.name ?? undefined;
        message.quarantine = object.quarantine ?? undefined;
        message.hideAds = object.hideAds ?? undefined;
        message.emojisEnabled = object.emojisEnabled ?? undefined;
        message.advertiserCategory = object.advertiserCategory ?? undefined;
        message.publicDescription = object.publicDescription ?? undefined;
        message.commentScoreHideMins = object.commentScoreHideMins ?? undefined;
        message.allowPredictions = object.allowPredictions ?? undefined;
        message.userHasFavorited = object.userHasFavorited ?? undefined;
        message.userFlairTemplateId = object.userFlairTemplateId ?? undefined;
        message.communityIcon = object.communityIcon ?? undefined;
        message.bannerBackgroundImage = object.bannerBackgroundImage ?? undefined;
        message.originalContentTagEnabled = object.originalContentTagEnabled ?? undefined;
        message.communityReviewed = object.communityReviewed ?? undefined;
        message.submitText = object.submitText ?? undefined;
        message.descriptionHtml = object.descriptionHtml ?? undefined;
        message.spoilersEnabled = object.spoilersEnabled ?? undefined;
        message.commentContributionSettings =
            (object.commentContributionSettings !== undefined && object.commentContributionSettings !== null)
                ? CommentContributionSettings.fromPartial(object.commentContributionSettings)
                : undefined;
        message.allowTalks = object.allowTalks ?? undefined;
        message.headerSize = object.headerSize?.map((e) => e) || [];
        message.userFlairPosition = object.userFlairPosition ?? undefined;
        message.allOriginalContent = object.allOriginalContent ?? undefined;
        message.hasMenuWidget = object.hasMenuWidget ?? undefined;
        message.isEnrolledInNewModmail = object.isEnrolledInNewModmail ?? undefined;
        message.keyColor = object.keyColor ?? undefined;
        message.canAssignUserFlair = object.canAssignUserFlair ?? undefined;
        message.created = object.created ?? undefined;
        message.wls = object.wls ?? undefined;
        message.showMediaPreview = object.showMediaPreview ?? undefined;
        message.submissionType = object.submissionType ?? undefined;
        message.userIsSubscriber = object.userIsSubscriber ?? undefined;
        message.allowedMediaInComments = object.allowedMediaInComments?.map((e) => e) || [];
        message.allowVideogifs = object.allowVideogifs ?? undefined;
        message.shouldArchivePosts = object.shouldArchivePosts ?? undefined;
        message.userFlairType = object.userFlairType ?? undefined;
        message.allowPolls = object.allowPolls ?? undefined;
        message.collapseDeletedComments = object.collapseDeletedComments ?? undefined;
        message.emojisCustomSize = object.emojisCustomSize?.map((e) => e) || [];
        message.publicDescriptionHtml = object.publicDescriptionHtml ?? undefined;
        message.allowVideos = object.allowVideos ?? undefined;
        message.isCrosspostableSubreddit = object.isCrosspostableSubreddit ?? undefined;
        message.notificationLevel = object.notificationLevel ?? undefined;
        message.shouldShowMediaInCommentsSetting = object.shouldShowMediaInCommentsSetting ?? undefined;
        message.canAssignLinkFlair = object.canAssignLinkFlair ?? undefined;
        message.accountsActiveIsFuzzed = object.accountsActiveIsFuzzed ?? undefined;
        message.allowPredictionContributors = object.allowPredictionContributors ?? undefined;
        message.submitTextLabel = object.submitTextLabel ?? undefined;
        message.linkFlairPosition = object.linkFlairPosition ?? undefined;
        message.userSrFlairEnabled = object.userSrFlairEnabled ?? undefined;
        message.userFlairEnabledInSr = object.userFlairEnabledInSr ?? undefined;
        message.allowChatPostCreation = object.allowChatPostCreation ?? undefined;
        message.allowDiscovery = object.allowDiscovery ?? undefined;
        message.acceptFollowers = object.acceptFollowers ?? undefined;
        message.userSrThemeEnabled = object.userSrThemeEnabled ?? undefined;
        message.linkFlairEnabled = object.linkFlairEnabled ?? undefined;
        message.disableContributorRequests = object.disableContributorRequests ?? undefined;
        message.subredditType = object.subredditType ?? undefined;
        message.suggestedCommentSort = object.suggestedCommentSort ?? undefined;
        message.bannerImg = object.bannerImg ?? undefined;
        message.userFlairText = object.userFlairText ?? undefined;
        message.contentCategory = object.contentCategory ?? undefined;
        message.bannerBackgroundColor = object.bannerBackgroundColor ?? undefined;
        message.showMedia = object.showMedia ?? undefined;
        message.id = object.id ?? undefined;
        message.userIsModerator = object.userIsModerator ?? undefined;
        message.over18 = object.over18 ?? undefined;
        message.headerTitle = object.headerTitle ?? undefined;
        message.description = object.description ?? undefined;
        message.isChatPostFeatureEnabled = object.isChatPostFeatureEnabled ?? undefined;
        message.submitLinkLabel = object.submitLinkLabel ?? undefined;
        message.userFlairTextColor = object.userFlairTextColor ?? undefined;
        message.restrictCommenting = object.restrictCommenting ?? undefined;
        message.userFlairCssClass = object.userFlairCssClass ?? undefined;
        message.allowImages = object.allowImages ?? undefined;
        message.lang = object.lang ?? undefined;
        message.whitelistStatus = object.whitelistStatus ?? undefined;
        message.url = object.url ?? undefined;
        message.createdUtc = object.createdUtc ?? undefined;
        message.bannerSize = object.bannerSize?.map((e) => e) || [];
        message.mobileBannerImage = object.mobileBannerImage ?? undefined;
        message.userIsContributor = object.userIsContributor ?? undefined;
        message.allowPredictionsTournament = object.allowPredictionsTournament ?? undefined;
        return message;
    },
};
messageTypeRegistry.set(FullSubredditObject.$type, FullSubredditObject);
function createBaseSubredditsSearchResponse() {
    return { kind: undefined, data: undefined };
}
export const SubredditsSearchResponse = {
    $type: "devvit.plugin.redditapi.subreddits.SubredditsSearchResponse",
    encode(message, writer = _m0.Writer.create()) {
        if (message.kind !== undefined) {
            StringValue.encode({ value: message.kind }, writer.uint32(10).fork()).ldelim();
        }
        if (message.data !== undefined) {
            SubredditsSearchResponse_WrappedSubredditObject.encode(message.data, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSubredditsSearchResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.kind = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.data = SubredditsSearchResponse_WrappedSubredditObject.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            kind: isSet(object.kind) ? String(object.kind) : undefined,
            data: isSet(object.data) ? SubredditsSearchResponse_WrappedSubredditObject.fromJSON(object.data) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.kind !== undefined) {
            obj.kind = message.kind;
        }
        if (message.data !== undefined) {
            obj.data = SubredditsSearchResponse_WrappedSubredditObject.toJSON(message.data);
        }
        return obj;
    },
    create(base) {
        return SubredditsSearchResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSubredditsSearchResponse();
        message.kind = object.kind ?? undefined;
        message.data = (object.data !== undefined && object.data !== null)
            ? SubredditsSearchResponse_WrappedSubredditObject.fromPartial(object.data)
            : undefined;
        return message;
    },
};
messageTypeRegistry.set(SubredditsSearchResponse.$type, SubredditsSearchResponse);
function createBaseSubredditsSearchResponse_WrappedSubredditObject() {
    return { after: undefined, before: undefined, dist: undefined, geoFilter: undefined, children: [] };
}
export const SubredditsSearchResponse_WrappedSubredditObject = {
    $type: "devvit.plugin.redditapi.subreddits.SubredditsSearchResponse.WrappedSubredditObject",
    encode(message, writer = _m0.Writer.create()) {
        if (message.after !== undefined) {
            StringValue.encode({ value: message.after }, writer.uint32(10).fork()).ldelim();
        }
        if (message.before !== undefined) {
            StringValue.encode({ value: message.before }, writer.uint32(18).fork()).ldelim();
        }
        if (message.dist !== undefined) {
            Int32Value.encode({ value: message.dist }, writer.uint32(26).fork()).ldelim();
        }
        if (message.geoFilter !== undefined) {
            StringValue.encode({ value: message.geoFilter }, writer.uint32(34).fork()).ldelim();
        }
        for (const v of message.children) {
            SubredditsSearchResponse_WrappedSubredditObject_SubredditData.encode(v, writer.uint32(42).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSubredditsSearchResponse_WrappedSubredditObject();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.after = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.before = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.dist = Int32Value.decode(reader, reader.uint32()).value;
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.geoFilter = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.children.push(SubredditsSearchResponse_WrappedSubredditObject_SubredditData.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            after: isSet(object.after) ? String(object.after) : undefined,
            before: isSet(object.before) ? String(object.before) : undefined,
            dist: isSet(object.dist) ? Number(object.dist) : undefined,
            geoFilter: isSet(object.geoFilter) ? String(object.geoFilter) : undefined,
            children: globalThis.Array.isArray(object?.children)
                ? object.children.map((e) => SubredditsSearchResponse_WrappedSubredditObject_SubredditData.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.after !== undefined) {
            obj.after = message.after;
        }
        if (message.before !== undefined) {
            obj.before = message.before;
        }
        if (message.dist !== undefined) {
            obj.dist = message.dist;
        }
        if (message.geoFilter !== undefined) {
            obj.geoFilter = message.geoFilter;
        }
        if (message.children?.length) {
            obj.children = message.children.map((e) => SubredditsSearchResponse_WrappedSubredditObject_SubredditData.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return SubredditsSearchResponse_WrappedSubredditObject.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSubredditsSearchResponse_WrappedSubredditObject();
        message.after = object.after ?? undefined;
        message.before = object.before ?? undefined;
        message.dist = object.dist ?? undefined;
        message.geoFilter = object.geoFilter ?? undefined;
        message.children =
            object.children?.map((e) => SubredditsSearchResponse_WrappedSubredditObject_SubredditData.fromPartial(e)) || [];
        return message;
    },
};
messageTypeRegistry.set(SubredditsSearchResponse_WrappedSubredditObject.$type, SubredditsSearchResponse_WrappedSubredditObject);
function createBaseSubredditsSearchResponse_WrappedSubredditObject_SubredditData() {
    return { kind: undefined, data: undefined };
}
export const SubredditsSearchResponse_WrappedSubredditObject_SubredditData = {
    $type: "devvit.plugin.redditapi.subreddits.SubredditsSearchResponse.WrappedSubredditObject.SubredditData",
    encode(message, writer = _m0.Writer.create()) {
        if (message.kind !== undefined) {
            StringValue.encode({ value: message.kind }, writer.uint32(10).fork()).ldelim();
        }
        if (message.data !== undefined) {
            FullSubredditObject.encode(message.data, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSubredditsSearchResponse_WrappedSubredditObject_SubredditData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.kind = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.data = FullSubredditObject.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            kind: isSet(object.kind) ? String(object.kind) : undefined,
            data: isSet(object.data) ? FullSubredditObject.fromJSON(object.data) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.kind !== undefined) {
            obj.kind = message.kind;
        }
        if (message.data !== undefined) {
            obj.data = FullSubredditObject.toJSON(message.data);
        }
        return obj;
    },
    create(base) {
        return SubredditsSearchResponse_WrappedSubredditObject_SubredditData.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSubredditsSearchResponse_WrappedSubredditObject_SubredditData();
        message.kind = object.kind ?? undefined;
        message.data = (object.data !== undefined && object.data !== null)
            ? FullSubredditObject.fromPartial(object.data)
            : undefined;
        return message;
    },
};
messageTypeRegistry.set(SubredditsSearchResponse_WrappedSubredditObject_SubredditData.$type, SubredditsSearchResponse_WrappedSubredditObject_SubredditData);
function createBaseUserSearchResponse() {
    return { kind: undefined, data: undefined };
}
export const UserSearchResponse = {
    $type: "devvit.plugin.redditapi.subreddits.UserSearchResponse",
    encode(message, writer = _m0.Writer.create()) {
        if (message.kind !== undefined) {
            StringValue.encode({ value: message.kind }, writer.uint32(10).fork()).ldelim();
        }
        if (message.data !== undefined) {
            UserSearchResponse_AccData.encode(message.data, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUserSearchResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.kind = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.data = UserSearchResponse_AccData.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            kind: isSet(object.kind) ? String(object.kind) : undefined,
            data: isSet(object.data) ? UserSearchResponse_AccData.fromJSON(object.data) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.kind !== undefined) {
            obj.kind = message.kind;
        }
        if (message.data !== undefined) {
            obj.data = UserSearchResponse_AccData.toJSON(message.data);
        }
        return obj;
    },
    create(base) {
        return UserSearchResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUserSearchResponse();
        message.kind = object.kind ?? undefined;
        message.data = (object.data !== undefined && object.data !== null)
            ? UserSearchResponse_AccData.fromPartial(object.data)
            : undefined;
        return message;
    },
};
messageTypeRegistry.set(UserSearchResponse.$type, UserSearchResponse);
function createBaseUserSearchResponse_AccData() {
    return {
        after: undefined,
        dist: undefined,
        modhash: undefined,
        geoFilter: undefined,
        children: [],
        before: undefined,
    };
}
export const UserSearchResponse_AccData = {
    $type: "devvit.plugin.redditapi.subreddits.UserSearchResponse.AccData",
    encode(message, writer = _m0.Writer.create()) {
        if (message.after !== undefined) {
            StringValue.encode({ value: message.after }, writer.uint32(10).fork()).ldelim();
        }
        if (message.dist !== undefined) {
            Int64Value.encode({ value: message.dist }, writer.uint32(18).fork()).ldelim();
        }
        if (message.modhash !== undefined) {
            StringValue.encode({ value: message.modhash }, writer.uint32(26).fork()).ldelim();
        }
        if (message.geoFilter !== undefined) {
            StringValue.encode({ value: message.geoFilter }, writer.uint32(34).fork()).ldelim();
        }
        for (const v of message.children) {
            UserSearchResponse_Account.encode(v, writer.uint32(42).fork()).ldelim();
        }
        if (message.before !== undefined) {
            StringValue.encode({ value: message.before }, writer.uint32(50).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUserSearchResponse_AccData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.after = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.dist = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.modhash = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.geoFilter = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.children.push(UserSearchResponse_Account.decode(reader, reader.uint32()));
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.before = StringValue.decode(reader, reader.uint32()).value;
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            after: isSet(object.after) ? String(object.after) : undefined,
            dist: isSet(object.dist) ? Number(object.dist) : undefined,
            modhash: isSet(object.modhash) ? String(object.modhash) : undefined,
            geoFilter: isSet(object.geoFilter) ? String(object.geoFilter) : undefined,
            children: globalThis.Array.isArray(object?.children)
                ? object.children.map((e) => UserSearchResponse_Account.fromJSON(e))
                : [],
            before: isSet(object.before) ? String(object.before) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.after !== undefined) {
            obj.after = message.after;
        }
        if (message.dist !== undefined) {
            obj.dist = message.dist;
        }
        if (message.modhash !== undefined) {
            obj.modhash = message.modhash;
        }
        if (message.geoFilter !== undefined) {
            obj.geoFilter = message.geoFilter;
        }
        if (message.children?.length) {
            obj.children = message.children.map((e) => UserSearchResponse_Account.toJSON(e));
        }
        if (message.before !== undefined) {
            obj.before = message.before;
        }
        return obj;
    },
    create(base) {
        return UserSearchResponse_AccData.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUserSearchResponse_AccData();
        message.after = object.after ?? undefined;
        message.dist = object.dist ?? undefined;
        message.modhash = object.modhash ?? undefined;
        message.geoFilter = object.geoFilter ?? undefined;
        message.children = object.children?.map((e) => UserSearchResponse_Account.fromPartial(e)) || [];
        message.before = object.before ?? undefined;
        return message;
    },
};
messageTypeRegistry.set(UserSearchResponse_AccData.$type, UserSearchResponse_AccData);
function createBaseUserSearchResponse_Account() {
    return { kind: undefined, data: undefined };
}
export const UserSearchResponse_Account = {
    $type: "devvit.plugin.redditapi.subreddits.UserSearchResponse.Account",
    encode(message, writer = _m0.Writer.create()) {
        if (message.kind !== undefined) {
            StringValue.encode({ value: message.kind }, writer.uint32(10).fork()).ldelim();
        }
        if (message.data !== undefined) {
            UserSearchResponse_AccountData.encode(message.data, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUserSearchResponse_Account();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.kind = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.data = UserSearchResponse_AccountData.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            kind: isSet(object.kind) ? String(object.kind) : undefined,
            data: isSet(object.data) ? UserSearchResponse_AccountData.fromJSON(object.data) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.kind !== undefined) {
            obj.kind = message.kind;
        }
        if (message.data !== undefined) {
            obj.data = UserSearchResponse_AccountData.toJSON(message.data);
        }
        return obj;
    },
    create(base) {
        return UserSearchResponse_Account.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUserSearchResponse_Account();
        message.kind = object.kind ?? undefined;
        message.data = (object.data !== undefined && object.data !== null)
            ? UserSearchResponse_AccountData.fromPartial(object.data)
            : undefined;
        return message;
    },
};
messageTypeRegistry.set(UserSearchResponse_Account.$type, UserSearchResponse_Account);
function createBaseUserSearchResponse_AccountData() {
    return {
        isEmployee: undefined,
        isFriend: undefined,
        snoovatarSize: [],
        id: undefined,
        verified: undefined,
        isGold: undefined,
        isMod: undefined,
        hasVerifiedEmail: undefined,
        iconImg: undefined,
        hideFromRobots: undefined,
        linkKarma: undefined,
        acceptChats: undefined,
        isBlocked: undefined,
        prefShowSnoovatar: undefined,
        name: undefined,
        created: undefined,
        createdUtc: undefined,
        snoovatarImg: undefined,
        commentKarma: undefined,
        acceptFollowers: undefined,
        hasSubscribed: undefined,
        acceptPms: undefined,
        isSuspended: undefined,
        subreddit: undefined,
    };
}
export const UserSearchResponse_AccountData = {
    $type: "devvit.plugin.redditapi.subreddits.UserSearchResponse.AccountData",
    encode(message, writer = _m0.Writer.create()) {
        if (message.isEmployee !== undefined) {
            BoolValue.encode({ value: message.isEmployee }, writer.uint32(10).fork()).ldelim();
        }
        if (message.isFriend !== undefined) {
            BoolValue.encode({ value: message.isFriend }, writer.uint32(18).fork()).ldelim();
        }
        for (const v of message.snoovatarSize) {
            Int32Value.encode({ value: v }, writer.uint32(26).fork()).ldelim();
        }
        if (message.id !== undefined) {
            StringValue.encode({ value: message.id }, writer.uint32(34).fork()).ldelim();
        }
        if (message.verified !== undefined) {
            BoolValue.encode({ value: message.verified }, writer.uint32(42).fork()).ldelim();
        }
        if (message.isGold !== undefined) {
            BoolValue.encode({ value: message.isGold }, writer.uint32(50).fork()).ldelim();
        }
        if (message.isMod !== undefined) {
            BoolValue.encode({ value: message.isMod }, writer.uint32(58).fork()).ldelim();
        }
        if (message.hasVerifiedEmail !== undefined) {
            BoolValue.encode({ value: message.hasVerifiedEmail }, writer.uint32(66).fork()).ldelim();
        }
        if (message.iconImg !== undefined) {
            StringValue.encode({ value: message.iconImg }, writer.uint32(74).fork()).ldelim();
        }
        if (message.hideFromRobots !== undefined) {
            BoolValue.encode({ value: message.hideFromRobots }, writer.uint32(82).fork()).ldelim();
        }
        if (message.linkKarma !== undefined) {
            Int32Value.encode({ value: message.linkKarma }, writer.uint32(90).fork()).ldelim();
        }
        if (message.acceptChats !== undefined) {
            BoolValue.encode({ value: message.acceptChats }, writer.uint32(98).fork()).ldelim();
        }
        if (message.isBlocked !== undefined) {
            BoolValue.encode({ value: message.isBlocked }, writer.uint32(106).fork()).ldelim();
        }
        if (message.prefShowSnoovatar !== undefined) {
            BoolValue.encode({ value: message.prefShowSnoovatar }, writer.uint32(114).fork()).ldelim();
        }
        if (message.name !== undefined) {
            StringValue.encode({ value: message.name }, writer.uint32(122).fork()).ldelim();
        }
        if (message.created !== undefined) {
            Int64Value.encode({ value: message.created }, writer.uint32(130).fork()).ldelim();
        }
        if (message.createdUtc !== undefined) {
            Int64Value.encode({ value: message.createdUtc }, writer.uint32(138).fork()).ldelim();
        }
        if (message.snoovatarImg !== undefined) {
            StringValue.encode({ value: message.snoovatarImg }, writer.uint32(146).fork()).ldelim();
        }
        if (message.commentKarma !== undefined) {
            Int64Value.encode({ value: message.commentKarma }, writer.uint32(154).fork()).ldelim();
        }
        if (message.acceptFollowers !== undefined) {
            BoolValue.encode({ value: message.acceptFollowers }, writer.uint32(162).fork()).ldelim();
        }
        if (message.hasSubscribed !== undefined) {
            BoolValue.encode({ value: message.hasSubscribed }, writer.uint32(170).fork()).ldelim();
        }
        if (message.acceptPms !== undefined) {
            BoolValue.encode({ value: message.acceptPms }, writer.uint32(178).fork()).ldelim();
        }
        if (message.isSuspended !== undefined) {
            BoolValue.encode({ value: message.isSuspended }, writer.uint32(186).fork()).ldelim();
        }
        if (message.subreddit !== undefined) {
            UserSearchResponse_AccountData_Subreddit.encode(message.subreddit, writer.uint32(194).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUserSearchResponse_AccountData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.isEmployee = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.isFriend = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.snoovatarSize.push(Int32Value.decode(reader, reader.uint32()).value);
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.id = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.verified = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.isGold = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.isMod = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.hasVerifiedEmail = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 9:
                    if (tag !== 74) {
                        break;
                    }
                    message.iconImg = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.hideFromRobots = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 11:
                    if (tag !== 90) {
                        break;
                    }
                    message.linkKarma = Int32Value.decode(reader, reader.uint32()).value;
                    continue;
                case 12:
                    if (tag !== 98) {
                        break;
                    }
                    message.acceptChats = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 13:
                    if (tag !== 106) {
                        break;
                    }
                    message.isBlocked = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 14:
                    if (tag !== 114) {
                        break;
                    }
                    message.prefShowSnoovatar = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 15:
                    if (tag !== 122) {
                        break;
                    }
                    message.name = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 16:
                    if (tag !== 130) {
                        break;
                    }
                    message.created = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 17:
                    if (tag !== 138) {
                        break;
                    }
                    message.createdUtc = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 18:
                    if (tag !== 146) {
                        break;
                    }
                    message.snoovatarImg = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 19:
                    if (tag !== 154) {
                        break;
                    }
                    message.commentKarma = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 20:
                    if (tag !== 162) {
                        break;
                    }
                    message.acceptFollowers = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 21:
                    if (tag !== 170) {
                        break;
                    }
                    message.hasSubscribed = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 22:
                    if (tag !== 178) {
                        break;
                    }
                    message.acceptPms = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 23:
                    if (tag !== 186) {
                        break;
                    }
                    message.isSuspended = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 24:
                    if (tag !== 194) {
                        break;
                    }
                    message.subreddit = UserSearchResponse_AccountData_Subreddit.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            isEmployee: isSet(object.isEmployee) ? Boolean(object.isEmployee) : undefined,
            isFriend: isSet(object.isFriend) ? Boolean(object.isFriend) : undefined,
            snoovatarSize: globalThis.Array.isArray(object?.snoovatarSize)
                ? object.snoovatarSize.map((e) => Number(e))
                : [],
            id: isSet(object.id) ? String(object.id) : undefined,
            verified: isSet(object.verified) ? Boolean(object.verified) : undefined,
            isGold: isSet(object.isGold) ? Boolean(object.isGold) : undefined,
            isMod: isSet(object.isMod) ? Boolean(object.isMod) : undefined,
            hasVerifiedEmail: isSet(object.hasVerifiedEmail) ? Boolean(object.hasVerifiedEmail) : undefined,
            iconImg: isSet(object.iconImg) ? String(object.iconImg) : undefined,
            hideFromRobots: isSet(object.hideFromRobots) ? Boolean(object.hideFromRobots) : undefined,
            linkKarma: isSet(object.linkKarma) ? Number(object.linkKarma) : undefined,
            acceptChats: isSet(object.acceptChats) ? Boolean(object.acceptChats) : undefined,
            isBlocked: isSet(object.isBlocked) ? Boolean(object.isBlocked) : undefined,
            prefShowSnoovatar: isSet(object.prefShowSnoovatar) ? Boolean(object.prefShowSnoovatar) : undefined,
            name: isSet(object.name) ? String(object.name) : undefined,
            created: isSet(object.created) ? Number(object.created) : undefined,
            createdUtc: isSet(object.createdUtc) ? Number(object.createdUtc) : undefined,
            snoovatarImg: isSet(object.snoovatarImg) ? String(object.snoovatarImg) : undefined,
            commentKarma: isSet(object.commentKarma) ? Number(object.commentKarma) : undefined,
            acceptFollowers: isSet(object.acceptFollowers) ? Boolean(object.acceptFollowers) : undefined,
            hasSubscribed: isSet(object.hasSubscribed) ? Boolean(object.hasSubscribed) : undefined,
            acceptPms: isSet(object.acceptPms) ? Boolean(object.acceptPms) : undefined,
            isSuspended: isSet(object.isSuspended) ? Boolean(object.isSuspended) : undefined,
            subreddit: isSet(object.subreddit)
                ? UserSearchResponse_AccountData_Subreddit.fromJSON(object.subreddit)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.isEmployee !== undefined) {
            obj.isEmployee = message.isEmployee;
        }
        if (message.isFriend !== undefined) {
            obj.isFriend = message.isFriend;
        }
        if (message.snoovatarSize?.length) {
            obj.snoovatarSize = message.snoovatarSize;
        }
        if (message.id !== undefined) {
            obj.id = message.id;
        }
        if (message.verified !== undefined) {
            obj.verified = message.verified;
        }
        if (message.isGold !== undefined) {
            obj.isGold = message.isGold;
        }
        if (message.isMod !== undefined) {
            obj.isMod = message.isMod;
        }
        if (message.hasVerifiedEmail !== undefined) {
            obj.hasVerifiedEmail = message.hasVerifiedEmail;
        }
        if (message.iconImg !== undefined) {
            obj.iconImg = message.iconImg;
        }
        if (message.hideFromRobots !== undefined) {
            obj.hideFromRobots = message.hideFromRobots;
        }
        if (message.linkKarma !== undefined) {
            obj.linkKarma = message.linkKarma;
        }
        if (message.acceptChats !== undefined) {
            obj.acceptChats = message.acceptChats;
        }
        if (message.isBlocked !== undefined) {
            obj.isBlocked = message.isBlocked;
        }
        if (message.prefShowSnoovatar !== undefined) {
            obj.prefShowSnoovatar = message.prefShowSnoovatar;
        }
        if (message.name !== undefined) {
            obj.name = message.name;
        }
        if (message.created !== undefined) {
            obj.created = message.created;
        }
        if (message.createdUtc !== undefined) {
            obj.createdUtc = message.createdUtc;
        }
        if (message.snoovatarImg !== undefined) {
            obj.snoovatarImg = message.snoovatarImg;
        }
        if (message.commentKarma !== undefined) {
            obj.commentKarma = message.commentKarma;
        }
        if (message.acceptFollowers !== undefined) {
            obj.acceptFollowers = message.acceptFollowers;
        }
        if (message.hasSubscribed !== undefined) {
            obj.hasSubscribed = message.hasSubscribed;
        }
        if (message.acceptPms !== undefined) {
            obj.acceptPms = message.acceptPms;
        }
        if (message.isSuspended !== undefined) {
            obj.isSuspended = message.isSuspended;
        }
        if (message.subreddit !== undefined) {
            obj.subreddit = UserSearchResponse_AccountData_Subreddit.toJSON(message.subreddit);
        }
        return obj;
    },
    create(base) {
        return UserSearchResponse_AccountData.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUserSearchResponse_AccountData();
        message.isEmployee = object.isEmployee ?? undefined;
        message.isFriend = object.isFriend ?? undefined;
        message.snoovatarSize = object.snoovatarSize?.map((e) => e) || [];
        message.id = object.id ?? undefined;
        message.verified = object.verified ?? undefined;
        message.isGold = object.isGold ?? undefined;
        message.isMod = object.isMod ?? undefined;
        message.hasVerifiedEmail = object.hasVerifiedEmail ?? undefined;
        message.iconImg = object.iconImg ?? undefined;
        message.hideFromRobots = object.hideFromRobots ?? undefined;
        message.linkKarma = object.linkKarma ?? undefined;
        message.acceptChats = object.acceptChats ?? undefined;
        message.isBlocked = object.isBlocked ?? undefined;
        message.prefShowSnoovatar = object.prefShowSnoovatar ?? undefined;
        message.name = object.name ?? undefined;
        message.created = object.created ?? undefined;
        message.createdUtc = object.createdUtc ?? undefined;
        message.snoovatarImg = object.snoovatarImg ?? undefined;
        message.commentKarma = object.commentKarma ?? undefined;
        message.acceptFollowers = object.acceptFollowers ?? undefined;
        message.hasSubscribed = object.hasSubscribed ?? undefined;
        message.acceptPms = object.acceptPms ?? undefined;
        message.isSuspended = object.isSuspended ?? undefined;
        message.subreddit = (object.subreddit !== undefined && object.subreddit !== null)
            ? UserSearchResponse_AccountData_Subreddit.fromPartial(object.subreddit)
            : undefined;
        return message;
    },
};
messageTypeRegistry.set(UserSearchResponse_AccountData.$type, UserSearchResponse_AccountData);
function createBaseUserSearchResponse_AccountData_Subreddit() {
    return {
        defaultSet: undefined,
        userIsContributor: undefined,
        bannerImg: undefined,
        allowedMediaInComments: [],
        userIsBanned: undefined,
        freeFormReports: undefined,
        communityIcon: undefined,
        showMedia: undefined,
        iconColor: undefined,
        userIsMuted: undefined,
        displayName: undefined,
        headerImg: undefined,
        title: undefined,
        previousNames: [],
        over18: undefined,
        iconSize: [],
        primaryColor: undefined,
        iconImg: undefined,
        description: undefined,
        submitLinkLabel: undefined,
        headerSize: [],
        restrictPosting: undefined,
        restrictCommenting: undefined,
        subscribers: undefined,
        submitTextLabel: undefined,
        isDefaultIcon: undefined,
        linkFlairPosition: undefined,
        displayNamePrefixed: undefined,
        keyColor: undefined,
        name: undefined,
        isDefaultBanner: undefined,
        url: undefined,
        quarantine: undefined,
        bannerSize: [],
        userIsModerator: undefined,
        acceptFollowers: undefined,
        publicDescription: undefined,
        linkFlairEnabled: undefined,
        disableContributorRequests: undefined,
        subredditType: undefined,
        userIsSubscriber: undefined,
    };
}
export const UserSearchResponse_AccountData_Subreddit = {
    $type: "devvit.plugin.redditapi.subreddits.UserSearchResponse.AccountData.Subreddit",
    encode(message, writer = _m0.Writer.create()) {
        if (message.defaultSet !== undefined) {
            BoolValue.encode({ value: message.defaultSet }, writer.uint32(10).fork()).ldelim();
        }
        if (message.userIsContributor !== undefined) {
            BoolValue.encode({ value: message.userIsContributor }, writer.uint32(18).fork()).ldelim();
        }
        if (message.bannerImg !== undefined) {
            StringValue.encode({ value: message.bannerImg }, writer.uint32(26).fork()).ldelim();
        }
        for (const v of message.allowedMediaInComments) {
            StringValue.encode({ value: v }, writer.uint32(34).fork()).ldelim();
        }
        if (message.userIsBanned !== undefined) {
            BoolValue.encode({ value: message.userIsBanned }, writer.uint32(42).fork()).ldelim();
        }
        if (message.freeFormReports !== undefined) {
            BoolValue.encode({ value: message.freeFormReports }, writer.uint32(50).fork()).ldelim();
        }
        if (message.communityIcon !== undefined) {
            StringValue.encode({ value: message.communityIcon }, writer.uint32(58).fork()).ldelim();
        }
        if (message.showMedia !== undefined) {
            BoolValue.encode({ value: message.showMedia }, writer.uint32(66).fork()).ldelim();
        }
        if (message.iconColor !== undefined) {
            StringValue.encode({ value: message.iconColor }, writer.uint32(74).fork()).ldelim();
        }
        if (message.userIsMuted !== undefined) {
            BoolValue.encode({ value: message.userIsMuted }, writer.uint32(82).fork()).ldelim();
        }
        if (message.displayName !== undefined) {
            StringValue.encode({ value: message.displayName }, writer.uint32(90).fork()).ldelim();
        }
        if (message.headerImg !== undefined) {
            StringValue.encode({ value: message.headerImg }, writer.uint32(98).fork()).ldelim();
        }
        if (message.title !== undefined) {
            StringValue.encode({ value: message.title }, writer.uint32(106).fork()).ldelim();
        }
        for (const v of message.previousNames) {
            StringValue.encode({ value: v }, writer.uint32(114).fork()).ldelim();
        }
        if (message.over18 !== undefined) {
            BoolValue.encode({ value: message.over18 }, writer.uint32(122).fork()).ldelim();
        }
        for (const v of message.iconSize) {
            Int32Value.encode({ value: v }, writer.uint32(130).fork()).ldelim();
        }
        if (message.primaryColor !== undefined) {
            StringValue.encode({ value: message.primaryColor }, writer.uint32(138).fork()).ldelim();
        }
        if (message.iconImg !== undefined) {
            StringValue.encode({ value: message.iconImg }, writer.uint32(146).fork()).ldelim();
        }
        if (message.description !== undefined) {
            StringValue.encode({ value: message.description }, writer.uint32(154).fork()).ldelim();
        }
        if (message.submitLinkLabel !== undefined) {
            StringValue.encode({ value: message.submitLinkLabel }, writer.uint32(162).fork()).ldelim();
        }
        for (const v of message.headerSize) {
            Int32Value.encode({ value: v }, writer.uint32(170).fork()).ldelim();
        }
        if (message.restrictPosting !== undefined) {
            BoolValue.encode({ value: message.restrictPosting }, writer.uint32(178).fork()).ldelim();
        }
        if (message.restrictCommenting !== undefined) {
            BoolValue.encode({ value: message.restrictCommenting }, writer.uint32(186).fork()).ldelim();
        }
        if (message.subscribers !== undefined) {
            Int64Value.encode({ value: message.subscribers }, writer.uint32(194).fork()).ldelim();
        }
        if (message.submitTextLabel !== undefined) {
            StringValue.encode({ value: message.submitTextLabel }, writer.uint32(202).fork()).ldelim();
        }
        if (message.isDefaultIcon !== undefined) {
            BoolValue.encode({ value: message.isDefaultIcon }, writer.uint32(210).fork()).ldelim();
        }
        if (message.linkFlairPosition !== undefined) {
            StringValue.encode({ value: message.linkFlairPosition }, writer.uint32(218).fork()).ldelim();
        }
        if (message.displayNamePrefixed !== undefined) {
            StringValue.encode({ value: message.displayNamePrefixed }, writer.uint32(226).fork()).ldelim();
        }
        if (message.keyColor !== undefined) {
            StringValue.encode({ value: message.keyColor }, writer.uint32(234).fork()).ldelim();
        }
        if (message.name !== undefined) {
            StringValue.encode({ value: message.name }, writer.uint32(242).fork()).ldelim();
        }
        if (message.isDefaultBanner !== undefined) {
            BoolValue.encode({ value: message.isDefaultBanner }, writer.uint32(250).fork()).ldelim();
        }
        if (message.url !== undefined) {
            StringValue.encode({ value: message.url }, writer.uint32(258).fork()).ldelim();
        }
        if (message.quarantine !== undefined) {
            BoolValue.encode({ value: message.quarantine }, writer.uint32(266).fork()).ldelim();
        }
        for (const v of message.bannerSize) {
            Int32Value.encode({ value: v }, writer.uint32(274).fork()).ldelim();
        }
        if (message.userIsModerator !== undefined) {
            BoolValue.encode({ value: message.userIsModerator }, writer.uint32(282).fork()).ldelim();
        }
        if (message.acceptFollowers !== undefined) {
            BoolValue.encode({ value: message.acceptFollowers }, writer.uint32(290).fork()).ldelim();
        }
        if (message.publicDescription !== undefined) {
            StringValue.encode({ value: message.publicDescription }, writer.uint32(298).fork()).ldelim();
        }
        if (message.linkFlairEnabled !== undefined) {
            BoolValue.encode({ value: message.linkFlairEnabled }, writer.uint32(306).fork()).ldelim();
        }
        if (message.disableContributorRequests !== undefined) {
            BoolValue.encode({ value: message.disableContributorRequests }, writer.uint32(314).fork()).ldelim();
        }
        if (message.subredditType !== undefined) {
            StringValue.encode({ value: message.subredditType }, writer.uint32(322).fork()).ldelim();
        }
        if (message.userIsSubscriber !== undefined) {
            BoolValue.encode({ value: message.userIsSubscriber }, writer.uint32(330).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUserSearchResponse_AccountData_Subreddit();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.defaultSet = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.userIsContributor = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.bannerImg = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.allowedMediaInComments.push(StringValue.decode(reader, reader.uint32()).value);
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.userIsBanned = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.freeFormReports = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.communityIcon = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.showMedia = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 9:
                    if (tag !== 74) {
                        break;
                    }
                    message.iconColor = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.userIsMuted = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 11:
                    if (tag !== 90) {
                        break;
                    }
                    message.displayName = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 12:
                    if (tag !== 98) {
                        break;
                    }
                    message.headerImg = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 13:
                    if (tag !== 106) {
                        break;
                    }
                    message.title = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 14:
                    if (tag !== 114) {
                        break;
                    }
                    message.previousNames.push(StringValue.decode(reader, reader.uint32()).value);
                    continue;
                case 15:
                    if (tag !== 122) {
                        break;
                    }
                    message.over18 = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 16:
                    if (tag !== 130) {
                        break;
                    }
                    message.iconSize.push(Int32Value.decode(reader, reader.uint32()).value);
                    continue;
                case 17:
                    if (tag !== 138) {
                        break;
                    }
                    message.primaryColor = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 18:
                    if (tag !== 146) {
                        break;
                    }
                    message.iconImg = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 19:
                    if (tag !== 154) {
                        break;
                    }
                    message.description = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 20:
                    if (tag !== 162) {
                        break;
                    }
                    message.submitLinkLabel = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 21:
                    if (tag !== 170) {
                        break;
                    }
                    message.headerSize.push(Int32Value.decode(reader, reader.uint32()).value);
                    continue;
                case 22:
                    if (tag !== 178) {
                        break;
                    }
                    message.restrictPosting = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 23:
                    if (tag !== 186) {
                        break;
                    }
                    message.restrictCommenting = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 24:
                    if (tag !== 194) {
                        break;
                    }
                    message.subscribers = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 25:
                    if (tag !== 202) {
                        break;
                    }
                    message.submitTextLabel = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 26:
                    if (tag !== 210) {
                        break;
                    }
                    message.isDefaultIcon = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 27:
                    if (tag !== 218) {
                        break;
                    }
                    message.linkFlairPosition = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 28:
                    if (tag !== 226) {
                        break;
                    }
                    message.displayNamePrefixed = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 29:
                    if (tag !== 234) {
                        break;
                    }
                    message.keyColor = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 30:
                    if (tag !== 242) {
                        break;
                    }
                    message.name = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 31:
                    if (tag !== 250) {
                        break;
                    }
                    message.isDefaultBanner = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 32:
                    if (tag !== 258) {
                        break;
                    }
                    message.url = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 33:
                    if (tag !== 266) {
                        break;
                    }
                    message.quarantine = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 34:
                    if (tag !== 274) {
                        break;
                    }
                    message.bannerSize.push(Int32Value.decode(reader, reader.uint32()).value);
                    continue;
                case 35:
                    if (tag !== 282) {
                        break;
                    }
                    message.userIsModerator = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 36:
                    if (tag !== 290) {
                        break;
                    }
                    message.acceptFollowers = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 37:
                    if (tag !== 298) {
                        break;
                    }
                    message.publicDescription = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 38:
                    if (tag !== 306) {
                        break;
                    }
                    message.linkFlairEnabled = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 39:
                    if (tag !== 314) {
                        break;
                    }
                    message.disableContributorRequests = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 40:
                    if (tag !== 322) {
                        break;
                    }
                    message.subredditType = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 41:
                    if (tag !== 330) {
                        break;
                    }
                    message.userIsSubscriber = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            defaultSet: isSet(object.defaultSet) ? Boolean(object.defaultSet) : undefined,
            userIsContributor: isSet(object.userIsContributor) ? Boolean(object.userIsContributor) : undefined,
            bannerImg: isSet(object.bannerImg) ? String(object.bannerImg) : undefined,
            allowedMediaInComments: globalThis.Array.isArray(object?.allowedMediaInComments)
                ? object.allowedMediaInComments.map((e) => String(e))
                : [],
            userIsBanned: isSet(object.userIsBanned) ? Boolean(object.userIsBanned) : undefined,
            freeFormReports: isSet(object.freeFormReports) ? Boolean(object.freeFormReports) : undefined,
            communityIcon: isSet(object.communityIcon) ? String(object.communityIcon) : undefined,
            showMedia: isSet(object.showMedia) ? Boolean(object.showMedia) : undefined,
            iconColor: isSet(object.iconColor) ? String(object.iconColor) : undefined,
            userIsMuted: isSet(object.userIsMuted) ? Boolean(object.userIsMuted) : undefined,
            displayName: isSet(object.displayName) ? String(object.displayName) : undefined,
            headerImg: isSet(object.headerImg) ? String(object.headerImg) : undefined,
            title: isSet(object.title) ? String(object.title) : undefined,
            previousNames: globalThis.Array.isArray(object?.previousNames)
                ? object.previousNames.map((e) => String(e))
                : [],
            over18: isSet(object.over18) ? Boolean(object.over18) : undefined,
            iconSize: globalThis.Array.isArray(object?.iconSize) ? object.iconSize.map((e) => Number(e)) : [],
            primaryColor: isSet(object.primaryColor) ? String(object.primaryColor) : undefined,
            iconImg: isSet(object.iconImg) ? String(object.iconImg) : undefined,
            description: isSet(object.description) ? String(object.description) : undefined,
            submitLinkLabel: isSet(object.submitLinkLabel) ? String(object.submitLinkLabel) : undefined,
            headerSize: globalThis.Array.isArray(object?.headerSize) ? object.headerSize.map((e) => Number(e)) : [],
            restrictPosting: isSet(object.restrictPosting) ? Boolean(object.restrictPosting) : undefined,
            restrictCommenting: isSet(object.restrictCommenting) ? Boolean(object.restrictCommenting) : undefined,
            subscribers: isSet(object.subscribers) ? Number(object.subscribers) : undefined,
            submitTextLabel: isSet(object.submitTextLabel) ? String(object.submitTextLabel) : undefined,
            isDefaultIcon: isSet(object.isDefaultIcon) ? Boolean(object.isDefaultIcon) : undefined,
            linkFlairPosition: isSet(object.linkFlairPosition) ? String(object.linkFlairPosition) : undefined,
            displayNamePrefixed: isSet(object.displayNamePrefixed) ? String(object.displayNamePrefixed) : undefined,
            keyColor: isSet(object.keyColor) ? String(object.keyColor) : undefined,
            name: isSet(object.name) ? String(object.name) : undefined,
            isDefaultBanner: isSet(object.isDefaultBanner) ? Boolean(object.isDefaultBanner) : undefined,
            url: isSet(object.url) ? String(object.url) : undefined,
            quarantine: isSet(object.quarantine) ? Boolean(object.quarantine) : undefined,
            bannerSize: globalThis.Array.isArray(object?.bannerSize) ? object.bannerSize.map((e) => Number(e)) : [],
            userIsModerator: isSet(object.userIsModerator) ? Boolean(object.userIsModerator) : undefined,
            acceptFollowers: isSet(object.acceptFollowers) ? Boolean(object.acceptFollowers) : undefined,
            publicDescription: isSet(object.publicDescription) ? String(object.publicDescription) : undefined,
            linkFlairEnabled: isSet(object.linkFlairEnabled) ? Boolean(object.linkFlairEnabled) : undefined,
            disableContributorRequests: isSet(object.disableContributorRequests)
                ? Boolean(object.disableContributorRequests)
                : undefined,
            subredditType: isSet(object.subredditType) ? String(object.subredditType) : undefined,
            userIsSubscriber: isSet(object.userIsSubscriber) ? Boolean(object.userIsSubscriber) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.defaultSet !== undefined) {
            obj.defaultSet = message.defaultSet;
        }
        if (message.userIsContributor !== undefined) {
            obj.userIsContributor = message.userIsContributor;
        }
        if (message.bannerImg !== undefined) {
            obj.bannerImg = message.bannerImg;
        }
        if (message.allowedMediaInComments?.length) {
            obj.allowedMediaInComments = message.allowedMediaInComments;
        }
        if (message.userIsBanned !== undefined) {
            obj.userIsBanned = message.userIsBanned;
        }
        if (message.freeFormReports !== undefined) {
            obj.freeFormReports = message.freeFormReports;
        }
        if (message.communityIcon !== undefined) {
            obj.communityIcon = message.communityIcon;
        }
        if (message.showMedia !== undefined) {
            obj.showMedia = message.showMedia;
        }
        if (message.iconColor !== undefined) {
            obj.iconColor = message.iconColor;
        }
        if (message.userIsMuted !== undefined) {
            obj.userIsMuted = message.userIsMuted;
        }
        if (message.displayName !== undefined) {
            obj.displayName = message.displayName;
        }
        if (message.headerImg !== undefined) {
            obj.headerImg = message.headerImg;
        }
        if (message.title !== undefined) {
            obj.title = message.title;
        }
        if (message.previousNames?.length) {
            obj.previousNames = message.previousNames;
        }
        if (message.over18 !== undefined) {
            obj.over18 = message.over18;
        }
        if (message.iconSize?.length) {
            obj.iconSize = message.iconSize;
        }
        if (message.primaryColor !== undefined) {
            obj.primaryColor = message.primaryColor;
        }
        if (message.iconImg !== undefined) {
            obj.iconImg = message.iconImg;
        }
        if (message.description !== undefined) {
            obj.description = message.description;
        }
        if (message.submitLinkLabel !== undefined) {
            obj.submitLinkLabel = message.submitLinkLabel;
        }
        if (message.headerSize?.length) {
            obj.headerSize = message.headerSize;
        }
        if (message.restrictPosting !== undefined) {
            obj.restrictPosting = message.restrictPosting;
        }
        if (message.restrictCommenting !== undefined) {
            obj.restrictCommenting = message.restrictCommenting;
        }
        if (message.subscribers !== undefined) {
            obj.subscribers = message.subscribers;
        }
        if (message.submitTextLabel !== undefined) {
            obj.submitTextLabel = message.submitTextLabel;
        }
        if (message.isDefaultIcon !== undefined) {
            obj.isDefaultIcon = message.isDefaultIcon;
        }
        if (message.linkFlairPosition !== undefined) {
            obj.linkFlairPosition = message.linkFlairPosition;
        }
        if (message.displayNamePrefixed !== undefined) {
            obj.displayNamePrefixed = message.displayNamePrefixed;
        }
        if (message.keyColor !== undefined) {
            obj.keyColor = message.keyColor;
        }
        if (message.name !== undefined) {
            obj.name = message.name;
        }
        if (message.isDefaultBanner !== undefined) {
            obj.isDefaultBanner = message.isDefaultBanner;
        }
        if (message.url !== undefined) {
            obj.url = message.url;
        }
        if (message.quarantine !== undefined) {
            obj.quarantine = message.quarantine;
        }
        if (message.bannerSize?.length) {
            obj.bannerSize = message.bannerSize;
        }
        if (message.userIsModerator !== undefined) {
            obj.userIsModerator = message.userIsModerator;
        }
        if (message.acceptFollowers !== undefined) {
            obj.acceptFollowers = message.acceptFollowers;
        }
        if (message.publicDescription !== undefined) {
            obj.publicDescription = message.publicDescription;
        }
        if (message.linkFlairEnabled !== undefined) {
            obj.linkFlairEnabled = message.linkFlairEnabled;
        }
        if (message.disableContributorRequests !== undefined) {
            obj.disableContributorRequests = message.disableContributorRequests;
        }
        if (message.subredditType !== undefined) {
            obj.subredditType = message.subredditType;
        }
        if (message.userIsSubscriber !== undefined) {
            obj.userIsSubscriber = message.userIsSubscriber;
        }
        return obj;
    },
    create(base) {
        return UserSearchResponse_AccountData_Subreddit.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUserSearchResponse_AccountData_Subreddit();
        message.defaultSet = object.defaultSet ?? undefined;
        message.userIsContributor = object.userIsContributor ?? undefined;
        message.bannerImg = object.bannerImg ?? undefined;
        message.allowedMediaInComments = object.allowedMediaInComments?.map((e) => e) || [];
        message.userIsBanned = object.userIsBanned ?? undefined;
        message.freeFormReports = object.freeFormReports ?? undefined;
        message.communityIcon = object.communityIcon ?? undefined;
        message.showMedia = object.showMedia ?? undefined;
        message.iconColor = object.iconColor ?? undefined;
        message.userIsMuted = object.userIsMuted ?? undefined;
        message.displayName = object.displayName ?? undefined;
        message.headerImg = object.headerImg ?? undefined;
        message.title = object.title ?? undefined;
        message.previousNames = object.previousNames?.map((e) => e) || [];
        message.over18 = object.over18 ?? undefined;
        message.iconSize = object.iconSize?.map((e) => e) || [];
        message.primaryColor = object.primaryColor ?? undefined;
        message.iconImg = object.iconImg ?? undefined;
        message.description = object.description ?? undefined;
        message.submitLinkLabel = object.submitLinkLabel ?? undefined;
        message.headerSize = object.headerSize?.map((e) => e) || [];
        message.restrictPosting = object.restrictPosting ?? undefined;
        message.restrictCommenting = object.restrictCommenting ?? undefined;
        message.subscribers = object.subscribers ?? undefined;
        message.submitTextLabel = object.submitTextLabel ?? undefined;
        message.isDefaultIcon = object.isDefaultIcon ?? undefined;
        message.linkFlairPosition = object.linkFlairPosition ?? undefined;
        message.displayNamePrefixed = object.displayNamePrefixed ?? undefined;
        message.keyColor = object.keyColor ?? undefined;
        message.name = object.name ?? undefined;
        message.isDefaultBanner = object.isDefaultBanner ?? undefined;
        message.url = object.url ?? undefined;
        message.quarantine = object.quarantine ?? undefined;
        message.bannerSize = object.bannerSize?.map((e) => e) || [];
        message.userIsModerator = object.userIsModerator ?? undefined;
        message.acceptFollowers = object.acceptFollowers ?? undefined;
        message.publicDescription = object.publicDescription ?? undefined;
        message.linkFlairEnabled = object.linkFlairEnabled ?? undefined;
        message.disableContributorRequests = object.disableContributorRequests ?? undefined;
        message.subredditType = object.subredditType ?? undefined;
        message.userIsSubscriber = object.userIsSubscriber ?? undefined;
        return message;
    },
};
messageTypeRegistry.set(UserSearchResponse_AccountData_Subreddit.$type, UserSearchResponse_AccountData_Subreddit);
function createBaseSubredditAddRemovalReasonRequest() {
    return { subreddit: "", message: "", title: "" };
}
export const SubredditAddRemovalReasonRequest = {
    $type: "devvit.plugin.redditapi.subreddits.SubredditAddRemovalReasonRequest",
    encode(message, writer = _m0.Writer.create()) {
        if (message.subreddit !== "") {
            writer.uint32(10).string(message.subreddit);
        }
        if (message.message !== "") {
            writer.uint32(18).string(message.message);
        }
        if (message.title !== "") {
            writer.uint32(26).string(message.title);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSubredditAddRemovalReasonRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.subreddit = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.message = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.title = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            subreddit: isSet(object.subreddit) ? globalThis.String(object.subreddit) : "",
            message: isSet(object.message) ? globalThis.String(object.message) : "",
            title: isSet(object.title) ? globalThis.String(object.title) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.subreddit !== "") {
            obj.subreddit = message.subreddit;
        }
        if (message.message !== "") {
            obj.message = message.message;
        }
        if (message.title !== "") {
            obj.title = message.title;
        }
        return obj;
    },
    create(base) {
        return SubredditAddRemovalReasonRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSubredditAddRemovalReasonRequest();
        message.subreddit = object.subreddit ?? "";
        message.message = object.message ?? "";
        message.title = object.title ?? "";
        return message;
    },
};
messageTypeRegistry.set(SubredditAddRemovalReasonRequest.$type, SubredditAddRemovalReasonRequest);
function createBaseSubredditAddRemovalReasonResponse() {
    return { id: "" };
}
export const SubredditAddRemovalReasonResponse = {
    $type: "devvit.plugin.redditapi.subreddits.SubredditAddRemovalReasonResponse",
    encode(message, writer = _m0.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSubredditAddRemovalReasonResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== "") {
            obj.id = message.id;
        }
        return obj;
    },
    create(base) {
        return SubredditAddRemovalReasonResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSubredditAddRemovalReasonResponse();
        message.id = object.id ?? "";
        return message;
    },
};
messageTypeRegistry.set(SubredditAddRemovalReasonResponse.$type, SubredditAddRemovalReasonResponse);
function createBaseSubredditGetRemovalReasonsRequest() {
    return { subreddit: "" };
}
export const SubredditGetRemovalReasonsRequest = {
    $type: "devvit.plugin.redditapi.subreddits.SubredditGetRemovalReasonsRequest",
    encode(message, writer = _m0.Writer.create()) {
        if (message.subreddit !== "") {
            writer.uint32(10).string(message.subreddit);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSubredditGetRemovalReasonsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.subreddit = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { subreddit: isSet(object.subreddit) ? globalThis.String(object.subreddit) : "" };
    },
    toJSON(message) {
        const obj = {};
        if (message.subreddit !== "") {
            obj.subreddit = message.subreddit;
        }
        return obj;
    },
    create(base) {
        return SubredditGetRemovalReasonsRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSubredditGetRemovalReasonsRequest();
        message.subreddit = object.subreddit ?? "";
        return message;
    },
};
messageTypeRegistry.set(SubredditGetRemovalReasonsRequest.$type, SubredditGetRemovalReasonsRequest);
function createBaseSubredditGetRemovalReasonsResponse() {
    return { data: {}, order: [] };
}
export const SubredditGetRemovalReasonsResponse = {
    $type: "devvit.plugin.redditapi.subreddits.SubredditGetRemovalReasonsResponse",
    encode(message, writer = _m0.Writer.create()) {
        Object.entries(message.data).forEach(([key, value]) => {
            SubredditGetRemovalReasonsResponse_DataEntry.encode({ key: key, value }, writer.uint32(10).fork())
                .ldelim();
        });
        for (const v of message.order) {
            writer.uint32(18).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSubredditGetRemovalReasonsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    const entry1 = SubredditGetRemovalReasonsResponse_DataEntry.decode(reader, reader.uint32());
                    if (entry1.value !== undefined) {
                        message.data[entry1.key] = entry1.value;
                    }
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.order.push(reader.string());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            data: isObject(object.data)
                ? Object.entries(object.data).reduce((acc, [key, value]) => {
                    acc[key] = SubredditGetRemovalReasonsResponse_SubredditRemovalReason.fromJSON(value);
                    return acc;
                }, {})
                : {},
            order: globalThis.Array.isArray(object?.order) ? object.order.map((e) => globalThis.String(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.data) {
            const entries = Object.entries(message.data);
            if (entries.length > 0) {
                obj.data = {};
                entries.forEach(([k, v]) => {
                    obj.data[k] = SubredditGetRemovalReasonsResponse_SubredditRemovalReason.toJSON(v);
                });
            }
        }
        if (message.order?.length) {
            obj.order = message.order;
        }
        return obj;
    },
    create(base) {
        return SubredditGetRemovalReasonsResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSubredditGetRemovalReasonsResponse();
        message.data = Object.entries(object.data ?? {}).reduce((acc, [key, value]) => {
            if (value !== undefined) {
                acc[key] = SubredditGetRemovalReasonsResponse_SubredditRemovalReason.fromPartial(value);
            }
            return acc;
        }, {});
        message.order = object.order?.map((e) => e) || [];
        return message;
    },
};
messageTypeRegistry.set(SubredditGetRemovalReasonsResponse.$type, SubredditGetRemovalReasonsResponse);
function createBaseSubredditGetRemovalReasonsResponse_SubredditRemovalReason() {
    return { id: "", message: "", title: "" };
}
export const SubredditGetRemovalReasonsResponse_SubredditRemovalReason = {
    $type: "devvit.plugin.redditapi.subreddits.SubredditGetRemovalReasonsResponse.SubredditRemovalReason",
    encode(message, writer = _m0.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        if (message.message !== "") {
            writer.uint32(18).string(message.message);
        }
        if (message.title !== "") {
            writer.uint32(26).string(message.title);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSubredditGetRemovalReasonsResponse_SubredditRemovalReason();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.message = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.title = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.String(object.id) : "",
            message: isSet(object.message) ? globalThis.String(object.message) : "",
            title: isSet(object.title) ? globalThis.String(object.title) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.message !== "") {
            obj.message = message.message;
        }
        if (message.title !== "") {
            obj.title = message.title;
        }
        return obj;
    },
    create(base) {
        return SubredditGetRemovalReasonsResponse_SubredditRemovalReason.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSubredditGetRemovalReasonsResponse_SubredditRemovalReason();
        message.id = object.id ?? "";
        message.message = object.message ?? "";
        message.title = object.title ?? "";
        return message;
    },
};
messageTypeRegistry.set(SubredditGetRemovalReasonsResponse_SubredditRemovalReason.$type, SubredditGetRemovalReasonsResponse_SubredditRemovalReason);
function createBaseSubredditGetRemovalReasonsResponse_DataEntry() {
    return { key: "", value: undefined };
}
export const SubredditGetRemovalReasonsResponse_DataEntry = {
    $type: "devvit.plugin.redditapi.subreddits.SubredditGetRemovalReasonsResponse.DataEntry",
    encode(message, writer = _m0.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== undefined) {
            SubredditGetRemovalReasonsResponse_SubredditRemovalReason.encode(message.value, writer.uint32(18).fork())
                .ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSubredditGetRemovalReasonsResponse_DataEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.value = SubredditGetRemovalReasonsResponse_SubredditRemovalReason.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            key: isSet(object.key) ? globalThis.String(object.key) : "",
            value: isSet(object.value)
                ? SubredditGetRemovalReasonsResponse_SubredditRemovalReason.fromJSON(object.value)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.key !== "") {
            obj.key = message.key;
        }
        if (message.value !== undefined) {
            obj.value = SubredditGetRemovalReasonsResponse_SubredditRemovalReason.toJSON(message.value);
        }
        return obj;
    },
    create(base) {
        return SubredditGetRemovalReasonsResponse_DataEntry.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSubredditGetRemovalReasonsResponse_DataEntry();
        message.key = object.key ?? "";
        message.value = (object.value !== undefined && object.value !== null)
            ? SubredditGetRemovalReasonsResponse_SubredditRemovalReason.fromPartial(object.value)
            : undefined;
        return message;
    },
};
messageTypeRegistry.set(SubredditGetRemovalReasonsResponse_DataEntry.$type, SubredditGetRemovalReasonsResponse_DataEntry);
function createBaseSubredditUpdateRemovalReasonRequest() {
    return { subreddit: "", reasonId: "", message: "", title: "" };
}
export const SubredditUpdateRemovalReasonRequest = {
    $type: "devvit.plugin.redditapi.subreddits.SubredditUpdateRemovalReasonRequest",
    encode(message, writer = _m0.Writer.create()) {
        if (message.subreddit !== "") {
            writer.uint32(10).string(message.subreddit);
        }
        if (message.reasonId !== "") {
            writer.uint32(18).string(message.reasonId);
        }
        if (message.message !== "") {
            writer.uint32(26).string(message.message);
        }
        if (message.title !== "") {
            writer.uint32(34).string(message.title);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSubredditUpdateRemovalReasonRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.subreddit = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.reasonId = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.message = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.title = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            subreddit: isSet(object.subreddit) ? globalThis.String(object.subreddit) : "",
            reasonId: isSet(object.reasonId) ? globalThis.String(object.reasonId) : "",
            message: isSet(object.message) ? globalThis.String(object.message) : "",
            title: isSet(object.title) ? globalThis.String(object.title) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.subreddit !== "") {
            obj.subreddit = message.subreddit;
        }
        if (message.reasonId !== "") {
            obj.reasonId = message.reasonId;
        }
        if (message.message !== "") {
            obj.message = message.message;
        }
        if (message.title !== "") {
            obj.title = message.title;
        }
        return obj;
    },
    create(base) {
        return SubredditUpdateRemovalReasonRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSubredditUpdateRemovalReasonRequest();
        message.subreddit = object.subreddit ?? "";
        message.reasonId = object.reasonId ?? "";
        message.message = object.message ?? "";
        message.title = object.title ?? "";
        return message;
    },
};
messageTypeRegistry.set(SubredditUpdateRemovalReasonRequest.$type, SubredditUpdateRemovalReasonRequest);
function createBaseSubredditUpdateRemovalReasonResponse() {
    return {};
}
export const SubredditUpdateRemovalReasonResponse = {
    $type: "devvit.plugin.redditapi.subreddits.SubredditUpdateRemovalReasonResponse",
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSubredditUpdateRemovalReasonResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return SubredditUpdateRemovalReasonResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseSubredditUpdateRemovalReasonResponse();
        return message;
    },
};
messageTypeRegistry.set(SubredditUpdateRemovalReasonResponse.$type, SubredditUpdateRemovalReasonResponse);
function createBaseSubredditDeleteRemovalReasonRequest() {
    return { subreddit: "", reasonId: "" };
}
export const SubredditDeleteRemovalReasonRequest = {
    $type: "devvit.plugin.redditapi.subreddits.SubredditDeleteRemovalReasonRequest",
    encode(message, writer = _m0.Writer.create()) {
        if (message.subreddit !== "") {
            writer.uint32(10).string(message.subreddit);
        }
        if (message.reasonId !== "") {
            writer.uint32(18).string(message.reasonId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSubredditDeleteRemovalReasonRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.subreddit = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.reasonId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            subreddit: isSet(object.subreddit) ? globalThis.String(object.subreddit) : "",
            reasonId: isSet(object.reasonId) ? globalThis.String(object.reasonId) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.subreddit !== "") {
            obj.subreddit = message.subreddit;
        }
        if (message.reasonId !== "") {
            obj.reasonId = message.reasonId;
        }
        return obj;
    },
    create(base) {
        return SubredditDeleteRemovalReasonRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSubredditDeleteRemovalReasonRequest();
        message.subreddit = object.subreddit ?? "";
        message.reasonId = object.reasonId ?? "";
        return message;
    },
};
messageTypeRegistry.set(SubredditDeleteRemovalReasonRequest.$type, SubredditDeleteRemovalReasonRequest);
function createBaseSubredditDeleteRemovalReasonResponse() {
    return {};
}
export const SubredditDeleteRemovalReasonResponse = {
    $type: "devvit.plugin.redditapi.subreddits.SubredditDeleteRemovalReasonResponse",
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSubredditDeleteRemovalReasonResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return SubredditDeleteRemovalReasonResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseSubredditDeleteRemovalReasonResponse();
        return message;
    },
};
messageTypeRegistry.set(SubredditDeleteRemovalReasonResponse.$type, SubredditDeleteRemovalReasonResponse);
function createBaseGetHighlightedPostsRequest() {
    return { subredditName: "" };
}
export const GetHighlightedPostsRequest = {
    $type: "devvit.plugin.redditapi.subreddits.GetHighlightedPostsRequest",
    encode(message, writer = _m0.Writer.create()) {
        if (message.subredditName !== "") {
            writer.uint32(10).string(message.subredditName);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetHighlightedPostsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.subredditName = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { subredditName: isSet(object.subredditName) ? globalThis.String(object.subredditName) : "" };
    },
    toJSON(message) {
        const obj = {};
        if (message.subredditName !== "") {
            obj.subredditName = message.subredditName;
        }
        return obj;
    },
    create(base) {
        return GetHighlightedPostsRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetHighlightedPostsRequest();
        message.subredditName = object.subredditName ?? "";
        return message;
    },
};
messageTypeRegistry.set(GetHighlightedPostsRequest.$type, GetHighlightedPostsRequest);
function createBaseHighlightedPost() {
    return { postId: "", expiresAt: undefined, label: undefined };
}
export const HighlightedPost = {
    $type: "devvit.plugin.redditapi.subreddits.HighlightedPost",
    encode(message, writer = _m0.Writer.create()) {
        if (message.postId !== "") {
            writer.uint32(10).string(message.postId);
        }
        if (message.expiresAt !== undefined) {
            writer.uint32(16).int64(message.expiresAt);
        }
        if (message.label !== undefined) {
            writer.uint32(24).int32(message.label);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseHighlightedPost();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.postId = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.expiresAt = longToNumber(reader.int64());
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.label = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            postId: isSet(object.postId) ? globalThis.String(object.postId) : "",
            expiresAt: isSet(object.expiresAt) ? globalThis.Number(object.expiresAt) : undefined,
            label: isSet(object.label) ? highlightedPostLabelFromJSON(object.label) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.postId !== "") {
            obj.postId = message.postId;
        }
        if (message.expiresAt !== undefined) {
            obj.expiresAt = Math.round(message.expiresAt);
        }
        if (message.label !== undefined) {
            obj.label = highlightedPostLabelToJSON(message.label);
        }
        return obj;
    },
    create(base) {
        return HighlightedPost.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseHighlightedPost();
        message.postId = object.postId ?? "";
        message.expiresAt = object.expiresAt ?? undefined;
        message.label = object.label ?? undefined;
        return message;
    },
};
messageTypeRegistry.set(HighlightedPost.$type, HighlightedPost);
function createBaseGetHighlightedPostsResponse() {
    return { highlightedPosts: [] };
}
export const GetHighlightedPostsResponse = {
    $type: "devvit.plugin.redditapi.subreddits.GetHighlightedPostsResponse",
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.highlightedPosts) {
            HighlightedPost.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetHighlightedPostsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.highlightedPosts.push(HighlightedPost.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            highlightedPosts: globalThis.Array.isArray(object?.highlightedPosts)
                ? object.highlightedPosts.map((e) => HighlightedPost.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.highlightedPosts?.length) {
            obj.highlightedPosts = message.highlightedPosts.map((e) => HighlightedPost.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return GetHighlightedPostsResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetHighlightedPostsResponse();
        message.highlightedPosts = object.highlightedPosts?.map((e) => HighlightedPost.fromPartial(e)) || [];
        return message;
    },
};
messageTypeRegistry.set(GetHighlightedPostsResponse.$type, GetHighlightedPostsResponse);
function createBaseReorderHighlightedPostsRequest() {
    return { subredditId: "", postIdsHighlightOrder: [] };
}
export const ReorderHighlightedPostsRequest = {
    $type: "devvit.plugin.redditapi.subreddits.ReorderHighlightedPostsRequest",
    encode(message, writer = _m0.Writer.create()) {
        if (message.subredditId !== "") {
            writer.uint32(10).string(message.subredditId);
        }
        for (const v of message.postIdsHighlightOrder) {
            writer.uint32(18).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseReorderHighlightedPostsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.subredditId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.postIdsHighlightOrder.push(reader.string());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            subredditId: isSet(object.subredditId) ? globalThis.String(object.subredditId) : "",
            postIdsHighlightOrder: globalThis.Array.isArray(object?.postIdsHighlightOrder)
                ? object.postIdsHighlightOrder.map((e) => globalThis.String(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.subredditId !== "") {
            obj.subredditId = message.subredditId;
        }
        if (message.postIdsHighlightOrder?.length) {
            obj.postIdsHighlightOrder = message.postIdsHighlightOrder;
        }
        return obj;
    },
    create(base) {
        return ReorderHighlightedPostsRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseReorderHighlightedPostsRequest();
        message.subredditId = object.subredditId ?? "";
        message.postIdsHighlightOrder = object.postIdsHighlightOrder?.map((e) => e) || [];
        return message;
    },
};
messageTypeRegistry.set(ReorderHighlightedPostsRequest.$type, ReorderHighlightedPostsRequest);
function createBaseReorderHighlightedPostsResponse() {
    return {};
}
export const ReorderHighlightedPostsResponse = {
    $type: "devvit.plugin.redditapi.subreddits.ReorderHighlightedPostsResponse",
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseReorderHighlightedPostsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return ReorderHighlightedPostsResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseReorderHighlightedPostsResponse();
        return message;
    },
};
messageTypeRegistry.set(ReorderHighlightedPostsResponse.$type, ReorderHighlightedPostsResponse);
function longToNumber(long) {
    if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
        throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
    }
    return long.toNumber();
}
if (_m0.util.Long !== Long) {
    _m0.util.Long = Long;
    _m0.configure();
}
function isObject(value) {
    return typeof value === "object" && value !== null;
}
function isSet(value) {
    return value !== null && value !== undefined;
}
